var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g, _path61, _path62, _path63, _g2, _path64, _path65, _path66, _g3, _path67, _path68, _path69, _g4, _path70, _path71, _path72, _g5, _path73, _path74, _g6, _path75, _path76, _path77, _g7, _path78, _path79, _path80, _g8, _path81, _path82, _g9, _path83, _path84, _path85, _g10, _path86, _path87, _g11, _path88, _path89, _path90, _g12, _path91, _path92, _g13, _path93, _path94, _path95, _g14, _path96, _path97, _g15, _path98, _path99, _path100, _g16, _path101, _path102, _g17, _path103, _path104, _path105, _g18, _path106, _path107, _g19, _path108, _path109, _path110, _g20, _path111, _path112, _g21, _path113, _path114, _path115, _g22, _path116, _path117, _g23, _path118, _path119, _path120, _g24, _path121, _path122, _g25, _path123, _path124, _path125, _g26, _path126, _path127, _g27, _path128, _path129, _path130, _g28, _path131, _path132, _g29, _path133, _path134, _path135, _g30, _path136, _path137, _g31, _path138, _path139, _path140, _g32, _path141, _path142, _g33, _path143, _path144, _path145, _g34, _path146, _path147, _g35, _path148, _path149, _path150, _g36, _path151, _path152, _g37, _path153, _path154, _path155, _path156, _g38, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _g39, _path189, _path190, _g40, _path191, _path192, _path193, _path194, _g41, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _g42, _path227, _path228, _g43, _path229, _path230, _path231, _path232, _g44, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _g45, _path265, _path266, _g46, _path267, _path268, _path269, _path270, _g47, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _g48, _path341, _path342, _path343, _g49, _path344, _path345, _path346, _g50, _path347, _path348, _path349, _g51, _path350, _path351, _path352, _g52, _path353, _path354, _path355, _g53, _path356, _path357, _path358, _g54, _path359, _path360, _path361, _g55, _path362, _path363, _path364, _g56, _path365, _path366, _path367, _g57, _path368, _path369, _path370, _g58, _path371, _path372, _path373, _g59, _path374, _path375, _g60, _path376, _path377, _path378, _g61, _path379, _path380, _path381, _g62, _path382, _path383, _g63, _path384, _path385, _path386, _g64, _path387, _path388, _path389, _g65, _path390, _path391, _g66, _path392, _path393, _path394, _path395, _g67, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _g68, _path406, _path407, _g69, _path408, _path409, _path410, _path411, _g70, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _g71, _path450, _path451, _g72, _path452, _path453, _path454, _g73, _path455, _path456, _g74, _path457, _path458, _path459, _g75, _path460, _path461, _path462, _g76, _path463, _path464, _g77, _path465, _path466, _path467, _g78, _path468, _path469, _path470, _g79, _path471, _path472, _g80, _path473, _path474, _path475, _g81, _path476, _path477, _g82, _path478, _path479, _path480, _g83, _path481, _path482, _g84, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _g85, _path492, _path493, _path494, _g86, _path495, _path496, _path497, _g87, _path498, _path499, _path500, _g88, _path501, _path502, _path503, _g89, _path504, _path505, _g90, _path506, _path507, _path508, _g91, _path509, _path510, _path511, _g92, _path512, _path513, _g93, _path514, _path515, _path516, _g94, _path517, _path518, _g95, _path519, _path520, _path521, _g96, _path522, _path523, _g97, _path524, _path525, _path526, _g98, _path527, _path528, _g99, _path529, _path530, _path531, _g100, _path532, _path533, _g101, _path534, _path535, _path536, _g102, _path537, _path538, _g103, _path539, _path540, _path541, _g104, _path542, _path543, _g105, _path544, _path545, _path546, _g106, _path547, _path548, _g107, _path549, _path550, _path551, _g108, _path552, _path553, _g109, _path554, _path555, _path556, _g110, _path557, _path558, _g111, _path559, _path560, _path561, _g112, _path562, _path563, _g113, _path564, _path565, _path566, _g114, _path567, _path568, _g115, _path569, _path570, _path571, _g116, _path572, _path573, _g117, _path574, _path575, _path576, _g118, _path577, _path578, _g119, _path579, _path580, _path581, _g120, _path582, _path583, _g121, _path584, _path585, _path586, _path587, _g122, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _g123, _path620, _path621, _g124, _path622, _path623, _path624, _path625, _g125, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _g126, _path658, _path659, _g127, _path660, _path661, _path662, _path663, _g128, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _g129, _path696, _path697, _g130, _path698, _path699, _path700, _path701, _g131, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _g132, _path734, _path735, _g133, _path736, _path737, _path738, _path739, _g134, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _g135, _path772, _path773, _g136, _path774, _path775, _path776, _g137, _path777, _path778, _path779, _g138, _path780, _path781, _path782, _g139, _path783, _path784, _path785, _path786, _path787, _path788, _g140, _path789, _path790, _path791, _g141, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _g142, _path845, _path846, _g143, _path847, _path848, _path849, _g144, _path850, _path851, _path852, _g145, _path853, _path854, _path855, _g146, _path856, _path857, _g147, _path858, _path859, _path860, _g148, _path861, _path862, _g149, _path863, _path864, _path865, _g150, _path866, _path867, _g151, _path868, _path869, _path870, _g152, _path871, _path872, _g153, _path873, _path874, _path875, _g154, _path876, _path877, _path878, _g155, _path879, _path880, _path881, _g156, _path882, _path883, _path884, _g157, _path885, _path886, _g158, _path887, _path888, _path889, _g159, _path890, _path891, _path892, _g160, _path893, _path894, _path895, _g161, _path896, _path897, _path898, _g162, _path899, _path900, _path901, _path902, _path903, _g163, _path904, _path905, _g164, _path906, _path907, _path908, _g165, _path909, _path910, _g166, _path911, _path912, _path913, _g167, _path914, _path915, _path916, _g168, _path917, _path918, _g169, _path919, _path920, _path921, _g170, _path922, _path923, _g171, _path924, _path925, _path926, _g172, _path927, _path928, _g173, _path929, _path930, _path931, _g174, _path932, _path933, _path934, _g175, _path935, _path936, _g176, _path937, _path938, _path939, _g177, _path940, _path941, _g178, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _g179, _path953, _path954, _g180, _path955, _path956, _path957, _g181, _path958, _path959, _path960, _g182, _path961, _path962, _path963, _path964, _g183, _path965, _path966, _g184, _path967, _path968, _path969, _g185, _path970, _path971, _g186, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _g187, _path987, _path988, _g188, _path989, _path990, _path991, _path992, _g189, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _g190, _path1025, _path1026, _g191, _path1027, _path1028, _path1029, _path1030, _g192, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _g193, _path1063, _path1064, _g194, _path1065, _path1066, _path1067, _path1068, _g195, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _g196, _path1101, _path1102, _g197, _path1103, _path1104, _path1105, _path1106, _g198, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _g199, _path1139, _path1140, _g200, _path1141, _path1142, _path1143, _path1144, _g201, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _g202, _path1183, _path1184, _path1185, _g203, _path1186, _path1187, _path1188, _g204, _path1189, _path1190, _path1191, _g205, _path1192, _path1193, _path1194, _g206, _path1195, _path1196, _path1197, _g207, _path1198, _path1199, _path1200, _g208, _path1201, _path1202, _path1203, _g209, _path1204, _path1205, _path1206, _g210, _path1207, _path1208, _path1209, _g211, _path1210, _path1211, _path1212, _g212, _path1213, _path1214, _path1215, _g213, _path1216, _path1217, _g214, _path1218, _path1219, _path1220, _g215, _path1221, _path1222, _path1223, _g216, _path1224, _path1225, _g217, _path1226, _path1227, _path1228, _g218, _path1229, _path1230, _path1231, _g219, _path1232, _path1233, _g220, _path1234, _path1235, _path1236, _path1237, _g221, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _g222, _path1248, _path1249, _g223, _path1250, _path1251, _path1252, _path1253, _g224, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _g225, _path1292, _path1293, _g226, _path1294, _path1295, _path1296, _g227, _path1297, _path1298, _g228, _path1299, _path1300, _path1301, _g229, _path1302, _path1303, _path1304, _g230, _path1305, _path1306, _g231, _path1307, _path1308, _path1309, _g232, _path1310, _path1311, _path1312, _g233, _path1313, _path1314, _g234, _path1315, _path1316, _path1317, _g235, _path1318, _path1319, _g236, _path1320, _path1321, _path1322, _g237, _path1323, _path1324, _g238, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 466,
    viewBox: "0 0 391 466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 194.059C243.5 260.652 189.978 314.599 124 314.599C58.0219 314.599 4.5 260.652 4.5 194.059C4.5 127.467 58.0219 73.5195 124 73.5195C189.978 73.5195 243.5 127.467 243.5 194.059Z",
    stroke: "#BEBEBE",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.75948 155.519L-2.45288 160.884C-2.37073 162.322 -0.84247 163.204 0.443418 162.557L5.24305 160.14L0.750016 163.088C-0.453728 163.877 -0.453728 165.642 0.750016 166.432L5.24305 169.38L0.443418 166.963C-0.84247 166.315 -2.37073 167.198 -2.45288 168.635L-2.75948 174L-3.06608 168.635C-3.14822 167.198 -4.67648 166.315 -5.96237 166.963L-10.762 169.38L-6.26897 166.432C-5.06523 165.642 -5.06523 163.877 -6.26897 163.088L-10.762 160.14L-5.96237 162.557C-4.67648 163.204 -3.14822 162.322 -3.06608 160.884L-2.75948 155.519Z",
    fill: "#53C888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 155.519L93.1863 160.884C93.2684 162.322 94.7967 163.204 96.0826 162.557L100.882 160.14L96.3892 163.088C95.1854 163.877 95.1854 165.642 96.3892 166.432L100.882 169.38L96.0826 166.963C94.7967 166.315 93.2684 167.198 93.1863 168.635L92.8797 174L92.5731 168.635C92.4909 167.198 90.9627 166.315 89.6768 166.963L84.8772 169.38L89.3702 166.432C90.5739 165.642 90.5739 163.877 89.3702 163.088L84.8772 160.14L89.6768 162.557C90.9627 163.204 92.4909 162.322 92.5731 160.884L92.8797 155.519Z",
    fill: "#53C888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 119.02L125.066 124.385C125.148 125.822 126.677 126.704 127.962 126.057L132.762 123.64L128.269 126.588C127.065 127.378 127.065 129.142 128.269 129.932L132.762 132.88L127.962 130.463C126.677 129.816 125.148 130.698 125.066 132.135L124.76 137.501L124.453 132.135C124.371 130.698 122.843 129.816 121.557 130.463L116.757 132.88L121.25 129.932C122.454 129.142 122.454 127.378 121.25 126.588L116.757 123.64L121.557 126.057C122.843 126.704 124.371 125.822 124.453 124.385L124.76 119.02Z",
    fill: "#53C888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 119.02L93.1863 124.385C93.2684 125.822 94.7967 126.704 96.0826 126.057L100.882 123.64L96.3892 126.588C95.1854 127.378 95.1854 129.142 96.3892 129.932L100.882 132.88L96.0826 130.463C94.7967 129.816 93.2684 130.698 93.1863 132.135L92.8797 137.501L92.5731 132.135C92.4909 130.698 90.9627 129.816 89.6768 130.463L84.8772 132.88L89.3702 129.932C90.5739 129.142 90.5739 127.378 89.3702 126.588L84.8772 123.64L89.6768 126.057C90.9627 126.704 92.4909 125.822 92.5731 124.385L92.8797 119.02Z",
    fill: "#53C888"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1204 192.02L29.427 197.385C29.5091 198.823 31.0374 199.705 32.3233 199.057L37.1229 196.64L32.6299 199.588C31.4262 200.378 31.4262 202.143 32.6299 202.933L37.1229 205.881L32.3233 203.464C31.0374 202.816 29.5091 203.699 29.427 205.136L29.1204 210.501L28.8138 205.136C28.7317 203.699 27.2034 202.816 25.9175 203.464L21.1179 205.881L25.6109 202.933C26.8147 202.143 26.8147 200.378 25.6109 199.588L21.1179 196.64L25.9175 199.057C27.2034 199.705 28.7317 198.823 28.8138 197.385L29.1204 192.02Z",
    fill: "#53C888"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1204 119.02L29.427 124.385C29.5091 125.822 31.0374 126.704 32.3233 126.057L37.1229 123.64L32.6299 126.588C31.4262 127.378 31.4262 129.142 32.6299 129.932L37.1229 132.88L32.3233 130.463C31.0374 129.816 29.5091 130.698 29.427 132.135L29.1204 137.501L28.8138 132.135C28.7317 130.698 27.2034 129.816 25.9175 130.463L21.1179 132.88L25.6109 129.932C26.8147 129.142 26.8147 127.378 25.6109 126.588L21.1179 123.64L25.9175 126.057C27.2034 126.704 28.7317 125.822 28.8138 124.385L29.1204 119.02Z",
    fill: "#53C888"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.75948 119.02L-2.45288 124.385C-2.37073 125.822 -0.84247 126.704 0.443418 126.057L5.24305 123.64L0.750016 126.588C-0.453728 127.378 -0.453728 129.142 0.750016 129.932L5.24305 132.88L0.443418 130.463C-0.84247 129.816 -2.37073 130.698 -2.45288 132.135L-2.75948 137.501L-3.06608 132.135C-3.14822 130.698 -4.67648 129.816 -5.96237 130.463L-10.762 132.88L-6.26897 129.932C-5.06523 129.142 -5.06523 127.378 -6.26897 126.588L-10.762 123.64L-5.96237 126.057C-4.67648 126.704 -3.14822 125.822 -3.06608 124.385L-2.75948 119.02Z",
    fill: "#53C888"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.75948 192.02L-2.45288 197.385C-2.37073 198.823 -0.84247 199.705 0.443418 199.057L5.24305 196.64L0.750016 199.588C-0.453728 200.378 -0.453728 202.143 0.750016 202.933L5.24305 205.881L0.443418 203.464C-0.84247 202.816 -2.37073 203.699 -2.45288 205.136L-2.75948 210.501L-3.06608 205.136C-3.14822 203.699 -4.67648 202.816 -5.96237 203.464L-10.762 205.881L-6.26897 202.933C-5.06523 202.143 -5.06523 200.378 -6.26897 199.588L-10.762 196.64L-5.96237 199.057C-4.67648 199.705 -3.14822 198.823 -3.06608 197.385L-2.75948 192.02Z",
    fill: "#53C888"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 192.02L125.066 197.385C125.148 198.823 126.677 199.705 127.962 199.057L132.762 196.64L128.269 199.588C127.065 200.378 127.065 202.143 128.269 202.933L132.762 205.881L127.962 203.464C126.677 202.816 125.148 203.699 125.066 205.136L124.76 210.501L124.453 205.136C124.371 203.699 122.843 202.816 121.557 203.464L116.757 205.881L121.25 202.933C122.454 202.143 122.454 200.378 121.25 199.588L116.757 196.64L121.557 199.057C122.843 199.705 124.371 198.823 124.453 197.385L124.76 192.02Z",
    fill: "#53C888"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 192.02L93.1863 197.385C93.2684 198.823 94.7967 199.705 96.0826 199.057L100.882 196.64L96.3892 199.588C95.1854 200.378 95.1854 202.143 96.3892 202.933L100.882 205.881L96.0826 203.464C94.7967 202.816 93.2684 203.699 93.1863 205.136L92.8797 210.501L92.5731 205.136C92.4909 203.699 90.9627 202.816 89.6768 203.464L84.8772 205.881L89.3702 202.933C90.5739 202.143 90.5739 200.378 89.3702 199.588L84.8772 196.64L89.6768 199.057C90.9627 199.705 92.4909 198.823 92.5731 197.385L92.8797 192.02Z",
    fill: "#53C888"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0003 155.519L61.3069 160.884C61.389 162.322 62.9173 163.204 64.2032 162.557L69.0028 160.14L64.5098 163.088C63.306 163.877 63.306 165.642 64.5098 166.432L69.0028 169.38L64.2032 166.963C62.9173 166.315 61.389 167.198 61.3069 168.635L61.0003 174L60.6937 168.635C60.6115 167.198 59.0833 166.315 57.7974 166.963L52.9978 169.38L57.4908 166.432C58.6945 165.642 58.6945 163.877 57.4908 163.088L52.9978 160.14L57.7974 162.557C59.0833 163.204 60.6115 162.322 60.6937 160.884L61.0003 155.519Z",
    fill: "#53C888"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 155.519L125.066 160.884C125.148 162.322 126.677 163.204 127.962 162.557L132.762 160.14L128.269 163.088C127.065 163.877 127.065 165.642 128.269 166.432L132.762 169.38L127.962 166.963C126.677 166.315 125.148 167.198 125.066 168.635L124.76 174L124.453 168.635C124.371 167.198 122.843 166.315 121.557 166.963L116.757 169.38L121.25 166.432C122.454 165.642 122.454 163.877 121.25 163.088L116.757 160.14L121.557 162.557C122.843 163.204 124.371 162.322 124.453 160.884L124.76 155.519Z",
    fill: "#53C888"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1204 155.519L29.427 160.884C29.5091 162.322 31.0374 163.204 32.3233 162.557L37.1229 160.14L32.6299 163.088C31.4262 163.877 31.4262 165.642 32.6299 166.432L37.1229 169.38L32.3233 166.963C31.0374 166.315 29.5091 167.198 29.427 168.635L29.1204 174L28.8138 168.635C28.7317 167.198 27.2034 166.315 25.9175 166.963L21.1179 169.38L25.6109 166.432C26.8147 165.642 26.8147 163.877 25.6109 163.088L21.1179 160.14L25.9175 162.557C27.2034 163.204 28.7317 162.322 28.8138 160.884L29.1204 155.519Z",
    fill: "#53C888"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0003 119.02L61.3069 124.385C61.389 125.822 62.9173 126.704 64.2032 126.057L69.0028 123.64L64.5098 126.588C63.306 127.378 63.306 129.142 64.5098 129.932L69.0028 132.88L64.2032 130.463C62.9173 129.816 61.389 130.698 61.3069 132.135L61.0003 137.501L60.6937 132.135C60.6115 130.698 59.0833 129.816 57.7974 130.463L52.9978 132.88L57.4908 129.932C58.6945 129.142 58.6945 127.378 57.4908 126.588L52.9978 123.64L57.7974 126.057C59.0833 126.704 60.6115 125.822 60.6937 124.385L61.0003 119.02Z",
    fill: "#53C888"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0003 192.02L61.3069 197.385C61.389 198.823 62.9173 199.705 64.2032 199.057L69.0028 196.64L64.5098 199.588C63.306 200.378 63.306 202.143 64.5098 202.933L69.0028 205.881L64.2032 203.464C62.9173 202.816 61.389 203.699 61.3069 205.136L61.0003 210.501L60.6937 205.136C60.6115 203.699 59.0833 202.816 57.7974 203.464L52.9978 205.881L57.4908 202.933C58.6945 202.143 58.6945 200.378 57.4908 199.588L52.9978 196.64L57.7974 199.057C59.0833 199.705 60.6115 198.823 60.6937 197.385L61.0003 192.02Z",
    fill: "#53C888"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1204 228.519L29.427 233.884C29.5091 235.322 31.0374 236.204 32.3233 235.556L37.1229 233.139L32.6299 236.087C31.4262 236.877 31.4262 238.642 32.6299 239.432L37.1229 242.38L32.3233 239.963C31.0374 239.315 29.5091 240.198 29.427 241.635L29.1204 247L28.8138 241.635C28.7317 240.198 27.2034 239.315 25.9175 239.963L21.1179 242.38L25.6109 239.432C26.8147 238.642 26.8147 236.877 25.6109 236.087L21.1179 233.139L25.9175 235.556C27.2034 236.204 28.7317 235.322 28.8138 233.884L29.1204 228.519Z",
    fill: "#53C888"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.75948 228.519L-2.45288 233.884C-2.37073 235.322 -0.84247 236.204 0.443418 235.556L5.24305 233.139L0.750016 236.087C-0.453728 236.877 -0.453728 238.642 0.750016 239.432L5.24305 242.38L0.443418 239.963C-0.84247 239.315 -2.37073 240.198 -2.45288 241.635L-2.75948 247L-3.06608 241.635C-3.14822 240.198 -4.67648 239.315 -5.96237 239.963L-10.762 242.38L-6.26897 239.432C-5.06523 238.642 -5.06523 236.877 -6.26897 236.087L-10.762 233.139L-5.96237 235.556C-4.67648 236.204 -3.14822 235.322 -3.06608 233.884L-2.75948 228.519Z",
    fill: "#53C888"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 228.519L125.066 233.884C125.148 235.322 126.677 236.204 127.962 235.556L132.762 233.139L128.269 236.087C127.065 236.877 127.065 238.642 128.269 239.432L132.762 242.38L127.962 239.963C126.677 239.315 125.148 240.198 125.066 241.635L124.76 247L124.453 241.635C124.371 240.198 122.843 239.315 121.557 239.963L116.757 242.38L121.25 239.432C122.454 238.642 122.454 236.877 121.25 236.087L116.757 233.139L121.557 235.556C122.843 236.204 124.371 235.322 124.453 233.884L124.76 228.519Z",
    fill: "#53C888"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 228.519L93.1863 233.884C93.2684 235.322 94.7967 236.204 96.0826 235.556L100.882 233.139L96.3892 236.087C95.1854 236.877 95.1854 238.642 96.3892 239.432L100.882 242.38L96.0826 239.963C94.7967 239.315 93.2684 240.198 93.1863 241.635L92.8797 247L92.5731 241.635C92.4909 240.198 90.9627 239.315 89.6768 239.963L84.8772 242.38L89.3702 239.432C90.5739 238.642 90.5739 236.877 89.3702 236.087L84.8772 233.139L89.6768 235.556C90.9627 236.204 92.4909 235.322 92.5731 233.884L92.8797 228.519Z",
    fill: "#53C888"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0003 228.519L61.3069 233.884C61.389 235.322 62.9173 236.204 64.2032 235.556L69.0028 233.139L64.5098 236.087C63.306 236.877 63.306 238.642 64.5098 239.432L69.0028 242.38L64.2032 239.963C62.9173 239.315 61.389 240.198 61.3069 241.635L61.0003 247L60.6937 241.635C60.6115 240.198 59.0833 239.315 57.7974 239.963L52.9978 242.38L57.4908 239.432C58.6945 238.642 58.6945 236.877 57.4908 236.087L52.9978 233.139L57.7974 235.556C59.0833 236.204 60.6115 235.322 60.6937 233.884L61.0003 228.519Z",
    fill: "#53C888"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1204 265.019L29.427 270.384C29.5091 271.822 31.0374 272.704 32.3233 272.057L37.1229 269.64L32.6299 272.588C31.4262 273.377 31.4262 275.142 32.6299 275.932L37.1229 278.88L32.3233 276.463C31.0374 275.815 29.5091 276.698 29.427 278.135L29.1204 283.5L28.8138 278.135C28.7317 276.698 27.2034 275.815 25.9175 276.463L21.1179 278.88L25.6109 275.932C26.8147 275.142 26.8147 273.377 25.6109 272.588L21.1179 269.64L25.9175 272.057C27.2034 272.704 28.7317 271.822 28.8138 270.384L29.1204 265.019Z",
    fill: "#53C888"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.75948 265.019L-2.45288 270.384C-2.37073 271.822 -0.84247 272.704 0.443418 272.057L5.24305 269.64L0.750016 272.588C-0.453728 273.377 -0.453728 275.142 0.750016 275.932L5.24305 278.88L0.443418 276.463C-0.84247 275.815 -2.37073 276.698 -2.45288 278.135L-2.75948 283.5L-3.06608 278.135C-3.14822 276.698 -4.67648 275.815 -5.96237 276.463L-10.762 278.88L-6.26897 275.932C-5.06523 275.142 -5.06523 273.377 -6.26897 272.588L-10.762 269.64L-5.96237 272.057C-4.67648 272.704 -3.14822 271.822 -3.06608 270.384L-2.75948 265.019Z",
    fill: "#53C888"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 265.019L125.066 270.384C125.148 271.822 126.677 272.704 127.962 272.057L132.762 269.64L128.269 272.588C127.065 273.377 127.065 275.142 128.269 275.932L132.762 278.88L127.962 276.463C126.677 275.815 125.148 276.698 125.066 278.135L124.76 283.5L124.453 278.135C124.371 276.698 122.843 275.815 121.557 276.463L116.757 278.88L121.25 275.932C122.454 275.142 122.454 273.377 121.25 272.588L116.757 269.64L121.557 272.057C122.843 272.704 124.371 271.822 124.453 270.384L124.76 265.019Z",
    fill: "#53C888"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 265.019L93.1863 270.384C93.2684 271.822 94.7967 272.704 96.0826 272.057L100.882 269.64L96.3892 272.588C95.1854 273.377 95.1854 275.142 96.3892 275.932L100.882 278.88L96.0826 276.463C94.7967 275.815 93.2684 276.698 93.1863 278.135L92.8797 283.5L92.5731 278.135C92.4909 276.698 90.9627 275.815 89.6768 276.463L84.8772 278.88L89.3702 275.932C90.5739 275.142 90.5739 273.377 89.3702 272.588L84.8772 269.64L89.6768 272.057C90.9627 272.704 92.4909 271.822 92.5731 270.384L92.8797 265.019Z",
    fill: "#53C888"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0003 265.019L61.3069 270.384C61.389 271.822 62.9173 272.704 64.2032 272.057L69.0028 269.64L64.5098 272.588C63.306 273.377 63.306 275.142 64.5098 275.932L69.0028 278.88L64.2032 276.463C62.9173 275.815 61.389 276.698 61.3069 278.135L61.0003 283.5L60.6937 278.135C60.6115 276.698 59.0833 275.815 57.7974 276.463L52.9978 278.88L57.4908 275.932C58.6945 275.142 58.6945 273.377 57.4908 272.588L52.9978 269.64L57.7974 272.057C59.0833 272.704 60.6115 271.822 60.6937 270.384L61.0003 265.019Z",
    fill: "#53C888"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.75948 338.02L-2.45288 343.385C-2.37073 344.823 -0.84247 345.705 0.443418 345.057L5.24305 342.64L0.750016 345.588C-0.453728 346.378 -0.453728 348.143 0.750016 348.933L5.24305 351.881L0.443418 349.464C-0.84247 348.816 -2.37073 349.699 -2.45288 351.136L-2.75948 356.501L-3.06608 351.136C-3.14822 349.699 -4.67648 348.816 -5.96237 349.464L-10.762 351.881L-6.26897 348.933C-5.06523 348.143 -5.06523 346.378 -6.26897 345.588L-10.762 342.64L-5.96237 345.057C-4.67648 345.705 -3.14822 344.823 -3.06608 343.385L-2.75948 338.02Z",
    fill: "#53C888"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 338.02L93.1863 343.385C93.2684 344.823 94.7967 345.705 96.0826 345.057L100.882 342.64L96.3892 345.588C95.1854 346.378 95.1854 348.143 96.3892 348.933L100.882 351.881L96.0826 349.464C94.7967 348.816 93.2684 349.699 93.1863 351.136L92.8797 356.501L92.5731 351.136C92.4909 349.699 90.9627 348.816 89.6768 349.464L84.8772 351.881L89.3702 348.933C90.5739 348.143 90.5739 346.378 89.3702 345.588L84.8772 342.64L89.6768 345.057C90.9627 345.705 92.4909 344.823 92.5731 343.385L92.8797 338.02Z",
    fill: "#53C888"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 301.52L125.066 306.885C125.148 308.322 126.677 309.205 127.962 308.557L132.762 306.14L128.269 309.088C127.065 309.878 127.065 311.643 128.269 312.432L132.762 315.381L127.962 312.964C126.677 312.316 125.148 313.198 125.066 314.636L124.76 320.001L124.453 314.636C124.371 313.198 122.843 312.316 121.557 312.964L116.757 315.381L121.25 312.432C122.454 311.643 122.454 309.878 121.25 309.088L116.757 306.14L121.557 308.557C122.843 309.205 124.371 308.322 124.453 306.885L124.76 301.52Z",
    fill: "#53C888"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 301.52L93.1863 306.885C93.2684 308.322 94.7967 309.205 96.0826 308.557L100.882 306.14L96.3892 309.088C95.1854 309.878 95.1854 311.643 96.3892 312.432L100.882 315.381L96.0826 312.964C94.7967 312.316 93.2684 313.198 93.1863 314.636L92.8797 320.001L92.5731 314.636C92.4909 313.198 90.9627 312.316 89.6768 312.964L84.8772 315.381L89.3702 312.432C90.5739 311.643 90.5739 309.878 89.3702 309.088L84.8772 306.14L89.6768 308.557C90.9627 309.205 92.4909 308.322 92.5731 306.885L92.8797 301.52Z",
    fill: "#53C888"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1204 374.52L29.427 379.885C29.5091 381.322 31.0374 382.204 32.3233 381.557L37.1229 379.14L32.6299 382.088C31.4262 382.878 31.4262 384.642 32.6299 385.432L37.1229 388.38L32.3233 385.963C31.0374 385.316 29.5091 386.198 29.427 387.635L29.1204 393.001L28.8138 387.635C28.7317 386.198 27.2034 385.316 25.9175 385.963L21.1179 388.38L25.6109 385.432C26.8147 384.642 26.8147 382.878 25.6109 382.088L21.1179 379.14L25.9175 381.557C27.2034 382.204 28.7317 381.322 28.8138 379.885L29.1204 374.52Z",
    fill: "#53C888"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1204 301.52L29.427 306.885C29.5091 308.322 31.0374 309.205 32.3233 308.557L37.1229 306.14L32.6299 309.088C31.4262 309.878 31.4262 311.643 32.6299 312.432L37.1229 315.381L32.3233 312.964C31.0374 312.316 29.5091 313.198 29.427 314.636L29.1204 320.001L28.8138 314.636C28.7317 313.198 27.2034 312.316 25.9175 312.964L21.1179 315.381L25.6109 312.432C26.8147 311.643 26.8147 309.878 25.6109 309.088L21.1179 306.14L25.9175 308.557C27.2034 309.205 28.7317 308.322 28.8138 306.885L29.1204 301.52Z",
    fill: "#53C888"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.75948 301.52L-2.45288 306.885C-2.37073 308.322 -0.84247 309.205 0.443418 308.557L5.24305 306.14L0.750016 309.088C-0.453728 309.878 -0.453728 311.643 0.750016 312.432L5.24305 315.381L0.443418 312.964C-0.84247 312.316 -2.37073 313.198 -2.45288 314.636L-2.75948 320.001L-3.06608 314.636C-3.14822 313.198 -4.67648 312.316 -5.96237 312.964L-10.762 315.381L-6.26897 312.432C-5.06523 311.643 -5.06523 309.878 -6.26897 309.088L-10.762 306.14L-5.96237 308.557C-4.67648 309.205 -3.14822 308.322 -3.06608 306.885L-2.75948 301.52Z",
    fill: "#53C888"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.75948 374.52L-2.45288 379.885C-2.37073 381.322 -0.84247 382.204 0.443418 381.557L5.24305 379.14L0.750016 382.088C-0.453728 382.878 -0.453728 384.642 0.750016 385.432L5.24305 388.38L0.443418 385.963C-0.84247 385.316 -2.37073 386.198 -2.45288 387.635L-2.75948 393.001L-3.06608 387.635C-3.14822 386.198 -4.67648 385.316 -5.96237 385.963L-10.762 388.38L-6.26897 385.432C-5.06523 384.642 -5.06523 382.878 -6.26897 382.088L-10.762 379.14L-5.96237 381.557C-4.67648 382.204 -3.14822 381.322 -3.06608 379.885L-2.75948 374.52Z",
    fill: "#53C888"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 374.52L125.066 379.885C125.148 381.322 126.677 382.204 127.962 381.557L132.762 379.14L128.269 382.088C127.065 382.878 127.065 384.642 128.269 385.432L132.762 388.38L127.962 385.963C126.677 385.316 125.148 386.198 125.066 387.635L124.76 393.001L124.453 387.635C124.371 386.198 122.843 385.316 121.557 385.963L116.757 388.38L121.25 385.432C122.454 384.642 122.454 382.878 121.25 382.088L116.757 379.14L121.557 381.557C122.843 382.204 124.371 381.322 124.453 379.885L124.76 374.52Z",
    fill: "#53C888"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 374.52L93.1863 379.885C93.2684 381.322 94.7967 382.204 96.0826 381.557L100.882 379.14L96.3892 382.088C95.1854 382.878 95.1854 384.642 96.3892 385.432L100.882 388.38L96.0826 385.963C94.7967 385.316 93.2684 386.198 93.1863 387.635L92.8797 393.001L92.5731 387.635C92.4909 386.198 90.9627 385.316 89.6768 385.963L84.8772 388.38L89.3702 385.432C90.5739 384.642 90.5739 382.878 89.3702 382.088L84.8772 379.14L89.6768 381.557C90.9627 382.204 92.4909 381.322 92.5731 379.885L92.8797 374.52Z",
    fill: "#53C888"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0003 338.02L61.3069 343.385C61.389 344.823 62.9173 345.705 64.2032 345.057L69.0028 342.64L64.5098 345.588C63.306 346.378 63.306 348.143 64.5098 348.933L69.0028 351.881L64.2032 349.464C62.9173 348.816 61.389 349.699 61.3069 351.136L61.0003 356.501L60.6937 351.136C60.6115 349.699 59.0833 348.816 57.7974 349.464L52.9978 351.881L57.4908 348.933C58.6945 348.143 58.6945 346.378 57.4908 345.588L52.9978 342.64L57.7974 345.057C59.0833 345.705 60.6115 344.823 60.6937 343.385L61.0003 338.02Z",
    fill: "#53C888"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 338.02L125.066 343.385C125.148 344.823 126.677 345.705 127.962 345.057L132.762 342.64L128.269 345.588C127.065 346.378 127.065 348.143 128.269 348.933L132.762 351.881L127.962 349.464C126.677 348.816 125.148 349.699 125.066 351.136L124.76 356.501L124.453 351.136C124.371 349.699 122.843 348.816 121.557 349.464L116.757 351.881L121.25 348.933C122.454 348.143 122.454 346.378 121.25 345.588L116.757 342.64L121.557 345.057C122.843 345.705 124.371 344.823 124.453 343.385L124.76 338.02Z",
    fill: "#53C888"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1204 338.02L29.427 343.385C29.5091 344.823 31.0374 345.705 32.3233 345.057L37.1229 342.64L32.6299 345.588C31.4262 346.378 31.4262 348.143 32.6299 348.933L37.1229 351.881L32.3233 349.464C31.0374 348.816 29.5091 349.699 29.427 351.136L29.1204 356.501L28.8138 351.136C28.7317 349.699 27.2034 348.816 25.9175 349.464L21.1179 351.881L25.6109 348.933C26.8147 348.143 26.8147 346.378 25.6109 345.588L21.1179 342.64L25.9175 345.057C27.2034 345.705 28.7317 344.823 28.8138 343.385L29.1204 338.02Z",
    fill: "#53C888"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0003 301.52L61.3069 306.885C61.389 308.322 62.9173 309.205 64.2032 308.557L69.0028 306.14L64.5098 309.088C63.306 309.878 63.306 311.643 64.5098 312.432L69.0028 315.381L64.2032 312.964C62.9173 312.316 61.389 313.198 61.3069 314.636L61.0003 320.001L60.6937 314.636C60.6115 313.198 59.0833 312.316 57.7974 312.964L52.9978 315.381L57.4908 312.432C58.6945 311.643 58.6945 309.878 57.4908 309.088L52.9978 306.14L57.7974 308.557C59.0833 309.205 60.6115 308.322 60.6937 306.885L61.0003 301.52Z",
    fill: "#53C888"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0003 374.52L61.3069 379.885C61.389 381.322 62.9173 382.204 64.2032 381.557L69.0028 379.14L64.5098 382.088C63.306 382.878 63.306 384.642 64.5098 385.432L69.0028 388.38L64.2032 385.963C62.9173 385.316 61.389 386.198 61.3069 387.635L61.0003 393.001L60.6937 387.635C60.6115 386.198 59.0833 385.316 57.7974 385.963L52.9978 388.38L57.4908 385.432C58.6945 384.642 58.6945 382.878 57.4908 382.088L52.9978 379.14L57.7974 381.557C59.0833 382.204 60.6115 381.322 60.6937 379.885L61.0003 374.52Z",
    fill: "#53C888"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1204 411.019L29.427 416.384C29.5091 417.822 31.0374 418.704 32.3233 418.057L37.1229 415.64L32.6299 418.588C31.4262 419.377 31.4262 421.142 32.6299 421.932L37.1229 424.88L32.3233 422.463C31.0374 421.815 29.5091 422.698 29.427 424.135L29.1204 429.5L28.8138 424.135C28.7317 422.698 27.2034 421.815 25.9175 422.463L21.1179 424.88L25.6109 421.932C26.8147 421.142 26.8147 419.377 25.6109 418.588L21.1179 415.64L25.9175 418.057C27.2034 418.704 28.7317 417.822 28.8138 416.384L29.1204 411.019Z",
    fill: "#53C888"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.75948 411.019L-2.45288 416.384C-2.37073 417.822 -0.84247 418.704 0.443418 418.057L5.24305 415.64L0.750016 418.588C-0.453728 419.377 -0.453728 421.142 0.750016 421.932L5.24305 424.88L0.443418 422.463C-0.84247 421.815 -2.37073 422.698 -2.45288 424.135L-2.75948 429.5L-3.06608 424.135C-3.14822 422.698 -4.67648 421.815 -5.96237 422.463L-10.762 424.88L-6.26897 421.932C-5.06523 421.142 -5.06523 419.377 -6.26897 418.588L-10.762 415.64L-5.96237 418.057C-4.67648 418.704 -3.14822 417.822 -3.06608 416.384L-2.75948 411.019Z",
    fill: "#53C888"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 411.019L125.066 416.384C125.148 417.822 126.677 418.704 127.962 418.057L132.762 415.64L128.269 418.588C127.065 419.377 127.065 421.142 128.269 421.932L132.762 424.88L127.962 422.463C126.677 421.815 125.148 422.698 125.066 424.135L124.76 429.5L124.453 424.135C124.371 422.698 122.843 421.815 121.557 422.463L116.757 424.88L121.25 421.932C122.454 421.142 122.454 419.377 121.25 418.588L116.757 415.64L121.557 418.057C122.843 418.704 124.371 417.822 124.453 416.384L124.76 411.019Z",
    fill: "#53C888"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 411.019L93.1863 416.384C93.2684 417.822 94.7967 418.704 96.0826 418.057L100.882 415.64L96.3892 418.588C95.1854 419.377 95.1854 421.142 96.3892 421.932L100.882 424.88L96.0826 422.463C94.7967 421.815 93.2684 422.698 93.1863 424.135L92.8797 429.5L92.5731 424.135C92.4909 422.698 90.9627 421.815 89.6768 422.463L84.8772 424.88L89.3702 421.932C90.5739 421.142 90.5739 419.377 89.3702 418.588L84.8772 415.64L89.6768 418.057C90.9627 418.704 92.4909 417.822 92.5731 416.384L92.8797 411.019Z",
    fill: "#53C888"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0003 411.019L61.3069 416.384C61.389 417.822 62.9173 418.704 64.2032 418.057L69.0028 415.64L64.5098 418.588C63.306 419.377 63.306 421.142 64.5098 421.932L69.0028 424.88L64.2032 422.463C62.9173 421.815 61.389 422.698 61.3069 424.135L61.0003 429.5L60.6937 424.135C60.6115 422.698 59.0833 421.815 57.7974 422.463L52.9978 424.88L57.4908 421.932C58.6945 421.142 58.6945 419.377 57.4908 418.588L52.9978 415.64L57.7974 418.057C59.0833 418.704 60.6115 417.822 60.6937 416.384L61.0003 411.019Z",
    fill: "#53C888"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1204 447.52L29.427 452.885C29.5091 454.322 31.0374 455.204 32.3233 454.557L37.1229 452.14L32.6299 455.088C31.4262 455.878 31.4262 457.642 32.6299 458.432L37.1229 461.38L32.3233 458.963C31.0374 458.316 29.5091 459.198 29.427 460.635L29.1204 466.001L28.8138 460.635C28.7317 459.198 27.2034 458.316 25.9175 458.963L21.1179 461.38L25.6109 458.432C26.8147 457.642 26.8147 455.878 25.6109 455.088L21.1179 452.14L25.9175 454.557C27.2034 455.204 28.7317 454.322 28.8138 452.885L29.1204 447.52Z",
    fill: "#53C888"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.75948 447.52L-2.45288 452.885C-2.37073 454.322 -0.84247 455.204 0.443418 454.557L5.24305 452.14L0.750016 455.088C-0.453728 455.878 -0.453728 457.642 0.750016 458.432L5.24305 461.38L0.443418 458.963C-0.84247 458.316 -2.37073 459.198 -2.45288 460.635L-2.75948 466.001L-3.06608 460.635C-3.14822 459.198 -4.67648 458.316 -5.96237 458.963L-10.762 461.38L-6.26897 458.432C-5.06523 457.642 -5.06523 455.878 -6.26897 455.088L-10.762 452.14L-5.96237 454.557C-4.67648 455.204 -3.14822 454.322 -3.06608 452.885L-2.75948 447.52Z",
    fill: "#53C888"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M124.76 447.52L125.066 452.885C125.148 454.322 126.677 455.204 127.962 454.557L132.762 452.14L128.269 455.088C127.065 455.878 127.065 457.642 128.269 458.432L132.762 461.38L127.962 458.963C126.677 458.316 125.148 459.198 125.066 460.635L124.76 466.001L124.453 460.635C124.371 459.198 122.843 458.316 121.557 458.963L116.757 461.38L121.25 458.432C122.454 457.642 122.454 455.878 121.25 455.088L116.757 452.14L121.557 454.557C122.843 455.204 124.371 454.322 124.453 452.885L124.76 447.52Z",
    fill: "#53C888"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8797 447.52L93.1863 452.885C93.2684 454.322 94.7967 455.204 96.0826 454.557L100.882 452.14L96.3892 455.088C95.1854 455.878 95.1854 457.642 96.3892 458.432L100.882 461.38L96.0826 458.963C94.7967 458.316 93.2684 459.198 93.1863 460.635L92.8797 466.001L92.5731 460.635C92.4909 459.198 90.9627 458.316 89.6768 458.963L84.8772 461.38L89.3702 458.432C90.5739 457.642 90.5739 455.878 89.3702 455.088L84.8772 452.14L89.6768 454.557C90.9627 455.204 92.4909 454.322 92.5731 452.885L92.8797 447.52Z",
    fill: "#53C888"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0003 447.52L61.3069 452.885C61.389 454.322 62.9173 455.204 64.2032 454.557L69.0028 452.14L64.5098 455.088C63.306 455.878 63.306 457.642 64.5098 458.432L69.0028 461.38L64.2032 458.963C62.9173 458.316 61.389 459.198 61.3069 460.635L61.0003 466.001L60.6937 460.635C60.6115 459.198 59.0833 458.316 57.7974 458.963L52.9978 461.38L57.4908 458.432C58.6945 457.642 58.6945 455.878 57.4908 455.088L52.9978 452.14L57.7974 454.557C59.0833 455.204 60.6115 454.322 60.6937 452.885L61.0003 447.52Z",
    fill: "#53C888"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M261.5 22.5195C261.5 33.3691 251.855 42.5195 239.5 42.5195C227.145 42.5195 217.5 33.3691 217.5 22.5195C217.5 11.67 227.145 2.51953 239.5 2.51953C251.855 2.51953 261.5 11.67 261.5 22.5195Z",
    stroke: "#BEBEBE",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M385.867 207.037C386.023 151.277 308.107 105.856 211.837 105.588C115.567 105.319 37.3991 150.303 37.2434 206.064C37.0877 261.824 115.003 307.244 211.273 307.513C307.543 307.782 385.711 262.797 385.867 207.037Z",
    fill: "#98A4E0"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M389.822 179.722C389.982 122.696 310.298 76.2448 211.844 75.9699C113.39 75.6949 33.4476 121.7 33.2883 178.726C33.1291 235.752 112.813 282.203 211.267 282.478C309.721 282.753 389.663 236.748 389.822 179.722Z",
    fill: "#26272A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M389.822 168.215C389.982 111.189 310.298 64.7378 211.844 64.4628C113.39 64.1879 33.4476 110.193 33.2883 167.219C33.1291 224.245 112.813 270.696 211.267 270.971C309.721 271.246 389.663 225.24 389.822 168.215Z",
    fill: "#474848"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M305.604 112.257L200.804 75.6689V97.6183L289.738 148.964H302.003L328.49 133.515V128.26L305.604 112.257Z",
    fill: "#BDBDBD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M200.648 65.4488L297.702 121.486V143.899L200.648 87.8619V65.4488Z",
    fill: "#53C888"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M297.702 121.486L326.825 104.674V127.087L297.702 143.899V121.486Z",
    fill: "#439B6B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M221.197 39.7084L223.834 38.1809C224.534 37.7808 225.489 37.8353 226.553 38.4445L223.916 39.9721C222.852 39.3538 221.888 39.2992 221.197 39.7084Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 221,
    y: 37,
    width: 6,
    height: 3
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M221.197 39.7084L223.834 38.1809C224.534 37.7808 225.489 37.8353 226.553 38.4445L223.916 39.9721C222.852 39.3538 221.888 39.2992 221.197 39.7084Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.197 39.7077L223.834 38.1802C224.307 37.9074 224.898 37.8438 225.553 38.0165L222.916 39.5441C222.252 39.3713 221.661 39.435 221.197 39.7077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.916 39.5536L225.553 38.026C225.871 38.1079 226.208 38.2534 226.553 38.4534L223.916 39.9809C223.571 39.7809 223.234 39.6445 222.916 39.5536Z",
    fill: "white"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M223.916 39.9717L226.552 38.4441L331.671 99.1366L329.043 100.664L223.916 39.9717Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M334.372 108.202L331.735 109.73C332.426 109.33 332.844 108.484 332.854 107.275C332.854 104.847 331.153 101.883 329.035 100.664L331.671 99.1368C333.79 100.355 335.49 103.319 335.49 105.747C335.49 106.956 335.063 107.802 334.372 108.202Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 329,
    y: 99,
    width: 7,
    height: 11
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M334.372 108.202L331.735 109.73C332.426 109.33 332.844 108.484 332.854 107.275C332.854 104.847 331.153 101.883 329.035 100.664L331.671 99.1368C333.79 100.355 335.49 103.319 335.49 105.747C335.49 106.956 335.063 107.802 334.372 108.202Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.043 100.664L331.68 99.1368C331.78 99.1913 331.88 99.255 331.98 99.3277L329.343 100.855C329.243 100.792 329.143 100.728 329.043 100.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.343 100.855L331.98 99.3277C332.462 99.655 332.926 100.064 333.344 100.537L330.707 102.065C330.289 101.592 329.825 101.173 329.343 100.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.707 102.074L333.344 100.546C333.944 101.228 334.453 102.037 334.835 102.883L332.198 104.41C331.825 103.565 331.316 102.756 330.707 102.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.199 104.41L334.836 102.883C335.072 103.419 335.254 103.965 335.363 104.501L332.726 106.029C332.617 105.483 332.435 104.938 332.199 104.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.726 106.029L335.363 104.502C335.454 104.929 335.499 105.347 335.499 105.747C335.499 105.856 335.499 105.965 335.49 106.065L332.853 107.593C332.853 107.493 332.862 107.384 332.862 107.275C332.862 106.866 332.817 106.447 332.726 106.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.844 107.602L335.48 106.075C335.408 107.111 334.999 107.848 334.371 108.211L331.734 109.739C332.362 109.375 332.771 108.639 332.844 107.602Z",
    fill: "white"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M329.044 100.664C331.162 101.883 332.863 104.847 332.863 107.275C332.863 109.702 331.135 110.684 329.026 109.466L223.907 48.7734C221.789 47.555 220.088 44.5908 220.088 42.1631C220.088 39.7354 221.816 38.7534 223.925 39.9718L329.044 100.664Z",
    fill: "#E0E2EA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M223.034 41.672L198.685 55.82C199.276 55.4745 200.094 55.529 200.994 56.0473L225.344 41.8993C224.444 41.3811 223.625 41.3265 223.034 41.672Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 41,
    width: 28,
    height: 16
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M223.034 41.672L198.685 55.82C199.276 55.4745 200.094 55.529 200.994 56.0473L225.344 41.8993C224.444 41.3811 223.625 41.3265 223.034 41.672Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.994 56.0565L225.343 41.9086C224.771 41.5812 224.234 41.4358 223.761 41.463L199.412 55.611C199.884 55.5837 200.421 55.7201 200.994 56.0565Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.412 55.6117L223.762 41.4637C223.489 41.4819 223.243 41.5547 223.034 41.6819L198.685 55.8299C198.903 55.7026 199.148 55.6299 199.412 55.6117Z",
    fill: "#252529"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M304.022 115.54L328.372 101.383L225.345 41.8994L200.995 56.0565L304.022 115.54Z",
    fill: "#252529"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M306.312 124.214L330.662 110.066C331.244 109.73 331.608 109.002 331.608 107.984L307.258 122.132C307.258 123.159 306.894 123.878 306.312 124.214Z",
    fill: "#1A191D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 306,
    y: 107,
    width: 26,
    height: 18
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M306.312 124.214L330.662 110.066C331.244 109.73 331.608 109.002 331.608 107.984L307.258 122.132C307.258 123.159 306.894 123.878 306.312 124.214Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.312 124.214L330.662 110.066C331.244 109.73 331.608 109.002 331.608 107.984L307.258 122.132C307.258 123.159 306.894 123.878 306.312 124.214Z",
    fill: "#1A191D"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M307.257 122.132L331.607 107.975L331.616 107.002L307.266 121.15L307.257 122.132Z",
    fill: "#1A191D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M307.267 121.15L331.617 107.002C331.617 104.938 330.171 102.429 328.38 101.392L304.03 115.54C305.821 116.577 307.276 119.086 307.267 121.15Z",
    fill: "#1A191D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 304,
    y: 101,
    width: 28,
    height: 21
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M307.267 121.15L331.617 107.002C331.617 104.938 330.171 102.429 328.38 101.392L304.03 115.54C305.821 116.577 307.276 119.086 307.267 121.15Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.267 121.15L331.617 107.002C331.617 106.329 331.463 105.611 331.199 104.901L306.849 119.049C307.122 119.749 307.276 120.477 307.267 121.15Z",
    fill: "#1A191D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84 119.049L331.19 104.901C331.008 104.42 330.762 103.947 330.481 103.501L306.131 117.649C306.413 118.095 306.658 118.567 306.84 119.049Z",
    fill: "#1A191D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.131 117.649L330.481 103.501C329.917 102.61 329.18 101.856 328.371 101.383L304.021 115.531C304.831 115.994 305.567 116.758 306.131 117.649Z",
    fill: "#1A191D"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M193.939 55.7839L196.576 54.2563C197.276 53.8563 198.24 53.9108 199.304 54.52L196.667 56.0476C195.603 55.4293 194.639 55.3747 193.939 55.7839Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 54,
    width: 7,
    height: 3
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M193.939 55.7839L196.576 54.2563C197.276 53.8563 198.24 53.9108 199.304 54.52L196.667 56.0476C195.603 55.4293 194.639 55.3747 193.939 55.7839Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.939 55.7836L196.576 54.256C197.049 53.9833 197.64 53.9196 198.294 54.0924L195.657 55.6199C194.994 55.4472 194.403 55.5017 193.939 55.7836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.657 55.6292L198.294 54.1017C198.612 54.1835 198.948 54.329 199.294 54.529L196.657 56.0565C196.311 55.8565 195.975 55.7201 195.657 55.6292Z",
    fill: "white"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M196.657 56.057L199.294 54.5203L304.413 115.213L301.785 116.749L196.657 56.057Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M307.113 124.278L304.476 125.805C305.167 125.405 305.585 124.56 305.594 123.35C305.594 120.923 303.894 117.959 301.775 116.74L304.412 115.213C306.531 116.431 308.231 119.395 308.231 121.823C308.231 123.032 307.804 123.878 307.113 124.278Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 301,
    y: 115,
    width: 8,
    height: 11
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M307.113 124.278L304.476 125.805C305.167 125.405 305.585 124.56 305.594 123.35C305.594 120.923 303.894 117.959 301.775 116.74L304.412 115.213C306.531 116.431 308.231 119.395 308.231 121.823C308.231 123.032 307.804 123.878 307.113 124.278Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.786 116.749L304.422 115.222C304.522 115.276 304.622 115.34 304.723 115.413L302.086 116.94C301.986 116.877 301.886 116.813 301.786 116.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.085 116.931L304.722 115.404C305.204 115.731 305.667 116.14 306.086 116.622L303.449 118.15C303.031 117.677 302.567 117.259 302.085 116.931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.449 118.15L306.086 116.622C306.686 117.304 307.195 118.113 307.568 118.959L304.931 120.486C304.559 119.641 304.049 118.832 303.449 118.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.941 120.486L307.578 118.959C307.814 119.495 307.996 120.041 308.105 120.577L305.468 122.105C305.359 121.568 305.177 121.014 304.941 120.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.467 122.105L308.104 120.578C308.195 121.005 308.24 121.423 308.24 121.823C308.24 121.932 308.24 122.042 308.231 122.142L305.594 123.669C305.594 123.569 305.603 123.46 305.603 123.351C305.603 122.951 305.558 122.523 305.467 122.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.584 123.669L308.221 122.141C308.148 123.178 307.739 123.914 307.112 124.278L304.475 125.805C305.102 125.442 305.512 124.705 305.584 123.669Z",
    fill: "white"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M301.785 116.749C303.903 117.968 305.603 120.932 305.603 123.36C305.603 125.787 303.876 126.769 301.766 125.551L196.648 64.8584C194.529 63.64 192.829 60.6758 192.829 58.2481C192.829 55.8204 194.557 54.8384 196.666 56.0568L301.785 116.749Z",
    fill: "#E0E2EA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M299.367 118.949L300.203 118.458C300.585 118.24 301.122 118.268 301.703 118.604L300.867 119.095C300.285 118.759 299.749 118.722 299.367 118.949Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 299,
    y: 118,
    width: 3,
    height: 2
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M299.367 118.949L300.203 118.458C300.585 118.24 301.122 118.268 301.703 118.604L300.867 119.095C300.285 118.759 299.749 118.722 299.367 118.949Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.367 118.95L300.204 118.459C300.386 118.349 300.604 118.304 300.849 118.322L300.013 118.813C299.767 118.795 299.549 118.841 299.367 118.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.012 118.813L300.849 118.322C300.985 118.331 301.14 118.368 301.294 118.422L300.457 118.913C300.303 118.859 300.157 118.832 300.012 118.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.458 118.904L301.294 118.413C301.431 118.458 301.567 118.522 301.704 118.604L300.867 119.095C300.73 119.013 300.594 118.95 300.458 118.904Z",
    fill: "white"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M303.184 123.605L302.348 124.096C302.73 123.878 302.957 123.405 302.966 122.741C302.966 121.405 302.03 119.777 300.866 119.104L301.702 118.613C302.866 119.286 303.812 120.914 303.803 122.25C303.803 122.914 303.566 123.387 303.184 123.605Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 300,
    y: 118,
    width: 4,
    height: 7
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M303.184 123.605L302.348 124.096C302.73 123.878 302.957 123.405 302.966 122.741C302.966 121.405 302.03 119.777 300.866 119.104L301.702 118.613C302.866 119.286 303.812 120.914 303.803 122.25C303.803 122.914 303.566 123.387 303.184 123.605Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.866 119.095L301.703 118.604C301.703 118.604 301.721 118.604 301.721 118.613L300.884 119.104C300.884 119.104 300.866 119.104 300.866 119.095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.885 119.114L301.722 118.622C301.876 118.713 302.031 118.822 302.177 118.95L301.34 119.441C301.194 119.314 301.039 119.205 300.885 119.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.339 119.432L302.176 118.94C302.331 119.068 302.476 119.222 302.622 119.377L301.785 119.868C301.649 119.705 301.494 119.559 301.339 119.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.786 119.877L302.623 119.386C302.95 119.759 303.232 120.205 303.441 120.669L302.604 121.16C302.395 120.696 302.122 120.25 301.786 119.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.603 121.159L303.439 120.668C303.512 120.841 303.585 121.013 303.64 121.195L302.803 121.687C302.748 121.514 302.684 121.332 302.603 121.159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.793 121.678L303.63 121.186C303.685 121.368 303.73 121.559 303.758 121.741L302.921 122.232C302.894 122.05 302.848 121.869 302.793 121.678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.921 122.232L303.758 121.741C303.785 121.914 303.803 122.087 303.794 122.25L302.957 122.742C302.957 122.578 302.948 122.405 302.921 122.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.967 122.741L303.804 122.25C303.804 122.432 303.786 122.605 303.75 122.76L302.913 123.251C302.949 123.096 302.967 122.933 302.967 122.741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.913 123.25L303.75 122.759C303.659 123.15 303.459 123.441 303.186 123.596L302.349 124.087C302.622 123.933 302.822 123.642 302.913 123.25Z",
    fill: "white"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M300.866 119.095C302.03 119.768 302.975 121.395 302.966 122.732C302.966 124.069 302.02 124.614 300.848 123.941C299.684 123.268 298.738 121.641 298.747 120.304C298.747 118.968 299.693 118.422 300.866 119.095Z",
    fill: "#252529"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M299.357 120.168L299.903 119.85C300.148 119.704 300.503 119.722 300.885 119.95L300.339 120.268C299.957 120.05 299.612 120.023 299.357 120.168Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 299,
    y: 119,
    width: 2,
    height: 2
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M299.357 120.168L299.903 119.85C300.148 119.704 300.503 119.722 300.885 119.95L300.339 120.268C299.957 120.05 299.612 120.023 299.357 120.168Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.357 120.168L299.903 119.85C300.021 119.777 300.167 119.75 300.321 119.759L299.775 120.077C299.621 120.068 299.475 120.096 299.357 120.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.785 120.077L300.33 119.759C300.421 119.759 300.522 119.786 300.622 119.822L300.076 120.141C299.976 120.104 299.876 120.086 299.785 120.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.075 120.141L300.621 119.822C300.703 119.849 300.794 119.895 300.885 119.949L300.339 120.268C300.248 120.213 300.157 120.177 300.075 120.141Z",
    fill: "white"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M301.857 123.205L301.312 123.523C301.557 123.378 301.712 123.078 301.712 122.641C301.712 121.768 301.103 120.704 300.339 120.268L300.884 119.95C301.648 120.386 302.257 121.45 302.257 122.323C302.257 122.759 302.103 123.059 301.857 123.205Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 300,
    y: 119,
    width: 3,
    height: 5
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M301.857 123.205L301.312 123.523C301.557 123.378 301.712 123.078 301.712 122.641C301.712 121.768 301.103 120.704 300.339 120.268L300.884 119.95C301.648 120.386 302.257 121.45 302.257 122.323C302.257 122.759 302.103 123.059 301.857 123.205Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.339 120.259L300.885 119.941C300.885 119.941 300.885 119.941 300.894 119.941L300.348 120.259C300.348 120.259 300.348 120.259 300.339 120.259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.348 120.269L300.893 119.95C300.994 120.014 301.094 120.077 301.194 120.159L300.648 120.478C300.548 120.396 300.448 120.323 300.348 120.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.647 120.486L301.193 120.168C301.293 120.25 301.393 120.35 301.484 120.45L300.939 120.768C300.848 120.668 300.748 120.568 300.647 120.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.938 120.768L301.484 120.45C301.703 120.695 301.885 120.987 302.021 121.287L301.475 121.605C301.339 121.305 301.157 121.014 300.938 120.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.467 121.605L302.013 121.286C302.058 121.396 302.104 121.514 302.14 121.632L301.594 121.95C301.558 121.832 301.512 121.723 301.467 121.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.593 121.95L302.139 121.632C302.175 121.75 302.203 121.868 302.221 121.986L301.675 122.305C301.657 122.187 301.63 122.068 301.593 121.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.685 122.305L302.231 121.986C302.249 122.096 302.258 122.214 302.258 122.314L301.712 122.632C301.712 122.523 301.712 122.405 301.685 122.296V122.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.712 122.641L302.257 122.323C302.257 122.441 302.248 122.55 302.221 122.65L301.675 122.969C301.703 122.869 301.712 122.76 301.712 122.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.675 122.969L302.221 122.65C302.167 122.905 302.03 123.096 301.857 123.196L301.312 123.514C301.493 123.414 301.621 123.223 301.675 122.969Z",
    fill: "white"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M300.339 120.259C301.103 120.695 301.712 121.759 301.712 122.632C301.712 123.505 301.094 123.86 300.33 123.414C299.566 122.978 298.957 121.914 298.957 121.041C298.957 120.168 299.575 119.813 300.339 120.259Z",
    fill: "#252529"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M282.363 108.948L283.199 108.457C283.581 108.238 284.118 108.266 284.7 108.602L283.863 109.093C283.281 108.757 282.745 108.72 282.363 108.948Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 282,
    y: 108,
    width: 3,
    height: 2
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M282.363 108.948L283.199 108.457C283.581 108.238 284.118 108.266 284.7 108.602L283.863 109.093C283.281 108.757 282.745 108.72 282.363 108.948Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.363 108.948L283.2 108.457C283.382 108.348 283.6 108.302 283.846 108.32L283.009 108.811C282.763 108.793 282.545 108.839 282.363 108.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.009 108.811L283.846 108.32C283.983 108.329 284.137 108.366 284.292 108.42L283.455 108.911C283.3 108.857 283.155 108.83 283.009 108.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.455 108.903L284.292 108.411C284.428 108.457 284.565 108.521 284.701 108.602L283.864 109.094C283.728 109.012 283.592 108.948 283.455 108.903Z",
    fill: "white"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M286.192 113.603L285.355 114.094C285.737 113.876 285.964 113.403 285.973 112.739C285.973 111.403 285.037 109.775 283.873 109.102L284.71 108.611C285.873 109.284 286.819 110.912 286.81 112.248C286.81 112.912 286.574 113.385 286.192 113.603Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 283,
    y: 108,
    width: 4,
    height: 7
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M286.192 113.603L285.355 114.094C285.737 113.876 285.964 113.403 285.973 112.739C285.973 111.403 285.037 109.775 283.873 109.102L284.71 108.611C285.873 109.284 286.819 110.912 286.81 112.248C286.81 112.912 286.574 113.385 286.192 113.603Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.863 109.093L284.7 108.602C284.7 108.602 284.718 108.602 284.718 108.611L283.881 109.102C283.881 109.102 283.863 109.102 283.863 109.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.882 109.112L284.719 108.621C284.873 108.711 285.028 108.821 285.174 108.948L284.337 109.439C284.191 109.312 284.036 109.203 283.882 109.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.345 109.43L285.182 108.939C285.337 109.066 285.482 109.221 285.628 109.375L284.791 109.867C284.654 109.703 284.5 109.557 284.345 109.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.782 109.875L285.619 109.384C285.946 109.757 286.228 110.203 286.437 110.667L285.6 111.158C285.391 110.694 285.118 110.248 284.782 109.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.601 111.157L286.438 110.666C286.51 110.839 286.583 111.012 286.638 111.194L285.801 111.685C285.746 111.512 285.682 111.33 285.601 111.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.801 111.676L286.638 111.184C286.692 111.366 286.738 111.557 286.765 111.739L285.928 112.231C285.901 112.049 285.855 111.867 285.801 111.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.927 112.23L286.764 111.739C286.791 111.912 286.809 112.085 286.8 112.248L285.963 112.74C285.963 112.567 285.954 112.394 285.927 112.221V112.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.964 112.74L286.801 112.248C286.801 112.43 286.782 112.603 286.746 112.758L285.909 113.249C285.946 113.094 285.964 112.931 285.964 112.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.91 113.249L286.747 112.757C286.656 113.149 286.456 113.44 286.183 113.594L285.346 114.086C285.619 113.931 285.819 113.64 285.91 113.249Z",
    fill: "white"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M283.864 109.093C285.028 109.766 285.973 111.394 285.964 112.73C285.964 114.067 285.018 114.612 283.846 113.94C282.682 113.267 281.736 111.639 281.745 110.303C281.745 108.966 282.691 108.42 283.864 109.093Z",
    fill: "#252529"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M282.363 110.166L282.909 109.848C283.154 109.702 283.509 109.721 283.891 109.948L283.345 110.266C282.963 110.048 282.618 110.021 282.363 110.166Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 282,
    y: 109,
    width: 2,
    height: 2
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M282.363 110.166L282.909 109.848C283.154 109.702 283.509 109.721 283.891 109.948L283.345 110.266C282.963 110.048 282.618 110.021 282.363 110.166Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.363 110.167L282.909 109.848C283.027 109.776 283.172 109.748 283.327 109.757L282.781 110.076C282.627 110.067 282.481 110.094 282.363 110.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.783 110.075L283.328 109.757C283.419 109.757 283.52 109.784 283.62 109.821L283.074 110.139C282.974 110.103 282.874 110.085 282.783 110.075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.074 110.139L283.62 109.821C283.701 109.848 283.792 109.893 283.883 109.948L283.338 110.266C283.247 110.212 283.156 110.175 283.074 110.139Z",
    fill: "white"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M284.855 113.203L284.31 113.521C284.555 113.376 284.71 113.076 284.71 112.639C284.71 111.766 284.101 110.703 283.337 110.266L283.882 109.948C284.646 110.384 285.255 111.448 285.255 112.321C285.255 112.758 285.101 113.058 284.855 113.203Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 283,
    y: 109,
    width: 3,
    height: 5
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M284.855 113.203L284.31 113.521C284.555 113.376 284.71 113.076 284.71 112.639C284.71 111.766 284.101 110.703 283.337 110.266L283.882 109.948C284.646 110.384 285.255 111.448 285.255 112.321C285.255 112.758 285.101 113.058 284.855 113.203Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.337 110.257L283.883 109.939C283.883 109.939 283.883 109.939 283.892 109.939L283.346 110.257C283.346 110.257 283.346 110.257 283.337 110.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.354 110.266L283.9 109.948C284 110.012 284.1 110.084 284.2 110.157L283.654 110.475C283.554 110.394 283.463 110.321 283.354 110.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.654 110.484L284.2 110.166C284.3 110.248 284.4 110.348 284.491 110.448L283.945 110.767C283.854 110.666 283.754 110.566 283.654 110.484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.936 110.766L284.482 110.448C284.7 110.694 284.882 110.985 285.019 111.285L284.473 111.603C284.336 111.303 284.154 111.012 283.936 110.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.473 111.603L285.019 111.284C285.064 111.394 285.11 111.512 285.146 111.63L284.601 111.949C284.564 111.83 284.519 111.721 284.473 111.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.601 111.948L285.147 111.63C285.183 111.748 285.211 111.866 285.229 111.985L284.683 112.303C284.665 112.185 284.637 112.066 284.601 111.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.682 112.303L285.227 111.985C285.246 112.094 285.255 112.212 285.255 112.312L284.709 112.63C284.709 112.521 284.709 112.412 284.682 112.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.709 112.639L285.255 112.321C285.255 112.439 285.245 112.548 285.218 112.648L284.672 112.967C284.7 112.867 284.709 112.758 284.709 112.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.673 112.967L285.219 112.648C285.165 112.903 285.028 113.094 284.855 113.194L284.31 113.513C284.492 113.413 284.619 113.222 284.673 112.967Z",
    fill: "white"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M283.336 110.257C284.1 110.694 284.709 111.758 284.709 112.63C284.709 113.503 284.091 113.858 283.327 113.412C282.563 112.976 281.954 111.912 281.954 111.039C281.954 110.166 282.572 109.812 283.336 110.257Z",
    fill: "#252529"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M264.778 98.7368L265.615 98.2459C265.997 98.0276 266.533 98.0549 267.115 98.3913L266.279 98.8823C265.697 98.5459 265.16 98.5095 264.778 98.7368Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 264,
    y: 98,
    width: 4,
    height: 1
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M264.778 98.7368L265.615 98.2459C265.997 98.0276 266.533 98.0549 267.115 98.3913L266.279 98.8823C265.697 98.5459 265.16 98.5095 264.778 98.7368Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.778 98.7375L265.615 98.2463C265.797 98.1372 266.015 98.0917 266.261 98.1099L265.424 98.6011C265.179 98.5829 264.96 98.6284 264.778 98.7375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.423 98.5917L266.26 98.1004C266.397 98.1095 266.551 98.1459 266.706 98.2005L265.869 98.6917C265.714 98.6372 265.569 98.6099 265.423 98.5917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.87 98.6917L266.707 98.2005C266.843 98.246 266.979 98.3097 267.116 98.3916L266.279 98.8828C266.143 98.8009 266.006 98.7372 265.87 98.6917Z",
    fill: "white"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M268.606 103.383L267.77 103.874C268.152 103.656 268.379 103.183 268.388 102.52C268.388 101.183 267.451 99.5554 266.288 98.8826L267.124 98.3916C268.288 99.0644 269.234 100.692 269.224 102.029C269.224 102.692 268.988 103.165 268.606 103.383Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 98,
    width: 4,
    height: 6
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M268.606 103.383L267.77 103.874C268.152 103.656 268.379 103.183 268.388 102.52C268.388 101.183 267.451 99.5554 266.288 98.8826L267.124 98.3916C268.288 99.0644 269.234 100.692 269.224 102.029C269.224 102.692 268.988 103.165 268.606 103.383Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.278 98.8828L267.115 98.3916C267.115 98.3916 267.133 98.3916 267.133 98.4007L266.296 98.8919C266.296 98.8919 266.278 98.8919 266.278 98.8828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.297 98.8919L267.134 98.4006C267.289 98.4916 267.444 98.6008 267.589 98.7281L266.752 99.2193C266.607 99.092 266.452 98.9828 266.297 98.8919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.76 99.2192L267.597 98.728C267.751 98.8553 267.897 99.01 268.042 99.1646L267.206 99.6558C267.069 99.4921 266.914 99.3465 266.76 99.2192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.197 99.6556L268.034 99.1644C268.361 99.5373 268.643 99.9831 268.852 100.447L268.015 100.938C267.806 100.474 267.533 100.029 267.197 99.6556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.014 100.938L268.851 100.446C268.924 100.619 268.997 100.792 269.051 100.974L268.214 101.465C268.16 101.292 268.096 101.11 268.014 100.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.215 101.465L269.052 100.974C269.107 101.156 269.152 101.347 269.18 101.529L268.343 102.02C268.315 101.838 268.27 101.656 268.215 101.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.342 102.01L269.179 101.519C269.206 101.692 269.224 101.865 269.215 102.029L268.378 102.52C268.378 102.356 268.369 102.183 268.342 102.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.379 102.529L269.216 102.037C269.216 102.219 269.198 102.392 269.162 102.547L268.325 103.038C268.361 102.884 268.379 102.72 268.379 102.529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.324 103.038L269.161 102.547C269.07 102.938 268.87 103.229 268.597 103.384L267.76 103.875C268.033 103.72 268.233 103.429 268.324 103.038Z",
    fill: "white"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M266.278 98.8826C267.442 99.5555 268.387 101.183 268.378 102.52C268.378 103.856 267.433 104.402 266.26 103.729C265.096 103.056 264.15 101.429 264.159 100.092C264.159 98.7553 265.105 98.2098 266.278 98.8826Z",
    fill: "#252529"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M264.778 99.9462L265.324 99.6279C265.57 99.4823 265.925 99.5005 266.307 99.7279L265.761 100.046C265.379 99.828 265.033 99.8007 264.778 99.9462Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 264,
    y: 99,
    width: 3,
    height: 2
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M264.778 99.9462L265.324 99.6279C265.57 99.4823 265.925 99.5005 266.307 99.7279L265.761 100.046C265.379 99.828 265.033 99.8007 264.778 99.9462Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.778 99.9463L265.324 99.6279C265.442 99.5552 265.588 99.5279 265.743 99.537L265.197 99.8554C265.042 99.8463 264.897 99.8735 264.778 99.9463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.197 99.8554L265.743 99.537C265.834 99.537 265.934 99.5643 266.034 99.6007L265.488 99.9191C265.388 99.8827 265.288 99.8645 265.197 99.8554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.487 99.9188L266.033 99.6004C266.115 99.6277 266.206 99.6732 266.297 99.7277L265.751 100.046C265.66 99.9915 265.569 99.9552 265.487 99.9188Z",
    fill: "white"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M267.269 102.983L266.723 103.301C266.969 103.156 267.123 102.856 267.123 102.419C267.123 101.546 266.514 100.483 265.75 100.046L266.296 99.7279C267.06 100.164 267.669 101.228 267.669 102.101C267.669 102.537 267.514 102.838 267.269 102.983Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 265,
    y: 99,
    width: 3,
    height: 5
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M267.269 102.983L266.723 103.301C266.969 103.156 267.123 102.856 267.123 102.419C267.123 101.546 266.514 100.483 265.75 100.046L266.296 99.7279C267.06 100.164 267.669 101.228 267.669 102.101C267.669 102.537 267.514 102.838 267.269 102.983Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.75 100.046L266.296 99.7279C266.296 99.7279 266.296 99.7279 266.305 99.7279L265.76 100.046C265.76 100.046 265.76 100.046 265.75 100.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.769 100.055L266.315 99.737C266.415 99.8007 266.515 99.8644 266.615 99.9463L266.069 100.265C265.969 100.183 265.869 100.11 265.769 100.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.07 100.265L266.616 99.9464C266.716 100.028 266.816 100.128 266.907 100.228L266.361 100.547C266.27 100.447 266.17 100.347 266.07 100.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.36 100.555L266.906 100.237C267.124 100.482 267.306 100.774 267.442 101.074L266.897 101.392C266.76 101.092 266.578 100.801 266.36 100.555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.888 101.392L267.434 101.074C267.479 101.183 267.524 101.301 267.561 101.419L267.015 101.738C266.979 101.619 266.933 101.51 266.888 101.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.015 101.728L267.56 101.41C267.597 101.528 267.624 101.647 267.642 101.765L267.097 102.083C267.078 101.965 267.051 101.847 267.015 101.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.097 102.092L267.643 101.774C267.661 101.883 267.67 102.001 267.67 102.101L267.124 102.42C267.124 102.31 267.124 102.192 267.097 102.083V102.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.125 102.428L267.671 102.11C267.671 102.228 267.661 102.337 267.634 102.438L267.088 102.756C267.116 102.656 267.125 102.547 267.125 102.428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.087 102.756L267.633 102.438C267.578 102.692 267.442 102.883 267.269 102.983L266.723 103.302C266.905 103.202 267.032 103.011 267.087 102.756Z",
    fill: "white"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M265.752 100.046C266.515 100.483 267.125 101.547 267.125 102.419C267.125 103.292 266.506 103.647 265.743 103.201C264.979 102.765 264.37 101.701 264.37 100.828C264.37 99.9554 264.988 99.6008 265.752 100.046Z",
    fill: "#252529"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M246.738 88.335L247.575 87.844C247.957 87.6258 248.493 87.6531 249.075 87.9895L248.239 88.4805C247.657 88.1441 247.12 88.1077 246.738 88.335Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 246,
    y: 87,
    width: 4,
    height: 2
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M246.738 88.335L247.575 87.844C247.957 87.6258 248.493 87.6531 249.075 87.9895L248.239 88.4805C247.657 88.1441 247.12 88.1077 246.738 88.335Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.738 88.3353L247.575 87.8441C247.757 87.7349 247.975 87.6894 248.221 87.7076L247.384 88.1988C247.139 88.1807 246.92 88.2261 246.738 88.3353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.385 88.1988L248.222 87.7076C248.358 87.7167 248.513 87.7531 248.667 87.8077L247.831 88.2989C247.676 88.2443 247.53 88.217 247.385 88.1988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.831 88.2989L248.667 87.8077C248.804 87.8532 248.94 87.9168 249.077 87.9987L248.24 88.4899C248.103 88.4081 247.967 88.3444 247.831 88.2989Z",
    fill: "white"
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M250.558 92.9905L249.721 93.4815C250.103 93.2633 250.331 92.7905 250.34 92.1267C250.34 90.7901 249.403 89.1626 248.239 88.4897L249.076 87.9987C250.24 88.6716 251.185 90.2991 251.176 91.6357C251.176 92.2995 250.94 92.7723 250.558 92.9905Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 248,
    y: 87,
    width: 4,
    height: 7
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M250.558 92.9905L249.721 93.4815C250.103 93.2633 250.331 92.7905 250.34 92.1267C250.34 90.7901 249.403 89.1626 248.239 88.4897L249.076 87.9987C250.24 88.6716 251.185 90.2991 251.176 91.6357C251.176 92.2995 250.94 92.7723 250.558 92.9905Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.239 88.4899L249.076 87.9987C249.076 87.9987 249.094 87.9987 249.094 88.0078L248.257 88.499C248.257 88.499 248.239 88.499 248.239 88.4899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.256 88.499L249.093 88.0078C249.248 88.0987 249.403 88.2079 249.548 88.3352L248.711 88.8265C248.566 88.6991 248.411 88.59 248.256 88.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.712 88.8262L249.549 88.335C249.703 88.4623 249.849 88.617 249.995 88.7716L249.158 89.2629C249.021 89.0991 248.867 88.9536 248.712 88.8262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.158 89.2627L249.995 88.7715C250.323 89.1445 250.605 89.5902 250.814 90.0541L249.977 90.5454C249.768 90.0814 249.495 89.6357 249.158 89.2627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.976 90.5448L250.813 90.0536C250.885 90.2264 250.958 90.3992 251.013 90.5812L250.176 91.0724C250.121 90.8996 250.057 90.7176 249.976 90.5448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.167 91.0628L251.004 90.5716C251.058 90.7535 251.104 90.9446 251.131 91.1265L250.294 91.6177C250.267 91.4358 250.222 91.2538 250.167 91.0628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.295 91.6176L251.132 91.1264C251.159 91.2992 251.177 91.4721 251.168 91.6358L250.331 92.127C250.331 91.9633 250.322 91.7904 250.295 91.6176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.341 92.1359L251.178 91.6446C251.178 91.8266 251.159 91.9994 251.123 92.1541L250.286 92.6453C250.323 92.4906 250.341 92.3269 250.341 92.1359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.284 92.6361L251.121 92.1449C251.03 92.5361 250.83 92.8272 250.557 92.9818L249.72 93.473C249.993 93.3184 250.193 93.0273 250.284 92.6361Z",
    fill: "white"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M248.239 88.4899C249.403 89.1627 250.348 90.7903 250.339 92.1269C250.339 93.4635 249.393 94.009 248.221 93.3362C247.057 92.6633 246.111 91.0358 246.12 89.6992C246.12 88.3626 247.066 87.817 248.239 88.4899Z",
    fill: "#252529"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M246.729 89.5536L247.275 89.2352C247.521 89.0897 247.876 89.1079 248.258 89.3353L247.712 89.6537C247.33 89.4354 246.984 89.4081 246.729 89.5536Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 246,
    y: 89,
    width: 3,
    height: 1
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M246.729 89.5536L247.275 89.2352C247.521 89.0897 247.876 89.1079 248.258 89.3353L247.712 89.6537C247.33 89.4354 246.984 89.4081 246.729 89.5536Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.729 89.5537L247.275 89.2353C247.394 89.1625 247.539 89.1353 247.694 89.1444L247.148 89.4627C246.993 89.4536 246.848 89.4809 246.729 89.5537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.158 89.4627L247.704 89.1443C247.794 89.1443 247.895 89.1716 247.995 89.2079L247.449 89.5263C247.349 89.4899 247.249 89.4717 247.158 89.4627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.448 89.5262L247.994 89.2078C248.076 89.2351 248.167 89.2806 248.258 89.3352L247.712 89.6535C247.621 89.599 247.53 89.5626 247.448 89.5262Z",
    fill: "white"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M249.23 92.5902L248.684 92.9084C248.93 92.7629 249.084 92.4629 249.084 92.0264C249.084 91.1536 248.475 90.0897 247.711 89.6533L248.257 89.3351C249.021 89.7715 249.63 90.8353 249.63 91.7082C249.63 92.1446 249.475 92.4447 249.23 92.5902Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 247,
    y: 89,
    width: 3,
    height: 4
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M249.23 92.5902L248.684 92.9084C248.93 92.7629 249.084 92.4629 249.084 92.0264C249.084 91.1536 248.475 90.0897 247.711 89.6533L248.257 89.3351C249.021 89.7715 249.63 90.8353 249.63 91.7082C249.63 92.1446 249.475 92.4447 249.23 92.5902Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.711 89.6534L248.257 89.3351C248.257 89.3351 248.257 89.3351 248.266 89.3351L247.721 89.6534H247.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.721 89.6627L248.267 89.3443C248.367 89.408 248.467 89.4808 248.567 89.5535L248.021 89.8719C247.921 89.79 247.83 89.7173 247.721 89.6627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.02 89.872L248.565 89.5536C248.665 89.6354 248.765 89.7355 248.856 89.8356L248.311 90.154C248.22 90.0539 248.12 89.9538 248.02 89.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.312 90.1537L248.857 89.8354C249.076 90.081 249.258 90.3721 249.394 90.6723L248.848 90.9907C248.712 90.6905 248.53 90.3993 248.312 90.1537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.848 90.9901L249.394 90.6717C249.439 90.7809 249.485 90.8991 249.521 91.0174L248.975 91.3358C248.939 91.2175 248.894 91.1084 248.848 90.9901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.975 91.3357L249.521 91.0174C249.557 91.1356 249.585 91.2539 249.603 91.3721L249.057 91.6905C249.039 91.5723 249.011 91.454 248.975 91.3357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.057 91.6905L249.603 91.3721C249.621 91.4813 249.63 91.5995 249.63 91.6996L249.084 92.018C249.084 91.9088 249.084 91.7997 249.057 91.6905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.085 92.0266L249.631 91.7082C249.631 91.8265 249.622 91.9356 249.595 92.0357L249.049 92.3541C249.076 92.254 249.085 92.1448 249.085 92.0266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.048 92.3631L249.594 92.0447C249.539 92.2995 249.403 92.4905 249.23 92.5906L248.684 92.909C248.866 92.8089 248.993 92.6178 249.048 92.3631Z",
    fill: "white"
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M247.711 89.6536C248.475 90.09 249.084 91.1538 249.084 92.0267C249.084 92.8996 248.466 93.2542 247.702 92.8087C246.938 92.3722 246.329 91.3084 246.329 90.4355C246.329 89.5626 246.947 89.208 247.711 89.6536Z",
    fill: "#252529"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M229.427 78.4239L230.263 77.9329C230.645 77.7147 231.182 77.742 231.764 78.0784L230.927 78.5694C230.345 78.233 229.809 78.1966 229.427 78.4239Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 77,
    width: 3,
    height: 2
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M229.427 78.4239L230.263 77.9329C230.645 77.7147 231.182 77.742 231.764 78.0784L230.927 78.5694C230.345 78.233 229.809 78.1966 229.427 78.4239Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.427 78.4242L230.264 77.933C230.446 77.8238 230.664 77.7783 230.91 77.7965L230.073 78.2878C229.827 78.2696 229.609 78.3151 229.427 78.4242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.073 78.2881L230.91 77.7969C231.046 77.806 231.201 77.8424 231.355 77.897L230.519 78.3882C230.364 78.3336 230.218 78.3063 230.073 78.2881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.518 78.3791L231.354 77.8879C231.491 77.9334 231.627 77.997 231.764 78.0789L230.927 78.5701C230.79 78.4883 230.654 78.4246 230.518 78.3791Z",
    fill: "white"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M233.245 83.0799L232.409 83.5709C232.791 83.3527 233.018 82.8798 233.027 82.2161C233.027 80.8795 232.091 79.2519 230.927 78.5791L231.763 78.0881C232.927 78.7609 233.873 80.3885 233.864 81.7251C233.864 82.3889 233.627 82.8617 233.245 83.0799Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 230,
    y: 78,
    width: 4,
    height: 6
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M233.245 83.0799L232.409 83.5709C232.791 83.3527 233.018 82.8798 233.027 82.2161C233.027 80.8795 232.091 79.2519 230.927 78.5791L231.763 78.0881C232.927 78.7609 233.873 80.3885 233.864 81.7251C233.864 82.3889 233.627 82.8617 233.245 83.0799Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.927 78.5699L231.764 78.0787C231.764 78.0787 231.782 78.0787 231.782 78.0878L230.945 78.579C230.945 78.579 230.927 78.579 230.927 78.5699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.944 78.5794L231.781 78.0882C231.936 78.1791 232.091 78.2883 232.236 78.4156L231.399 78.9069C231.254 78.7795 231.099 78.6703 230.944 78.5794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.399 78.9067L232.236 78.4155C232.391 78.5428 232.537 78.6975 232.682 78.8521L231.845 79.3433C231.709 79.1796 231.554 79.0341 231.399 78.9067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.845 79.343L232.682 78.8518C233.009 79.2247 233.291 79.6705 233.5 80.1344L232.663 80.6256C232.454 80.1617 232.181 79.7159 231.845 79.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.664 80.6247L233.501 80.1335C233.574 80.3063 233.647 80.4792 233.701 80.6611L232.864 81.1523C232.81 80.9795 232.746 80.7975 232.664 80.6247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.854 81.1521L233.691 80.6608C233.746 80.8428 233.791 81.0338 233.819 81.2157L232.982 81.707C232.955 81.525 232.909 81.3431 232.854 81.1521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.981 81.6979L233.818 81.2066C233.846 81.3795 233.864 81.5523 233.855 81.7161L233.018 82.2073C233.018 82.0436 233.009 81.8707 232.981 81.6979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.027 82.216L233.864 81.7248C233.864 81.9067 233.845 82.0796 233.809 82.2342L232.972 82.7254C233.009 82.5708 233.027 82.407 233.027 82.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.973 82.7253L233.81 82.234C233.719 82.6252 233.518 82.9163 233.246 83.0709L232.409 83.5622C232.682 83.4075 232.882 83.1164 232.973 82.7253Z",
    fill: "white"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M230.927 78.5697C232.091 79.2425 233.037 80.8701 233.028 82.2067C233.028 83.5433 232.082 84.0888 230.909 83.416C229.745 82.7431 228.8 81.1156 228.809 79.779C228.809 78.4424 229.754 77.8968 230.927 78.5697Z",
    fill: "#252529"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M229.417 79.6428L229.963 79.3244C230.209 79.1789 230.564 79.1971 230.946 79.4245L230.4 79.7429C230.018 79.5245 229.672 79.4973 229.417 79.6428Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 79,
    width: 2,
    height: 1
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M229.417 79.6428L229.963 79.3244C230.209 79.1789 230.564 79.1971 230.946 79.4245L230.4 79.7429C230.018 79.5245 229.672 79.4973 229.417 79.6428Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.417 79.6429L229.963 79.3245C230.082 79.2517 230.227 79.2244 230.382 79.2335L229.836 79.5519C229.681 79.5428 229.536 79.5701 229.417 79.6429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.844 79.5519L230.39 79.2335C230.481 79.2335 230.581 79.2608 230.681 79.2971L230.135 79.6155C230.035 79.5791 229.935 79.5609 229.844 79.5519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.135 79.6154L230.681 79.297C230.763 79.3243 230.854 79.3698 230.945 79.4243L230.399 79.7427C230.308 79.6881 230.217 79.6517 230.135 79.6154Z",
    fill: "white"
  }))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M231.918 82.6794L231.373 82.9976C231.618 82.8521 231.773 82.552 231.773 82.1156C231.773 81.2427 231.164 80.1789 230.4 79.7425L230.945 79.4242C231.709 79.8607 232.318 80.9245 232.318 81.7974C232.318 82.2338 232.164 82.5339 231.918 82.6794Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 230,
    y: 79,
    width: 3,
    height: 4
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M231.918 82.6794L231.373 82.9976C231.618 82.8521 231.773 82.552 231.773 82.1156C231.773 81.2427 231.164 80.1789 230.4 79.7425L230.945 79.4242C231.709 79.8607 232.318 80.9245 232.318 81.7974C232.318 82.2338 232.164 82.5339 231.918 82.6794Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.4 79.7335L230.946 79.4151C230.946 79.4151 230.946 79.4151 230.955 79.4151L230.409 79.7335C230.409 79.7335 230.409 79.7335 230.4 79.7335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.409 79.7426L230.955 79.4243C231.055 79.4879 231.155 79.5607 231.255 79.6335L230.709 79.9519C230.609 79.87 230.518 79.7972 230.409 79.7426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.708 79.9612L231.254 79.6428C231.354 79.7246 231.454 79.8247 231.545 79.9248L230.999 80.2432C230.908 80.1431 230.808 80.043 230.708 79.9612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.999 80.2429L231.545 79.9245C231.763 80.1702 231.945 80.4613 232.082 80.7615L231.536 81.0798C231.399 80.7796 231.217 80.4885 230.999 80.2429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.526 81.0793L232.072 80.7609C232.118 80.87 232.163 80.9883 232.2 81.1066L231.654 81.4249C231.617 81.3067 231.572 81.1975 231.526 81.0793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.653 81.4156L232.199 81.0972C232.236 81.2155 232.263 81.3337 232.281 81.452L231.735 81.7704C231.717 81.6521 231.69 81.5338 231.653 81.4156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.745 81.7797L232.291 81.4613C232.309 81.5705 232.318 81.6887 232.318 81.7888L231.772 82.1072C231.772 81.998 231.772 81.8798 231.745 81.7706V81.7797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.773 82.1158L232.319 81.7974C232.319 81.9156 232.309 82.0248 232.282 82.1249L231.736 82.4432C231.764 82.3432 231.773 82.234 231.773 82.1158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.736 82.4432L232.282 82.1248C232.227 82.3795 232.091 82.5706 231.918 82.6706L231.372 82.989C231.554 82.889 231.681 82.6979 231.736 82.4432Z",
    fill: "white"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M230.399 79.7336C231.162 80.1701 231.772 81.2339 231.772 82.1068C231.772 82.9797 231.153 83.3343 230.39 82.8887C229.626 82.4432 229.017 81.3885 229.017 80.5156C229.017 79.6427 229.635 79.2881 230.399 79.7336Z",
    fill: "#252529"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M212.741 68.7045L213.578 68.2135C213.96 67.9952 214.496 68.0225 215.078 68.359L214.241 68.8499C213.66 68.5135 213.123 68.4771 212.741 68.7045Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 68,
    width: 4,
    height: 1
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M212.741 68.7045L213.578 68.2135C213.96 67.9952 214.496 68.0225 215.078 68.359L214.241 68.8499C213.66 68.5135 213.123 68.4771 212.741 68.7045Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.741 68.7048L213.578 68.2135C213.76 68.1044 213.978 68.0589 214.224 68.0771L213.387 68.5683C213.141 68.5501 212.923 68.5956 212.741 68.7048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.388 68.5683L214.225 68.0771C214.361 68.0862 214.516 68.1226 214.67 68.1772L213.833 68.6684C213.679 68.6138 213.533 68.5865 213.388 68.5683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.833 68.6684L214.669 68.1772C214.806 68.2227 214.942 68.2863 215.079 68.3682L214.242 68.8594C214.105 68.7776 213.969 68.7139 213.833 68.6684Z",
    fill: "white"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M216.57 73.3597L215.733 73.8507C216.115 73.6325 216.342 73.1597 216.351 72.4959C216.351 71.1593 215.415 69.5318 214.251 68.8589L215.087 68.3679C216.251 69.0408 217.197 70.6683 217.188 72.0049C217.188 72.6687 216.951 73.1415 216.57 73.3597Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 214,
    y: 68,
    width: 4,
    height: 6
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M216.57 73.3597L215.733 73.8507C216.115 73.6325 216.342 73.1597 216.351 72.4959C216.351 71.1593 215.415 69.5318 214.251 68.8589L215.087 68.3679C216.251 69.0408 217.197 70.6683 217.188 72.0049C217.188 72.6687 216.951 73.1415 216.57 73.3597Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.242 68.8502L215.079 68.359C215.079 68.359 215.097 68.359 215.097 68.368L214.26 68.8593C214.26 68.8593 214.242 68.8593 214.242 68.8502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.26 68.8683L215.097 68.3771C215.252 68.4681 215.406 68.5772 215.552 68.7046L214.715 69.1958C214.57 69.0685 214.415 68.9593 214.26 68.8683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.723 69.1958L215.56 68.7045C215.715 68.8319 215.86 68.9866 216.006 69.1412L215.169 69.6324C215.032 69.4687 214.878 69.3231 214.723 69.1958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.161 69.6323L215.998 69.1411C216.325 69.514 216.607 69.9598 216.816 70.4237L215.979 70.9149C215.77 70.451 215.497 70.0052 215.161 69.6323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.978 70.9141L216.815 70.4229C216.888 70.5957 216.96 70.7686 217.015 70.9505L216.178 71.4417C216.124 71.2689 216.06 71.087 215.978 70.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.179 71.4323L217.016 70.941C217.07 71.123 217.116 71.314 217.143 71.4959L216.306 71.9872C216.279 71.8052 216.233 71.6233 216.179 71.4323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.306 71.9871L217.143 71.4958C217.17 71.6687 217.189 71.8415 217.179 72.0053L216.343 72.4965C216.343 72.3327 216.333 72.1599 216.306 71.9871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.343 72.4963L217.18 72.0051C217.18 72.187 217.161 72.3599 217.125 72.5145L216.288 73.0057C216.324 72.8511 216.343 72.6873 216.343 72.4963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.289 73.0056L217.126 72.5144C217.035 72.9055 216.835 73.1966 216.562 73.3513L215.725 73.8425C215.998 73.6878 216.198 73.3967 216.289 73.0056Z",
    fill: "white"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M214.241 68.8499C215.405 69.5227 216.351 71.1503 216.342 72.4869C216.342 73.8235 215.396 74.369 214.223 73.6962C213.059 73.0233 212.114 71.3958 212.123 70.0592C212.123 68.7226 213.068 68.177 214.241 68.8499Z",
    fill: "#252529"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M212.741 69.9228L213.287 69.6044C213.533 69.4589 213.887 69.4771 214.269 69.7045L213.724 70.0229C213.342 69.8045 212.996 69.7772 212.741 69.9228Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 212,
    y: 69,
    width: 3,
    height: 2
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M212.741 69.9228L213.287 69.6044C213.533 69.4589 213.887 69.4771 214.269 69.7045L213.724 70.0229C213.342 69.8045 212.996 69.7772 212.741 69.9228Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.741 69.9229L213.287 69.6045C213.405 69.5317 213.551 69.5044 213.705 69.5135L213.16 69.8319C213.005 69.8228 212.859 69.8501 212.741 69.9229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.16 69.832L213.705 69.5136C213.796 69.5136 213.897 69.5409 213.997 69.5773L213.451 69.8957C213.351 69.8593 213.251 69.8411 213.16 69.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.45 69.8956L213.996 69.5772C214.077 69.6045 214.168 69.65 214.259 69.7046L213.714 70.023C213.623 69.9684 213.532 69.932 213.45 69.8956Z",
    fill: "white"
  }))), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M215.233 72.9597L214.687 73.2779C214.933 73.1324 215.087 72.8324 215.087 72.3959C215.087 71.5231 214.478 70.4592 213.714 70.0228L214.26 69.7046C215.024 70.141 215.633 71.2048 215.633 72.0777C215.633 72.5142 215.478 72.8142 215.233 72.9597Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 213,
    y: 69,
    width: 3,
    height: 5
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M215.233 72.9597L214.687 73.2779C214.933 73.1324 215.087 72.8324 215.087 72.3959C215.087 71.5231 214.478 70.4592 213.714 70.0228L214.26 69.7046C215.024 70.141 215.633 71.2048 215.633 72.0777C215.633 72.5142 215.478 72.8142 215.233 72.9597Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.714 70.023L214.26 69.7046C214.26 69.7046 214.26 69.7046 214.269 69.7046L213.723 70.023C213.723 70.023 213.723 70.023 213.714 70.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.732 70.0319L214.278 69.7135C214.378 69.7772 214.478 69.85 214.578 69.9227L214.032 70.2411C213.932 70.1593 213.841 70.0865 213.732 70.0319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.033 70.2414L214.579 69.923C214.679 70.0049 214.779 70.105 214.87 70.205L214.324 70.5234C214.233 70.4233 214.133 70.3233 214.033 70.2414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.314 70.5234L214.86 70.205C215.079 70.4506 215.261 70.7417 215.397 71.0419L214.851 71.3603C214.715 71.0601 214.533 70.769 214.314 70.5234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.851 71.3595L215.397 71.0411C215.442 71.1503 215.488 71.2686 215.524 71.3868L214.978 71.7052C214.942 71.5869 214.897 71.4778 214.851 71.3595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.979 71.7051L215.525 71.3867C215.561 71.5049 215.588 71.6232 215.607 71.7415L215.061 72.0598C215.043 71.9416 215.015 71.8233 214.979 71.7051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.06 72.0597L215.606 71.7413C215.624 71.8505 215.633 71.9688 215.633 72.0688L215.087 72.3872C215.087 72.278 215.087 72.1598 215.06 72.0506V72.0597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.089 72.396L215.634 72.0776C215.634 72.1959 215.625 72.3051 215.598 72.4051L215.052 72.7235C215.08 72.6234 215.089 72.5143 215.089 72.396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.051 72.7326L215.597 72.4142C215.543 72.6689 215.406 72.8599 215.233 72.96L214.688 73.2784C214.869 73.1783 214.997 72.9873 215.051 72.7326Z",
    fill: "white"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M213.715 70.023C214.478 70.4594 215.088 71.5232 215.088 72.3961C215.088 73.269 214.469 73.6236 213.705 73.1781C212.942 72.7416 212.333 71.6778 212.333 70.8049C212.333 69.932 212.951 69.5774 213.715 70.023Z",
    fill: "#252529"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M194.685 57.8751L195.521 57.3841C195.903 57.1659 196.439 57.1932 197.021 57.5296L196.185 58.0206C195.603 57.6842 195.066 57.6478 194.685 57.8751Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 57,
    width: 4,
    height: 2
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M194.685 57.8751L195.521 57.3841C195.903 57.1659 196.439 57.1932 197.021 57.5296L196.185 58.0206C195.603 57.6842 195.066 57.6478 194.685 57.8751Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.685 57.8754L195.521 57.3842C195.703 57.275 195.922 57.2296 196.167 57.2478L195.33 57.739C195.085 57.7208 194.867 57.7663 194.685 57.8754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.338 57.739L196.175 57.2478C196.312 57.2569 196.466 57.2933 196.621 57.3479L195.784 57.8391C195.629 57.7845 195.484 57.7572 195.338 57.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.776 57.8299L196.613 57.3387C196.75 57.3842 196.886 57.4478 197.023 57.5297L196.186 58.0209C196.049 57.9391 195.913 57.8754 195.776 57.8299Z",
    fill: "white"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M198.511 62.5306L197.675 63.0216C198.057 62.8034 198.284 62.3306 198.293 61.6668C198.293 60.3303 197.357 58.7027 196.193 58.0298L197.029 57.5388C198.193 58.2117 199.139 59.8393 199.13 61.1759C199.13 61.8396 198.893 62.3124 198.511 62.5306Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 57,
    width: 4,
    height: 7
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M198.511 62.5306L197.675 63.0216C198.057 62.8034 198.284 62.3306 198.293 61.6668C198.293 60.3303 197.357 58.7027 196.193 58.0298L197.029 57.5388C198.193 58.2117 199.139 59.8393 199.13 61.1759C199.13 61.8396 198.893 62.3124 198.511 62.5306Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.185 58.0211L197.022 57.5299C197.022 57.5299 197.04 57.5299 197.04 57.539L196.203 58.0302C196.203 58.0302 196.185 58.0302 196.185 58.0211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.212 58.0391L197.049 57.5478C197.204 57.6388 197.359 57.748 197.504 57.8753L196.667 58.3665C196.522 58.2392 196.367 58.13 196.212 58.0391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.666 58.3663L197.503 57.875C197.658 58.0024 197.803 58.157 197.949 58.3117L197.112 58.8029C196.975 58.6392 196.821 58.4936 196.666 58.3663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.112 58.8029L197.949 58.3117C198.276 58.6846 198.558 59.1304 198.767 59.5943L197.931 60.0855C197.721 59.6216 197.448 59.1758 197.112 58.8029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.921 60.0847L198.758 59.5935C198.831 59.7663 198.904 59.9392 198.958 60.1211L198.122 60.6123C198.067 60.4395 198.003 60.2576 197.921 60.0847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.121 60.6033L198.958 60.1121C199.012 60.294 199.058 60.4851 199.085 60.667L198.248 61.1582C198.221 60.9763 198.175 60.7944 198.121 60.6033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.249 61.1578L199.086 60.6666C199.113 60.8394 199.131 61.0122 199.122 61.176L198.285 61.6672C198.285 61.4944 198.276 61.3215 198.249 61.1487V61.1578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.284 61.6669L199.121 61.1757C199.121 61.3576 199.103 61.5305 199.066 61.6851L198.229 62.1763C198.266 62.0217 198.284 61.858 198.284 61.6669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.23 62.1761L199.067 61.6848C198.976 62.076 198.776 62.3671 198.503 62.5217L197.666 63.013C197.939 62.8583 198.139 62.5672 198.23 62.1761Z",
    fill: "white"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M196.185 58.0205C197.348 58.6934 198.294 60.3209 198.285 61.6575C198.285 62.9941 197.339 63.5397 196.166 62.8668C195.003 62.194 194.057 60.5664 194.066 59.2298C194.066 57.8932 195.012 57.3477 196.185 58.0205Z",
    fill: "#252529"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M194.685 59.0937L195.23 58.7754C195.476 58.6298 195.831 58.648 196.213 58.8754L195.667 59.1938C195.285 58.9755 194.939 58.9482 194.685 59.0937Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 58,
    width: 3,
    height: 2
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M194.685 59.0937L195.23 58.7754C195.476 58.6298 195.831 58.648 196.213 58.8754L195.667 59.1938C195.285 58.9755 194.939 58.9482 194.685 59.0937Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.685 59.0938L195.23 58.7754C195.349 58.7027 195.494 58.6754 195.649 58.6845L195.103 59.0028C194.948 58.9937 194.803 59.021 194.685 59.0938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.102 59.0028L195.648 58.6845C195.739 58.6845 195.839 58.7117 195.939 58.7481L195.393 59.0665C195.293 59.0301 195.193 59.0119 195.102 59.0028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.394 59.0667L195.939 58.7483C196.021 58.7756 196.112 58.8211 196.203 58.8757L195.657 59.1941C195.566 59.1395 195.475 59.1031 195.394 59.0667Z",
    fill: "white"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M197.175 62.1308L196.63 62.449C196.875 62.3035 197.03 62.0035 197.03 61.567C197.03 60.6941 196.421 59.6303 195.657 59.1939L196.202 58.8756C196.966 59.3121 197.575 60.3759 197.575 61.2488C197.575 61.6852 197.421 61.9853 197.175 62.1308Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 195,
    y: 58,
    width: 3,
    height: 5
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M197.175 62.1308L196.63 62.449C196.875 62.3035 197.03 62.0035 197.03 61.567C197.03 60.6941 196.421 59.6303 195.657 59.1939L196.202 58.8756C196.966 59.3121 197.575 60.3759 197.575 61.2488C197.575 61.6852 197.421 61.9853 197.175 62.1308Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.666 59.194L196.212 58.8756C196.212 58.8756 196.212 58.8756 196.221 58.8756L195.675 59.194C195.675 59.194 195.675 59.194 195.666 59.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.674 59.2027L196.22 58.8843C196.32 58.948 196.42 59.0117 196.52 59.0936L195.975 59.4119C195.874 59.3301 195.783 59.2573 195.674 59.2027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.975 59.4119L196.521 59.0935C196.621 59.1754 196.721 59.2754 196.812 59.3755L196.266 59.6939C196.175 59.5938 196.075 59.4937 195.975 59.4119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.266 59.6941L196.812 59.3757C197.03 59.6213 197.212 59.9124 197.349 60.2126L196.803 60.531C196.666 60.2308 196.484 59.9397 196.266 59.6941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.793 60.5303L197.339 60.212C197.385 60.3211 197.43 60.4394 197.467 60.5576L196.921 60.876C196.884 60.7578 196.839 60.6486 196.793 60.5303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.921 60.8757L197.467 60.5573C197.504 60.6755 197.531 60.7938 197.549 60.912L197.003 61.2304C196.985 61.1122 196.958 60.9939 196.921 60.8757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.002 61.2305L197.548 60.9121C197.566 61.0213 197.575 61.1396 197.575 61.2396L197.029 61.558C197.029 61.4489 197.029 61.3306 197.002 61.2214V61.2305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.03 61.5668L197.576 61.2485C197.576 61.3667 197.567 61.4759 197.539 61.5759L196.994 61.8943C197.021 61.7943 197.03 61.6851 197.03 61.5668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.994 61.9034L197.54 61.585C197.485 61.8397 197.349 62.0307 197.176 62.1308L196.63 62.4492C196.812 62.3491 196.939 62.1581 196.994 61.9034Z",
    fill: "white"
  }))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M195.667 59.1938C196.431 59.6302 197.04 60.694 197.04 61.5669C197.04 62.4398 196.421 62.7944 195.658 62.3489C194.894 61.9124 194.285 60.8486 194.285 59.9757C194.285 59.1029 194.903 58.7483 195.667 59.1938Z",
    fill: "#252529"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M246.194 70.0322V69.3772C246.194 69.6774 246.394 69.9867 246.794 70.2141V70.8691C246.394 70.6417 246.194 70.3324 246.194 70.0322Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 246,
    y: 69,
    width: 1,
    height: 2
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M246.194 70.0322V69.3772C246.194 69.6774 246.394 69.9867 246.794 70.2141V70.8691C246.394 70.6417 246.194 70.3324 246.194 70.0322Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.803 70.2141V70.8691C246.403 70.6417 246.203 70.3324 246.203 70.0322V69.3772C246.203 69.6774 246.403 69.9867 246.803 70.2141Z",
    fill: "#C2C3D0"
  }))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M266.461 72.3049V72.9599C266.461 73.2601 266.261 73.5603 265.87 73.7877V73.1327C266.261 72.9053 266.461 72.6051 266.461 72.3049Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 265,
    y: 72,
    width: 2,
    height: 2
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M266.461 72.3049V72.9599C266.461 73.2601 266.261 73.5603 265.87 73.7877V73.1327C266.261 72.9053 266.461 72.6051 266.461 72.3049Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.46 72.3049V72.9599C266.46 72.9599 266.46 73.0508 266.442 73.0963V72.4413C266.442 72.4413 266.46 72.3504 266.46 72.3049Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.442 72.4413V73.0963C266.388 73.3419 266.206 73.5784 265.887 73.7694V73.1145C266.206 72.9234 266.388 72.6869 266.442 72.4413Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.897 73.1141V73.7691C265.897 73.7691 265.879 73.7782 265.87 73.7873V73.1323C265.87 73.1323 265.888 73.1232 265.897 73.1141Z",
    fill: "#C2C3D0"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M265.869 73.1322V73.7868L260.313 77.0146V76.36L265.869 73.1322Z",
    fill: "#C2C3D0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M257.45 76.3601V77.0148L246.793 70.8682L246.803 70.2136L257.45 76.3601Z",
    fill: "#C2C3D0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M260.314 76.3602V77.0149C259.523 77.4695 258.241 77.4695 257.45 77.0149V76.3602C258.241 76.8148 259.532 76.8148 260.314 76.3602Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 257,
    y: 76,
    width: 4,
    height: 2
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M260.314 76.3602V77.0149C259.523 77.4695 258.241 77.4695 257.45 77.0149V76.3602C258.241 76.8148 259.532 76.8148 260.314 76.3602Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.314 76.3603V77.0152C260.177 77.0971 260.023 77.1608 259.868 77.2063V76.5513C260.032 76.4967 260.177 76.433 260.314 76.3603Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.869 76.5601V77.215C259.478 77.3424 259.023 77.3879 258.596 77.3515V76.6965C259.032 76.7329 259.478 76.6874 259.869 76.5601Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.596 76.6969V77.3519C258.178 77.3155 257.769 77.2063 257.45 77.0244V76.3694C257.778 76.5605 258.178 76.6696 258.596 76.6969Z",
    fill: "#C2C3D0"
  }))), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M265.861 71.4683C266.652 71.9229 266.661 72.6685 265.861 73.1322L260.305 76.3601C259.514 76.8147 258.232 76.8147 257.441 76.3601L246.794 70.2135C246.003 69.7589 245.994 69.0133 246.785 68.5496L252.34 65.3218C253.131 64.8671 254.413 64.8671 255.204 65.3218L265.852 71.4683H265.861Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M249.158 67.613L249.449 67.7857L251.395 66.6583L251.104 66.4946L249.158 67.613Z",
    fill: "#424242"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M251.604 70.3951L249.903 71.3861L247.121 69.7768L248.821 68.7857L251.604 70.3951Z",
    fill: "#686868"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M259.341 70.0227L257.631 71.0138L254.849 69.4044L256.558 68.4133L259.341 70.0227Z",
    fill: "#686868"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M259.387 68.3493L258.551 68.8312L257.187 68.0492L258.024 67.5583L259.387 68.3493Z",
    fill: "#686868"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M261.168 69.386L260.331 69.8679L258.967 69.086L259.804 68.595L261.168 69.386Z",
    fill: "#686868"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M255.651 70.3863L254.351 71.1409L252.214 69.9134L253.514 69.1497L255.651 70.3863Z",
    fill: "#686868"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M258.305 71.7865L257.005 72.5503L254.868 71.3137L256.177 70.5499L258.305 71.7865Z",
    fill: "#686868"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M256.859 74.2323L255.804 74.8415L254.077 73.8504L255.131 73.2322L256.859 74.2323Z",
    fill: "#686868"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M265.961 72.0593L264.906 72.6685L263.178 71.6774L264.233 71.0591L265.961 72.0593Z",
    fill: "#686868"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M263.524 70.6861L262.469 71.3044L260.741 70.3042L261.796 69.695L263.524 70.6861Z",
    fill: "#686868"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M264.742 72.8046L263.997 73.241L262.769 72.5318L263.515 72.0953L264.742 72.8046Z",
    fill: "#686868"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M263.724 73.4503L262.978 73.8868L261.742 73.1775L262.496 72.7411L263.724 73.4503Z",
    fill: "#686868"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M262.723 73.9779L261.969 74.4144L260.741 73.7051L261.496 73.2687L262.723 73.9779Z",
    fill: "#686868"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M256.06 72.405L253.868 73.678L250.295 71.614L252.486 70.341L256.06 72.405Z",
    fill: "#686868"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M257.549 67.3312L255.63 68.4405L252.493 66.6311L254.412 65.5127L257.549 67.3312Z",
    fill: "#686868"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M263.159 71.9771L261.232 73.0955L258.095 71.2861L260.013 70.1677L263.159 71.9771Z",
    fill: "#686868"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M257.096 73.0777L256.46 73.4507L255.604 72.9595L256.241 72.5865L257.096 73.0777Z",
    fill: "#686868"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M258.151 73.7143L257.523 74.0781L256.668 73.5869L257.296 73.223L258.151 73.7143Z",
    fill: "#686868"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M259.106 72.9051L258.288 73.3872L257.187 72.7504L258.006 72.2683L259.106 72.9051Z",
    fill: "#686868"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M259.359 72.2774L258.85 72.5685L258.177 72.1773L258.677 71.8862L259.359 72.2774Z",
    fill: "#686868"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M260.297 72.8596L259.788 73.1507L259.115 72.7595L259.615 72.4593L260.297 72.8596Z",
    fill: "#686868"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M259.322 73.9052L258.822 74.1963L258.14 73.8051L258.64 73.514L259.322 73.9052Z",
    fill: "#686868"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M260.051 73.5141L259.55 73.8052L258.868 73.4141L259.369 73.123L260.051 73.5141Z",
    fill: "#686868"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M260.905 73.2595L260.578 73.4597L260.168 73.214L260.496 73.023L260.905 73.2595Z",
    fill: "#686868"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M259.968 75.5325L258.55 76.3599L256.231 75.0233L257.649 74.1959L259.968 75.5325Z",
    fill: "#686868"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M261.487 74.696L260.541 75.2415L258.986 74.3505L259.941 73.7958L261.487 74.696Z",
    fill: "#686868"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M252.859 68.995L251.467 69.8042L249.212 68.4949L250.594 67.6857L252.859 68.995Z",
    fill: "#686868"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M253.496 67.6766L252.641 68.1676L251.25 67.3675L252.105 66.8674L253.496 67.6766Z",
    fill: "#686868"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M255.267 68.7587L254.413 69.2497L253.021 68.4405L253.867 67.9495L255.267 68.7587Z",
    fill: "#686868"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M217.944 53.7202V53.0652C217.944 53.3654 218.144 53.6747 218.544 53.9021V54.5571C218.144 54.3297 217.944 54.0204 217.944 53.7202Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 53,
    width: 2,
    height: 2
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M217.944 53.7202V53.0652C217.944 53.3654 218.144 53.6747 218.544 53.9021V54.5571C218.144 54.3297 217.944 54.0204 217.944 53.7202Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.544 53.9021V54.5571C218.144 54.3297 217.944 54.0204 217.944 53.7202V53.0652C217.944 53.3654 218.144 53.6747 218.544 53.9021Z",
    fill: "#C2C3D0"
  }))), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M238.2 55.9928V56.6477C238.2 56.9479 238 57.2481 237.609 57.4755V56.8206C238 56.5932 238.2 56.293 238.2 55.9928Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 237,
    y: 55,
    width: 2,
    height: 3
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M238.2 55.9928V56.6477C238.2 56.9479 238 57.2481 237.609 57.4755V56.8206C238 56.5932 238.2 56.293 238.2 55.9928Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.201 55.9928V56.6478C238.201 56.6478 238.201 56.7388 238.183 56.7843V56.1293C238.183 56.1293 238.201 56.0383 238.201 55.9928Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.192 56.1295V56.7844C238.137 57.03 237.955 57.2666 237.637 57.4576V56.8026C237.955 56.6116 238.137 56.3751 238.192 56.1295Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.636 56.8022V57.4572C237.636 57.4572 237.618 57.4663 237.609 57.4754V56.8204C237.609 56.8204 237.627 56.8113 237.636 56.8022Z",
    fill: "#C2C3D0"
  }))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M237.609 56.8204V57.475L232.054 60.7029V60.0482L237.609 56.8204Z",
    fill: "#C2C3D0"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M229.19 60.0482V60.7029L218.543 54.5563V53.9017L229.19 60.0482Z",
    fill: "#C2C3D0"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M232.054 60.0484V60.7031C231.263 61.1577 229.981 61.1577 229.19 60.7031V60.0484C229.981 60.503 231.272 60.503 232.054 60.0484Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 60,
    width: 4,
    height: 2
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M232.054 60.0484V60.7031C231.263 61.1577 229.981 61.1577 229.19 60.7031V60.0484C229.981 60.503 231.272 60.503 232.054 60.0484Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.055 60.0484V60.7034C231.918 60.7853 231.764 60.8489 231.609 60.8944V60.2394C231.773 60.1849 231.918 60.1212 232.055 60.0484Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.61 60.2481V60.9031C231.219 61.0304 230.764 61.0759 230.336 61.0395V60.3845C230.773 60.4209 231.219 60.3754 231.61 60.2481Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.336 60.3848V61.0397C229.918 61.0034 229.508 60.8942 229.19 60.7123V60.0573C229.517 60.2483 229.918 60.3575 230.336 60.3848Z",
    fill: "#C2C3D0"
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M237.601 55.1563C238.392 55.6109 238.402 56.3565 237.601 56.8202L232.046 60.048C231.255 60.5026 229.973 60.5026 229.182 60.048L218.534 53.9015C217.743 53.4469 217.734 52.7013 218.525 52.2376L224.081 49.0097C224.872 48.5551 226.154 48.5551 226.945 49.0097L237.592 55.1563H237.601Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M220.898 51.3012L221.189 51.474L223.135 50.3465L222.844 50.1828L220.898 51.3012Z",
    fill: "#424242"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M223.343 54.0833L221.643 55.0744L218.861 53.465L220.561 52.4739L223.343 54.0833Z",
    fill: "#686868"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M231.083 53.7108L229.382 54.7018L226.591 53.0925L228.3 52.1014L231.083 53.7108Z",
    fill: "#686868"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M231.126 52.0378L230.29 52.5197L228.926 51.7377L229.762 51.2558L231.126 52.0378Z",
    fill: "#686868"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M232.908 53.0743L232.072 53.5562L230.708 52.7742L231.545 52.2832L232.908 53.0743Z",
    fill: "#686868"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M227.398 54.0745L226.089 54.8292L223.952 53.6017L225.261 52.8379L227.398 54.0745Z",
    fill: "#686868"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M230.053 55.4748L228.744 56.2386L226.607 55.002L227.917 54.2383L230.053 55.4748Z",
    fill: "#686868"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M228.599 57.9207L227.544 58.5299L225.817 57.5388L226.872 56.9205L228.599 57.9207Z",
    fill: "#686868"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M237.711 55.7475L236.656 56.3658L234.928 55.3656L235.983 54.7473L237.711 55.7475Z",
    fill: "#686868"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M235.264 54.3744L234.21 54.9927L232.482 53.9925L233.546 53.3833L235.264 54.3744Z",
    fill: "#686868"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M236.483 56.493L235.737 56.9294L234.51 56.2202L235.255 55.7838L236.483 56.493Z",
    fill: "#686868"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M235.464 57.1384L234.719 57.5749L233.491 56.8657L234.237 56.4292L235.464 57.1384Z",
    fill: "#686868"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M234.464 57.6659L233.719 58.1023L232.482 57.3931L233.237 56.9567L234.464 57.6659Z",
    fill: "#686868"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M227.799 56.0931L225.608 57.3661L222.034 55.3021L224.225 54.0291L227.799 56.0931Z",
    fill: "#686868"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M229.3 51.0192L227.372 52.1285L224.235 50.3191L226.154 49.2007L229.3 51.0192Z",
    fill: "#686868"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M234.9 55.6656L232.981 56.784L229.835 54.9745L231.763 53.8562L234.9 55.6656Z",
    fill: "#686868"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M228.836 56.7661L228.209 57.139L227.354 56.6478L227.981 56.2748L228.836 56.7661Z",
    fill: "#686868"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M229.891 57.4024L229.264 57.7662L228.409 57.275L229.045 56.9111L229.891 57.4024Z",
    fill: "#686868"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M230.845 56.6026L230.026 57.0756L228.926 56.4389L229.744 55.9567L230.845 56.6026Z",
    fill: "#686868"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M231.1 55.966L230.6 56.2571L229.917 55.866L230.418 55.5749L231.1 55.966Z",
    fill: "#686868"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M232.036 56.5479L231.536 56.839L230.854 56.4479L231.354 56.1568L232.036 56.5479Z",
    fill: "#686868"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M231.073 57.5933L230.564 57.8844L229.881 57.4932L230.391 57.2021L231.073 57.5933Z",
    fill: "#686868"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M231.791 57.2022L231.291 57.4933L230.609 57.1022L231.109 56.8111L231.791 57.2022Z",
    fill: "#686868"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M232.654 56.9477L232.318 57.1479L231.908 56.9023L232.236 56.7112L232.654 56.9477Z",
    fill: "#686868"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M231.708 59.221L230.29 60.0484L227.971 58.7118L229.39 57.8844L231.708 59.221Z",
    fill: "#686868"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M233.228 58.3843L232.282 58.9299L230.736 58.0388L231.682 57.4842L233.228 58.3843Z",
    fill: "#686868"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M224.597 52.6833L223.215 53.4926L220.951 52.1832L222.333 51.3831L224.597 52.6833Z",
    fill: "#686868"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M225.234 51.3647L224.389 51.8557L222.988 51.0556L223.843 50.5555L225.234 51.3647Z",
    fill: "#686868"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M227.009 52.447L226.154 52.938L224.763 52.1288L225.617 51.6378L227.009 52.447Z",
    fill: "#686868"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M294.601 97.3733V96.7183C294.601 97.0185 294.801 97.3278 295.201 97.5552V98.2102C294.801 97.9828 294.601 97.6735 294.601 97.3733Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 96,
    width: 2,
    height: 3
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M294.601 97.3733V96.7183C294.601 97.0185 294.801 97.3278 295.201 97.5552V98.2102C294.801 97.9828 294.601 97.6735 294.601 97.3733Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.201 97.5552V98.2102C294.801 97.9828 294.601 97.6735 294.601 97.3733V96.7183C294.601 97.0185 294.801 97.3278 295.201 97.5552Z",
    fill: "#C2C3D0"
  }))), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M314.859 99.6461V100.301C314.859 100.601 314.659 100.901 314.268 101.129V100.474C314.659 100.246 314.859 99.9463 314.859 99.6461Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 314,
    y: 99,
    width: 1,
    height: 3
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M314.859 99.6461V100.301C314.859 100.601 314.659 100.901 314.268 101.129V100.474C314.659 100.246 314.859 99.9463 314.859 99.6461Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.859 99.6462V100.301C314.859 100.301 314.859 100.392 314.841 100.438V99.7826C314.841 99.7826 314.859 99.6916 314.859 99.6462Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85 99.7824V100.437C314.795 100.683 314.613 100.92 314.295 101.111V100.456C314.613 100.265 314.795 100.028 314.85 99.7824Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.295 100.464V101.119C314.295 101.119 314.277 101.128 314.268 101.138V100.483C314.268 100.483 314.286 100.473 314.295 100.464Z",
    fill: "#C2C3D0"
  }))), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M314.268 100.473V101.128L308.713 104.356V103.701L314.268 100.473Z",
    fill: "#C2C3D0"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M305.849 103.702V104.356L295.202 98.2096V97.555L305.849 103.702Z",
    fill: "#C2C3D0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M308.713 103.701V104.356C307.922 104.811 306.64 104.811 305.849 104.356V103.701C306.64 104.156 307.931 104.156 308.713 103.701Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 305,
    y: 103,
    width: 4,
    height: 2
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M308.713 103.701V104.356C307.922 104.811 306.64 104.811 305.849 104.356V103.701C306.64 104.156 307.931 104.156 308.713 103.701Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.714 103.701V104.356C308.577 104.438 308.423 104.502 308.268 104.547V103.892C308.432 103.838 308.577 103.774 308.714 103.701Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.268 103.901V104.556C307.877 104.684 307.422 104.729 306.994 104.693V104.038C307.431 104.074 307.877 104.029 308.268 103.901Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.995 104.038V104.693C306.577 104.656 306.168 104.547 305.849 104.365V103.71C306.177 103.901 306.577 104.011 306.995 104.038Z",
    fill: "#C2C3D0"
  }))), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M314.26 98.8186C315.051 99.2732 315.06 100.019 314.26 100.483L308.704 103.71C307.913 104.165 306.631 104.165 305.84 103.71L295.193 97.5638C294.402 97.1092 294.392 96.3636 295.183 95.8999L300.739 92.6721C301.53 92.2174 302.812 92.2174 303.603 92.6721L314.25 98.8186H314.26Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M297.557 94.9635L297.848 95.1272L299.793 94.0088L299.502 93.836L297.557 94.9635Z",
    fill: "#424242"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M300.003 97.737L298.302 98.728L295.52 97.1187L297.22 96.1367L300.003 97.737Z",
    fill: "#686868"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M307.741 97.3638L306.04 98.3549L303.249 96.7455L304.958 95.7545L307.741 97.3638Z",
    fill: "#686868"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M307.786 95.6907L306.958 96.1817L305.594 95.3907L306.422 94.9088L307.786 95.6907Z",
    fill: "#686868"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M309.568 96.7273L308.731 97.2092L307.376 96.4273L308.204 95.9454L309.568 96.7273Z",
    fill: "#686868"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M304.057 97.7274L302.748 98.4912L300.611 97.2546L301.921 96.4908L304.057 97.7274Z",
    fill: "#686868"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M306.713 99.1278L305.404 99.8916L303.267 98.655L304.576 97.9003L306.713 99.1278Z",
    fill: "#686868"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M305.258 101.574L304.204 102.192L302.476 101.192L303.531 100.583L305.258 101.574Z",
    fill: "#686868"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M314.369 99.4006L313.314 100.019L311.587 99.0187L312.642 98.4095L314.369 99.4006Z",
    fill: "#686868"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M311.932 98.0368L310.868 98.646L309.141 97.6458L310.204 97.0367L311.932 98.0368Z",
    fill: "#686868"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M313.15 100.146L312.395 100.583L311.167 99.8735L311.913 99.4371L313.15 100.146Z",
    fill: "#686868"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M312.122 100.791L311.376 101.228L310.149 100.519L310.895 100.082L312.122 100.791Z",
    fill: "#686868"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M311.122 101.319L310.377 101.756L309.149 101.046L309.895 100.61L311.122 101.319Z",
    fill: "#686868"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M304.458 99.7462L302.276 101.019L298.693 98.9551L300.885 97.6822L304.458 99.7462Z",
    fill: "#686868"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M305.958 94.6727L304.039 95.7911L300.893 93.9726L302.812 92.8542L305.958 94.6727Z",
    fill: "#686868"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M311.559 99.3279L309.641 100.437L306.495 98.6277L308.422 97.5094L311.559 99.3279Z",
    fill: "#686868"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M305.495 100.428L304.868 100.792L304.013 100.301L304.64 99.9371L305.495 100.428Z",
    fill: "#686868"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M306.558 101.055L305.922 101.428L305.066 100.937L305.703 100.564L306.558 101.055Z",
    fill: "#686868"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M307.504 100.256L306.685 100.729L305.584 100.092L306.403 99.6188L307.504 100.256Z",
    fill: "#686868"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M307.76 99.6191L307.259 99.9102L306.577 99.519L307.077 99.228L307.76 99.6191Z",
    fill: "#686868"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M308.695 100.201L308.194 100.492L307.512 100.101L308.013 99.8098L308.695 100.201Z",
    fill: "#686868"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M307.731 101.246L307.221 101.538L306.548 101.146L307.049 100.855L307.731 101.246Z",
    fill: "#686868"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M308.45 100.856L307.949 101.147L307.267 100.755L307.767 100.464L308.45 100.856Z",
    fill: "#686868"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M309.313 100.61L308.977 100.801L308.567 100.564L308.904 100.373L309.313 100.61Z",
    fill: "#686868"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M308.367 102.883L306.949 103.701L304.63 102.365L306.049 101.537L308.367 102.883Z",
    fill: "#686868"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M309.886 102.037L308.94 102.583L307.395 101.692L308.34 101.146L309.886 102.037Z",
    fill: "#686868"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M301.258 96.3364L299.876 97.1456L297.612 95.8363L298.994 95.0362L301.258 96.3364Z",
    fill: "#686868"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M301.893 95.0178L301.048 95.5088L299.647 94.7087L300.502 94.2177L301.893 95.0178Z",
    fill: "#686868"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M303.667 96.0997L302.822 96.5907L301.421 95.7906L302.276 95.2905L303.667 96.0997Z",
    fill: "#686868"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M271.315 84.9347V84.2797C271.315 84.5799 271.516 84.8892 271.916 85.1166V85.7716C271.516 85.5442 271.315 85.2349 271.315 84.9347Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 84,
    width: 1,
    height: 2
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M271.315 84.9347V84.2797C271.315 84.5799 271.516 84.8892 271.916 85.1166V85.7716C271.516 85.5442 271.315 85.2349 271.315 84.9347Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.916 85.1166V85.7716C271.516 85.5442 271.315 85.2349 271.315 84.9347V84.2797C271.315 84.5799 271.516 84.8892 271.916 85.1166Z",
    fill: "#C2C3D0"
  }))), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M291.574 87.2073V87.8622C291.574 88.1624 291.374 88.4626 290.983 88.69V88.0351C291.374 87.8077 291.574 87.5075 291.574 87.2073Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 290,
    y: 87,
    width: 2,
    height: 2
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M291.574 87.2073V87.8622C291.574 88.1624 291.374 88.4626 290.983 88.69V88.0351C291.374 87.8077 291.574 87.5075 291.574 87.2073Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.574 87.2072V87.8622C291.574 87.8622 291.574 87.9531 291.556 87.9986V87.3437C291.556 87.3437 291.574 87.2527 291.574 87.2072Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.555 87.3441V87.9991C291.501 88.2447 291.319 88.4812 291 88.6722V88.0173C291.319 87.8262 291.501 87.5897 291.555 87.3441Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.01 88.0258V88.6808C291.01 88.6808 290.992 88.6899 290.983 88.699V88.044C290.983 88.044 291.001 88.0349 291.01 88.0258Z",
    fill: "#C2C3D0"
  }))), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M290.983 88.035V88.6896L285.427 91.9175V91.2628L290.983 88.035Z",
    fill: "#C2C3D0"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M282.564 91.2628V91.9175L271.907 85.7709L271.916 85.1163L282.564 91.2628Z",
    fill: "#C2C3D0"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M285.428 91.2627V91.9173C284.637 92.3719 283.355 92.3719 282.564 91.9173V91.2627C283.355 91.7173 284.646 91.7173 285.428 91.2627Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 282,
    y: 91,
    width: 4,
    height: 2
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M285.428 91.2627V91.9173C284.637 92.3719 283.355 92.3719 282.564 91.9173V91.2627C283.355 91.7173 284.646 91.7173 285.428 91.2627Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.428 91.2627V91.9177C285.291 91.9995 285.137 92.0632 284.982 92.1087V91.4537C285.146 91.3992 285.291 91.3355 285.428 91.2627Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.983 91.463V92.1179C284.591 92.2453 284.137 92.2908 283.709 92.2544V91.5994C284.146 91.6358 284.591 91.5903 284.983 91.463Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.71 91.5997V92.2547C283.292 92.2183 282.882 92.1092 282.564 91.9272V91.2723C282.891 91.4633 283.292 91.5724 283.71 91.5997Z",
    fill: "#C2C3D0"
  }))), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M290.973 86.3798C291.764 86.8344 291.773 87.58 290.973 88.0437L285.417 91.2715C284.626 91.7262 283.344 91.7262 282.553 91.2715L271.906 85.125C271.115 84.6704 271.106 83.9248 271.897 83.4611L277.452 80.2332C278.243 79.7786 279.525 79.7786 280.317 80.2332L290.964 86.3798H290.973Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M274.271 82.5248L274.561 82.6885L276.507 81.561L276.216 81.3973L274.271 82.5248Z",
    fill: "#424242"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M276.716 85.2981L275.016 86.2892L272.234 84.6798L273.934 83.6887L276.716 85.2981Z",
    fill: "#686868"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M284.455 84.9254L282.754 85.9165L279.963 84.3071L281.672 83.316L284.455 84.9254Z",
    fill: "#686868"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M284.5 83.2525L283.663 83.7344L282.299 82.9524L283.136 82.4705L284.5 83.2525Z",
    fill: "#686868"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M286.282 84.2888L285.445 84.7707L284.082 83.9887L284.918 83.5068L286.282 84.2888Z",
    fill: "#686868"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M280.772 85.289L279.462 86.0527L277.326 84.8162L278.635 84.0524L280.772 85.289Z",
    fill: "#686868"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M283.427 86.6892L282.118 87.453L279.981 86.2164L281.29 85.4617L283.427 86.6892Z",
    fill: "#686868"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M281.973 89.1351L280.918 89.7534L279.191 88.7533L280.246 88.135L281.973 89.1351Z",
    fill: "#686868"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M291.074 86.9622L290.019 87.5805L288.3 86.5803L289.355 85.9711L291.074 86.9622Z",
    fill: "#686868"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M288.637 85.5982L287.582 86.2074L285.854 85.2073L286.909 84.5981L288.637 85.5982Z",
    fill: "#686868"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M289.855 87.7074L289.109 88.1438L287.882 87.4346L288.627 86.9982L289.855 87.7074Z",
    fill: "#686868"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M288.837 88.3532L288.092 88.7896L286.864 88.0804L287.61 87.6439L288.837 88.3532Z",
    fill: "#686868"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M287.837 88.8804L287.091 89.3168L285.854 88.6076L286.609 88.1712L287.837 88.8804Z",
    fill: "#686868"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M281.172 87.3075L278.981 88.5804L275.408 86.5164L277.599 85.2435L281.172 87.3075Z",
    fill: "#686868"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M282.673 82.234L280.746 83.3524L277.609 81.5339L279.527 80.4155L282.673 82.234Z",
    fill: "#686868"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M288.274 86.88L286.355 87.9983L283.209 86.1889L285.137 85.0705L288.274 86.88Z",
    fill: "#686868"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M282.209 87.9898L281.573 88.3536L280.727 87.8624L281.354 87.4894L282.209 87.9898Z",
    fill: "#686868"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M283.264 88.6171L282.636 88.9901L281.781 88.4897L282.418 88.1259L283.264 88.6171Z",
    fill: "#686868"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M284.219 87.8172L283.4 88.2903L282.299 87.6535L283.118 87.1805L284.219 87.8172Z",
    fill: "#686868"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M284.474 87.1804L283.974 87.4715L283.292 87.0804L283.792 86.7893L284.474 87.1804Z",
    fill: "#686868"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M285.41 87.7623L284.909 88.0534L284.227 87.6623L284.727 87.3711L285.41 87.7623Z",
    fill: "#686868"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M284.437 88.808L283.937 89.0991L283.254 88.708L283.764 88.4169L284.437 88.808Z",
    fill: "#686868"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M285.164 88.4171L284.664 88.7082L283.981 88.317L284.482 88.0259L285.164 88.4171Z",
    fill: "#686868"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M286.028 88.1712L285.691 88.3622L285.282 88.1257L285.609 87.9256L286.028 88.1712Z",
    fill: "#686868"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M285.083 90.4445L283.664 91.2629L281.346 89.9263L282.764 89.0988L285.083 90.4445Z",
    fill: "#686868"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M286.6 89.5988L285.654 90.1444L284.1 89.2533L285.054 88.7078L286.6 89.5988Z",
    fill: "#686868"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M277.972 83.8979L276.59 84.7072L274.326 83.3979L275.708 82.5977L277.972 83.8979Z",
    fill: "#686868"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M278.608 82.5795L277.762 83.0705L276.362 82.2703L277.216 81.7702L278.608 82.5795Z",
    fill: "#686868"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M280.381 83.6615L279.526 84.1525L278.135 83.3524L278.99 82.8523L280.381 83.6615Z",
    fill: "#686868"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M276.799 70.5228L276.717 43.9454L259.05 33.8709V60.2483L276.799 70.5228Z",
    fill: "#3F3F3F"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M276.716 43.9454L279.444 39.8265V68.9862L276.798 70.5137L276.716 43.9454Z",
    fill: "#C2C3D0"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M249.249 57.2568L251.894 58.2751V84.8889L249.249 86.4165V57.2568Z",
    fill: "#C2C3D0"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M249.249 59.8027V57.2568L279.445 39.8265V42.3724L249.249 59.8027Z",
    fill: "#C2C3D0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M229.754 75.2142V46.0273L249.248 57.2565V86.4162L229.754 75.2142Z",
    fill: "#E0E2EA"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M249.248 57.2568L229.754 46.0276L259.977 28.579L279.444 39.8265L249.248 57.2568Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M251.894 58.2843L276.716 43.9454L276.798 70.5319L251.894 84.889V58.2843Z",
    fill: "url(#paint0_linear_47_2)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M217.579 57.7659L233.772 48.3551L241.837 52.9832L225.58 62.3849L217.579 57.7659Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M217.579 57.766L217.533 106.838L225.607 111.503L225.58 62.385L217.579 57.766Z",
    fill: "#E0E2EA"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M225.581 62.3849L241.838 52.9832L241.829 55.6655L228.063 63.6396L225.581 62.3849Z",
    fill: "#C2C3D0"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M225.608 111.503L225.581 62.3848L228.063 63.6396V107.465L225.608 111.503Z",
    fill: "#C2C3D0"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M225.607 111.502L228.062 107.465L233.608 104.265V106.883L225.607 111.502Z",
    fill: "#C2C3D0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M233.609 104.265L228.062 101.055V107.466L233.609 104.265Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M226.044 69.7593L227.044 69.1682L227.017 78.9791L226.017 79.561L226.044 69.7593Z",
    fill: "#424242"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M215.188 63.4944L216.198 62.9033L227.045 69.1681L226.045 69.7591L215.188 63.4944Z",
    fill: "#252529"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M226.045 69.759L226.018 79.5607L215.161 73.2959L215.188 63.4942L226.045 69.759Z",
    fill: "#252529"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M225.307 70.1226L225.28 78.2785L215.86 72.8412L215.879 64.6852L225.307 70.1226Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M220.525 68.0495L220.507 71.9593L216.47 69.6225L216.488 65.7218L220.525 68.0495Z",
    fill: "#439B6B"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M221.962 68.7316C222.335 68.9499 222.635 69.4684 222.635 69.896C222.635 70.3235 222.335 70.4964 221.962 70.278C221.589 70.0597 221.289 69.5412 221.289 69.1136C221.289 68.6861 221.589 68.5132 221.962 68.7316Z",
    fill: "#FFD100"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M224.016 69.8589C224.389 70.0772 224.689 70.5958 224.689 71.0233C224.689 71.4509 224.389 71.6237 224.016 71.4054C223.643 71.187 223.343 70.6685 223.343 70.241C223.343 69.8134 223.643 69.6406 224.016 69.8589Z",
    fill: "#FFD100"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M221.971 71.0232V72.2513L220.907 71.6327V70.4046L221.971 71.0232Z",
    fill: "#252529"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M223.335 71.7776L223.326 72.9966L222.262 72.3871V71.159L223.335 71.7776Z",
    fill: "#252529"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M224.771 72.5689V73.797L223.707 73.1784V71.9594L224.771 72.5689Z",
    fill: "#252529"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M217.57 71.3959L217.56 72.6148L216.496 72.0054L216.505 70.7773L217.57 71.3959Z",
    fill: "#252529"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M218.925 72.1414V73.3694L217.852 72.7508L217.861 71.5319L218.925 72.1414Z",
    fill: "#252529"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M220.37 72.9416L220.361 74.1697L219.296 73.5511V72.323L220.37 72.9416Z",
    fill: "#252529"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M221.744 73.7415V74.9605L220.679 74.351V73.1229L221.744 73.7415Z",
    fill: "#252529"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M223.107 74.4874L223.098 75.7155L222.034 75.0969L222.043 73.8779L223.107 74.4874Z",
    fill: "#252529"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M224.544 75.2873V76.5154L223.479 75.8968V74.6687L224.544 75.2873Z",
    fill: "#252529"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M221.843 80.5517L224.016 86.1436C224.152 86.4982 223.77 86.8256 223.443 86.6346L219.097 84.1251C218.897 84.0069 218.833 83.7432 218.969 83.5432L221.143 80.4517C221.324 80.188 221.734 80.2426 221.843 80.5335V80.5517Z",
    fill: "#FFD100"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M223.645 86.8075C223.554 86.8075 223.472 86.7802 223.39 86.7348L219.044 84.2252C218.917 84.1525 218.835 84.0343 218.798 83.8888C218.771 83.7524 218.798 83.5978 218.88 83.4796L221.053 80.3882C221.162 80.2336 221.344 80.1518 221.535 80.17C221.726 80.1972 221.881 80.3154 221.953 80.4973L224.127 86.0892C224.208 86.2983 224.154 86.5165 223.981 86.662C223.881 86.7438 223.763 86.7893 223.645 86.7893V86.8075ZM221.472 80.4064C221.381 80.4064 221.29 80.4518 221.235 80.5337L219.062 83.6251C219.017 83.6888 218.998 83.7706 219.017 83.8524C219.035 83.9343 219.08 83.9979 219.153 84.0434L223.499 86.5529C223.626 86.6256 223.754 86.5893 223.836 86.5256C223.908 86.462 223.972 86.3438 223.917 86.1983L221.744 80.6064C221.708 80.5064 221.617 80.4336 221.508 80.4245C221.499 80.4245 221.481 80.4245 221.472 80.4245V80.4064Z",
    fill: "#1A191D"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M221.907 82.1157L221.843 84.3615L221.306 84.0524L221.225 81.7247L221.907 82.1157ZM221.879 85.1253C221.879 85.1889 221.843 85.198 221.788 85.1708L221.361 84.9253C221.306 84.898 221.279 84.8434 221.279 84.7798V84.2797C221.279 84.216 221.306 84.1888 221.361 84.2251L221.788 84.4706C221.852 84.507 221.879 84.5616 221.879 84.6252V85.1253Z",
    fill: "#252529"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M299.313 44.5183C298.449 45.0183 297.667 45.873 297.103 46.8459L297.73 47.2096C298.13 46.5095 298.685 45.9003 299.313 45.5457C299.94 45.1911 300.485 45.1547 300.895 45.3911L301.522 44.3C300.949 43.9727 300.176 44.0182 299.313 44.5183Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M299.32 47.0641C298.848 47.3368 298.438 47.8733 298.22 48.437C298.111 48.7189 298.047 49.0008 298.047 49.2645C298.047 50.0737 298.62 50.401 299.329 49.9919C300.039 49.5827 300.602 48.6007 300.593 47.7915C300.593 47.5278 300.53 47.3096 300.421 47.1641C300.202 46.8549 299.793 46.7913 299.32 47.0641Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M299.303 41.4358C297.703 42.3633 296.248 43.9454 295.203 45.7639L295.83 46.1276C296.721 44.5909 297.939 43.2452 299.303 42.4633C300.667 41.6813 301.886 41.6086 302.786 42.1178L303.413 41.0267C302.358 40.4266 300.904 40.5175 299.303 41.4358Z",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M299.293 38.3537C296.947 39.7085 294.829 42.0271 293.301 44.6821L293.929 45.0458C295.302 42.6726 297.202 40.5905 299.293 39.3812C301.385 38.1718 303.294 38.0536 304.667 38.8447L305.294 37.7536C303.758 36.8716 301.63 36.9989 299.284 38.3537H299.293Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M307.949 39.181C307.968 44.6547 304.103 51.3377 299.348 54.0927C294.583 56.8386 290.701 54.6292 290.683 49.1555C290.664 43.6909 294.529 36.9988 299.293 34.2528C304.049 31.5069 307.94 33.7164 307.958 39.1901L307.949 39.181ZM299.348 53.6745C303.912 51.0376 307.613 44.6365 307.595 39.3901C307.577 34.1528 303.858 32.0252 299.293 34.662C294.729 37.2988 291.028 43.7091 291.046 48.9463C291.065 54.1927 294.783 56.3113 299.348 53.6745Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M317.151 139.935C306.931 145.836 306.876 155.402 317.032 161.293C327.18 167.195 343.692 167.195 353.912 161.293C364.132 155.392 364.186 145.827 354.03 139.935C343.883 134.034 327.371 134.034 317.151 139.935Z",
    fill: "#BDBDBD"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M312.624 148.564V150.191C312.642 153.737 314.969 157.274 319.625 159.984C328.999 165.43 344.238 165.43 353.667 159.984C358.413 157.247 360.787 153.646 360.777 150.055V148.427C360.777 152.019 358.413 155.619 353.667 158.356C344.238 163.803 328.999 163.803 319.625 158.356C314.969 155.656 312.642 152.11 312.633 148.564H312.624Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 312,
    y: 148,
    width: 49,
    height: 17
  }, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M312.624 148.564V150.191C312.642 153.737 314.969 157.274 319.625 159.984C328.999 165.43 344.238 165.43 353.667 159.984C358.413 157.247 360.787 153.646 360.777 150.055V148.427C360.777 152.019 358.413 155.619 353.667 158.356C344.238 163.803 328.999 163.803 319.625 158.356C314.969 155.656 312.642 152.11 312.633 148.564H312.624Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.624 148.564V150.191C312.642 153.737 314.969 157.274 319.625 159.984C328.999 165.43 344.238 165.43 353.667 159.984C358.413 157.247 360.787 153.646 360.777 150.055V148.427C360.777 152.019 358.413 155.619 353.667 158.356C344.238 163.803 328.999 163.803 319.625 158.356C314.969 155.656 312.642 152.11 312.633 148.564H312.624Z",
    fill: "#252529"
  }))), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M319.734 138.635C310.305 144.081 310.25 152.91 319.625 158.356C328.999 163.803 344.238 163.803 353.667 158.356C363.096 152.91 363.151 144.081 353.776 138.635C344.411 133.188 329.163 133.188 319.734 138.635Z",
    fill: "#38373E"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M316.879 142.39V143.181C316.879 143.408 317.034 143.645 317.343 143.817C317.952 144.172 318.952 144.172 319.562 143.817C319.871 143.636 320.025 143.408 320.025 143.172V142.381C320.025 142.617 319.871 142.854 319.562 143.026C318.943 143.381 317.952 143.381 317.343 143.026C317.043 142.854 316.888 142.617 316.888 142.39H316.879Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 316,
    y: 142,
    width: 5,
    height: 3
  }, _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M316.879 142.39V143.181C316.879 143.408 317.034 143.645 317.343 143.817C317.952 144.172 318.952 144.172 319.562 143.817C319.871 143.636 320.025 143.408 320.025 143.172V142.381C320.025 142.617 319.871 142.854 319.562 143.026C318.943 143.381 317.952 143.381 317.343 143.026C317.043 142.854 316.888 142.617 316.888 142.39H316.879Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.879 142.39V143.181C316.879 143.318 316.934 143.463 317.052 143.59V142.799C316.943 142.672 316.879 142.535 316.879 142.39Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.043 142.799V143.59C317.116 143.672 317.216 143.754 317.334 143.827C317.552 143.954 317.825 144.036 318.116 144.073V143.281C317.825 143.245 317.552 143.163 317.334 143.036C317.216 142.963 317.116 142.89 317.043 142.799Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.116 143.282V144.073C318.625 144.137 319.171 144.055 319.562 143.827C319.871 143.645 320.026 143.418 320.026 143.181V142.39C320.026 142.627 319.871 142.863 319.562 143.036C319.171 143.263 318.625 143.345 318.125 143.282H318.116Z",
    fill: "#C2C3D0"
  }))), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M317.343 141.744C316.725 142.099 316.725 142.672 317.343 143.026C317.952 143.381 318.952 143.381 319.562 143.026C320.18 142.672 320.18 142.09 319.562 141.735C318.952 141.381 317.952 141.381 317.343 141.735V141.744Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M314.324 148.727V149.518C314.324 149.746 314.479 149.982 314.788 150.155C315.397 150.51 316.397 150.51 317.006 150.155C317.316 149.973 317.47 149.746 317.47 149.509V148.718C317.47 148.955 317.316 149.191 317.006 149.364C316.388 149.719 315.397 149.719 314.788 149.364C314.488 149.191 314.333 148.955 314.333 148.727H314.324Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 314,
    y: 148,
    width: 4,
    height: 3
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M314.324 148.727V149.518C314.324 149.746 314.479 149.982 314.788 150.155C315.397 150.51 316.397 150.51 317.006 150.155C317.316 149.973 317.47 149.746 317.47 149.509V148.718C317.47 148.955 317.316 149.191 317.006 149.364C316.388 149.719 315.397 149.719 314.788 149.364C314.488 149.191 314.333 148.955 314.333 148.727H314.324Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.324 148.727V149.519C314.324 149.655 314.379 149.801 314.497 149.928V149.137C314.388 149.009 314.324 148.873 314.324 148.727Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.487 149.127V149.919C314.56 150.001 314.66 150.082 314.778 150.155C314.997 150.283 315.27 150.364 315.561 150.401V149.609C315.27 149.573 314.997 149.491 314.778 149.364C314.66 149.291 314.56 149.218 314.487 149.127Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.559 149.61V150.401C316.069 150.465 316.614 150.383 317.005 150.156C317.315 149.974 317.469 149.746 317.469 149.51V148.718C317.469 148.955 317.315 149.191 317.005 149.364C316.614 149.592 316.069 149.673 315.568 149.61H315.559Z",
    fill: "#C2C3D0"
  }))), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M314.788 148.073C314.17 148.427 314.17 149 314.788 149.355C315.397 149.709 316.397 149.709 317.007 149.355C317.625 149 317.625 148.418 317.007 148.064C316.397 147.709 315.397 147.709 314.788 148.064V148.073Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M317.651 154.692V155.483C317.651 155.71 317.805 155.947 318.115 156.12C318.724 156.474 319.724 156.474 320.333 156.12C320.642 155.938 320.797 155.71 320.797 155.474V154.683C320.797 154.919 320.642 155.156 320.333 155.328C319.715 155.683 318.724 155.683 318.115 155.328C317.815 155.156 317.66 154.919 317.66 154.692H317.651Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 154,
    width: 4,
    height: 3
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M317.651 154.692V155.483C317.651 155.71 317.805 155.947 318.115 156.12C318.724 156.474 319.724 156.474 320.333 156.12C320.642 155.938 320.797 155.71 320.797 155.474V154.683C320.797 154.919 320.642 155.156 320.333 155.328C319.715 155.683 318.724 155.683 318.115 155.328C317.815 155.156 317.66 154.919 317.66 154.692H317.651Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.651 154.692V155.483C317.651 155.62 317.705 155.765 317.824 155.893V155.101C317.715 154.974 317.651 154.837 317.651 154.692Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.815 155.101V155.893C317.888 155.974 317.988 156.056 318.107 156.129C318.325 156.256 318.598 156.338 318.889 156.375V155.583C318.598 155.547 318.325 155.465 318.107 155.338C317.988 155.265 317.888 155.192 317.815 155.101Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.888 155.574V156.366C319.397 156.43 319.943 156.348 320.334 156.12C320.643 155.938 320.798 155.711 320.798 155.474V154.683C320.798 154.919 320.643 155.156 320.334 155.329C319.943 155.556 319.397 155.638 318.897 155.574H318.888Z",
    fill: "#C2C3D0"
  }))), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M318.115 154.047C317.496 154.401 317.496 154.974 318.115 155.329C318.724 155.683 319.724 155.683 320.333 155.329C320.951 154.974 320.951 154.392 320.333 154.037C319.724 153.683 318.724 153.683 318.115 154.037V154.047Z",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M324.861 158.538V159.329C324.861 159.557 325.016 159.793 325.325 159.966C325.934 160.32 326.934 160.32 327.544 159.966C327.853 159.784 328.007 159.557 328.007 159.32V158.529C328.007 158.765 327.853 159.002 327.544 159.175C326.925 159.529 325.934 159.529 325.325 159.175C325.025 159.002 324.87 158.765 324.87 158.538H324.861Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 324,
    y: 158,
    width: 5,
    height: 3
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M324.861 158.538V159.329C324.861 159.557 325.016 159.793 325.325 159.966C325.934 160.32 326.934 160.32 327.544 159.966C327.853 159.784 328.007 159.557 328.007 159.32V158.529C328.007 158.765 327.853 159.002 327.544 159.175C326.925 159.529 325.934 159.529 325.325 159.175C325.025 159.002 324.87 158.765 324.87 158.538H324.861Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.861 158.538V159.329C324.861 159.466 324.916 159.611 325.034 159.739V158.947C324.925 158.82 324.861 158.684 324.861 158.538Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.025 158.947V159.739C325.098 159.821 325.198 159.903 325.316 159.975C325.535 160.103 325.808 160.185 326.099 160.221V159.43C325.808 159.393 325.535 159.311 325.316 159.184C325.198 159.111 325.098 159.038 325.025 158.947Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.099 159.43V160.221C326.608 160.285 327.154 160.203 327.545 159.975C327.854 159.794 328.009 159.566 328.009 159.33V158.538C328.009 158.775 327.854 159.011 327.545 159.184C327.154 159.411 326.608 159.493 326.108 159.43H326.099Z",
    fill: "#C2C3D0"
  }))), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M325.325 157.893C324.707 158.247 324.707 158.82 325.325 159.175C325.934 159.529 326.934 159.529 327.544 159.175C328.162 158.82 328.162 158.238 327.544 157.884C326.934 157.529 325.934 157.529 325.325 157.884V157.893Z",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M335.328 160.002V160.793C335.328 161.02 335.482 161.257 335.791 161.43C336.401 161.784 337.401 161.784 338.01 161.43C338.319 161.248 338.474 161.02 338.474 160.784V159.993C338.474 160.229 338.319 160.466 338.01 160.639C337.392 160.993 336.401 160.993 335.791 160.639C335.491 160.466 335.337 160.229 335.337 160.002H335.328Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 159,
    width: 4,
    height: 3
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M335.328 160.002V160.793C335.328 161.02 335.482 161.257 335.791 161.43C336.401 161.784 337.401 161.784 338.01 161.43C338.319 161.248 338.474 161.02 338.474 160.784V159.993C338.474 160.229 338.319 160.466 338.01 160.639C337.392 160.993 336.401 160.993 335.791 160.639C335.491 160.466 335.337 160.229 335.337 160.002H335.328Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.328 160.002V160.794C335.328 160.93 335.382 161.076 335.5 161.203V160.412C335.391 160.284 335.328 160.148 335.328 160.002Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.492 160.402V161.193C335.564 161.275 335.665 161.357 335.783 161.43C336.001 161.557 336.274 161.639 336.565 161.676V160.884C336.274 160.848 336.001 160.766 335.783 160.639C335.665 160.566 335.564 160.493 335.492 160.402Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.564 160.884V161.676C337.073 161.74 337.619 161.658 338.01 161.43C338.32 161.248 338.474 161.021 338.474 160.784V159.993C338.474 160.23 338.32 160.466 338.01 160.639C337.619 160.866 337.073 160.948 336.573 160.884H336.564Z",
    fill: "#C2C3D0"
  }))), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M335.791 159.356C335.173 159.711 335.173 160.284 335.791 160.638C336.401 160.993 337.401 160.993 338.01 160.638C338.628 160.284 338.628 159.702 338.01 159.347C337.401 158.993 336.401 158.993 335.791 159.347V159.356Z",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M346.983 157.984V158.775C346.983 159.002 347.138 159.238 347.447 159.411C348.056 159.766 349.057 159.766 349.666 159.411C349.975 159.229 350.129 159.002 350.129 158.766V157.975C350.129 158.211 349.975 158.447 349.666 158.62C349.047 158.975 348.056 158.975 347.447 158.62C347.147 158.447 346.992 158.211 346.992 157.984H346.983Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 346,
    y: 157,
    width: 5,
    height: 3
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M346.983 157.984V158.775C346.983 159.002 347.138 159.238 347.447 159.411C348.056 159.766 349.057 159.766 349.666 159.411C349.975 159.229 350.129 159.002 350.129 158.766V157.975C350.129 158.211 349.975 158.447 349.666 158.62C349.047 158.975 348.056 158.975 347.447 158.62C347.147 158.447 346.992 158.211 346.992 157.984H346.983Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.983 157.984V158.775C346.983 158.911 347.038 159.057 347.156 159.184V158.393C347.047 158.266 346.983 158.129 346.983 157.984Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.148 158.383V159.175C347.221 159.257 347.321 159.339 347.439 159.411C347.657 159.539 347.93 159.621 348.221 159.657V158.866C347.93 158.829 347.657 158.747 347.439 158.62C347.321 158.547 347.221 158.474 347.148 158.383Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.221 158.866V159.657C348.73 159.721 349.276 159.639 349.667 159.412C349.976 159.23 350.131 159.002 350.131 158.766V157.974C350.131 158.211 349.976 158.447 349.667 158.62C349.276 158.848 348.73 158.93 348.23 158.866H348.221Z",
    fill: "#C2C3D0"
  }))), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M347.439 157.338C346.821 157.692 346.821 158.265 347.439 158.62C348.049 158.975 349.049 158.975 349.658 158.62C350.276 158.265 350.276 157.683 349.658 157.329C349.049 156.974 348.049 156.974 347.439 157.329V157.338Z",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M354.786 152.191V152.982C354.786 153.21 354.941 153.446 355.25 153.619C355.859 153.974 356.859 153.974 357.468 153.619C357.778 153.437 357.932 153.21 357.932 152.973V152.182C357.932 152.419 357.778 152.655 357.468 152.828C356.85 153.183 355.859 153.183 355.25 152.828C354.95 152.655 354.795 152.419 354.795 152.191H354.786Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 354,
    y: 152,
    width: 4,
    height: 2
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M354.786 152.191V152.982C354.786 153.21 354.941 153.446 355.25 153.619C355.859 153.974 356.859 153.974 357.468 153.619C357.778 153.437 357.932 153.21 357.932 152.973V152.182C357.932 152.419 357.778 152.655 357.468 152.828C356.85 153.183 355.859 153.183 355.25 152.828C354.95 152.655 354.795 152.419 354.795 152.191H354.786Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.786 152.191V152.983C354.786 153.119 354.84 153.265 354.958 153.392V152.601C354.849 152.473 354.786 152.337 354.786 152.191Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.949 152.6V153.392C355.022 153.474 355.122 153.556 355.24 153.628C355.458 153.756 355.731 153.838 356.022 153.874V153.082C355.731 153.046 355.458 152.964 355.24 152.837C355.122 152.764 355.022 152.691 354.949 152.6Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.021 153.083V153.874C356.53 153.938 357.076 153.856 357.467 153.629C357.776 153.447 357.931 153.219 357.931 152.983V152.191C357.931 152.428 357.776 152.664 357.467 152.837C357.076 153.065 356.53 153.147 356.03 153.083H356.021Z",
    fill: "#C2C3D0"
  }))), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M355.25 151.546C354.632 151.901 354.632 152.474 355.25 152.828C355.859 153.183 356.859 153.183 357.468 152.828C358.087 152.474 358.087 151.892 357.468 151.537C356.859 151.183 355.859 151.183 355.25 151.537V151.546Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M354.194 143.354V144.145C354.194 144.372 354.349 144.608 354.658 144.781C355.267 145.136 356.267 145.136 356.877 144.781C357.186 144.599 357.34 144.372 357.34 144.136V143.345C357.34 143.581 357.186 143.817 356.877 143.99C356.258 144.345 355.267 144.345 354.658 143.99C354.358 143.817 354.203 143.581 354.203 143.354H354.194Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 354,
    y: 143,
    width: 4,
    height: 3
  }, _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M354.194 143.354V144.145C354.194 144.372 354.349 144.608 354.658 144.781C355.267 145.136 356.267 145.136 356.877 144.781C357.186 144.599 357.34 144.372 357.34 144.136V143.345C357.34 143.581 357.186 143.817 356.877 143.99C356.258 144.345 355.267 144.345 354.658 143.99C354.358 143.817 354.203 143.581 354.203 143.354H354.194Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.194 143.354V144.145C354.194 144.281 354.249 144.427 354.367 144.554V143.763C354.258 143.636 354.194 143.499 354.194 143.354Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.358 143.763V144.554C354.431 144.636 354.531 144.718 354.649 144.791C354.867 144.918 355.14 145 355.431 145.036V144.245C355.14 144.209 354.867 144.127 354.649 143.999C354.531 143.927 354.431 143.854 354.358 143.763Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.43 144.236V145.027C355.94 145.091 356.485 145.009 356.877 144.782C357.186 144.6 357.341 144.373 357.341 144.136V143.345C357.341 143.581 357.186 143.818 356.877 143.99C356.485 144.218 355.94 144.3 355.439 144.236H355.43Z",
    fill: "#C2C3D0"
  }))), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M354.649 142.708C354.03 143.063 354.03 143.636 354.649 143.99C355.258 144.345 356.258 144.345 356.867 143.99C357.486 143.636 357.486 143.054 356.867 142.699C356.258 142.344 355.258 142.344 354.649 142.699V142.708Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M317.742 127.451L317.796 147.637C317.796 150.455 319.66 153.274 323.361 155.429C330.817 159.766 342.946 159.766 350.457 155.429C354.23 153.247 356.121 150.392 356.112 147.527L356.058 127.342C356.058 130.197 354.184 133.061 350.402 135.243C342.901 139.581 330.762 139.581 323.306 135.243C319.606 133.089 317.751 130.279 317.742 127.451Z",
    fill: "#439B6B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 127,
    width: 40,
    height: 32
  }, _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M317.742 127.451L317.796 147.637C317.796 150.455 319.66 153.274 323.361 155.429C330.817 159.766 342.946 159.766 350.457 155.429C354.23 153.247 356.121 150.392 356.112 147.527L356.058 127.342C356.058 130.197 354.184 133.061 350.402 135.243C342.901 139.581 330.762 139.581 323.306 135.243C319.606 133.089 317.751 130.279 317.742 127.451Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.742 127.451L317.796 147.637C317.796 150.455 319.66 153.274 323.361 155.429C330.817 159.766 342.946 159.766 350.457 155.429C354.23 153.247 356.121 150.392 356.112 147.527L356.058 127.342C356.058 130.197 354.184 133.061 350.402 135.243C342.901 139.581 330.762 139.581 323.306 135.243C319.606 133.089 317.751 130.279 317.742 127.451Z",
    fill: "#439B6B"
  }))), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M323.397 119.55C315.896 123.887 315.85 130.906 323.306 135.243C330.762 139.581 342.892 139.581 350.402 135.243C357.903 130.906 357.94 123.887 350.484 119.55C343.028 115.222 330.908 115.213 323.397 119.55Z",
    fill: "#4FDA8E"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M303.458 84.425L305.376 83.3066C305.685 83.1248 305.885 82.7429 305.885 82.1973L303.967 83.3157C303.967 83.8613 303.776 84.2522 303.458 84.425Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 303,
    y: 82,
    width: 3,
    height: 3
  }, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M303.458 84.425L305.376 83.3066C305.685 83.1248 305.885 82.7429 305.885 82.1973L303.967 83.3157C303.967 83.8613 303.776 84.2522 303.458 84.425Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.458 84.425L305.376 83.3066C305.685 83.1248 305.885 82.7429 305.885 82.1973L303.967 83.3157C303.967 83.8613 303.776 84.2522 303.458 84.425Z",
    fill: "#E0E2EA"
  }))), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M303.967 83.3067L305.876 82.1974L305.94 59.8025L304.03 60.9118L303.967 83.3067Z",
    fill: "#E0E2EA"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M302.976 56.6839L301.058 57.8023C301.376 57.6205 301.812 57.6478 302.294 57.9205L304.213 56.8021C303.731 56.5203 303.294 56.493 302.976 56.6839Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 301,
    y: 56,
    width: 4,
    height: 2
  }, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M302.976 56.6839L301.058 57.8023C301.376 57.6205 301.812 57.6478 302.294 57.9205L304.213 56.8021C303.731 56.5203 303.294 56.493 302.976 56.6839Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.295 57.9206L304.213 56.8022C304.086 56.7295 303.968 56.6749 303.85 56.6386L301.931 57.7569C302.049 57.7933 302.177 57.8479 302.295 57.9206Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.93 57.7478L303.848 56.6294C303.648 56.5658 303.457 56.5476 303.294 56.5658L301.375 57.6841C301.539 57.6569 301.73 57.6841 301.93 57.7478Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.376 57.693L303.295 56.5746C303.177 56.5928 303.077 56.6291 302.977 56.6837L301.058 57.8021C301.149 57.7475 301.258 57.7111 301.376 57.693Z",
    fill: "#E0E2EA"
  }))), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M304.031 60.9119L305.95 59.7935C305.95 58.6933 305.177 57.3477 304.222 56.793L302.304 57.9114C303.258 58.466 304.04 59.8026 304.031 60.9119Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 302,
    y: 56,
    width: 4,
    height: 5
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M304.031 60.9119L305.95 59.7935C305.95 58.6933 305.177 57.3477 304.222 56.793L302.304 57.9114C303.258 58.466 304.04 59.8026 304.031 60.9119Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.031 60.9121L305.95 59.7938C305.95 59.6301 305.932 59.4664 305.904 59.3028L303.986 60.4211C304.013 60.5848 304.031 60.7485 304.031 60.9121Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.977 60.4209L305.896 59.3025C305.85 59.057 305.778 58.8024 305.669 58.5569L303.75 59.6753C303.85 59.9208 303.932 60.1754 303.977 60.4209Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.759 59.6845L305.677 58.5661C305.577 58.3297 305.45 58.1024 305.314 57.8842L303.395 59.0025C303.54 59.2208 303.659 59.4481 303.759 59.6845Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.385 58.9931L305.304 57.8747C305.122 57.6019 304.904 57.3473 304.676 57.1382L302.758 58.2566C302.994 58.4657 303.203 58.7203 303.385 58.9931Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.759 58.2569L304.677 57.1386C304.532 57.0022 304.377 56.8931 304.213 56.8021L302.295 57.9205C302.459 58.0115 302.613 58.1297 302.759 58.2569Z",
    fill: "#E0E2EA"
  }))), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M302.295 57.9204C301.331 57.3658 300.558 57.8113 300.549 58.9115L300.485 81.3064C300.485 82.4065 301.258 83.7522 302.213 84.3069C303.168 84.8615 303.95 84.416 303.959 83.3158L304.022 60.9209C304.022 59.8207 303.249 58.4751 302.295 57.9204Z",
    fill: "#C2C3D0"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M320.479 122.686V126.423C320.498 128.578 322.107 130.733 325.317 132.388C331.772 135.698 342.274 135.698 348.775 132.388C352.049 130.715 353.676 128.533 353.676 126.342V122.605C353.676 124.796 352.04 126.978 348.766 128.651C342.265 131.97 331.763 131.97 325.308 128.651C322.098 127.005 320.489 124.85 320.489 122.686H320.479Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 320,
    y: 122,
    width: 34,
    height: 13
  }, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M320.479 122.686V126.423C320.498 128.578 322.107 130.733 325.317 132.388C331.772 135.698 342.274 135.698 348.775 132.388C352.049 130.715 353.676 128.533 353.676 126.342V122.605C353.676 124.796 352.04 126.978 348.766 128.651C342.265 131.97 331.763 131.97 325.308 128.651C322.098 127.005 320.489 124.85 320.489 122.686H320.479Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.479 122.686V126.423C320.498 128.578 322.107 130.733 325.317 132.388C331.772 135.698 342.274 135.698 348.775 132.388C352.049 130.715 353.676 128.533 353.676 126.342V122.605C353.676 124.796 352.04 126.978 348.766 128.651C342.265 131.97 331.763 131.97 325.308 128.651C322.098 127.005 320.489 124.85 320.489 122.686H320.479Z",
    fill: "#252529"
  }))), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M325.371 115.849C318.87 119.604 318.833 125.687 325.298 129.442C331.754 133.198 342.256 133.198 348.757 129.442C355.258 125.687 355.294 119.604 348.839 115.849C342.383 112.094 331.872 112.094 325.371 115.849Z",
    fill: "#38373E"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M330.409 101.292L320.707 106.929C321.935 106.22 323.626 106.32 325.49 107.402L335.191 101.764C333.318 100.682 331.627 100.582 330.409 101.292Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 320,
    y: 100,
    width: 16,
    height: 8
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M330.409 101.292L320.707 106.929C321.935 106.22 323.626 106.32 325.49 107.402L335.191 101.764C333.318 100.682 331.627 100.582 330.409 101.292Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.49 107.402L335.191 101.765C333.728 100.919 332.364 100.674 331.254 100.955L321.553 106.593C322.662 106.311 324.026 106.556 325.49 107.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.553 106.593L331.254 100.956C330.954 101.028 330.663 101.146 330.409 101.301L320.707 106.938C320.971 106.784 321.253 106.675 321.553 106.593Z",
    fill: "white"
  }))), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M331.49 115.14L341.192 109.502C340.091 106.338 337.818 103.283 335.19 101.765L325.489 107.402C328.117 108.92 330.39 111.966 331.49 115.14Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 325,
    y: 101,
    width: 17,
    height: 15
  }, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M331.49 115.14L341.192 109.502C340.091 106.338 337.818 103.283 335.19 101.765L325.489 107.402C328.117 108.92 330.39 111.966 331.49 115.14Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.49 115.14L341.192 109.502C340.91 108.684 340.546 107.875 340.119 107.093L330.417 112.73C330.844 113.512 331.208 114.321 331.49 115.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.417 112.73L340.119 107.093C338.891 104.856 337.136 102.892 335.19 101.765L325.489 107.402C327.444 108.529 329.189 110.493 330.417 112.73Z",
    fill: "white"
  }))), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M340.31 126.505L350.012 120.868L341.192 109.493L331.49 115.14L340.31 126.505Z",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M340.72 130.924L350.421 125.287C351.385 124.723 351.413 122.686 350.012 120.868L340.311 126.505C341.72 128.314 341.684 130.36 340.72 130.924Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 340,
    y: 120,
    width: 12,
    height: 11
  }, _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M340.72 130.924L350.421 125.287C351.385 124.723 351.413 122.686 350.012 120.868L340.311 126.505C341.72 128.314 341.684 130.36 340.72 130.924Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.719 130.924L350.421 125.287C351.248 124.805 351.385 123.232 350.521 121.65L340.819 127.287C341.683 128.869 341.547 130.442 340.719 130.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.82 127.287L350.521 121.65C350.376 121.386 350.212 121.131 350.012 120.877L340.311 126.514C340.511 126.769 340.683 127.032 340.82 127.287Z",
    fill: "white"
  }))), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M325.489 107.402C321.771 105.256 318.752 106.974 318.743 111.248C318.734 115.521 321.734 120.722 325.453 122.868L339.092 130.742C341.429 132.088 342.31 129.069 340.319 126.514L331.499 115.149C330.399 111.984 328.126 108.929 325.498 107.411L325.489 107.402Z",
    fill: "#C2C3D0"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M299.575 56.9113L296.083 58.939C296.52 58.6844 297.12 58.7117 297.784 59.0845L301.275 57.0568C300.612 56.684 300.021 56.6568 299.575 56.9113Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 296,
    y: 56,
    width: 6,
    height: 4
  }, _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M299.575 56.9113L296.083 58.939C296.52 58.6844 297.12 58.7117 297.784 59.0845L301.275 57.0568C300.612 56.684 300.021 56.6568 299.575 56.9113Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.775 59.0844L301.266 57.0568C300.757 56.7658 300.275 56.6931 299.884 56.784L296.393 58.8116C296.784 58.7116 297.265 58.7934 297.775 59.0844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.392 58.8117L299.884 56.7841C299.775 56.8114 299.666 56.8568 299.566 56.9114L296.074 58.939C296.174 58.8845 296.274 58.839 296.392 58.8117Z",
    fill: "white"
  }))), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M332.317 84.6342L335.809 82.6066C336.273 82.3429 336.554 81.761 336.554 80.9518L333.063 82.9794C333.063 83.7977 332.781 84.3706 332.317 84.6342Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 80,
    width: 5,
    height: 5
  }, _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M332.317 84.6342L335.809 82.6066C336.273 82.3429 336.554 81.761 336.554 80.9518L333.063 82.9794C333.063 83.7977 332.781 84.3706 332.317 84.6342Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.317 84.6342L335.809 82.6066C336.273 82.3429 336.554 81.761 336.554 80.9518L333.063 82.9794C333.063 83.7977 332.781 84.3706 332.317 84.6342Z",
    fill: "white"
  }))), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M330.59 77.4513L334.081 75.4145L301.266 57.0567L297.775 59.0844L330.59 77.4513Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M333.063 82.9703L336.555 80.9426V79.7788L333.063 81.8155V82.9703Z",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M333.063 81.8154L336.555 79.7878C336.555 78.1602 335.455 76.2144 334.082 75.4234L330.59 77.451C331.954 78.2421 333.063 80.1969 333.063 81.8154Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 330,
    y: 75,
    width: 7,
    height: 7
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M333.063 81.8154L336.555 79.7878C336.555 78.1602 335.455 76.2144 334.082 75.4234L330.59 77.451C331.954 78.2421 333.063 80.1969 333.063 81.8154Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.063 81.8157L336.555 79.7881C336.555 79.0061 336.3 78.1423 335.873 77.3695L332.381 79.3971C332.8 80.17 333.063 81.0337 333.063 81.8157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.382 79.388L335.873 77.3603C335.418 76.542 334.791 75.8237 334.082 75.4146L330.59 77.4422C331.29 77.8513 331.927 78.5696 332.382 79.388Z",
    fill: "white"
  }))), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M330.636 77.4058L297.821 59.0389C296.466 58.2842 295.375 58.9571 295.375 60.5664C295.375 62.1667 296.457 64.1034 297.803 64.9127L330.572 84.4161C331.972 85.2253 333.091 84.5525 333.1 82.934V81.7702C333.1 80.1426 332 78.1968 330.636 77.4058Z",
    fill: "#C2C3D0"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M305.194 92.4447L304.03 91.7719L303.139 93.3267L304.303 93.9904L305.194 92.4447Z",
    fill: "#2A2A2A"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M304.304 93.9907L303.139 93.3266L303.876 93.7633L305.049 94.4273L304.304 93.9907Z",
    fill: "#232323"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M305.195 89.5259L304.022 88.8531L304.031 91.7718L305.195 92.4446V89.5259Z",
    fill: "#303030"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M303.559 88.5715L302.386 87.8987L304.022 88.8534L305.195 89.5262L303.559 88.5715Z",
    fill: "#232323"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M303.986 87.1076L302.822 86.4347L300.349 87.8531L301.522 88.526L303.986 87.1076Z",
    fill: "#1E1E1E"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M301.523 88.5261L300.349 87.8529L300.358 89.0719L301.523 89.745V88.5261Z",
    fill: "#303030"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M301.522 89.7441L303.559 88.5712L305.195 89.5259V92.4446L304.304 93.9903L305.05 94.4268L306.25 92.3446L306.241 88.4166L303.986 87.1073L301.522 88.5257V89.7441Z",
    fill: "#2B2B2B"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M292.074 92.8632V92.2628C292.074 92.5448 292.256 92.8268 292.629 93.036V93.6364C292.256 93.4272 292.074 93.1452 292.074 92.8632Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 292,
    y: 92,
    width: 1,
    height: 2
  }, _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M292.074 92.8632V92.2628C292.074 92.5448 292.256 92.8268 292.629 93.036V93.6364C292.256 93.4272 292.074 93.1452 292.074 92.8632Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.629 93.027V93.6274C292.256 93.4182 292.074 93.1361 292.074 92.8541V92.2538C292.074 92.5358 292.256 92.8178 292.629 93.027Z",
    fill: "#C2C3D0"
  }))), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M310.796 94.9634V95.5638C310.796 95.8367 310.614 96.1187 310.25 96.328V95.7276C310.614 95.5183 310.796 95.2454 310.796 94.9634Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 310,
    y: 94,
    width: 1,
    height: 3
  }, _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M310.796 94.9634V95.5638C310.796 95.8367 310.614 96.1187 310.25 96.328V95.7276C310.614 95.5183 310.796 95.2454 310.796 94.9634Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.797 94.9634V95.5638C310.797 95.5638 310.797 95.6457 310.778 95.6912V95.0908C310.778 95.0908 310.797 95.0089 310.797 94.9634Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.786 95.0906V95.691C310.741 95.9184 310.568 96.1367 310.277 96.3186V95.7183C310.577 95.5454 310.741 95.318 310.786 95.0906Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.277 95.7091V96.3095C310.277 96.3095 310.259 96.3095 310.25 96.3186V95.7182C310.25 95.7182 310.268 95.7182 310.277 95.7091Z",
    fill: "#C2C3D0"
  }))), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M310.25 95.7271V96.3273L305.113 99.3096L305.122 98.7095L310.25 95.7271Z",
    fill: "#C2C3D0"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M302.476 98.7097L302.467 99.3098L292.629 93.636V93.0268L302.476 98.7097Z",
    fill: "#C2C3D0"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M305.122 98.7096V99.3097C304.395 99.7371 303.204 99.7371 302.477 99.3097V98.7096C303.213 99.137 304.395 99.137 305.122 98.7096Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 302,
    y: 98,
    width: 4,
    height: 2
  }, _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M305.122 98.7096V99.3097C304.395 99.7371 303.204 99.7371 302.477 99.3097V98.7096C303.213 99.137 304.395 99.137 305.122 98.7096Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.123 98.7097V99.3101C304.996 99.3828 304.859 99.4465 304.714 99.492V98.8916C304.859 98.8461 305.005 98.7825 305.123 98.7097Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.713 98.8914V99.4918C304.349 99.61 303.931 99.6555 303.53 99.6191V99.0187C303.931 99.0551 304.349 99.0096 304.713 98.8914Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.531 99.0189V99.6193C303.139 99.5829 302.767 99.4829 302.466 99.31V98.7096C302.767 98.8825 303.139 98.9825 303.531 99.0189Z",
    fill: "#C2C3D0"
  }))), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M310.25 94.1904C310.986 94.6178 310.986 95.2997 310.25 95.7271L305.113 98.7094C304.385 99.1368 303.203 99.1368 302.467 98.7094L292.629 93.0266C291.892 92.5992 291.892 91.9173 292.62 91.49L297.757 88.5076C298.484 88.0803 299.675 88.0803 300.403 88.5076L310.241 94.1904H310.25Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M294.812 90.6261L295.075 90.7807L296.876 89.7441L296.612 89.5896L294.812 90.6261Z",
    fill: "#424242"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M297.076 93.1993L295.503 94.1085L292.93 92.6264L294.503 91.7081L297.076 93.1993Z",
    fill: "#686868"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M304.221 92.854L302.648 93.7632L300.075 92.2812L301.648 91.3628L304.221 92.854Z",
    fill: "#686868"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M304.259 91.3082L303.495 91.7537L302.231 91.0263L303.004 90.5807L304.259 91.3082Z",
    fill: "#686868"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M305.905 92.2628L305.141 92.7083L303.877 91.9809L304.65 91.5354L305.905 92.2628Z",
    fill: "#686868"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M300.812 93.1903L299.603 93.8904L297.63 92.7448L298.839 92.0446L300.812 93.1903Z",
    fill: "#686868"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M303.267 94.4815L302.058 95.1816L300.084 94.0451L301.294 93.3449L303.267 94.4815Z",
    fill: "#686868"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M301.93 96.7456L300.957 97.3093L299.357 96.391L300.33 95.8181L301.93 96.7456Z",
    fill: "#686868"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M310.342 94.7363L309.369 95.3001L307.769 94.3817L308.741 93.818L310.342 94.7363Z",
    fill: "#686868"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M308.086 93.4724L307.113 94.0361L305.513 93.1178L306.495 92.5449L308.086 93.4724Z",
    fill: "#686868"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M309.214 95.4274L308.522 95.8276L307.385 95.1727L308.077 94.7724L309.214 95.4274Z",
    fill: "#686868"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M308.278 96.0181L307.578 96.4184L306.44 95.7634L307.141 95.3632L308.278 96.0181Z",
    fill: "#686868"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M307.35 96.5001L306.65 96.9094L305.522 96.2545L306.213 95.8451L307.35 96.5001Z",
    fill: "#686868"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M301.184 95.0543L299.166 96.2273L295.856 94.3178L297.884 93.1449L301.184 95.0543Z",
    fill: "#686868"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M302.567 90.3627L300.794 91.3902L297.894 89.7171L299.667 88.6897L302.567 90.3627Z",
    fill: "#686868"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M307.75 94.6634L305.977 95.6909L303.067 94.0179L304.85 92.9904L307.75 94.6634Z",
    fill: "#686868"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M302.139 95.6821L301.557 96.0187L300.775 95.5638L301.357 95.2273L302.139 95.6821Z",
    fill: "#686868"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M303.123 96.2639L302.54 96.6005L301.749 96.1456L302.331 95.809L303.123 96.2639Z",
    fill: "#686868"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M304.005 95.5184L303.25 95.9642L302.231 95.3729L302.986 94.9271L304.005 95.5184Z",
    fill: "#686868"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M304.24 94.9363L303.767 95.2092L303.139 94.8453L303.612 94.5724L304.24 94.9363Z",
    fill: "#686868"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M305.104 95.4728L304.64 95.7366L304.013 95.3819L304.477 95.109L305.104 95.4728Z",
    fill: "#686868"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M304.205 96.4367L303.741 96.7096L303.113 96.3457L303.577 96.0728L304.205 96.4367Z",
    fill: "#686868"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M304.876 96.0819L304.412 96.3457L303.785 95.9819L304.249 95.7181L304.876 96.0819Z",
    fill: "#686868"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M305.668 95.8457L305.368 96.0276L304.986 95.8093L305.295 95.6273L305.668 95.8457Z",
    fill: "#686868"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M304.804 97.9456L303.495 98.7094L301.34 97.4728L302.658 96.709L304.804 97.9456Z",
    fill: "#686868"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M306.204 97.1638L305.331 97.673L303.895 96.8547L304.777 96.3455L306.204 97.1638Z",
    fill: "#686868"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M298.231 91.9083L296.949 92.6448L294.857 91.4355L296.139 90.699L298.231 91.9083Z",
    fill: "#686868"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M298.821 90.681L298.03 91.1357L296.748 90.3992L297.53 89.9354L298.821 90.681Z",
    fill: "#686868"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M300.457 91.681L299.666 92.1356L298.384 91.39L299.166 90.9354L300.457 91.681Z",
    fill: "#686868"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M296.811 97.7733L295.647 97.1005L296.848 97.8097L298.012 98.4735L296.811 97.7733Z",
    fill: "#232323"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M301.521 88.5259L300.348 87.853L297.884 89.2806L299.048 89.9443L301.521 88.5259Z",
    fill: "#1E1E1E"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M299.048 89.9442L297.885 89.2805L295.639 93.1812L296.803 93.8449L299.048 89.9442Z",
    fill: "#2A2A2A"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M296.803 93.8449L295.639 93.1811L295.648 97.1L296.812 97.7729L296.803 93.8449Z",
    fill: "#303030"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M296.811 97.7728L298.011 98.473L298.757 97.1909L297.856 96.6636V93.7449L299.484 90.908L301.521 89.7442V88.5258L299.048 89.9442L296.802 93.8449L296.811 97.7728Z",
    fill: "#2B2B2B"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M301.74 84.4161L296.721 81.4974L296.739 87.8622L301.758 90.7809L301.74 84.4161Z",
    fill: "#C2C3D0"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M304.568 81.4427L299.549 78.524C299.249 78.3512 298.83 78.3694 298.367 78.6422L303.386 81.5609C303.849 81.2972 304.268 81.2699 304.568 81.4427Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 298,
    y: 78,
    width: 7,
    height: 4
  }, _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M304.568 81.4427L299.549 78.524C299.249 78.3512 298.83 78.3694 298.367 78.6422L303.386 81.5609C303.849 81.2972 304.268 81.2699 304.568 81.4427Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.568 81.4429L299.549 78.5242C299.403 78.4424 299.23 78.406 299.04 78.4151L304.059 81.3338C304.25 81.3247 304.422 81.3611 304.568 81.4429Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.058 81.3337L299.039 78.4151C298.93 78.4151 298.812 78.4514 298.694 78.4878L303.713 81.4065C303.831 81.361 303.949 81.3428 304.058 81.3337Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.713 81.4065L298.694 78.4878C298.594 78.5242 298.485 78.5696 298.376 78.6333L303.395 81.552C303.504 81.4883 303.613 81.4429 303.713 81.4065Z",
    fill: "#C2C3D0"
  }))), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M303.386 81.5518L298.367 78.6331C297.448 79.1605 296.712 80.4426 296.712 81.4973L301.731 84.416C301.731 83.3613 302.467 82.0792 303.386 81.5518Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 296,
    y: 78,
    width: 8,
    height: 7
  }, _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M303.386 81.5518L298.367 78.6331C297.448 79.1605 296.712 80.4426 296.712 81.4973L301.731 84.416C301.731 83.3613 302.467 82.0792 303.386 81.5518Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.384 81.5518L298.365 78.6331C298.365 78.6331 298.356 78.6331 298.347 78.6422L303.366 81.5608C303.366 81.5608 303.375 81.5609 303.384 81.5518Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.368 81.5611L298.349 78.6424C298.221 78.7151 298.103 78.797 297.994 78.897L303.013 81.8157C303.131 81.7157 303.25 81.6338 303.368 81.5611Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.012 81.8248L297.992 78.9061C297.874 79.0061 297.756 79.1243 297.647 79.2516L302.666 82.1703C302.775 82.043 302.893 81.9339 303.012 81.8248Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.668 82.1612L297.648 79.2425C297.385 79.5335 297.167 79.8881 297.003 80.2518L302.022 83.1705C302.186 82.8068 302.404 82.4522 302.668 82.1612Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.021 83.1704L297.002 80.2517C296.938 80.3881 296.893 80.5245 296.847 80.6609L301.866 83.5795C301.912 83.4432 301.957 83.3068 302.021 83.1704Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.867 83.5887L296.848 80.67C296.803 80.8155 296.766 80.9609 296.748 81.1064L301.767 84.0251C301.785 83.8796 301.822 83.7342 301.867 83.5887Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.767 84.0157L296.748 81.097C296.73 81.2334 296.712 81.3698 296.712 81.4971L301.731 84.4158C301.731 84.2885 301.74 84.1521 301.767 84.0157Z",
    fill: "#C2C3D0"
  }))), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M303.385 81.5519C302.467 82.0793 301.73 83.3613 301.73 84.4161L301.749 90.7808L305.067 88.8623L305.049 82.4975C305.049 81.4428 304.304 81.0246 303.385 81.5519Z",
    fill: "#E0E2EA"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M326.581 118.658L330.318 116.485C330.936 116.121 331.309 115.33 331.263 114.212L327.526 116.385C327.572 117.503 327.199 118.304 326.581 118.658Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 326,
    y: 114,
    width: 6,
    height: 5
  }, _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M326.581 118.658L330.318 116.485C330.936 116.121 331.309 115.33 331.263 114.212L327.526 116.385C327.572 117.503 327.199 118.304 326.581 118.658Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.581 118.658L330.318 116.485C330.936 116.121 331.309 115.33 331.263 114.212L327.526 116.385C327.572 117.503 327.199 118.304 326.581 118.658Z",
    fill: "#E0E2EA"
  }))), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M324.242 70.7957L320.505 72.9688C321.096 72.6232 321.923 72.6778 322.823 73.1961L326.56 71.023C325.66 70.5047 324.833 70.4501 324.242 70.7957Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 320,
    y: 70,
    width: 7,
    height: 4
  }, _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M324.242 70.7957L320.505 72.9688C321.096 72.6232 321.923 72.6778 322.823 73.1961L326.56 71.023C325.66 70.5047 324.833 70.4501 324.242 70.7957Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.825 73.1957L326.562 71.0226C326.217 70.8226 325.88 70.6953 325.571 70.6226L321.834 72.7957C322.152 72.8593 322.48 72.9957 322.825 73.1957Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.825 72.7957L325.562 70.6226C325.08 70.5226 324.652 70.5772 324.289 70.759L320.552 72.9321C320.906 72.7412 321.343 72.6957 321.825 72.7957Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.56 72.9322L324.297 70.7591C324.297 70.7591 324.261 70.7772 324.242 70.7954L320.505 72.9685C320.505 72.9685 320.542 72.9504 320.56 72.9322Z",
    fill: "#E0E2EA"
  }))), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M327.526 116.385L331.272 114.212L329.808 76.4601L326.071 78.6332L327.526 116.385Z",
    fill: "#E0E2EA"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M326.071 78.633L329.808 76.4599C329.726 74.4141 328.299 72.0228 326.562 71.0135L322.825 73.1866C324.562 74.1868 325.989 76.5872 326.071 78.633Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 322,
    y: 71,
    width: 8,
    height: 8
  }, _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M326.071 78.633L329.808 76.4599C329.726 74.4141 328.299 72.0228 326.562 71.0135L322.825 73.1866C324.562 74.1868 325.989 76.5872 326.071 78.633Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.071 78.6331L329.808 76.4599C329.781 75.7144 329.572 74.9324 329.235 74.1777L325.498 76.3508C325.834 77.1055 326.044 77.8875 326.071 78.6331Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.498 76.351L329.235 74.1779C328.953 73.5414 328.581 72.9322 328.144 72.4048L324.407 74.5779C324.844 75.1053 325.216 75.7145 325.498 76.351Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.407 74.5778L328.144 72.4047C327.672 71.8319 327.135 71.35 326.562 71.0135L322.825 73.1866C323.398 73.514 323.944 74.005 324.407 74.5778Z",
    fill: "#E0E2EA"
  }))), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M322.825 73.196C321.088 72.1959 319.652 72.9324 319.561 74.8781L317.897 110.821C317.797 112.912 319.279 115.558 321.143 116.631L324.271 118.44C326.135 119.513 327.626 118.586 327.535 116.395L326.08 78.6515C325.998 76.6057 324.571 74.2144 322.834 73.2051L322.825 73.196Z",
    fill: "#C2C3D0"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M320.833 108.338L319.615 109.048C320.151 108.738 320.897 108.784 321.715 109.257L322.934 108.548C322.115 108.075 321.37 108.029 320.833 108.338Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 319,
    y: 108,
    width: 4,
    height: 2
  }, _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M320.833 108.338L319.615 109.048C320.151 108.738 320.897 108.784 321.715 109.257L322.934 108.548C322.115 108.075 321.37 108.029 320.833 108.338Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.716 109.248L322.935 108.539C322.289 108.166 321.698 108.057 321.207 108.184L319.989 108.893C320.471 108.775 321.071 108.875 321.716 109.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.988 108.893L321.207 108.184C321.07 108.22 320.952 108.266 320.834 108.338L319.615 109.048C319.733 108.984 319.851 108.93 319.988 108.893Z",
    fill: "white"
  }))), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M323.798 116.231L325.016 115.521C325.543 115.212 325.871 114.558 325.88 113.63C325.88 111.757 324.571 109.475 322.943 108.538L321.725 109.248C323.352 110.184 324.671 112.466 324.661 114.339C324.661 115.267 324.334 115.922 323.798 116.231Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 321,
    y: 108,
    width: 5,
    height: 9
  }, _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M323.798 116.231L325.016 115.521C325.543 115.212 325.871 114.558 325.88 113.63C325.88 111.757 324.571 109.475 322.943 108.538L321.725 109.248C323.352 110.184 324.671 112.466 324.661 114.339C324.661 115.267 324.334 115.922 323.798 116.231Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.797 116.231L325.016 115.522C325.543 115.212 325.87 114.558 325.88 113.63C325.88 112.739 325.589 111.757 325.098 110.875L323.879 111.584C324.361 112.466 324.661 113.448 324.661 114.339C324.661 115.267 324.334 115.922 323.797 116.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.879 111.584L325.097 110.875C324.561 109.893 323.788 109.029 322.933 108.538L321.715 109.248C322.57 109.739 323.342 110.602 323.879 111.584Z",
    fill: "white"
  }))), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M321.716 109.248C320.088 108.311 318.761 109.066 318.761 110.93C318.761 112.803 320.07 115.076 321.698 116.022C323.325 116.958 324.653 116.213 324.653 114.34C324.653 112.466 323.343 110.184 321.716 109.248Z",
    fill: "#252529"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M297.429 87.5898L299.348 86.4714C299.657 86.2896 299.857 85.9077 299.857 85.3621L297.938 86.4805C297.938 87.0261 297.747 87.417 297.429 87.5898Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 297,
    y: 85,
    width: 3,
    height: 3
  }, _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M297.429 87.5898L299.348 86.4714C299.657 86.2896 299.857 85.9077 299.857 85.3621L297.938 86.4805C297.938 87.0261 297.747 87.417 297.429 87.5898Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.429 87.5898L299.348 86.4714C299.657 86.2896 299.857 85.9077 299.857 85.3621L297.938 86.4805C297.938 87.0261 297.747 87.417 297.429 87.5898Z",
    fill: "#E0E2EA"
  }))), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M297.939 86.471L299.857 85.3617L299.921 62.9669L298.003 64.0853L297.939 86.471Z",
    fill: "#E0E2EA"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M296.947 59.8483L295.029 60.9667C295.347 60.7848 295.783 60.8121 296.265 61.0849L298.184 59.9665C297.702 59.6847 297.266 59.6574 296.947 59.8483Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 59,
    width: 4,
    height: 3
  }, _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M296.947 59.8483L295.029 60.9667C295.347 60.7848 295.783 60.8121 296.265 61.0849L298.184 59.9665C297.702 59.6847 297.266 59.6574 296.947 59.8483Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.275 61.0849L298.194 59.9665C298.067 59.8938 297.948 59.8392 297.83 59.8029L295.912 60.9212C296.03 60.9576 296.157 61.0122 296.275 61.0849Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.902 60.9122L297.821 59.7938C297.621 59.7302 297.43 59.712 297.266 59.7302L295.348 60.8486C295.511 60.8213 295.702 60.8486 295.902 60.9122Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.348 60.8578L297.266 59.7395C297.148 59.7576 297.048 59.794 296.948 59.8486L295.029 60.967C295.12 60.9124 295.229 60.876 295.348 60.8578Z",
    fill: "#E0E2EA"
  }))), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M298.004 64.0855L299.922 62.9671C299.922 61.8669 299.15 60.5212 298.195 59.9666L296.276 61.0849C297.231 61.6396 298.013 62.9762 298.004 64.0855Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 296,
    y: 59,
    width: 4,
    height: 6
  }, _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M298.004 64.0855L299.922 62.9671C299.922 61.8669 299.15 60.5212 298.195 59.9666L296.276 61.0849C297.231 61.6396 298.013 62.9762 298.004 64.0855Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.003 64.0853L299.921 62.9669C299.921 62.8032 299.903 62.6396 299.876 62.4759L297.958 63.5943C297.985 63.758 298.003 63.9216 298.003 64.0853Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.957 63.5943L299.876 62.4759C299.83 62.2304 299.758 61.9758 299.648 61.7303L297.73 62.8487C297.83 63.0942 297.912 63.3488 297.957 63.5943Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.731 62.8488L299.649 61.7304C299.549 61.494 299.422 61.2667 299.286 61.0484L297.367 62.1668C297.513 62.385 297.631 62.6124 297.731 62.8488Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.367 62.1577L299.285 61.0393C299.103 60.7665 298.885 60.512 298.658 60.3028L296.739 61.4212C296.976 61.6303 297.185 61.8849 297.367 62.1577Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.74 61.4214L298.659 60.303C298.513 60.1666 298.359 60.0575 298.195 59.9666L296.276 61.0849C296.44 61.1759 296.595 61.2941 296.74 61.4214Z",
    fill: "#E0E2EA"
  }))), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M296.274 61.0848C295.31 60.5301 294.538 60.9757 294.528 62.0759L294.465 84.4707C294.465 85.5709 295.238 86.9166 296.192 87.4712C297.147 88.0259 297.929 87.5804 297.938 86.4802L298.002 64.0853C298.002 62.9851 297.229 61.6394 296.274 61.0848Z",
    fill: "#C2C3D0"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M295.667 83.7253L295.203 83.9982C295.403 83.8799 295.694 83.8981 296.003 84.0801L296.467 83.8072C296.158 83.6252 295.876 83.607 295.667 83.7253Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 83,
    width: 2,
    height: 2
  }, _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M295.667 83.7253L295.203 83.9982C295.403 83.8799 295.694 83.8981 296.003 84.0801L296.467 83.8072C296.158 83.6252 295.876 83.607 295.667 83.7253Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.994 84.0708L296.458 83.7979C296.213 83.6524 295.985 83.616 295.803 83.6615L295.339 83.9344C295.521 83.8889 295.749 83.9344 295.994 84.0708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.339 83.9347L295.803 83.6618C295.748 83.6708 295.703 83.6981 295.657 83.7163L295.193 83.9892C295.193 83.9892 295.284 83.9438 295.339 83.9347Z",
    fill: "white"
  }))), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M296.784 86.7347L297.247 86.4619C297.447 86.3437 297.575 86.0982 297.575 85.7436C297.575 85.0344 297.075 84.1615 296.456 83.8069L295.993 84.0797C296.611 84.4343 297.111 85.3072 297.111 86.0164C297.111 86.371 296.984 86.6165 296.784 86.7347Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 83,
    width: 3,
    height: 4
  }, _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M296.784 86.7347L297.247 86.4619C297.447 86.3437 297.575 86.0982 297.575 85.7436C297.575 85.0344 297.075 84.1615 296.456 83.8069L295.993 84.0797C296.611 84.4343 297.111 85.3072 297.111 86.0164C297.111 86.371 296.984 86.6165 296.784 86.7347Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.783 86.7347L297.247 86.4619C297.447 86.3437 297.574 86.0982 297.574 85.7436C297.574 85.4072 297.465 85.0344 297.274 84.6979L296.81 84.9707C296.992 85.3071 297.111 85.6799 297.111 86.0164C297.111 86.371 296.983 86.6165 296.783 86.7347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.822 84.9626L297.286 84.6897C297.085 84.3167 296.785 83.9892 296.467 83.7982L296.003 84.0711C296.33 84.2621 296.622 84.5896 296.822 84.9626Z",
    fill: "white"
  }))), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M295.993 84.071C295.374 83.7164 294.865 83.9983 294.865 84.7166C294.865 85.4258 295.365 86.2987 295.984 86.6533C296.602 87.0079 297.111 86.726 297.111 86.0077C297.111 85.2985 296.611 84.4256 295.993 84.071Z",
    fill: "#252529"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M295.312 61.8029L294.848 62.0758C295.057 61.9576 295.339 61.9758 295.649 62.1577L296.113 61.8848C295.803 61.7029 295.512 61.6847 295.312 61.8029Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 61,
    width: 3,
    height: 2
  }, _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M295.312 61.8029L294.848 62.0758C295.057 61.9576 295.339 61.9758 295.649 62.1577L296.113 61.8848C295.803 61.7029 295.512 61.6847 295.312 61.8029Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.648 62.1581L296.112 61.8852C295.866 61.7396 295.639 61.7033 295.457 61.7487L294.993 62.0216C295.175 61.9762 295.402 62.0216 295.648 62.1581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.985 62.0217L295.449 61.7488C295.394 61.7579 295.349 61.7852 295.303 61.8034L294.839 62.0763C294.839 62.0763 294.93 62.0308 294.985 62.0217Z",
    fill: "white"
  }))), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M296.439 64.8219L296.903 64.5491C297.103 64.4309 297.23 64.1854 297.23 63.8308C297.23 63.1125 296.73 62.2487 296.112 61.885L295.648 62.1578C296.266 62.5124 296.775 63.3853 296.766 64.1036C296.766 64.4582 296.639 64.7037 296.439 64.8219Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 61,
    width: 3,
    height: 4
  }, _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M296.439 64.8219L296.903 64.5491C297.103 64.4309 297.23 64.1854 297.23 63.8308C297.23 63.1125 296.73 62.2487 296.112 61.885L295.648 62.1578C296.266 62.5124 296.775 63.3853 296.766 64.1036C296.766 64.4582 296.639 64.7037 296.439 64.8219Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.439 64.8217L296.903 64.5489C297.103 64.4307 297.23 64.1852 297.23 63.8306C297.23 63.4942 297.121 63.1123 296.93 62.7759L296.466 63.0487C296.648 63.3851 296.766 63.7579 296.766 64.1034C296.766 64.458 296.639 64.7035 296.439 64.8217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.466 63.0494L296.93 62.7765C296.721 62.4035 296.43 62.076 296.103 61.885L295.639 62.1579C295.966 62.349 296.257 62.6764 296.466 63.0494Z",
    fill: "white"
  }))), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M295.648 62.158C295.03 61.8034 294.521 62.0853 294.521 62.8036C294.521 63.5219 295.021 64.3857 295.639 64.7494C296.257 65.104 296.766 64.8221 296.766 64.1038C296.766 63.3855 296.266 62.5217 295.648 62.158Z",
    fill: "#252529"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M213.497 203.464L329.236 163.057V187.298L231.018 244.008H217.471L188.211 226.941V221.14L213.497 203.464Z",
    fill: "#BDBDBD"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M258.642 108.793L248.531 114.631L248.54 172.741L258.66 166.894L258.642 108.793Z",
    fill: "#ABACC2"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M249.695 174.441V118.822L246.558 113.685V172.632L249.695 174.441Z",
    fill: "#C2C3D0"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M329.235 158.929L228.59 217.03V240.271L329.235 182.17V158.929Z",
    fill: "#53C888"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M228.591 217.031L198.395 199.6V222.841L228.591 240.271V217.031Z",
    fill: "#439B6B"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M329.236 158.929L299.04 141.49L198.395 199.6L228.545 217.03L329.236 158.929Z",
    fill: "#8C8C8C"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M307.923 132.234L305.195 130.643C304.477 130.224 303.477 130.279 302.376 130.915L305.104 132.506C306.204 131.87 307.205 131.815 307.923 132.234Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 302,
    y: 130,
    width: 6,
    height: 3
  }, _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M307.923 132.234L305.195 130.643C304.477 130.224 303.477 130.279 302.376 130.915L305.104 132.506C306.204 131.87 307.205 131.815 307.923 132.234Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.922 132.233L305.195 130.642C304.704 130.36 304.095 130.297 303.413 130.479L306.14 132.07C306.822 131.888 307.441 131.952 307.922 132.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.142 132.07L303.414 130.478C303.087 130.569 302.732 130.715 302.377 130.924L305.105 132.515C305.46 132.306 305.814 132.161 306.142 132.07Z",
    fill: "white"
  }))), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M305.105 132.516L302.368 130.925L193.367 193.863L196.104 195.445L305.105 132.516Z",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M190.566 203.264L193.294 204.855C192.584 204.437 192.139 203.564 192.139 202.31C192.139 199.791 193.903 196.718 196.094 195.454L193.366 193.863C191.175 195.126 189.402 198.2 189.411 200.718C189.411 201.973 189.857 202.846 190.566 203.264Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 189,
    y: 193,
    width: 8,
    height: 12
  }, _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M190.566 203.264L193.294 204.855C192.584 204.437 192.139 203.564 192.139 202.31C192.139 199.791 193.903 196.718 196.094 195.454L193.366 193.863C191.175 195.126 189.402 198.2 189.411 200.718C189.411 201.973 189.857 202.846 190.566 203.264Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.103 195.445L193.375 193.854C193.266 193.917 193.166 193.981 193.057 194.054L195.785 195.645C195.885 195.572 195.994 195.509 196.103 195.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.785 195.645L193.057 194.053C192.557 194.39 192.075 194.817 191.647 195.308L194.375 196.899C194.812 196.408 195.284 195.981 195.785 195.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.365 196.899L191.638 195.308C191.01 196.017 190.483 196.854 190.092 197.736L192.82 199.327C193.211 198.445 193.738 197.609 194.365 196.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.829 199.327L190.102 197.736C189.856 198.291 189.674 198.854 189.556 199.418L192.284 201.009C192.402 200.445 192.584 199.882 192.829 199.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.284 201.009L189.556 199.418C189.465 199.855 189.419 200.291 189.419 200.709C189.419 200.818 189.419 200.928 189.429 201.037L192.156 202.628C192.156 202.519 192.147 202.41 192.147 202.3C192.147 201.882 192.193 201.446 192.284 201.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.156 202.628L189.429 201.037C189.501 202.109 189.929 202.873 190.574 203.255L193.302 204.846C192.657 204.474 192.229 203.71 192.156 202.628Z",
    fill: "white"
  }))), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M196.103 195.445C193.911 196.708 192.138 199.782 192.147 202.3C192.147 204.819 193.939 205.837 196.13 204.573L305.131 141.644C307.322 140.38 309.095 137.307 309.086 134.788C309.086 132.27 307.295 131.251 305.104 132.515L196.103 195.445Z",
    fill: "#E0E2EA"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M306.023 134.28L331.272 148.955C330.663 148.6 329.809 148.646 328.872 149.191L303.622 134.516C304.559 133.98 305.404 133.925 306.023 134.28Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 303,
    y: 134,
    width: 29,
    height: 16
  }, _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M306.023 134.28L331.272 148.955C330.663 148.6 329.809 148.646 328.872 149.191L303.622 134.516C304.559 133.98 305.404 133.925 306.023 134.28Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.872 149.182L303.622 134.507C304.213 134.161 304.777 134.016 305.259 134.052L330.509 148.728C330.027 148.7 329.463 148.846 328.872 149.182Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.518 148.727L305.268 134.052C305.55 134.07 305.805 134.143 306.023 134.279L331.273 148.955C331.045 148.827 330.791 148.746 330.518 148.727Z",
    fill: "#252529"
  }))), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M222.044 210.866L196.794 196.19L303.622 134.507L328.872 149.182L222.044 210.866Z",
    fill: "#252529"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M219.67 219.858L194.42 205.183C193.811 204.828 193.438 204.082 193.438 203.019L218.688 217.694C218.688 218.758 219.07 219.503 219.67 219.858Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 203,
    width: 27,
    height: 17
  }, _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M219.67 219.858L194.42 205.183C193.811 204.828 193.438 204.082 193.438 203.019L218.688 217.694C218.688 218.758 219.07 219.503 219.67 219.858Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.67 219.858L194.42 205.183C193.811 204.828 193.438 204.082 193.438 203.019L218.688 217.694C218.688 218.758 219.07 219.503 219.67 219.858Z",
    fill: "#1A191D"
  }))), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M218.681 217.703L193.431 203.028V202.01L218.681 216.685V217.703Z",
    fill: "#1A191D"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M218.681 216.685L193.431 202.009C193.431 199.873 194.931 197.263 196.795 196.19L222.045 210.865C220.181 211.938 218.681 214.548 218.681 216.685Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 193,
    y: 196,
    width: 30,
    height: 21
  }, _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M218.681 216.685L193.431 202.009C193.431 199.873 194.931 197.263 196.795 196.19L222.045 210.865C220.181 211.938 218.681 214.548 218.681 216.685Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.681 216.685L193.431 202.009C193.431 201.309 193.585 200.564 193.867 199.836L219.117 214.512C218.835 215.239 218.681 215.985 218.681 216.685Z",
    fill: "#1A191D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.116 214.512L193.866 199.836C194.057 199.336 194.312 198.845 194.603 198.382L219.853 213.057C219.562 213.521 219.307 214.012 219.116 214.512Z",
    fill: "#1A191D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.853 213.057L194.603 198.381C195.194 197.463 195.958 196.672 196.794 196.19L222.044 210.866C221.208 211.347 220.444 212.138 219.853 213.057Z",
    fill: "#1A191D"
  }))), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M336.192 148.909L333.464 147.318C332.746 146.9 331.746 146.955 330.636 147.591L333.364 149.182C334.464 148.546 335.464 148.482 336.192 148.909Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 330,
    y: 147,
    width: 7,
    height: 3
  }, _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M336.192 148.909L333.464 147.318C332.746 146.9 331.746 146.955 330.636 147.591L333.364 149.182C334.464 148.546 335.464 148.482 336.192 148.909Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.192 148.909L333.464 147.318C332.973 147.036 332.364 146.973 331.682 147.154L334.41 148.746C335.092 148.564 335.71 148.627 336.192 148.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.41 148.746L331.683 147.155C331.355 147.246 331.001 147.391 330.646 147.6L333.374 149.191C333.728 148.982 334.083 148.837 334.41 148.746Z",
    fill: "white"
  }))), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M333.374 149.182L330.637 147.6L221.636 210.529L224.363 212.121L333.374 149.182Z",
    fill: "white"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M218.835 219.931L221.563 221.522C220.854 221.104 220.408 220.231 220.408 218.976C220.408 216.458 222.172 213.393 224.364 212.12L221.636 210.529C219.445 211.793 217.672 214.866 217.681 217.385C217.681 218.64 218.126 219.513 218.835 219.931Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 217,
    y: 210,
    width: 8,
    height: 12
  }, _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M218.835 219.931L221.563 221.522C220.854 221.104 220.408 220.231 220.408 218.976C220.408 216.458 222.172 213.393 224.364 212.12L221.636 210.529C219.445 211.793 217.672 214.866 217.681 217.385C217.681 218.64 218.126 219.513 218.835 219.931Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.363 212.12L221.635 210.529C221.526 210.593 221.426 210.656 221.317 210.729L224.045 212.32C224.145 212.248 224.254 212.184 224.363 212.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.054 212.311L221.326 210.72C220.826 211.056 220.344 211.484 219.908 211.975L222.635 213.566C223.072 213.075 223.545 212.648 224.054 212.311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.635 213.575L219.908 211.984C219.28 212.693 218.753 213.53 218.371 214.403L221.099 215.994C221.49 215.121 222.017 214.275 222.635 213.575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.09 215.994L218.362 214.403C218.117 214.957 217.935 215.521 217.817 216.085L220.545 217.676C220.663 217.112 220.845 216.549 221.09 215.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.545 217.676L217.817 216.085C217.726 216.521 217.681 216.958 217.681 217.376C217.681 217.485 217.681 217.594 217.69 217.703L220.418 219.294C220.418 219.185 220.408 219.076 220.408 218.967C220.408 218.549 220.454 218.112 220.545 217.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.416 219.303L217.688 217.712C217.761 218.785 218.189 219.549 218.834 219.931L221.562 221.522C220.916 221.149 220.489 220.385 220.416 219.303Z",
    fill: "white"
  }))), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M224.364 212.12C222.173 213.384 220.4 216.457 220.409 218.976C220.409 221.495 222.2 222.513 224.391 221.249L333.392 158.32C335.584 157.056 337.357 153.983 337.347 151.464C337.347 148.946 335.556 147.927 333.365 149.191L224.364 212.12Z",
    fill: "#C2C3D0"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M226.828 214.448L225.955 213.939C225.555 213.712 225.01 213.739 224.4 214.093L225.273 214.603C225.882 214.248 226.428 214.221 226.828 214.448Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 213,
    width: 3,
    height: 2
  }, _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M226.828 214.448L225.955 213.939C225.555 213.712 225.01 213.739 224.4 214.093L225.273 214.603C225.882 214.248 226.428 214.221 226.828 214.448Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.828 214.448L225.954 213.939C225.763 213.83 225.536 213.775 225.281 213.793L226.155 214.303C226.409 214.285 226.637 214.339 226.828 214.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.154 214.303L225.281 213.793C225.135 213.802 224.981 213.839 224.817 213.893L225.69 214.403C225.854 214.348 226.009 214.312 226.154 214.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.701 214.403L224.828 213.894C224.691 213.939 224.546 214.012 224.4 214.094L225.274 214.603C225.419 214.521 225.556 214.458 225.701 214.403Z",
    fill: "white"
  }))), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M222.862 219.267L223.735 219.776C223.344 219.549 223.098 219.067 223.098 218.376C223.098 216.994 224.071 215.303 225.281 214.603L224.408 214.093C223.198 214.794 222.226 216.485 222.226 217.867C222.226 218.558 222.471 219.04 222.862 219.267Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 214,
    width: 4,
    height: 6
  }, _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M222.862 219.267L223.735 219.776C223.344 219.549 223.098 219.067 223.098 218.376C223.098 216.994 224.071 215.303 225.281 214.603L224.408 214.093C223.198 214.794 222.226 216.485 222.226 217.867C222.226 218.558 222.471 219.04 222.862 219.267Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.272 214.594L224.399 214.084C224.399 214.084 224.38 214.084 224.38 214.093L225.254 214.603C225.254 214.603 225.272 214.603 225.272 214.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.254 214.612L224.381 214.103C224.217 214.203 224.062 214.312 223.908 214.439L224.781 214.949C224.936 214.821 225.09 214.703 225.254 214.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.774 214.949L223.9 214.439C223.737 214.576 223.582 214.73 223.437 214.894L224.31 215.403C224.455 215.24 224.61 215.085 224.774 214.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.319 215.403L223.446 214.894C223.1 215.285 222.809 215.74 222.6 216.222L223.473 216.731C223.682 216.249 223.973 215.794 224.319 215.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.473 216.73L222.6 216.221C222.518 216.403 222.454 216.585 222.399 216.767L223.273 217.276C223.327 217.094 223.4 216.912 223.473 216.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.272 217.276L222.399 216.766C222.344 216.957 222.299 217.148 222.262 217.339L223.136 217.849C223.163 217.658 223.208 217.467 223.272 217.276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.135 217.849L222.262 217.339C222.235 217.521 222.216 217.694 222.216 217.867L223.09 218.376C223.09 218.204 223.108 218.031 223.135 217.849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 218.376L222.216 217.867C222.216 218.058 222.234 218.231 222.271 218.395L223.144 218.904C223.108 218.749 223.09 218.567 223.09 218.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.154 218.903L222.28 218.394C222.371 218.803 222.58 219.103 222.862 219.267L223.736 219.777C223.454 219.613 223.245 219.313 223.154 218.903Z",
    fill: "white"
  }))), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M225.272 214.594C224.063 215.294 223.09 216.985 223.09 218.367C223.09 219.758 224.072 220.313 225.281 219.613C226.49 218.913 227.463 217.231 227.463 215.839C227.463 214.457 226.481 213.894 225.272 214.594Z",
    fill: "#252529"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M226.827 215.703L226.263 215.375C226 215.221 225.645 215.248 225.245 215.476L225.809 215.803C226.209 215.576 226.564 215.557 226.827 215.703Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 215,
    width: 2,
    height: 1
  }, _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M226.827 215.703L226.263 215.375C226 215.221 225.645 215.248 225.245 215.476L225.809 215.803C226.209 215.576 226.564 215.557 226.827 215.703Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.827 215.703L226.263 215.375C226.135 215.303 225.99 215.266 225.826 215.284L226.39 215.612C226.554 215.603 226.699 215.63 226.827 215.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.391 215.612L225.827 215.285C225.736 215.285 225.626 215.312 225.526 215.348L226.09 215.676C226.2 215.639 226.3 215.621 226.391 215.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.091 215.676L225.527 215.348C225.436 215.376 225.345 215.421 225.254 215.476L225.818 215.803C225.909 215.749 226.009 215.703 226.091 215.676Z",
    fill: "white"
  }))), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M224.244 218.858L224.808 219.185C224.553 219.04 224.39 218.722 224.39 218.267C224.39 217.367 225.026 216.258 225.808 215.803L225.244 215.476C224.453 215.93 223.817 217.031 223.826 217.94C223.826 218.385 223.989 218.704 224.244 218.858Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 215,
    width: 3,
    height: 5
  }, _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M224.244 218.858L224.808 219.185C224.553 219.04 224.39 218.722 224.39 218.267C224.39 217.367 225.026 216.258 225.808 215.803L225.244 215.476C224.453 215.93 223.817 217.031 223.826 217.94C223.826 218.385 223.989 218.704 224.244 218.858Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.818 215.803L225.254 215.476C225.254 215.476 225.245 215.476 225.236 215.476L225.8 215.803C225.8 215.803 225.809 215.803 225.818 215.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.799 215.812L225.235 215.485C225.126 215.548 225.026 215.621 224.926 215.703L225.49 216.031C225.59 215.949 225.69 215.876 225.799 215.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.491 216.039L224.927 215.712C224.817 215.803 224.717 215.903 224.626 216.012L225.19 216.339C225.281 216.23 225.381 216.13 225.491 216.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.19 216.33L224.626 216.003C224.399 216.258 224.217 216.558 224.071 216.867L224.635 217.195C224.772 216.876 224.963 216.576 225.19 216.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.644 217.194L224.08 216.867C224.026 216.985 223.98 217.103 223.944 217.221L224.508 217.549C224.544 217.431 224.59 217.312 224.644 217.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.508 217.549L223.944 217.221C223.907 217.349 223.88 217.467 223.853 217.594L224.417 217.922C224.435 217.794 224.462 217.676 224.508 217.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.426 217.922L223.862 217.594C223.844 217.712 223.835 217.821 223.835 217.94L224.399 218.267C224.399 218.149 224.408 218.04 224.426 217.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.39 218.276L223.826 217.949C223.826 218.076 223.835 218.185 223.862 218.294L224.426 218.622C224.399 218.522 224.39 218.404 224.39 218.276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.435 218.612L223.871 218.285C223.935 218.549 224.062 218.749 224.253 218.849L224.817 219.176C224.635 219.067 224.499 218.876 224.435 218.612Z",
    fill: "white"
  }))), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M225.818 215.803C225.027 216.257 224.391 217.357 224.4 218.267C224.4 219.176 225.046 219.54 225.828 219.085C226.619 218.63 227.255 217.53 227.246 216.621C227.246 215.721 226.6 215.348 225.818 215.803Z",
    fill: "#252529"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M245.121 203.592L244.248 203.083C243.848 202.855 243.302 202.883 242.693 203.237L243.566 203.746C244.175 203.392 244.721 203.364 245.121 203.592Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 242,
    y: 202,
    width: 4,
    height: 2
  }, _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M245.121 203.592L244.248 203.083C243.848 202.855 243.302 202.883 242.693 203.237L243.566 203.746C244.175 203.392 244.721 203.364 245.121 203.592Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.122 203.592L244.248 203.082C244.057 202.973 243.83 202.919 243.575 202.937L244.449 203.446C244.703 203.428 244.931 203.483 245.122 203.592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.45 203.446L243.577 202.937C243.431 202.946 243.277 202.982 243.113 203.037L243.986 203.546C244.15 203.492 244.304 203.455 244.45 203.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.985 203.546L243.112 203.037C242.976 203.082 242.83 203.155 242.685 203.237L243.558 203.746C243.703 203.664 243.84 203.601 243.985 203.546Z",
    fill: "white"
  }))), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M241.157 208.42L242.029 208.929C241.638 208.702 241.393 208.22 241.393 207.529C241.393 206.147 242.366 204.456 243.575 203.756L242.702 203.247C241.493 203.947 240.52 205.638 240.52 207.02C240.52 207.711 240.766 208.193 241.157 208.42Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 240,
    y: 203,
    width: 4,
    height: 6
  }, _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M241.157 208.42L242.029 208.929C241.638 208.702 241.393 208.22 241.393 207.529C241.393 206.147 242.366 204.456 243.575 203.756L242.702 203.247C241.493 203.947 240.52 205.638 240.52 207.02C240.52 207.711 240.766 208.193 241.157 208.42Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.566 203.746L242.692 203.237C242.692 203.237 242.674 203.237 242.674 203.246L243.548 203.756C243.548 203.756 243.566 203.756 243.566 203.746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.539 203.756L242.666 203.246C242.502 203.346 242.348 203.455 242.193 203.583L243.066 204.092C243.221 203.965 243.375 203.846 243.539 203.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.066 204.092L242.193 203.582C242.029 203.719 241.875 203.874 241.729 204.037L242.602 204.547C242.748 204.383 242.902 204.228 243.066 204.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.611 204.546L241.738 204.037C241.392 204.428 241.101 204.883 240.892 205.365L241.765 205.874C241.975 205.392 242.266 204.928 242.611 204.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.766 205.883L240.893 205.374C240.811 205.556 240.747 205.738 240.692 205.919L241.566 206.429C241.62 206.247 241.693 206.065 241.766 205.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.557 206.42L240.684 205.91C240.629 206.101 240.584 206.292 240.547 206.483L241.421 206.993C241.448 206.802 241.493 206.611 241.557 206.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.43 206.992L240.557 206.483C240.529 206.665 240.511 206.838 240.511 207.011L241.385 207.52C241.385 207.338 241.403 207.165 241.43 206.983V206.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.385 207.529L240.511 207.019C240.511 207.21 240.529 207.383 240.566 207.547L241.439 208.056C241.403 207.902 241.385 207.72 241.385 207.529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.439 208.056L240.565 207.547C240.656 207.956 240.866 208.256 241.148 208.42L242.021 208.929C241.739 208.766 241.53 208.465 241.439 208.056Z",
    fill: "white"
  }))), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M243.566 203.746C242.357 204.446 241.384 206.138 241.384 207.52C241.384 208.911 242.366 209.465 243.576 208.765C244.785 208.065 245.758 206.383 245.758 204.992C245.758 203.61 244.776 203.046 243.566 203.746Z",
    fill: "#252529"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M245.123 204.855L244.559 204.528C244.295 204.373 243.94 204.401 243.54 204.628L244.104 204.955C244.504 204.728 244.859 204.71 245.123 204.855Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 243,
    y: 204,
    width: 3,
    height: 1
  }, _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M245.123 204.855L244.559 204.528C244.295 204.373 243.94 204.401 243.54 204.628L244.104 204.955C244.504 204.728 244.859 204.71 245.123 204.855Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.121 204.856L244.557 204.528C244.43 204.455 244.284 204.419 244.121 204.437L244.685 204.765C244.848 204.756 244.994 204.783 245.121 204.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.683 204.765L244.119 204.437C244.028 204.437 243.919 204.464 243.819 204.501L244.383 204.828C244.492 204.792 244.592 204.774 244.683 204.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.385 204.828L243.821 204.501C243.73 204.528 243.639 204.574 243.548 204.628L244.112 204.956C244.203 204.901 244.303 204.856 244.385 204.828Z",
    fill: "white"
  }))), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M242.539 208.001L243.103 208.329C242.848 208.183 242.684 207.865 242.684 207.41C242.684 206.51 243.321 205.401 244.103 204.946L243.539 204.619C242.748 205.074 242.112 206.174 242.121 207.083C242.121 207.529 242.284 207.847 242.539 208.001Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 242,
    y: 204,
    width: 3,
    height: 5
  }, _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M242.539 208.001L243.103 208.329C242.848 208.183 242.684 207.865 242.684 207.41C242.684 206.51 243.321 205.401 244.103 204.946L243.539 204.619C242.748 205.074 242.112 206.174 242.121 207.083C242.121 207.529 242.284 207.847 242.539 208.001Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.102 204.956L243.538 204.628C243.538 204.628 243.529 204.628 243.52 204.628L244.084 204.956C244.084 204.956 244.093 204.956 244.102 204.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.093 204.965L243.529 204.637C243.42 204.701 243.32 204.774 243.22 204.855L243.784 205.183C243.884 205.101 243.984 205.028 244.093 204.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.784 205.183L243.22 204.855C243.11 204.946 243.01 205.046 242.919 205.156L243.483 205.483C243.574 205.374 243.674 205.274 243.784 205.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.485 205.483L242.921 205.155C242.693 205.41 242.511 205.71 242.366 206.019L242.93 206.347C243.066 206.029 243.257 205.728 243.485 205.483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.929 206.347L242.365 206.019C242.31 206.137 242.265 206.256 242.229 206.374L242.793 206.701C242.829 206.583 242.874 206.465 242.929 206.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.802 206.701L242.238 206.374C242.202 206.501 242.174 206.619 242.147 206.747L242.711 207.074C242.729 206.947 242.756 206.829 242.802 206.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.712 207.074L242.148 206.747C242.13 206.865 242.121 206.974 242.121 207.092L242.685 207.429C242.685 207.32 242.694 207.201 242.712 207.083V207.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.685 207.42L242.121 207.092C242.121 207.22 242.13 207.329 242.157 207.438L242.721 207.765C242.694 207.665 242.685 207.547 242.685 207.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.72 207.765L242.156 207.437C242.219 207.701 242.347 207.901 242.538 208.001L243.102 208.329C242.92 208.22 242.783 208.029 242.72 207.765Z",
    fill: "white"
  }))), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M244.103 204.955C243.312 205.41 242.675 206.51 242.684 207.419C242.684 208.329 243.33 208.692 244.112 208.238C244.903 207.783 245.539 206.683 245.53 205.774C245.53 204.874 244.885 204.501 244.103 204.955Z",
    fill: "#252529"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M263.542 192.826L262.67 192.317C262.269 192.09 261.724 192.117 261.115 192.472L261.988 192.981C262.597 192.626 263.142 192.599 263.542 192.826Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 261,
    y: 192,
    width: 3,
    height: 1
  }, _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M263.542 192.826L262.67 192.317C262.269 192.09 261.724 192.117 261.115 192.472L261.988 192.981C262.597 192.626 263.142 192.599 263.542 192.826Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.544 192.827L262.671 192.317C262.48 192.208 262.252 192.154 261.998 192.172L262.871 192.681C263.126 192.663 263.353 192.718 263.544 192.827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.871 192.681L261.998 192.172C261.852 192.181 261.697 192.217 261.534 192.272L262.407 192.781C262.571 192.727 262.725 192.69 262.871 192.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.416 192.781L261.543 192.272C261.406 192.317 261.261 192.39 261.115 192.472L261.989 192.981C262.134 192.899 262.271 192.836 262.416 192.781Z",
    fill: "white"
  }))), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M259.577 197.654L260.45 198.164C260.059 197.936 259.814 197.454 259.814 196.763C259.814 195.381 260.787 193.69 261.996 192.99L261.123 192.481C259.914 193.181 258.941 194.872 258.941 196.254C258.941 196.945 259.186 197.427 259.577 197.654Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 258,
    y: 192,
    width: 4,
    height: 7
  }, _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M259.577 197.654L260.45 198.164C260.059 197.936 259.814 197.454 259.814 196.763C259.814 195.381 260.787 193.69 261.996 192.99L261.123 192.481C259.914 193.181 258.941 194.872 258.941 196.254C258.941 196.945 259.186 197.427 259.577 197.654Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.988 192.981L261.114 192.472C261.114 192.472 261.096 192.472 261.096 192.481L261.969 192.99C261.969 192.99 261.988 192.99 261.988 192.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.971 192.99L261.098 192.481C260.934 192.581 260.779 192.69 260.625 192.817L261.498 193.327C261.652 193.199 261.807 193.081 261.971 192.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.498 193.326L260.625 192.817C260.461 192.953 260.306 193.108 260.161 193.272L261.034 193.781C261.179 193.617 261.334 193.463 261.498 193.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.034 193.781L260.16 193.272C259.815 193.663 259.524 194.118 259.314 194.6L260.188 195.109C260.397 194.627 260.688 194.163 261.034 193.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.189 195.118L259.315 194.608C259.233 194.79 259.17 194.972 259.115 195.154L259.989 195.664C260.043 195.482 260.116 195.3 260.189 195.118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.988 195.654L259.115 195.145C259.06 195.336 259.015 195.527 258.979 195.718L259.852 196.227C259.879 196.036 259.925 195.845 259.988 195.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.851 196.227L258.978 195.718C258.951 195.9 258.933 196.072 258.933 196.245L259.806 196.755C259.806 196.582 259.824 196.409 259.851 196.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.806 196.764L258.933 196.254C258.933 196.445 258.951 196.618 258.987 196.782L259.86 197.291C259.824 197.137 259.806 196.955 259.806 196.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.869 197.291L258.996 196.782C259.087 197.191 259.296 197.491 259.578 197.655L260.451 198.164C260.169 198.001 259.96 197.7 259.869 197.291Z",
    fill: "white"
  }))), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M261.988 192.981C260.779 193.681 259.806 195.372 259.806 196.754C259.806 198.145 260.788 198.7 261.997 198C263.207 197.3 264.18 195.617 264.18 194.226C264.18 192.844 263.198 192.28 261.988 192.981Z",
    fill: "#252529"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M263.543 194.09L262.979 193.763C262.715 193.608 262.36 193.636 261.96 193.863L262.524 194.191C262.924 193.963 263.279 193.945 263.543 194.09Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 261,
    y: 193,
    width: 3,
    height: 2
  }, _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M263.543 194.09L262.979 193.763C262.715 193.608 262.36 193.636 261.96 193.863L262.524 194.191C262.924 193.963 263.279 193.945 263.543 194.09Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.544 194.09L262.98 193.763C262.852 193.69 262.707 193.654 262.543 193.672L263.107 194C263.271 193.99 263.416 194.018 263.544 194.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.106 193.999L262.542 193.672C262.451 193.672 262.342 193.699 262.242 193.736L262.806 194.063C262.915 194.027 263.015 194.008 263.106 193.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.805 194.063L262.241 193.736C262.15 193.763 262.059 193.809 261.968 193.863L262.532 194.191C262.623 194.136 262.723 194.091 262.805 194.063Z",
    fill: "white"
  }))), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M260.96 197.236L261.524 197.564C261.269 197.418 261.105 197.1 261.105 196.645C261.105 195.745 261.742 194.636 262.524 194.181L261.96 193.854C261.169 194.309 260.533 195.409 260.542 196.318C260.542 196.764 260.705 197.082 260.96 197.236Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 260,
    y: 193,
    width: 3,
    height: 5
  }, _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M260.96 197.236L261.524 197.564C261.269 197.418 261.105 197.1 261.105 196.645C261.105 195.745 261.742 194.636 262.524 194.181L261.96 193.854C261.169 194.309 260.533 195.409 260.542 196.318C260.542 196.764 260.705 197.082 260.96 197.236Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.534 194.19L261.97 193.863C261.97 193.863 261.961 193.863 261.952 193.863L262.516 194.19C262.516 194.19 262.525 194.19 262.534 194.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.516 194.2L261.952 193.872C261.843 193.936 261.743 194.008 261.643 194.09L262.207 194.418C262.307 194.336 262.407 194.263 262.516 194.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.207 194.418L261.643 194.09C261.534 194.181 261.434 194.281 261.343 194.39L261.907 194.718C261.998 194.609 262.098 194.509 262.207 194.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.906 194.709L261.342 194.381C261.115 194.636 260.933 194.936 260.787 195.245L261.351 195.573C261.488 195.254 261.679 194.954 261.906 194.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.362 195.582L260.798 195.254C260.743 195.372 260.698 195.491 260.661 195.609L261.225 195.936C261.262 195.818 261.307 195.7 261.362 195.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.224 195.936L260.66 195.608C260.624 195.736 260.597 195.854 260.569 195.981L261.133 196.309C261.152 196.182 261.179 196.063 261.224 195.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.142 196.309L260.578 195.981C260.56 196.1 260.551 196.209 260.551 196.327L261.115 196.655C261.115 196.536 261.124 196.427 261.142 196.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.115 196.655L260.551 196.327C260.551 196.454 260.56 196.564 260.587 196.673L261.151 197C261.124 196.9 261.115 196.782 261.115 196.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.152 197L260.588 196.672C260.652 196.936 260.779 197.136 260.97 197.236L261.534 197.564C261.352 197.455 261.216 197.264 261.152 197Z",
    fill: "white"
  }))), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M262.533 194.19C261.742 194.645 261.106 195.745 261.115 196.654C261.115 197.564 261.76 197.927 262.542 197.473C263.333 197.018 263.97 195.918 263.961 195.009C263.961 194.108 263.315 193.736 262.533 194.19Z",
    fill: "#252529"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M282.491 181.979L281.618 181.47C281.218 181.242 280.673 181.27 280.063 181.624L280.936 182.133C281.546 181.779 282.091 181.752 282.491 181.979Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 280,
    y: 181,
    width: 3,
    height: 2
  }, _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M282.491 181.979L281.618 181.47C281.218 181.242 280.673 181.27 280.063 181.624L280.936 182.133C281.546 181.779 282.091 181.752 282.491 181.979Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.492 181.979L281.619 181.47C281.428 181.36 281.201 181.306 280.946 181.324L281.819 181.833C282.074 181.815 282.301 181.87 282.492 181.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.82 181.834L280.947 181.324C280.801 181.333 280.647 181.37 280.483 181.424L281.356 181.934C281.52 181.879 281.675 181.843 281.82 181.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.356 181.934L280.483 181.424C280.347 181.47 280.201 181.543 280.056 181.624L280.929 182.134C281.074 182.052 281.211 181.988 281.356 181.934Z",
    fill: "white"
  }))), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M278.528 186.798L279.4 187.307C279.009 187.08 278.764 186.598 278.764 185.907C278.764 184.525 279.737 182.834 280.946 182.134L280.073 181.624C278.864 182.324 277.891 184.016 277.891 185.398C277.891 186.089 278.137 186.571 278.528 186.798Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 277,
    y: 181,
    width: 4,
    height: 7
  }, _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M278.528 186.798L279.4 187.307C279.009 187.08 278.764 186.598 278.764 185.907C278.764 184.525 279.737 182.834 280.946 182.134L280.073 181.624C278.864 182.324 277.891 184.016 277.891 185.398C277.891 186.089 278.137 186.571 278.528 186.798Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.937 182.124L280.064 181.615C280.064 181.615 280.046 181.615 280.046 181.624L280.919 182.133C280.919 182.133 280.937 182.133 280.937 182.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.919 182.143L280.046 181.633C279.882 181.733 279.727 181.842 279.573 181.97L280.446 182.479C280.601 182.352 280.755 182.234 280.919 182.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.437 182.479L279.564 181.969C279.4 182.106 279.245 182.261 279.1 182.424L279.973 182.934C280.118 182.77 280.273 182.615 280.437 182.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.982 182.933L279.109 182.424C278.763 182.815 278.472 183.27 278.263 183.752L279.136 184.261C279.346 183.779 279.637 183.325 279.982 182.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.136 184.261L278.263 183.752C278.181 183.934 278.118 184.116 278.063 184.297L278.936 184.807C278.991 184.625 279.064 184.443 279.136 184.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.936 184.807L278.062 184.297C278.008 184.488 277.962 184.679 277.926 184.87L278.799 185.38C278.826 185.189 278.872 184.998 278.936 184.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.8 185.37L277.927 184.861C277.9 185.043 277.881 185.216 277.881 185.388L278.755 185.898C278.755 185.725 278.773 185.552 278.8 185.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.755 185.907L277.881 185.398C277.881 185.589 277.9 185.762 277.936 185.925L278.809 186.435C278.773 186.28 278.755 186.098 278.755 185.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.818 186.434L277.944 185.925C278.035 186.334 278.245 186.634 278.527 186.798L279.4 187.307C279.118 187.144 278.909 186.844 278.818 186.434Z",
    fill: "white"
  }))), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M280.937 182.124C279.727 182.824 278.754 184.516 278.754 185.898C278.754 187.289 279.736 187.843 280.946 187.143C282.155 186.443 283.128 184.761 283.128 183.37C283.128 181.988 282.146 181.424 280.937 182.124Z",
    fill: "#252529"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M282.491 183.234L281.927 182.906C281.663 182.752 281.308 182.779 280.908 183.006L281.472 183.334C281.872 183.106 282.227 183.088 282.491 183.234Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 280,
    y: 182,
    width: 3,
    height: 2
  }, _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M282.491 183.234L281.927 182.906C281.663 182.752 281.308 182.779 280.908 183.006L281.472 183.334C281.872 183.106 282.227 183.088 282.491 183.234Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.491 183.234L281.927 182.906C281.8 182.834 281.654 182.797 281.491 182.815L282.055 183.143C282.218 183.134 282.364 183.161 282.491 183.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.055 183.143L281.491 182.816C281.4 182.816 281.29 182.843 281.19 182.879L281.754 183.207C281.864 183.17 281.964 183.152 282.055 183.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.755 183.206L281.191 182.879C281.1 182.906 281.009 182.952 280.918 183.006L281.482 183.334C281.573 183.279 281.674 183.234 281.755 183.206Z",
    fill: "white"
  }))), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M279.91 186.38L280.473 186.707C280.219 186.562 280.055 186.243 280.055 185.789C280.055 184.888 280.692 183.779 281.473 183.325L280.91 182.997C280.119 183.452 279.482 184.552 279.491 185.461C279.491 185.907 279.655 186.225 279.91 186.38Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 279,
    y: 182,
    width: 3,
    height: 5
  }, _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M279.91 186.38L280.473 186.707C280.219 186.562 280.055 186.243 280.055 185.789C280.055 184.888 280.692 183.779 281.473 183.325L280.91 182.997C280.119 183.452 279.482 184.552 279.491 185.461C279.491 185.907 279.655 186.225 279.91 186.38Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.482 183.333L280.918 183.006C280.918 183.006 280.909 183.006 280.899 183.006L281.463 183.333C281.463 183.333 281.472 183.333 281.482 183.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.464 183.343L280.9 183.015C280.791 183.079 280.691 183.152 280.591 183.234L281.155 183.561C281.255 183.479 281.355 183.406 281.464 183.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.156 183.561L280.592 183.233C280.483 183.324 280.382 183.424 280.292 183.534L280.855 183.861C280.946 183.752 281.047 183.652 281.156 183.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.854 183.861L280.29 183.534C280.062 183.788 279.88 184.089 279.735 184.398L280.299 184.725C280.435 184.407 280.626 184.107 280.854 183.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.309 184.725L279.745 184.397C279.69 184.516 279.645 184.634 279.608 184.752L280.172 185.08C280.209 184.961 280.254 184.843 280.309 184.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.173 185.079L279.609 184.752C279.573 184.879 279.545 184.998 279.518 185.125L280.082 185.452C280.1 185.325 280.128 185.207 280.173 185.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.083 185.452L279.519 185.125C279.5 185.243 279.491 185.352 279.491 185.47L280.055 185.807C280.055 185.689 280.064 185.579 280.083 185.461V185.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.055 185.798L279.491 185.47C279.491 185.597 279.5 185.707 279.528 185.816L280.092 186.143C280.064 186.043 280.055 185.925 280.055 185.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.1 186.143L279.536 185.816C279.6 186.08 279.727 186.28 279.918 186.38L280.482 186.707C280.3 186.598 280.164 186.407 280.1 186.143Z",
    fill: "white"
  }))), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M281.482 183.333C280.69 183.788 280.054 184.888 280.063 185.797C280.063 186.707 280.709 187.07 281.491 186.616C282.282 186.161 282.918 185.061 282.909 184.152C282.909 183.252 282.263 182.879 281.482 183.333Z",
    fill: "#252529"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M300.632 171.731L299.759 171.222C299.359 170.995 298.814 171.022 298.205 171.377L299.077 171.886C299.687 171.531 300.232 171.504 300.632 171.731Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 298,
    y: 171,
    width: 3,
    height: 1
  }, _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M300.632 171.731L299.759 171.222C299.359 170.995 298.814 171.022 298.205 171.377L299.077 171.886C299.687 171.531 300.232 171.504 300.632 171.731Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.632 171.732L299.759 171.222C299.568 171.113 299.34 171.058 299.085 171.077L299.959 171.586C300.213 171.568 300.441 171.622 300.632 171.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.958 171.586L299.085 171.077C298.939 171.086 298.784 171.122 298.621 171.177L299.494 171.686C299.658 171.632 299.812 171.595 299.958 171.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.495 171.686L298.622 171.177C298.485 171.222 298.34 171.295 298.194 171.377L299.068 171.886C299.213 171.804 299.35 171.741 299.495 171.686Z",
    fill: "white"
  }))), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M296.667 176.56L297.54 177.069C297.149 176.841 296.903 176.36 296.903 175.668C296.903 174.286 297.876 172.595 299.085 171.895L298.212 171.386C297.003 172.086 296.03 173.777 296.03 175.159C296.03 175.85 296.276 176.332 296.667 176.56Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 296,
    y: 171,
    width: 4,
    height: 7
  }, _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M296.667 176.56L297.54 177.069C297.149 176.841 296.903 176.36 296.903 175.668C296.903 174.286 297.876 172.595 299.085 171.895L298.212 171.386C297.003 172.086 296.03 173.777 296.03 175.159C296.03 175.85 296.276 176.332 296.667 176.56Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.076 171.886L298.202 171.377C298.202 171.377 298.184 171.377 298.184 171.386L299.057 171.895C299.057 171.895 299.076 171.895 299.076 171.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.049 171.895L298.176 171.386C298.012 171.486 297.858 171.595 297.703 171.723L298.576 172.232C298.731 172.105 298.886 171.986 299.049 171.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.577 172.232L297.704 171.722C297.54 171.859 297.386 172.013 297.24 172.177L298.114 172.687C298.259 172.523 298.414 172.368 298.577 172.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.123 172.686L297.249 172.177C296.904 172.568 296.613 173.023 296.403 173.505L297.277 174.015C297.486 173.532 297.777 173.068 298.123 172.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.277 174.014L296.404 173.504C296.322 173.686 296.258 173.868 296.204 174.05L297.077 174.56C297.132 174.378 297.204 174.196 297.277 174.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.068 174.559L296.195 174.05C296.14 174.241 296.094 174.432 296.058 174.623L296.931 175.133C296.959 174.942 297.004 174.75 297.068 174.559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.939 175.132L296.066 174.623C296.039 174.805 296.021 174.978 296.021 175.151L296.894 175.66C296.894 175.478 296.912 175.305 296.939 175.123V175.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.894 175.66L296.021 175.15C296.021 175.341 296.039 175.514 296.075 175.678L296.948 176.187C296.912 176.032 296.894 175.851 296.894 175.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.948 176.187L296.074 175.677C296.165 176.087 296.374 176.387 296.656 176.551L297.53 177.06C297.248 176.896 297.038 176.596 296.948 176.187Z",
    fill: "white"
  }))), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M299.075 171.886C297.866 172.586 296.893 174.277 296.893 175.659C296.893 177.051 297.875 177.605 299.084 176.905C300.294 176.205 301.267 174.523 301.267 173.132C301.267 171.75 300.285 171.186 299.075 171.886Z",
    fill: "#252529"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M300.631 172.996L300.067 172.668C299.803 172.513 299.448 172.541 299.048 172.768L299.612 173.096C300.012 172.868 300.367 172.85 300.631 172.996Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 299,
    y: 172,
    width: 2,
    height: 2
  }, _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M300.631 172.996L300.067 172.668C299.803 172.513 299.448 172.541 299.048 172.768L299.612 173.096C300.012 172.868 300.367 172.85 300.631 172.996Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.631 172.995L300.067 172.668C299.94 172.595 299.794 172.559 299.63 172.577L300.194 172.904C300.358 172.895 300.504 172.923 300.631 172.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.194 172.895L299.63 172.568C299.539 172.568 299.43 172.595 299.33 172.632L299.894 172.959C300.003 172.923 300.103 172.905 300.194 172.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.895 172.959L299.331 172.632C299.24 172.659 299.149 172.705 299.058 172.759L299.622 173.087C299.713 173.032 299.813 172.987 299.895 172.959Z",
    fill: "white"
  }))), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M298.049 176.142L298.612 176.469C298.358 176.323 298.194 176.005 298.194 175.551C298.194 174.65 298.831 173.541 299.613 173.086L299.049 172.759C298.258 173.214 297.621 174.314 297.63 175.223C297.63 175.669 297.794 175.987 298.049 176.142Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 297,
    y: 172,
    width: 3,
    height: 5
  }, _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M298.049 176.142L298.612 176.469C298.358 176.323 298.194 176.005 298.194 175.551C298.194 174.65 298.831 173.541 299.613 173.086L299.049 172.759C298.258 173.214 297.621 174.314 297.63 175.223C297.63 175.669 297.794 175.987 298.049 176.142Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.622 173.095L299.058 172.768C299.058 172.768 299.049 172.768 299.04 172.768L299.604 173.095C299.604 173.095 299.613 173.095 299.622 173.095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.603 173.104L299.039 172.777C298.93 172.841 298.83 172.913 298.729 172.995L299.293 173.323C299.394 173.241 299.494 173.168 299.603 173.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.294 173.323L298.73 172.995C298.621 173.086 298.521 173.186 298.43 173.295L298.994 173.623C299.085 173.514 299.185 173.414 299.294 173.323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.994 173.614L298.43 173.286C298.202 173.541 298.021 173.841 297.875 174.15L298.439 174.478C298.575 174.159 298.766 173.859 298.994 173.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.44 174.486L297.876 174.159C297.821 174.277 297.776 174.395 297.739 174.514L298.303 174.841C298.34 174.723 298.385 174.605 298.44 174.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.312 174.841L297.748 174.514C297.712 174.641 297.685 174.759 297.657 174.887L298.221 175.214C298.239 175.087 298.267 174.969 298.312 174.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.221 175.214L297.657 174.886C297.639 175.005 297.63 175.114 297.63 175.232L298.194 175.569C298.194 175.46 298.203 175.341 298.221 175.223V175.214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.194 175.56L297.63 175.232C297.63 175.36 297.639 175.469 297.666 175.578L298.23 175.905C298.203 175.805 298.194 175.687 298.194 175.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.231 175.905L297.667 175.577C297.731 175.841 297.858 176.041 298.049 176.141L298.613 176.469C298.431 176.36 298.295 176.169 298.231 175.905Z",
    fill: "white"
  }))), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M299.622 173.096C298.831 173.55 298.194 174.65 298.203 175.56C298.203 176.469 298.849 176.833 299.631 176.378C300.422 175.923 301.058 174.823 301.049 173.914C301.049 173.014 300.404 172.641 299.622 173.096Z",
    fill: "#252529"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M318.36 161.539L317.487 161.03C317.087 160.802 316.542 160.83 315.933 161.184L316.805 161.693C317.415 161.339 317.96 161.311 318.36 161.539Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 315,
    y: 160,
    width: 4,
    height: 2
  }, _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M318.36 161.539L317.487 161.03C317.087 160.802 316.542 160.83 315.933 161.184L316.805 161.693C317.415 161.339 317.96 161.311 318.36 161.539Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.362 161.539L317.489 161.03C317.298 160.92 317.071 160.866 316.816 160.884L317.689 161.393C317.944 161.375 318.171 161.43 318.362 161.539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.689 161.393L316.816 160.884C316.67 160.893 316.516 160.93 316.352 160.984L317.225 161.494C317.389 161.439 317.544 161.403 317.689 161.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.233 161.494L316.36 160.984C316.224 161.03 316.078 161.102 315.933 161.184L316.806 161.694C316.951 161.612 317.088 161.548 317.233 161.494Z",
    fill: "white"
  }))), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M314.397 166.358L315.27 166.867C314.879 166.64 314.634 166.158 314.634 165.467C314.634 164.085 315.607 162.393 316.816 161.693L315.943 161.184C314.734 161.884 313.761 163.575 313.761 164.957C313.761 165.648 314.006 166.13 314.397 166.358Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 313,
    y: 161,
    width: 4,
    height: 6
  }, _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M314.397 166.358L315.27 166.867C314.879 166.64 314.634 166.158 314.634 165.467C314.634 164.085 315.607 162.393 316.816 161.693L315.943 161.184C314.734 161.884 313.761 163.575 313.761 164.957C313.761 165.648 314.006 166.13 314.397 166.358Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.807 161.684L315.934 161.175C315.934 161.175 315.916 161.175 315.916 161.184L316.789 161.693C316.789 161.693 316.807 161.693 316.807 161.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.79 161.703L315.917 161.193C315.753 161.293 315.598 161.403 315.444 161.53L316.317 162.039C316.472 161.912 316.626 161.794 316.79 161.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.316 162.039L315.443 161.53C315.279 161.666 315.125 161.821 314.979 161.985L315.852 162.494C315.998 162.33 316.152 162.176 316.316 162.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.853 162.494L314.979 161.984C314.634 162.376 314.343 162.83 314.133 163.313L315.007 163.822C315.216 163.34 315.507 162.876 315.853 162.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.007 163.821L314.134 163.312C314.052 163.494 313.988 163.676 313.934 163.857L314.807 164.367C314.861 164.185 314.934 164.003 315.007 163.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.807 164.367L313.934 163.858C313.879 164.049 313.834 164.24 313.797 164.431L314.671 164.94C314.698 164.749 314.743 164.558 314.807 164.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.672 164.931L313.798 164.421C313.771 164.603 313.753 164.776 313.753 164.949L314.626 165.458C314.626 165.285 314.644 165.112 314.672 164.931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.626 165.467L313.753 164.958C313.753 165.149 313.771 165.321 313.808 165.485L314.681 165.995C314.644 165.84 314.626 165.658 314.626 165.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.689 165.994L313.815 165.485C313.906 165.894 314.116 166.194 314.398 166.358L315.271 166.867C314.989 166.704 314.78 166.403 314.689 165.994Z",
    fill: "white"
  }))), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M316.807 161.684C315.597 162.384 314.625 164.076 314.625 165.458C314.625 166.849 315.607 167.403 316.816 166.703C318.025 166.003 318.998 164.321 318.998 162.93C318.998 161.548 318.016 160.984 316.807 161.684Z",
    fill: "#252529"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M318.37 162.794L317.806 162.466C317.542 162.312 317.187 162.339 316.787 162.566L317.351 162.894C317.751 162.666 318.106 162.648 318.37 162.794Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 316,
    y: 162,
    width: 3,
    height: 1
  }, _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M318.37 162.794L317.806 162.466C317.542 162.312 317.187 162.339 316.787 162.566L317.351 162.894C317.751 162.666 318.106 162.648 318.37 162.794Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.372 162.794L317.808 162.466C317.68 162.393 317.535 162.357 317.371 162.375L317.935 162.703C318.099 162.693 318.244 162.721 318.372 162.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.924 162.703L317.36 162.375C317.269 162.375 317.16 162.403 317.06 162.439L317.624 162.766C317.733 162.73 317.833 162.712 317.924 162.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.624 162.766L317.06 162.439C316.97 162.466 316.879 162.511 316.788 162.566L317.352 162.893C317.443 162.839 317.543 162.793 317.624 162.766Z",
    fill: "white"
  }))), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M315.779 165.94L316.343 166.267C316.088 166.122 315.925 165.803 315.925 165.349C315.925 164.449 316.561 163.339 317.343 162.885L316.779 162.557C315.988 163.012 315.352 164.112 315.361 165.021C315.361 165.467 315.525 165.785 315.779 165.94Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 315,
    y: 162,
    width: 3,
    height: 5
  }, _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M315.779 165.94L316.343 166.267C316.088 166.122 315.925 165.803 315.925 165.349C315.925 164.449 316.561 163.339 317.343 162.885L316.779 162.557C315.988 163.012 315.352 164.112 315.361 165.021C315.361 165.467 315.525 165.785 315.779 165.94Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.352 162.894L316.788 162.566C316.788 162.566 316.779 162.566 316.77 162.566L317.334 162.894C317.334 162.894 317.343 162.894 317.352 162.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.334 162.903L316.77 162.575C316.661 162.639 316.561 162.712 316.461 162.794L317.025 163.121C317.125 163.039 317.225 162.966 317.334 162.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.026 163.121L316.462 162.794C316.353 162.885 316.253 162.985 316.162 163.094L316.726 163.421C316.817 163.312 316.917 163.212 317.026 163.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.725 163.421L316.161 163.093C315.933 163.348 315.752 163.648 315.606 163.958L316.17 164.285C316.306 163.967 316.497 163.667 316.725 163.421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.18 164.285L315.616 163.957C315.562 164.076 315.516 164.194 315.48 164.312L316.044 164.64C316.08 164.521 316.126 164.403 316.18 164.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.043 164.639L315.479 164.312C315.443 164.439 315.415 164.557 315.388 164.685L315.952 165.012C315.97 164.885 315.998 164.767 316.043 164.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.961 165.012L315.397 164.685C315.379 164.803 315.37 164.912 315.37 165.031L315.934 165.358C315.934 165.24 315.943 165.131 315.961 165.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.934 165.358L315.37 165.03C315.37 165.158 315.379 165.267 315.406 165.376L315.97 165.703C315.943 165.603 315.934 165.485 315.934 165.358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.97 165.703L315.406 165.376C315.47 165.639 315.597 165.84 315.788 165.94L316.352 166.267C316.17 166.158 316.034 165.967 315.97 165.703Z",
    fill: "white"
  }))), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M317.351 162.893C316.56 163.348 315.924 164.448 315.933 165.357C315.933 166.267 316.578 166.63 317.36 166.176C318.151 165.721 318.788 164.621 318.779 163.712C318.779 162.811 318.133 162.439 317.351 162.893Z",
    fill: "#252529"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M335.028 151.509L334.155 151C333.755 150.773 333.209 150.8 332.6 151.155L333.473 151.664C334.082 151.309 334.628 151.282 335.028 151.509Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 150,
    width: 4,
    height: 2
  }, _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M335.028 151.509L334.155 151C333.755 150.773 333.209 150.8 332.6 151.155L333.473 151.664C334.082 151.309 334.628 151.282 335.028 151.509Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.029 151.51L334.156 151C333.965 150.891 333.738 150.837 333.483 150.855L334.356 151.364C334.611 151.346 334.838 151.401 335.029 151.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.356 151.373L333.482 150.864C333.337 150.873 333.182 150.909 333.019 150.964L333.892 151.473C334.056 151.419 334.21 151.382 334.356 151.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.891 151.464L333.018 150.955C332.881 151 332.736 151.073 332.59 151.155L333.464 151.664C333.609 151.583 333.746 151.519 333.891 151.464Z",
    fill: "white"
  }))), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M331.054 156.338L331.927 156.847C331.536 156.62 331.29 156.138 331.29 155.447C331.29 154.065 332.263 152.373 333.473 151.673L332.6 151.164C331.39 151.864 330.417 153.555 330.417 154.937C330.417 155.629 330.663 156.11 331.054 156.338Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 330,
    y: 151,
    width: 4,
    height: 6
  }, _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M331.054 156.338L331.927 156.847C331.536 156.62 331.29 156.138 331.29 155.447C331.29 154.065 332.263 152.373 333.473 151.673L332.6 151.164C331.39 151.864 330.417 153.555 330.417 154.937C330.417 155.629 330.663 156.11 331.054 156.338Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.473 151.664L332.6 151.155C332.6 151.155 332.582 151.155 332.582 151.164L333.455 151.673C333.455 151.673 333.473 151.673 333.473 151.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.445 151.683L332.572 151.173C332.408 151.273 332.254 151.382 332.099 151.51L332.972 152.019C333.127 151.892 333.282 151.773 333.445 151.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.973 152.019L332.1 151.51C331.936 151.646 331.781 151.801 331.636 151.964L332.509 152.474C332.655 152.31 332.809 152.156 332.973 152.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.519 152.474L331.645 151.964C331.3 152.356 331.009 152.81 330.799 153.292L331.673 153.802C331.882 153.32 332.173 152.856 332.519 152.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.674 153.801L330.8 153.292C330.718 153.473 330.655 153.655 330.6 153.837L331.473 154.347C331.528 154.165 331.601 153.983 331.674 153.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.463 154.347L330.59 153.837C330.535 154.028 330.49 154.219 330.454 154.41L331.327 154.92C331.354 154.729 331.4 154.538 331.463 154.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.335 154.91L330.462 154.401C330.435 154.583 330.417 154.756 330.417 154.929L331.29 155.438C331.29 155.256 331.308 155.083 331.335 154.901V154.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.29 155.447L330.417 154.937C330.417 155.129 330.435 155.301 330.471 155.465L331.344 155.975C331.308 155.82 331.29 155.638 331.29 155.447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.345 155.974L330.472 155.465C330.563 155.874 330.772 156.174 331.054 156.338L331.927 156.847C331.645 156.684 331.436 156.384 331.345 155.974Z",
    fill: "white"
  }))), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M333.473 151.664C332.264 152.364 331.291 154.055 331.291 155.437C331.291 156.829 332.273 157.383 333.482 156.683C334.692 155.983 335.665 154.301 335.665 152.91C335.665 151.528 334.683 150.964 333.473 151.664Z",
    fill: "#252529"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M335.028 152.774L334.464 152.446C334.2 152.292 333.846 152.319 333.445 152.546L334.009 152.874C334.41 152.646 334.764 152.628 335.028 152.774Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 333,
    y: 152,
    width: 3,
    height: 1
  }, _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M335.028 152.774L334.464 152.446C334.2 152.292 333.846 152.319 333.445 152.546L334.009 152.874C334.41 152.646 334.764 152.628 335.028 152.774Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.028 152.774L334.464 152.446C334.337 152.374 334.191 152.337 334.027 152.355L334.591 152.683C334.755 152.674 334.901 152.701 335.028 152.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.591 152.683L334.027 152.355C333.936 152.355 333.827 152.383 333.727 152.419L334.291 152.746C334.4 152.71 334.5 152.692 334.591 152.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.292 152.746L333.728 152.419C333.638 152.446 333.547 152.492 333.456 152.546L334.02 152.874C334.111 152.819 334.211 152.774 334.292 152.746Z",
    fill: "white"
  }))), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M332.446 155.92L333.009 156.247C332.755 156.101 332.591 155.783 332.591 155.329C332.591 154.428 333.228 153.319 334.01 152.864L333.446 152.537C332.655 152.992 332.018 154.092 332.027 155.001C332.027 155.447 332.191 155.765 332.446 155.92Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 152,
    width: 3,
    height: 5
  }, _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M332.446 155.92L333.009 156.247C332.755 156.101 332.591 155.783 332.591 155.329C332.591 154.428 333.228 153.319 334.01 152.864L333.446 152.537C332.655 152.992 332.018 154.092 332.027 155.001C332.027 155.447 332.191 155.765 332.446 155.92Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.01 152.874L333.446 152.546C333.446 152.546 333.437 152.546 333.428 152.546L333.992 152.874C333.992 152.874 334.001 152.874 334.01 152.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.001 152.883L333.437 152.555C333.328 152.619 333.228 152.692 333.127 152.774L333.691 153.101C333.792 153.019 333.892 152.946 334.001 152.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.691 153.101L333.127 152.774C333.018 152.865 332.918 152.965 332.827 153.074L333.391 153.401C333.482 153.292 333.582 153.192 333.691 153.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.392 153.401L332.828 153.074C332.601 153.328 332.419 153.629 332.273 153.938L332.837 154.265C332.974 153.947 333.165 153.647 333.392 153.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.836 154.265L332.272 153.937C332.218 154.056 332.172 154.174 332.136 154.292L332.7 154.62C332.736 154.501 332.782 154.383 332.836 154.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.709 154.619L332.145 154.292C332.108 154.419 332.081 154.538 332.054 154.665L332.618 154.992C332.636 154.865 332.663 154.747 332.709 154.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.619 154.992L332.055 154.665C332.036 154.783 332.027 154.892 332.027 155.01L332.591 155.347C332.591 155.229 332.6 155.12 332.619 155.001V154.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.591 155.338L332.027 155.01C332.027 155.137 332.036 155.247 332.064 155.356L332.628 155.683C332.6 155.583 332.591 155.465 332.591 155.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.627 155.683L332.063 155.356C332.127 155.619 332.255 155.82 332.446 155.92L333.01 156.247C332.828 156.138 332.691 155.947 332.627 155.683Z",
    fill: "white"
  }))), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M334.009 152.874C333.218 153.328 332.581 154.428 332.59 155.338C332.59 156.247 333.236 156.611 334.018 156.156C334.8 155.701 335.445 154.601 335.436 153.692C335.436 152.792 334.791 152.419 334.009 152.874Z",
    fill: "#252529"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M253.542 182.443V181.742C253.542 182.06 253.324 182.388 252.905 182.634V183.334C253.333 183.088 253.542 182.761 253.542 182.443Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 252,
    y: 181,
    width: 2,
    height: 3
  }, _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M253.542 182.443V181.742C253.542 182.06 253.324 182.388 252.905 182.634V183.334C253.333 183.088 253.542 182.761 253.542 182.443Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.905 182.643V183.343C253.332 183.097 253.542 182.77 253.542 182.451V181.751C253.542 182.069 253.323 182.397 252.905 182.643Z",
    fill: "#252529"
  }))), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M231.964 184.87V185.571C231.964 185.889 232.173 186.207 232.592 186.453V185.753C232.173 185.507 231.964 185.189 231.964 184.87Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 231,
    y: 184,
    width: 2,
    height: 3
  }, _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M231.964 184.87V185.571C231.964 185.889 232.173 186.207 232.592 186.453V185.753C232.173 185.507 231.964 185.189 231.964 184.87Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.964 184.87V185.571C231.964 185.616 231.964 185.671 231.982 185.716V185.016C231.973 184.97 231.964 184.925 231.964 184.87Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.974 185.015V185.716C232.029 185.98 232.229 186.234 232.565 186.434V185.734C232.229 185.534 232.029 185.279 231.974 185.015Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.564 185.734V186.434C232.564 186.434 232.583 186.443 232.592 186.452V185.752C232.592 185.752 232.574 185.743 232.564 185.734Z",
    fill: "#252529"
  }))), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M232.591 185.752V186.443L238.511 189.889V189.189L232.591 185.752Z",
    fill: "#252529"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M241.557 189.189V189.889L252.905 183.333V182.642L241.557 189.189Z",
    fill: "#252529"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M238.511 189.189V189.889C239.356 190.38 240.72 190.38 241.566 189.889V189.189C240.72 189.68 239.356 189.68 238.511 189.189Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 238,
    y: 189,
    width: 4,
    height: 2
  }, _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M238.511 189.189V189.889C239.356 190.38 240.72 190.38 241.566 189.889V189.189C240.72 189.68 239.356 189.68 238.511 189.189Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.511 189.189V189.89C238.656 189.971 238.82 190.044 238.984 190.099V189.398C238.811 189.344 238.656 189.271 238.511 189.189Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.985 189.398V190.099C239.403 190.235 239.885 190.28 240.34 190.244V189.544C239.876 189.58 239.394 189.535 238.985 189.398Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.338 189.544V190.244C240.784 190.208 241.22 190.09 241.566 189.889V189.189C241.22 189.389 240.793 189.507 240.338 189.544Z",
    fill: "#252529"
  }))), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M232.6 183.979C231.754 184.47 231.754 185.261 232.6 185.743L238.519 189.18C239.356 189.671 240.729 189.671 241.565 189.18L252.904 182.633C253.749 182.142 253.758 181.351 252.913 180.869L246.993 177.432C246.157 176.941 244.784 176.941 243.938 177.432L232.6 183.979Z",
    fill: "white"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M250.387 179.878L250.077 180.06L248.004 178.86L248.314 178.678L250.387 179.878Z",
    fill: "#424242"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M247.785 182.833L249.595 183.888L252.559 182.179L250.749 181.124L247.785 182.833Z",
    fill: "#686868"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M239.548 182.442L241.358 183.497L244.322 181.779L242.513 180.724L239.548 182.442Z",
    fill: "#686868"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M239.493 180.66L240.384 181.169L241.839 180.333L240.948 179.824L239.493 180.66Z",
    fill: "#686868"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M237.602 181.76L238.484 182.279L239.939 181.442L239.048 180.924L237.602 181.76Z",
    fill: "#686868"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M243.467 182.824L244.867 183.633L247.14 182.315L245.749 181.506L243.467 182.824Z",
    fill: "#686868"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M240.638 184.315L242.029 185.124L244.312 183.815L242.92 183.006L240.638 184.315Z",
    fill: "#686868"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M242.185 186.925L243.312 187.57L245.149 186.516L244.021 185.861L242.185 186.925Z",
    fill: "#686868"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M232.492 184.606L233.61 185.261L235.456 184.197L234.328 183.542L232.492 184.606Z",
    fill: "#686868"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M235.083 183.152L236.21 183.806L238.047 182.743L236.929 182.088L235.083 183.152Z",
    fill: "#686868"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M233.793 185.406L234.593 185.87L235.902 185.115L235.102 184.652L233.793 185.406Z",
    fill: "#686868"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M234.875 186.088L235.676 186.552L236.985 185.797L236.185 185.334L234.875 186.088Z",
    fill: "#686868"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M235.938 186.643L236.738 187.116L238.047 186.361L237.247 185.888L235.938 186.643Z",
    fill: "#686868"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M243.039 184.97L245.367 186.325L249.177 184.134L246.849 182.779L243.039 184.97Z",
    fill: "#686868"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M241.448 179.569L243.494 180.76L246.84 178.824L244.794 177.642L241.448 179.569Z",
    fill: "#686868"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M235.483 184.525L237.529 185.716L240.866 183.779L238.82 182.597L235.483 184.525Z",
    fill: "#686868"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M241.938 185.698L242.612 186.089L243.521 185.561L242.848 185.17L241.938 185.698Z",
    fill: "#686868"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M240.812 186.37L241.485 186.762L242.395 186.234L241.722 185.843L240.812 186.37Z",
    fill: "#686868"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M239.793 185.515L240.666 186.015L241.839 185.343L240.975 184.833L239.793 185.515Z",
    fill: "#686868"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M239.53 184.843L240.066 185.152L240.785 184.734L240.248 184.425L239.53 184.843Z",
    fill: "#686868"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M238.529 185.452L239.066 185.771L239.785 185.352L239.257 185.043L238.529 185.452Z",
    fill: "#686868"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M239.557 186.571L240.094 186.88L240.822 186.461L240.285 186.152L239.557 186.571Z",
    fill: "#686868"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M238.785 186.161L239.322 186.471L240.05 186.052L239.513 185.734L238.785 186.161Z",
    fill: "#686868"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M237.874 185.889L238.229 186.098L238.665 185.843L238.311 185.634L237.874 185.889Z",
    fill: "#686868"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M238.875 188.307L240.384 189.189L242.858 187.762L241.348 186.88L238.875 188.307Z",
    fill: "#686868"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M237.256 187.416L238.265 187.998L239.92 187.043L238.911 186.461L237.256 187.416Z",
    fill: "#686868"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M246.448 181.342L247.921 182.206L250.331 180.815L248.858 179.951L246.448 181.342Z",
    fill: "#686868"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M245.767 179.942L246.676 180.469L248.158 179.605L247.249 179.078L245.767 179.942Z",
    fill: "#686868"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M243.884 181.087L244.784 181.615L246.275 180.76L245.366 180.233L243.884 181.087Z",
    fill: "#686868"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M233.391 193.472V192.772C233.391 193.09 233.173 193.417 232.754 193.663V194.364C233.182 194.118 233.391 193.79 233.391 193.472Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 232,
    y: 192,
    width: 2,
    height: 3
  }, _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M233.391 193.472V192.772C233.391 193.09 233.173 193.417 232.754 193.663V194.364C233.182 194.118 233.391 193.79 233.391 193.472Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.746 193.672V194.372C233.174 194.127 233.383 193.799 233.383 193.481V192.781C233.383 193.099 233.165 193.426 232.746 193.672Z",
    fill: "#252529"
  }))), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M211.815 195.899V196.6C211.815 196.918 212.025 197.237 212.443 197.482V196.782C212.025 196.536 211.815 196.218 211.815 195.899Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 211,
    y: 195,
    width: 2,
    height: 3
  }, _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M211.815 195.899V196.6C211.815 196.918 212.025 197.237 212.443 197.482V196.782C212.025 196.536 211.815 196.218 211.815 195.899Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.815 195.899V196.6C211.815 196.645 211.815 196.7 211.834 196.745V196.045C211.825 195.999 211.815 195.954 211.815 195.899Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.824 196.045V196.746C211.879 197.009 212.079 197.264 212.416 197.464V196.764C212.079 196.564 211.879 196.309 211.824 196.045Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.415 196.763V197.464C212.415 197.464 212.433 197.473 212.442 197.482V196.781C212.442 196.781 212.424 196.772 212.415 196.763Z",
    fill: "#252529"
  }))), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M212.443 196.781V197.472L218.362 200.909V200.218L212.443 196.781Z",
    fill: "#252529"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M221.408 200.218V200.909L232.756 194.363L232.747 193.672L221.408 200.218Z",
    fill: "#252529"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M218.361 200.218V200.918C219.207 201.409 220.571 201.409 221.416 200.918V200.218C220.571 200.709 219.207 200.709 218.361 200.218Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 218,
    y: 200,
    width: 4,
    height: 2
  }, _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M218.361 200.218V200.918C219.207 201.409 220.571 201.409 221.416 200.918V200.218C220.571 200.709 219.207 200.709 218.361 200.218Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.361 200.218V200.919C218.507 201 218.671 201.073 218.834 201.128V200.427C218.662 200.373 218.507 200.3 218.361 200.218Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.835 200.427V201.128C219.253 201.264 219.736 201.31 220.19 201.273V200.573C219.726 200.609 219.244 200.564 218.835 200.427Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.19 200.573V201.273C220.636 201.237 221.072 201.119 221.418 200.919V200.218C221.072 200.418 220.645 200.537 220.19 200.573Z",
    fill: "#252529"
  }))), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M212.452 195.008C211.606 195.499 211.606 196.29 212.452 196.772L218.371 200.209C219.208 200.7 220.581 200.7 221.417 200.209L232.756 193.662C233.601 193.171 233.61 192.38 232.765 191.898L226.846 188.461C226.009 187.97 224.636 187.97 223.79 188.461L212.452 195.008Z",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M230.237 190.908L229.928 191.08L227.855 189.889L228.164 189.708L230.237 190.908Z",
    fill: "#424242"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M227.627 193.862L229.446 194.917L232.41 193.208L230.601 192.153L227.627 193.862Z",
    fill: "#686868"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M219.389 193.462L221.208 194.517L224.172 192.808L222.362 191.753L219.389 193.462Z",
    fill: "#686868"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M219.344 191.69L220.235 192.199L221.681 191.362L220.799 190.844L219.344 191.69Z",
    fill: "#686868"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M217.452 192.789L218.334 193.308L219.788 192.462L218.897 191.953L217.452 192.789Z",
    fill: "#686868"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M223.317 193.853L224.709 194.663L226.991 193.344L225.591 192.535L223.317 193.853Z",
    fill: "#686868"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M220.49 195.345L221.881 196.154L224.154 194.845L222.763 194.035L220.49 195.345Z",
    fill: "#686868"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M222.035 197.945L223.153 198.6L224.999 197.536L223.871 196.89L222.035 197.945Z",
    fill: "#686868"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M212.343 195.636L213.462 196.29L215.298 195.226L214.18 194.572L212.343 195.636Z",
    fill: "#686868"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M214.934 194.172L216.061 194.826L217.898 193.772L216.77 193.117L214.934 194.172Z",
    fill: "#686868"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M213.634 196.426L214.434 196.899L215.743 196.136L214.943 195.672L213.634 196.426Z",
    fill: "#686868"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M214.725 197.117L215.525 197.581L216.834 196.826L216.034 196.363L214.725 197.117Z",
    fill: "#686868"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M215.789 197.672L216.589 198.136L217.899 197.381L217.098 196.918L215.789 197.672Z",
    fill: "#686868"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M222.889 195.999L225.217 197.354L229.027 195.154L226.699 193.808L222.889 195.999Z",
    fill: "#686868"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M221.298 190.598L223.344 191.781L226.681 189.853L224.635 188.662L221.298 190.598Z",
    fill: "#686868"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M215.325 195.554L217.371 196.736L220.717 194.808L218.671 193.617L215.325 195.554Z",
    fill: "#686868"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M221.79 196.727L222.463 197.118L223.363 196.591L222.699 196.199L221.79 196.727Z",
    fill: "#686868"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M220.662 197.4L221.326 197.791L222.235 197.263L221.571 196.872L220.662 197.4Z",
    fill: "#686868"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M219.645 196.545L220.517 197.045L221.69 196.372L220.817 195.863L219.645 196.545Z",
    fill: "#686868"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M219.371 195.863L219.907 196.181L220.635 195.763L220.098 195.453L219.371 195.863Z",
    fill: "#686868"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M218.38 196.481L218.917 196.791L219.636 196.372L219.099 196.063L218.38 196.481Z",
    fill: "#686868"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M219.408 197.6L219.944 197.909L220.672 197.491L220.135 197.181L219.408 197.6Z",
    fill: "#686868"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M218.634 197.182L219.171 197.5L219.898 197.081L219.362 196.763L218.634 197.182Z",
    fill: "#686868"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M217.725 196.918L218.071 197.118L218.507 196.872L218.162 196.663L217.725 196.918Z",
    fill: "#686868"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M218.726 199.336L220.235 200.218L222.708 198.791L221.199 197.909L218.726 199.336Z",
    fill: "#686868"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M217.106 198.436L218.116 199.027L219.761 198.073L218.752 197.491L217.106 198.436Z",
    fill: "#686868"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M226.3 192.371L227.773 193.226L230.182 191.835L228.709 190.98L226.3 192.371Z",
    fill: "#686868"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M225.617 190.962L226.526 191.489L228.009 190.635L227.099 190.107L225.617 190.962Z",
    fill: "#686868"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M223.735 192.117L224.636 192.644L226.127 191.789L225.217 191.262L223.735 192.117Z",
    fill: "#686868"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M273.053 171.15V170.449C273.053 170.768 272.835 171.095 272.417 171.341V172.041C272.844 171.796 273.053 171.468 273.053 171.15Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 272,
    y: 170,
    width: 2,
    height: 3
  }, _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M273.053 171.15V170.449C273.053 170.768 272.835 171.095 272.417 171.341V172.041C272.844 171.796 273.053 171.468 273.053 171.15Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.417 171.341V172.041C272.844 171.796 273.053 171.468 273.053 171.15V170.449C273.053 170.768 272.835 171.095 272.417 171.341Z",
    fill: "#252529"
  }))), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M251.477 173.568V174.269C251.477 174.587 251.686 174.905 252.105 175.151V174.451C251.686 174.205 251.477 173.887 251.477 173.568Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 251,
    y: 173,
    width: 2,
    height: 3
  }, _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M251.477 173.568V174.269C251.477 174.587 251.686 174.905 252.105 175.151V174.451C251.686 174.205 251.477 173.887 251.477 173.568Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.477 173.568V174.269C251.477 174.314 251.477 174.369 251.495 174.414V173.714C251.486 173.668 251.477 173.623 251.477 173.568Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.495 173.714V174.414C251.549 174.678 251.749 174.933 252.086 175.133V174.432C251.749 174.232 251.549 173.978 251.495 173.714Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.078 174.432V175.132C252.078 175.132 252.096 175.141 252.105 175.15V174.45C252.105 174.45 252.087 174.441 252.078 174.432Z",
    fill: "#252529"
  }))), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M252.105 174.45V175.15L258.024 178.587V177.887L252.105 174.45Z",
    fill: "#252529"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M261.078 177.887V178.587L272.416 172.041V171.341L261.078 177.887Z",
    fill: "#252529"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M258.024 177.887V178.587C258.87 179.078 260.233 179.078 261.079 178.587V177.887C260.233 178.378 258.87 178.378 258.024 177.887Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 258,
    y: 177,
    width: 4,
    height: 2
  }, _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M258.024 177.887V178.587C258.87 179.078 260.233 179.078 261.079 178.587V177.887C260.233 178.378 258.87 178.378 258.024 177.887Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.024 177.887V178.588C258.169 178.67 258.333 178.742 258.497 178.797V178.096C258.324 178.042 258.169 177.969 258.024 177.887Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.497 178.096V178.797C258.915 178.933 259.397 178.979 259.852 178.942V178.242C259.388 178.278 258.906 178.233 258.497 178.096Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.852 178.242V178.942C260.297 178.906 260.734 178.788 261.08 178.588V177.887C260.734 178.087 260.306 178.206 259.852 178.242Z",
    fill: "#252529"
  }))), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M252.113 172.686C251.268 173.177 251.268 173.968 252.113 174.45L258.032 177.887C258.869 178.378 260.242 178.378 261.078 177.887L272.417 171.341C273.262 170.85 273.271 170.059 272.426 169.577L266.507 166.14C265.67 165.649 264.297 165.649 263.452 166.14L252.113 172.686Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M269.907 168.577L269.589 168.758L267.516 167.558L267.834 167.376L269.907 168.577Z",
    fill: "#424242"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M267.297 171.54L269.106 172.595L272.07 170.877L270.261 169.822L267.297 171.54Z",
    fill: "#686868"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M259.061 171.14L260.879 172.195L263.843 170.486L262.025 169.431L259.061 171.14Z",
    fill: "#686868"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M259.014 169.358L259.896 169.877L261.351 169.04L260.46 168.522L259.014 169.358Z",
    fill: "#686868"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M257.114 170.458L258.005 170.977L259.451 170.14L258.569 169.622L257.114 170.458Z",
    fill: "#686868"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M262.989 171.522L264.38 172.332L266.653 171.022L265.262 170.213L262.989 171.522Z",
    fill: "#686868"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M260.161 173.023L261.552 173.832L263.825 172.514L262.434 171.704L260.161 173.023Z",
    fill: "#686868"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M261.697 175.623L262.824 176.278L264.661 175.214L263.543 174.559L261.697 175.623Z",
    fill: "#686868"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M252.004 173.313L253.132 173.959L254.969 172.904L253.841 172.25L252.004 173.313Z",
    fill: "#686868"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M254.605 171.85L255.723 172.504L257.569 171.44L256.442 170.786L254.605 171.85Z",
    fill: "#686868"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M253.305 174.105L254.105 174.568L255.415 173.814L254.614 173.35L253.305 174.105Z",
    fill: "#686868"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M254.386 174.786L255.186 175.25L256.496 174.495L255.696 174.032L254.386 174.786Z",
    fill: "#686868"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M255.459 175.35L256.26 175.814L257.569 175.059L256.769 174.596L255.459 175.35Z",
    fill: "#686868"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M262.561 173.677L264.888 175.032L268.689 172.832L266.361 171.477L262.561 173.677Z",
    fill: "#686868"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M260.96 168.267L263.006 169.458L266.352 167.531L264.306 166.34L260.96 168.267Z",
    fill: "#686868"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M254.997 173.223L257.042 174.414L260.388 172.486L258.343 171.295L254.997 173.223Z",
    fill: "#686868"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M261.452 174.396L262.125 174.787L263.035 174.259L262.362 173.868L261.452 174.396Z",
    fill: "#686868"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M260.323 175.069L260.996 175.46L261.906 174.941L261.233 174.55L260.323 175.069Z",
    fill: "#686868"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M259.305 174.214L260.178 174.723L261.36 174.041L260.487 173.532L259.305 174.214Z",
    fill: "#686868"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M259.042 173.541L259.578 173.85L260.297 173.432L259.76 173.123L259.042 173.541Z",
    fill: "#686868"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M258.042 174.159L258.578 174.469L259.306 174.05L258.769 173.741L258.042 174.159Z",
    fill: "#686868"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M259.077 175.269L259.605 175.587L260.333 175.169L259.796 174.85L259.077 175.269Z",
    fill: "#686868"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M258.306 174.859L258.842 175.169L259.561 174.75L259.024 174.441L258.306 174.859Z",
    fill: "#686868"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M257.387 174.586L257.742 174.796L258.179 174.541L257.824 174.341L257.387 174.586Z",
    fill: "#686868"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M258.387 177.014L259.906 177.887L262.379 176.46L260.86 175.587L258.387 177.014Z",
    fill: "#686868"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M256.778 176.114L257.787 176.696L259.433 175.75L258.424 175.159L256.778 176.114Z",
    fill: "#686868"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M265.971 170.049L267.444 170.904L269.853 169.513L268.38 168.658L265.971 170.049Z",
    fill: "#686868"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M265.28 168.64L266.189 169.167L267.671 168.313L266.771 167.785L265.28 168.64Z",
    fill: "#686868"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M263.397 169.786L264.307 170.313L265.789 169.458L264.88 168.931L263.397 169.786Z",
    fill: "#686868"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M291.774 159.793V159.093C291.774 159.411 291.556 159.739 291.137 159.984V160.685C291.565 160.439 291.774 160.112 291.774 159.793Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 291,
    y: 159,
    width: 1,
    height: 2
  }, _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M291.774 159.793V159.093C291.774 159.411 291.556 159.739 291.137 159.984V160.685C291.565 160.439 291.774 160.112 291.774 159.793Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.129 159.984V160.685C291.556 160.439 291.766 160.112 291.766 159.793V159.093C291.766 159.411 291.547 159.739 291.129 159.984Z",
    fill: "#252529"
  }))), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M270.198 162.212V162.912C270.198 163.23 270.407 163.549 270.826 163.794V163.094C270.407 162.848 270.198 162.53 270.198 162.212Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 270,
    y: 162,
    width: 1,
    height: 2
  }, _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M270.198 162.212V162.912C270.198 163.23 270.407 163.549 270.826 163.794V163.094C270.407 162.848 270.198 162.53 270.198 162.212Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.198 162.212V162.912C270.198 162.957 270.198 163.012 270.216 163.058V162.357C270.207 162.312 270.198 162.266 270.198 162.212Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.207 162.357V163.058C270.262 163.322 270.462 163.576 270.798 163.777V163.076C270.462 162.876 270.262 162.621 270.207 162.357Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.798 163.075V163.776C270.798 163.776 270.816 163.785 270.825 163.794V163.093C270.825 163.093 270.807 163.084 270.798 163.075Z",
    fill: "#252529"
  }))), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M270.826 163.094V163.785L276.745 167.231V166.53L270.826 163.094Z",
    fill: "#252529"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M279.791 166.531V167.231L291.138 160.684L291.129 159.984L279.791 166.531Z",
    fill: "#252529"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M276.745 166.53V167.231C277.59 167.722 278.954 167.722 279.8 167.231V166.53C278.954 167.021 277.59 167.021 276.745 166.53Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 276,
    y: 166,
    width: 4,
    height: 2
  }, _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M276.745 166.53V167.231C277.59 167.722 278.954 167.722 279.8 167.231V166.53C278.954 167.021 277.59 167.021 276.745 166.53Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.745 166.53V167.231C276.89 167.313 277.054 167.386 277.218 167.44V166.74C277.045 166.685 276.89 166.612 276.745 166.53Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.218 166.74V167.44C277.636 167.577 278.118 167.622 278.573 167.586V166.885C278.109 166.922 277.627 166.876 277.218 166.74Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.572 166.885V167.586C279.018 167.549 279.455 167.431 279.8 167.231V166.53C279.455 166.731 279.027 166.849 278.572 166.885Z",
    fill: "#252529"
  }))), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M270.835 161.321C269.99 161.812 269.99 162.603 270.835 163.085L276.755 166.522C277.591 167.013 278.964 167.013 279.801 166.522L291.139 159.975C291.985 159.484 291.994 158.693 291.148 158.211L285.229 154.774C284.392 154.283 283.019 154.283 282.174 154.774L270.835 161.321Z",
    fill: "white"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M288.621 157.22L288.311 157.402L286.238 156.202L286.547 156.02L288.621 157.22Z",
    fill: "#424242"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M286.019 160.184L287.828 161.23L290.793 159.52L288.983 158.465L286.019 160.184Z",
    fill: "#686868"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M277.781 159.784L279.591 160.839L282.555 159.12L280.745 158.065L277.781 159.784Z",
    fill: "#686868"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M277.728 158.002L278.619 158.52L280.064 157.675L279.182 157.165L277.728 158.002Z",
    fill: "#686868"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M275.835 159.102L276.717 159.62L278.172 158.784L277.281 158.266L275.835 159.102Z",
    fill: "#686868"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M281.7 160.166L283.091 160.975L285.374 159.666L283.982 158.857L281.7 160.166Z",
    fill: "#686868"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M278.873 161.657L280.264 162.466L282.546 161.157L281.146 160.348L278.873 161.657Z",
    fill: "#686868"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M280.418 164.266L281.546 164.921L283.383 163.857L282.255 163.203L280.418 164.266Z",
    fill: "#686868"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M270.726 161.948L271.844 162.603L273.69 161.539L272.563 160.893L270.726 161.948Z",
    fill: "#686868"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M273.316 160.493L274.444 161.148L276.281 160.084L275.153 159.429L273.316 160.493Z",
    fill: "#686868"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M272.026 162.748L272.817 163.211L274.127 162.457L273.327 161.993L272.026 162.748Z",
    fill: "#686868"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M273.107 163.43L273.908 163.894L275.217 163.139L274.417 162.675L273.107 163.43Z",
    fill: "#686868"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M274.172 163.994L274.972 164.457L276.281 163.703L275.481 163.239L274.172 163.994Z",
    fill: "#686868"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M281.272 162.321L283.6 163.666L287.409 161.475L285.082 160.12L281.272 162.321Z",
    fill: "#686868"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M279.681 156.91L281.727 158.102L285.064 156.165L283.018 154.983L279.681 156.91Z",
    fill: "#686868"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M273.708 161.866L275.754 163.057L279.1 161.12L277.055 159.938L273.708 161.866Z",
    fill: "#686868"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M280.172 163.039L280.846 163.43L281.755 162.903L281.082 162.512L280.172 163.039Z",
    fill: "#686868"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M279.044 163.712L279.709 164.104L280.618 163.585L279.954 163.194L279.044 163.712Z",
    fill: "#686868"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M278.027 162.857L278.9 163.366L280.073 162.684L279.2 162.175L278.027 162.857Z",
    fill: "#686868"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M277.753 162.184L278.29 162.494L279.018 162.075L278.481 161.766L277.753 162.184Z",
    fill: "#686868"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M276.764 162.803L277.3 163.112L278.019 162.694L277.482 162.384L276.764 162.803Z",
    fill: "#686868"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M277.791 163.912L278.327 164.221L279.055 163.803L278.518 163.494L277.791 163.912Z",
    fill: "#686868"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M277.017 163.503L277.553 163.812L278.281 163.394L277.744 163.084L277.017 163.503Z",
    fill: "#686868"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M276.108 163.23L276.454 163.439L276.899 163.185L276.545 162.976L276.108 163.23Z",
    fill: "#686868"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M277.108 165.658L278.618 166.53L281.091 165.103L279.582 164.23L277.108 165.658Z",
    fill: "#686868"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M275.489 164.758L276.498 165.34L278.153 164.394L277.144 163.803L275.489 164.758Z",
    fill: "#686868"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M284.683 158.693L286.156 159.547L288.565 158.156L287.092 157.302L284.683 158.693Z",
    fill: "#686868"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M284 157.283L284.909 157.811L286.391 156.947L285.482 156.429L284 157.283Z",
    fill: "#686868"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M282.118 158.429L283.018 158.956L284.509 158.102L283.6 157.574L282.118 158.429Z",
    fill: "#686868"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M310.397 148.782V148.082C310.397 148.4 310.179 148.728 309.76 148.974V149.674C310.188 149.428 310.397 149.101 310.397 148.782Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 309,
    y: 148,
    width: 2,
    height: 2
  }, _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M310.397 148.782V148.082C310.397 148.4 310.179 148.728 309.76 148.974V149.674C310.188 149.428 310.397 149.101 310.397 148.782Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.75 148.973V149.674C310.178 149.428 310.387 149.101 310.387 148.782V148.082C310.387 148.4 310.168 148.728 309.75 148.973Z",
    fill: "#252529"
  }))), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M288.819 151.21V151.91C288.819 152.229 289.029 152.547 289.447 152.793V152.092C289.029 151.847 288.819 151.528 288.819 151.21Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 288,
    y: 151,
    width: 2,
    height: 2
  }, _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M288.819 151.21V151.91C288.819 152.229 289.029 152.547 289.447 152.793V152.092C289.029 151.847 288.819 151.528 288.819 151.21Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.819 151.21V151.91C288.819 151.956 288.819 152.01 288.838 152.056V151.355C288.828 151.31 288.819 151.264 288.819 151.21Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.83 151.346V152.046C288.885 152.31 289.085 152.565 289.421 152.765V152.065C289.085 151.864 288.885 151.61 288.83 151.346Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.42 152.064V152.765C289.42 152.765 289.439 152.774 289.448 152.783V152.083C289.448 152.083 289.43 152.074 289.42 152.064Z",
    fill: "#252529"
  }))), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M289.447 152.083V152.783L295.366 156.22V155.52L289.447 152.083Z",
    fill: "#252529"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M298.413 155.52V156.22L309.76 149.673L309.751 148.973L298.413 155.52Z",
    fill: "#252529"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M295.367 155.52V156.22C296.212 156.711 297.576 156.711 298.422 156.22V155.52C297.576 156.011 296.212 156.011 295.367 155.52Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 155,
    width: 4,
    height: 2
  }, _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M295.367 155.52V156.22C296.212 156.711 297.576 156.711 298.422 156.22V155.52C297.576 156.011 296.212 156.011 295.367 155.52Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.367 155.52V156.22C295.512 156.302 295.676 156.375 295.84 156.429V155.729C295.667 155.674 295.512 155.602 295.367 155.52Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.839 155.729V156.429C296.258 156.566 296.74 156.611 297.195 156.575V155.874C296.731 155.911 296.249 155.865 295.839 155.729Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.194 155.875V156.575C297.64 156.539 298.076 156.42 298.422 156.22V155.52C298.076 155.72 297.649 155.838 297.194 155.875Z",
    fill: "#252529"
  }))), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M289.455 150.319C288.61 150.81 288.61 151.601 289.455 152.083L295.375 155.519C296.211 156.01 297.584 156.01 298.421 155.519L309.759 148.973C310.605 148.482 310.614 147.691 309.768 147.209L303.849 143.772C303.012 143.281 301.639 143.281 300.794 143.772L289.455 150.319Z",
    fill: "white"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M307.241 146.209L306.932 146.391L304.859 145.19L305.168 145.018L307.241 146.209Z",
    fill: "#424242"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M304.631 149.173L306.45 150.228L309.414 148.509L307.605 147.463L304.631 149.173Z",
    fill: "#686868"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M296.394 148.773L298.212 149.828L301.176 148.118L299.367 147.063L296.394 148.773Z",
    fill: "#686868"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M296.349 146.991L297.24 147.509L298.686 146.673L297.804 146.154L296.349 146.991Z",
    fill: "#686868"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M294.458 148.1L295.339 148.609L296.794 147.773L295.903 147.254L294.458 148.1Z",
    fill: "#686868"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M300.322 149.154L301.713 149.964L303.995 148.654L302.595 147.845L300.322 149.154Z",
    fill: "#686868"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M297.494 150.655L298.885 151.464L301.158 150.146L299.767 149.336L297.494 150.655Z",
    fill: "#686868"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M299.042 153.256L300.16 153.91L302.006 152.846L300.878 152.192L299.042 153.256Z",
    fill: "#686868"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M289.347 150.946L290.466 151.591L292.302 150.537L291.184 149.882L289.347 150.946Z",
    fill: "#686868"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M291.939 149.482L293.066 150.137L294.903 149.073L293.776 148.418L291.939 149.482Z",
    fill: "#686868"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M290.638 151.737L291.438 152.201L292.748 151.446L291.948 150.982L290.638 151.737Z",
    fill: "#686868"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M291.73 152.419L292.53 152.883L293.839 152.128L293.039 151.664L291.73 152.419Z",
    fill: "#686868"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M292.794 152.982L293.594 153.446L294.903 152.691L294.103 152.228L292.794 152.982Z",
    fill: "#686868"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M299.896 151.31L302.223 152.664L306.033 150.464L303.705 149.109L299.896 151.31Z",
    fill: "#686868"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M298.304 145.9L300.35 147.091L303.686 145.163L301.641 143.972L298.304 145.9Z",
    fill: "#686868"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M292.329 150.855L294.375 152.046L297.721 150.118L295.675 148.927L292.329 150.855Z",
    fill: "#686868"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M298.795 152.028L299.468 152.42L300.369 151.901L299.705 151.51L298.795 152.028Z",
    fill: "#686868"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M297.668 152.71L298.332 153.101L299.242 152.573L298.578 152.182L297.668 152.71Z",
    fill: "#686868"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M296.649 151.846L297.522 152.355L298.695 151.673L297.822 151.173L296.649 151.846Z",
    fill: "#686868"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M296.376 151.174L296.913 151.483L297.64 151.064L297.104 150.755L296.376 151.174Z",
    fill: "#686868"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M295.385 151.792L295.922 152.101L296.641 151.683L296.104 151.373L295.385 151.792Z",
    fill: "#686868"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M296.413 152.91L296.949 153.219L297.677 152.801L297.14 152.492L296.413 152.91Z",
    fill: "#686868"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M295.639 152.492L296.176 152.801L296.904 152.383L296.367 152.074L295.639 152.492Z",
    fill: "#686868"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M294.73 152.228L295.076 152.428L295.522 152.174L295.167 151.973L294.73 152.228Z",
    fill: "#686868"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M295.73 154.647L297.239 155.529L299.713 154.101L298.203 153.219L295.73 154.647Z",
    fill: "#686868"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M294.113 153.746L295.122 154.328L296.777 153.383L295.768 152.792L294.113 153.746Z",
    fill: "#686868"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M303.304 147.682L304.777 148.536L307.186 147.145L305.713 146.291L303.304 147.682Z",
    fill: "#686868"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M302.623 146.272L303.532 146.8L305.014 145.945L304.105 145.418L302.623 146.272Z",
    fill: "#686868"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M300.741 147.427L301.641 147.954L303.133 147.091L302.223 146.563L300.741 147.427Z",
    fill: "#686868"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M263.916 160.484L263.952 172.204C263.952 172.286 264.006 172.359 264.106 172.423C264.316 172.541 264.652 172.541 264.861 172.423C264.97 172.359 265.016 172.286 265.016 172.204L264.979 160.484C264.979 160.566 264.925 160.648 264.825 160.702C264.616 160.821 264.279 160.821 264.07 160.702C263.97 160.639 263.916 160.566 263.916 160.484Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 263,
    y: 160,
    width: 3,
    height: 13
  }, _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M263.916 160.484L263.952 172.204C263.952 172.286 264.006 172.359 264.106 172.423C264.316 172.541 264.652 172.541 264.861 172.423C264.97 172.359 265.016 172.286 265.016 172.204L264.979 160.484C264.979 160.566 264.925 160.648 264.825 160.702C264.616 160.821 264.279 160.821 264.07 160.702C263.97 160.639 263.916 160.566 263.916 160.484Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.916 160.484L263.952 172.204C263.952 172.204 263.952 172.232 263.952 172.241L263.916 160.521C263.916 160.521 263.916 160.493 263.916 160.484Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.923 160.52L263.96 172.241C263.969 172.304 264.023 172.368 264.105 172.423L264.069 160.702C263.987 160.648 263.942 160.593 263.923 160.52Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.071 160.693L264.108 172.413C264.108 172.413 264.18 172.459 264.226 172.468L264.189 160.748C264.189 160.748 264.108 160.721 264.071 160.693Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.188 160.748L264.224 172.468C264.324 172.505 264.442 172.514 264.56 172.505L264.524 160.784C264.406 160.794 264.288 160.784 264.188 160.748Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.524 160.784L264.561 172.504C264.67 172.495 264.779 172.468 264.861 172.413C264.97 172.35 265.015 172.277 265.015 172.195L264.979 160.475C264.979 160.557 264.924 160.639 264.824 160.693C264.743 160.739 264.634 160.775 264.524 160.784Z",
    fill: "#252529"
  }))), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M264.07 160.266C263.861 160.384 263.861 160.584 264.07 160.702C264.279 160.821 264.616 160.821 264.825 160.702C265.034 160.584 265.034 160.384 264.825 160.266C264.616 160.147 264.279 160.147 264.07 160.266Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 272,
    y: 134,
    width: 5,
    height: 2
  }, _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M276.109 135.679L274.417 134.698C273.945 134.425 273.29 134.461 272.562 134.879L274.254 135.861C274.972 135.443 275.627 135.407 276.109 135.679Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.108 135.679L274.417 134.697C274.098 134.516 273.698 134.47 273.244 134.588L274.935 135.57C275.38 135.452 275.79 135.498 276.108 135.679Z",
    fill: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.944 135.571L273.253 134.589C273.035 134.643 272.807 134.743 272.571 134.88L274.262 135.862C274.498 135.725 274.726 135.634 274.944 135.571Z",
    fill: "#4A4A4A"
  }))), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M274.261 135.861L272.57 134.879L257.149 143.781L258.841 144.763L274.261 135.861Z",
    fill: "white"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M255.314 149.955L257.005 150.937C256.541 150.664 256.25 150.082 256.241 149.264C256.241 147.609 257.396 145.6 258.832 144.763L257.141 143.781C255.705 144.608 254.541 146.627 254.55 148.282C254.55 149.1 254.841 149.682 255.314 149.955Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 254,
    y: 143,
    width: 5,
    height: 8
  }, _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M255.314 149.955L257.005 150.937C256.541 150.664 256.25 150.082 256.241 149.264C256.241 147.609 257.396 145.6 258.832 144.763L257.141 143.781C255.705 144.608 254.541 146.627 254.55 148.282C254.55 149.1 254.841 149.682 255.314 149.955Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.843 144.763L257.151 143.781C257.078 143.817 257.014 143.863 256.941 143.908L258.633 144.891C258.697 144.845 258.77 144.8 258.843 144.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.634 144.89L256.943 143.908C256.615 144.127 256.297 144.408 256.015 144.736L257.706 145.718C257.988 145.399 258.306 145.118 258.634 144.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.706 145.718L256.015 144.736C255.605 145.199 255.26 145.754 255.005 146.327L256.697 147.309C256.951 146.736 257.297 146.181 257.706 145.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.696 147.309L255.005 146.327C254.841 146.691 254.723 147.063 254.65 147.427L256.342 148.409C256.414 148.045 256.542 147.664 256.696 147.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.332 148.409L254.641 147.427C254.577 147.718 254.55 148 254.55 148.273C254.55 148.345 254.55 148.418 254.55 148.491L256.241 149.473C256.241 149.4 256.241 149.327 256.241 149.255C256.241 148.982 256.268 148.691 256.332 148.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.25 149.473L254.559 148.491C254.605 149.2 254.886 149.7 255.314 149.946L257.005 150.928C256.578 150.682 256.305 150.182 256.25 149.473Z",
    fill: "white"
  }))), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M258.841 144.763C257.405 145.591 256.241 147.609 256.25 149.264C256.25 150.919 257.423 151.583 258.86 150.755L274.281 141.854C275.717 141.026 276.881 139.008 276.872 137.353C276.872 135.698 275.699 135.034 274.262 135.862L258.841 144.763Z",
    fill: "#ABACC2"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M270.944 123.878L270.999 143.408C270.999 144.008 271.399 144.608 272.181 145.063C273.763 145.981 276.345 145.981 277.936 145.063C278.737 144.599 279.137 143.99 279.137 143.381L279.082 123.85C279.082 124.459 278.682 125.069 277.882 125.532C276.282 126.451 273.708 126.451 272.126 125.532C271.335 125.078 270.944 124.478 270.944 123.878Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 270,
    y: 123,
    width: 10,
    height: 23
  }, _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M270.944 123.878L270.999 143.408C270.999 144.008 271.399 144.608 272.181 145.063C273.763 145.981 276.345 145.981 277.936 145.063C278.737 144.599 279.137 143.99 279.137 143.381L279.082 123.85C279.082 124.459 278.682 125.069 277.882 125.532C276.282 126.451 273.708 126.451 272.126 125.532C271.335 125.078 270.944 124.478 270.944 123.878Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.944 123.878L270.998 143.409C270.998 143.5 271.007 143.591 271.026 143.681L270.971 124.151C270.953 124.06 270.944 123.969 270.944 123.878Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.971 124.15L271.025 143.681C271.125 144.172 271.489 144.654 272.135 145.036L272.08 125.505C271.444 125.123 271.071 124.641 270.971 124.15Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.081 125.505L272.135 145.036C272.135 145.036 272.172 145.054 272.181 145.063C272.453 145.218 272.753 145.354 273.072 145.454L273.017 125.923C272.699 125.823 272.399 125.687 272.126 125.532C272.108 125.523 272.09 125.514 272.081 125.505Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.025 125.933L273.08 145.463C273.862 145.718 274.771 145.809 275.644 145.736L275.589 126.205C274.717 126.278 273.816 126.187 273.025 125.933Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.581 126.205L275.636 145.736C276.481 145.663 277.29 145.445 277.945 145.072C278.745 144.608 279.145 143.999 279.145 143.39L279.091 123.859C279.091 124.468 278.691 125.078 277.891 125.541C277.236 125.914 276.427 126.141 275.581 126.205Z",
    fill: "#C2C3D0"
  }))), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M272.153 122.196C270.552 123.114 270.543 124.614 272.134 125.533C273.717 126.451 276.299 126.451 277.89 125.533C279.481 124.614 279.49 123.114 277.908 122.196C276.326 121.277 273.744 121.277 272.153 122.196Z",
    fill: "#E0E2EA"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M261.887 160.202V163.33C261.896 163.703 262.142 164.066 262.624 164.348C263.606 164.921 265.197 164.921 266.179 164.348C266.679 164.066 266.924 163.684 266.924 163.312V160.184C266.924 160.557 266.67 160.939 266.17 161.22C265.188 161.793 263.597 161.793 262.615 161.22C262.133 160.939 261.887 160.566 261.887 160.202Z",
    fill: "#ABACC2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 261,
    y: 160,
    width: 6,
    height: 5
  }, _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M261.887 160.202V163.33C261.896 163.703 262.142 164.066 262.624 164.348C263.606 164.921 265.197 164.921 266.179 164.348C266.679 164.066 266.924 163.684 266.924 163.312V160.184C266.924 160.557 266.67 160.939 266.17 161.22C265.188 161.793 263.597 161.793 262.615 161.22C262.133 160.939 261.887 160.566 261.887 160.202Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.887 160.203V163.331C261.887 163.385 261.905 163.44 261.914 163.494V160.366C261.896 160.312 261.887 160.257 261.887 160.203Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.906 160.375V163.503C261.979 163.812 262.206 164.103 262.597 164.339V161.211C262.197 160.975 261.969 160.675 261.906 160.375Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.587 161.211V164.339C262.587 164.339 262.614 164.348 262.623 164.357C262.787 164.457 262.978 164.539 263.178 164.603V161.475C262.969 161.411 262.787 161.33 262.614 161.23C262.605 161.23 262.596 161.22 262.587 161.211Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.17 161.466V164.594C263.661 164.748 264.225 164.812 264.761 164.767V161.639C264.216 161.684 263.661 161.63 263.17 161.466Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.751 161.639V164.766C265.278 164.721 265.778 164.585 266.188 164.357C266.688 164.075 266.933 163.694 266.933 163.321V160.193C266.933 160.566 266.679 160.948 266.179 161.229C265.778 161.457 265.278 161.602 264.751 161.639Z",
    fill: "#C2C3D0"
  }))), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M262.633 159.166C261.651 159.739 261.642 160.657 262.624 161.221C263.606 161.793 265.197 161.793 266.179 161.221C267.161 160.648 267.17 159.729 266.188 159.166C265.206 158.593 263.615 158.593 262.633 159.166Z",
    fill: "#C2C3D0"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M260.451 145.154L260.496 160.775L264.379 163.03L264.333 147.409L260.451 145.154Z",
    fill: "#C2C3D0"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M264.334 147.409L264.379 163.03L268.289 160.775L268.244 145.154L264.334 147.409Z",
    fill: "#E0E2EA"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M260.451 145.154L264.333 147.409L268.243 145.154L264.36 142.899L260.451 145.154Z",
    fill: "white"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M282.783 139.153L281.092 138.171C280.619 137.898 279.965 137.934 279.237 138.353L280.929 139.335C281.656 138.916 282.311 138.88 282.783 139.153Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 279,
    y: 137,
    width: 4,
    height: 3
  }, _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M282.783 139.153L281.092 138.171C280.619 137.898 279.965 137.934 279.237 138.353L280.929 139.335C281.656 138.916 282.311 138.88 282.783 139.153Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.783 139.153L281.092 138.171C280.774 137.989 280.374 137.944 279.919 138.062L281.61 139.044C282.065 138.926 282.465 138.962 282.783 139.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.61 139.044L279.919 138.062C279.701 138.116 279.474 138.216 279.237 138.353L280.929 139.335C281.165 139.198 281.392 139.098 281.61 139.044Z",
    fill: "white"
  }))), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M280.928 139.335L279.236 138.353L263.815 147.254L265.507 148.236L280.928 139.335Z",
    fill: "white"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M261.979 153.428L263.67 154.41C263.206 154.137 262.915 153.555 262.906 152.737C262.906 151.082 264.061 149.073 265.507 148.236L263.815 147.254C262.379 148.082 261.215 150.1 261.215 151.755C261.215 152.573 261.506 153.155 261.979 153.428Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 261,
    y: 147,
    width: 5,
    height: 8
  }, _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M261.979 153.428L263.67 154.41C263.206 154.137 262.915 153.555 262.906 152.737C262.906 151.082 264.061 149.073 265.507 148.236L263.815 147.254C262.379 148.082 261.215 150.1 261.215 151.755C261.215 152.573 261.506 153.155 261.979 153.428Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.508 148.237L263.816 147.254C263.743 147.291 263.679 147.336 263.606 147.382L265.298 148.364C265.371 148.319 265.435 148.273 265.508 148.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.299 148.364L263.608 147.382C263.28 147.6 262.962 147.882 262.68 148.209L264.371 149.191C264.653 148.864 264.971 148.582 265.299 148.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.37 149.191L262.679 148.209C262.27 148.673 261.925 149.228 261.67 149.801L263.361 150.783C263.616 150.21 263.961 149.655 264.37 149.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.362 150.782L261.671 149.8C261.507 150.164 261.389 150.537 261.316 150.9L263.007 151.882C263.08 151.519 263.207 151.146 263.362 150.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.997 151.883L261.306 150.901C261.242 151.192 261.215 151.473 261.215 151.755C261.215 151.828 261.215 151.901 261.215 151.973L262.906 152.955C262.906 152.883 262.906 152.81 262.906 152.737C262.906 152.464 262.933 152.174 262.997 151.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.915 152.955L261.224 151.973C261.269 152.683 261.551 153.183 261.978 153.428L263.67 154.41C263.242 154.165 262.969 153.665 262.915 152.955Z",
    fill: "white"
  }))), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M265.507 148.236C264.07 149.064 262.906 151.082 262.906 152.737C262.906 154.392 264.079 155.056 265.525 154.228L280.946 145.327C282.382 144.499 283.546 142.481 283.546 140.826C283.546 139.171 282.373 138.507 280.928 139.335L265.507 148.236Z",
    fill: "#E0E2EA"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M313.897 140.899L256.669 107.857L246.558 113.685L303.832 146.709L313.897 140.899Z",
    fill: "white"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M313.896 140.899L313.96 202.61L303.803 208.474L303.83 146.709L313.896 140.899Z",
    fill: "#E0E2EA"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M303.832 146.709L246.558 113.685L246.567 116.986L300.722 148.282L303.832 146.709Z",
    fill: "#C2C3D0"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M303.805 208.474L303.832 146.709L300.722 148.282V203.392L303.805 208.474Z",
    fill: "#C2C3D0"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M303.259 155.974L301.995 155.238L302.022 167.567L303.295 168.304L303.259 155.974Z",
    fill: "#424242"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M316.897 148.091L315.633 147.363L301.995 155.237L303.259 155.974L316.897 148.091Z",
    fill: "#494949"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M303.259 155.974L303.296 168.303L316.934 160.429L316.898 148.091L303.259 155.974Z",
    fill: "#252529"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M304.177 156.438L304.213 166.694L316.061 159.847L316.033 149.591L304.177 156.438Z",
    fill: "white"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M310.197 153.828L310.215 158.738L315.289 155.81L315.279 150.9L310.197 153.828Z",
    fill: "#439B6B"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M308.378 154.692C307.915 154.965 307.533 155.61 307.533 156.147C307.533 156.683 307.915 156.901 308.378 156.629C308.842 156.356 309.224 155.71 309.224 155.174C309.224 154.637 308.842 154.419 308.378 154.692Z",
    fill: "#FFD100"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M305.796 156.101C305.332 156.374 304.95 157.019 304.95 157.556C304.95 158.092 305.332 158.31 305.796 158.038C306.26 157.765 306.641 157.119 306.641 156.583C306.641 156.046 306.26 155.828 305.796 156.101Z",
    fill: "#FFD100"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M308.369 157.565L308.378 159.111L309.715 158.329V156.792L308.369 157.565Z",
    fill: "#252529"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M306.669 158.511V160.048L308.006 159.275V157.738L306.669 158.511Z",
    fill: "#252529"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M304.85 159.511L304.859 161.057L306.195 160.284V158.738L304.85 159.511Z",
    fill: "#252529"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M313.916 158.029V159.575L315.262 158.802L315.253 157.256L313.916 158.029Z",
    fill: "#252529"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M312.205 158.974V160.511L313.551 159.738L313.542 158.202L312.205 158.974Z",
    fill: "#252529"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M310.396 159.975V161.52L311.741 160.747L311.732 159.202L310.396 159.975Z",
    fill: "#252529"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M308.659 160.984V162.52L309.996 161.747V160.211L308.659 160.984Z",
    fill: "#252529"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M306.951 161.929V163.466L308.296 162.693L308.287 161.148L306.951 161.929Z",
    fill: "#252529"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M305.141 162.93V164.466L306.477 163.694V162.157L305.141 162.93Z",
    fill: "#252529"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M303.805 208.474L300.722 203.392L293.739 199.364V202.664L303.805 208.474Z",
    fill: "#C2C3D0"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M293.739 199.363L300.722 195.326V203.391L293.739 199.363Z",
    fill: "#E0E2EA"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M308.633 169.813L305.987 176.632C305.824 177.06 306.287 177.469 306.687 177.233L311.979 174.178C312.225 174.032 312.298 173.705 312.134 173.468L309.488 169.704C309.261 169.386 308.77 169.44 308.633 169.804V169.813Z",
    fill: "#FFD100"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M306.032 177.287C305.832 177.114 305.76 176.832 305.86 176.587L308.505 169.768C308.587 169.549 308.778 169.404 309.015 169.377C309.251 169.349 309.469 169.449 309.606 169.64L312.252 173.405C312.352 173.55 312.388 173.732 312.352 173.896C312.315 174.068 312.206 174.214 312.052 174.305L306.76 177.36C306.66 177.414 306.551 177.442 306.441 177.442C306.296 177.442 306.151 177.387 306.032 177.287ZM309.042 169.64C308.906 169.658 308.806 169.74 308.751 169.868L306.105 176.687C306.041 176.86 306.105 177.005 306.205 177.087C306.296 177.169 306.451 177.214 306.614 177.123L311.906 174.068C311.997 174.014 312.052 173.932 312.079 173.841C312.097 173.741 312.079 173.641 312.024 173.559L309.378 169.795C309.315 169.695 309.206 169.64 309.087 169.64C309.069 169.64 309.06 169.64 309.042 169.64Z",
    fill: "#1A191D"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M309.378 171.24L309.287 174.086L308.633 174.468L308.56 171.722L309.387 171.24H309.378ZM308.587 174.777C308.587 174.696 308.624 174.623 308.696 174.587L309.215 174.286C309.278 174.25 309.315 174.286 309.315 174.359V174.968C309.315 175.05 309.278 175.114 309.215 175.15L308.696 175.45C308.633 175.487 308.587 175.468 308.587 175.396V174.787V174.777Z",
    fill: "#252529"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M208.814 141.326C213.933 144.281 213.96 149.073 208.878 152.019C203.795 154.974 195.53 154.974 190.411 152.019C185.292 149.064 185.264 144.272 190.347 141.317C195.43 138.362 203.695 138.362 208.814 141.317V141.326Z",
    fill: "#BDBDBD"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M194.321 102.91C191.111 102.792 190.156 107.547 190.756 111.712C191.347 115.876 192.657 123.714 191.984 126.214C191.175 129.242 191.275 136.08 191.948 140.299C192.657 144.818 190.502 146.227 191.857 147.727C192.984 148.973 200.449 145.972 200.449 145.972L199.767 143.981C199.767 143.981 196.748 144.827 195.994 144.163C194.721 143.036 197.694 133.898 197.776 128.233C197.858 122.668 197.776 116.222 197.067 112.185C196.357 108.138 194.33 102.91 194.33 102.91H194.321Z",
    fill: "#F2C3B1"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M191.711 145.054C192.175 145.054 192.43 145.618 193.566 145.999C194.339 146.254 197.03 146.254 198.067 145.818C199.094 145.381 200.258 144.372 199.513 144.054C199.467 144.063 199.413 144.081 199.34 144.099C199.758 143.79 202.522 143.508 202.713 143.735C203.05 144.136 202.195 146.227 200.84 146.7C199.831 147.054 198.813 146.972 196.43 147.454C194.803 147.782 194.221 148.527 192.53 148.382C191.184 148.273 191.211 147.127 191.284 146.2C191.366 145.163 191.557 145.045 191.72 145.054H191.711Z",
    fill: "#252529"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M200.384 103.801C197.174 103.683 196.22 108.439 196.82 112.603C197.411 116.767 198.72 124.605 198.047 127.105C197.238 130.133 197.338 136.971 198.011 141.19C198.72 145.709 196.565 147.118 197.92 148.618C199.048 149.864 206.512 146.864 206.512 146.864L206.585 145.445L205.821 144.872C205.821 144.872 202.803 145.718 202.048 145.054C200.775 143.927 203.748 134.789 203.83 129.124C203.912 123.559 203.83 117.113 203.121 113.076C202.412 109.03 200.384 103.801 200.384 103.801Z",
    fill: "#FCC9B4"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M197.776 145.945C198.24 145.945 198.495 146.509 199.631 146.891C200.404 147.146 203.041 146.964 204.132 146.709C206.278 146.264 206.378 144.9 205.578 144.954C205.541 144.954 205.478 144.972 205.405 144.991C205.823 144.682 208.524 144.591 208.651 144.863C208.978 145.554 208.187 147 206.833 147.473C205.823 147.828 204.887 147.864 202.505 148.346C200.877 148.673 200.295 149.419 198.604 149.273C197.258 149.164 197.285 148.018 197.358 147.091C197.44 146.054 197.631 145.936 197.795 145.945H197.776Z",
    fill: "#252529"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M202.859 58.5299C204.432 59.0481 205.068 60.5484 205.068 61.4213C205.068 62.2942 204.886 63.2034 204.968 63.8399C205.05 64.4764 205.177 65.4311 205.268 66.3949C205.35 67.3041 204.814 70.4683 202.795 70.4774C201.213 70.4865 202.277 73.8507 202.277 73.8507C202.277 73.8507 200.704 75.5329 198.885 75.5329C197.067 75.5329 195.33 74.0962 195.33 74.0962C195.33 74.0962 196.985 70.5411 196.558 68.4316C196.121 66.3312 196.603 59.9847 196.603 59.9847L202.877 58.5208L202.859 58.5299Z",
    fill: "#FCC9B4"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M200.358 67.7857C199.822 66.7946 197.476 67.6766 196.485 68.104C196.503 68.2222 196.521 68.3313 196.539 68.4313C196.639 68.9223 196.621 69.486 196.539 70.077C196.858 71.1772 197.221 72.3956 197.267 72.4956C197.33 72.632 199.376 74.2323 200.504 75.1143C201.531 74.6142 202.25 73.8413 202.25 73.8413C202.25 73.8413 201.186 70.4771 202.768 70.468C203.104 70.468 203.404 70.368 203.659 70.2134C202.895 69.8406 200.895 68.795 200.34 67.7766L200.358 67.7857Z",
    fill: "#F2C3B1"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M205.067 59.539C205.604 60.5483 205.976 62.7669 204.131 63.4397C202.994 63.8489 202.603 62.776 201.967 62.9396C201.148 63.1488 201.421 64.5945 202.412 65.1309C203.285 65.5946 201.785 68.0042 200.821 68.386C199.148 69.0498 197.102 69.7408 195.911 66.7676C194.72 63.7943 194.911 60.7029 196.429 59.0026C197.757 57.5205 198.648 57.275 200.43 57.275C201.858 57.275 204.058 57.6387 205.067 59.5299V59.539Z",
    fill: "#252529"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M198.149 61.5393C197.822 59.7845 196.158 61.7212 195.149 63.1032C195.167 64.2762 195.422 65.5309 195.922 66.7675C197.113 69.7408 199.159 69.0498 200.832 68.386C201.459 68.1405 202.332 67.0039 202.596 66.1311C201.623 65.5764 198.55 63.6761 198.159 61.5302L198.149 61.5393Z",
    fill: "#1A191D"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M202.322 73.6235C201.486 73.9963 199.586 74.0963 198.313 73.8599C196.44 73.5053 197.367 71.514 195.676 71.5504C194.503 71.5686 190.739 73.869 191.339 83.8525C191.575 87.8078 192.466 91.3448 191.993 95.5C191.521 99.6644 189.175 101.456 188.902 107.466C188.62 113.649 188.838 121.668 189.647 123.287C190.202 124.396 204.123 125.096 206.187 123.632C207.587 122.641 205.196 104.056 204.541 97.5186C203.586 90.8629 206.505 89.5535 206.523 86.2075C206.532 84.4799 207.996 77.1877 206.778 76.5331C204.45 75.2874 202.913 73.3689 202.331 73.6235H202.322Z",
    fill: "#F7F7F7"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M202.322 73.887C201.486 74.2598 199.586 74.3598 198.313 74.1234C196.44 73.7688 197.367 71.7776 195.676 71.8139C194.503 71.8321 190.739 74.1325 191.339 84.1161C191.575 88.0713 192.466 91.6083 191.993 95.7636C191.521 99.928 189.175 101.719 188.902 107.729C188.62 113.912 188.838 121.932 189.647 123.55C190.202 124.66 204.123 125.36 206.187 123.896C207.587 122.905 205.196 104.32 204.541 97.7822C203.586 91.1264 206.505 89.8171 206.523 86.4711C206.532 84.7435 207.996 77.4513 206.778 76.7966C204.45 75.551 202.913 73.6324 202.331 73.887H202.322Z",
    fill: "#F7F7F7"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M219.297 76.7787C219.297 76.7787 219.77 76.1513 219.833 75.4148C219.897 74.6692 219.524 72.2597 220.188 72.1597C220.797 72.0688 220.452 73.6054 220.779 73.6054C221.461 73.6054 221.479 69.6502 222.025 69.6502C222.452 69.6502 221.961 71.7051 222.234 71.7051C222.507 71.7051 222.825 71.9142 222.861 72.1506C222.888 72.387 223.07 72.2688 223.279 72.4507C223.489 72.6325 223.27 72.8326 223.416 72.8962C223.543 72.9599 223.752 73.0962 223.725 73.4145C223.689 73.7873 223.316 75.4967 222.525 76.1059C221.334 77.0242 221.47 77.7425 221.47 77.7425L219.297 76.7878V76.7787Z",
    fill: "#FCC9B4"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M204.531 97.7821C203.721 92.0901 205.722 90.308 206.34 87.8257L204.394 83.6523C204.394 83.6523 203.54 94.1814 201.521 101.674C200.485 105.502 202.148 115.694 199.421 119.831C197.411 122.877 192.71 124.35 192.71 124.35C197.075 124.887 204.694 124.95 206.176 123.896C207.577 122.905 205.185 104.32 204.531 97.7821Z",
    fill: "#EFEFEF"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M205.186 76.124C202.267 76.8332 203.049 82.3069 205.422 86.744C207.504 90.6356 209.841 92.0995 211.778 92.2268C216.415 92.5268 221.798 77.3696 221.798 77.3696L219.27 76.124L212.232 85.7529C212.232 85.7529 208.704 75.2784 205.186 76.124Z",
    fill: "#EFEFEF"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M196.568 58.7845C196.568 58.7845 197.05 58.1844 198.023 58.6481C199.032 59.13 199.523 60.703 198.623 61.6123C197.913 62.3397 196.368 60.8849 196.368 60.8849L196.568 58.7845Z",
    fill: "#252529"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M201.694 81.7702C202.794 79.7517 202.239 75.36 201.275 73.7961C201.194 73.8052 200.893 74.187 200.812 74.1961C200.011 75.4691 195.938 81.8066 193.01 84.1161C197.693 86.7802 200.43 84.0797 201.685 81.7702H201.694Z",
    fill: "#EFEFEF"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M197.494 58.8389C197.385 58.7844 192.266 57.2114 190.92 64.3854C189.575 71.5594 192.548 73.4961 193.694 76.3966C194.839 79.288 191.675 83.8888 191.675 83.8888C191.675 83.8888 196.985 85.7891 199.64 81.552C202.295 77.3149 201.74 72.5141 199.84 69.9773C197.94 67.4405 197.522 63.4034 198.294 61.494C198.876 60.0482 198.222 59.1935 197.503 58.8389H197.494Z",
    fill: "#E0B477"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M197.494 58.8389C197.385 58.7844 192.266 57.2114 190.92 64.3854C189.575 71.5594 192.548 73.4961 193.694 76.3966C194.839 79.288 191.675 83.8888 191.675 83.8888C191.675 83.8888 196.985 85.7891 199.64 81.552C202.295 77.3149 201.74 72.5141 199.84 69.9773C197.94 67.4405 197.522 63.4034 198.294 61.494C198.876 60.0482 198.222 59.1935 197.503 58.8389H197.494Z",
    fill: "#252529"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M198.285 61.5032C198.767 60.312 198.403 59.521 197.857 59.0846C196.284 59.4846 193.893 60.6848 194.22 64.3218C194.711 69.6864 199.949 72.2778 198.148 77.606C196.784 81.6431 195.802 82.3614 192.62 84.1344C194.266 84.4617 197.676 84.68 199.63 81.5521C202.285 77.315 201.731 72.5142 199.83 69.9774C197.93 67.4406 197.512 63.4035 198.285 61.4941V61.5032Z",
    fill: "#1A191D"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M157.386 35.5894C156.668 35.1711 156.004 35.1347 155.531 35.4075L156.059 36.3168C156.395 36.1258 156.868 36.1531 157.386 36.4441C157.904 36.735 158.368 37.2533 158.705 37.8443L159.232 37.5443C158.759 36.7259 158.104 36.0076 157.386 35.5894Z",
    fill: "white"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M157.395 33.0072C156.05 32.2344 154.831 32.1616 153.949 32.6617L154.477 33.571C155.222 33.1436 156.259 33.2073 157.395 33.8619C158.532 34.5166 159.559 35.6441 160.296 36.9261L160.823 36.626C159.95 35.1076 158.732 33.7801 157.395 33.0072Z",
    fill: "white"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M157.379 37.726C156.988 37.4987 156.642 37.5532 156.451 37.8078C156.36 37.9351 156.306 38.117 156.306 38.3352C156.306 39.008 156.778 39.8355 157.369 40.181C157.96 40.5265 158.442 40.2446 158.442 39.5718C158.442 39.3536 158.388 39.1081 158.297 38.8717C158.115 38.3988 157.77 37.9533 157.379 37.726Z",
    fill: "white"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M164.615 39.4718C164.606 44.0545 161.351 45.9093 157.359 43.6089C153.367 41.3085 150.14 35.7075 150.158 31.1249C150.176 26.5423 153.422 24.6874 157.414 26.9878C161.396 29.2882 164.633 34.8892 164.615 39.4718ZM157.359 43.2543C161.178 45.4547 164.297 43.6817 164.306 39.29C164.315 34.8983 161.223 29.5337 157.405 27.3333C153.586 25.1329 150.467 26.906 150.458 31.2977C150.449 35.6893 153.54 41.0539 157.359 43.2543Z",
    fill: "white"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M157.395 30.4337C155.431 29.3062 153.658 29.1971 152.367 29.9336L152.895 30.8429C154.049 30.1882 155.64 30.2791 157.395 31.2975C159.15 32.3068 160.732 34.0525 161.887 36.0347L162.414 35.7347C161.132 33.5161 159.359 31.5703 157.395 30.4337Z",
    fill: "white"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M115.196 113.112C108.604 116.913 108.568 123.086 115.114 126.887C121.661 130.688 132.308 130.688 138.9 126.887C145.492 123.086 145.529 116.913 138.982 113.112C132.435 109.311 121.788 109.311 115.196 113.112Z",
    fill: "#BDBDBD"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M130.064 108.311L131.31 107.584C132.301 107.011 133.674 107.093 135.193 107.966L133.947 108.693C132.428 107.82 131.056 107.738 130.064 108.311Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask141_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 107,
    width: 6,
    height: 2
  }, _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M130.064 108.311L131.31 107.584C132.301 107.011 133.674 107.093 135.193 107.966L133.947 108.693C132.428 107.82 131.056 107.738 130.064 108.311Z",
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask141_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.064 108.31L131.31 107.583C131.792 107.301 132.356 107.182 132.983 107.219L131.737 107.946C131.11 107.901 130.537 108.028 130.064 108.301V108.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.736 107.957L132.982 107.229C133.345 107.256 133.727 107.338 134.127 107.475L132.881 108.202C132.481 108.066 132.1 107.984 131.736 107.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.883 108.202L134.128 107.475C134.474 107.593 134.82 107.756 135.183 107.966L133.938 108.693C133.574 108.484 133.219 108.32 132.883 108.202Z",
    fill: "white"
  }))), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M139.03 120.868L137.784 121.595C138.766 121.023 139.366 119.822 139.375 118.104C139.384 114.649 136.956 110.439 133.947 108.702L135.192 107.975C138.202 109.711 140.63 113.921 140.621 117.376C140.621 119.095 140.011 120.304 139.03 120.868Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask142_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 107,
    width: 8,
    height: 15
  }, _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M139.03 120.868L137.784 121.595C138.766 121.023 139.366 119.822 139.375 118.104C139.384 114.649 136.956 110.439 133.947 108.702L135.192 107.975C138.202 109.711 140.63 113.921 140.621 117.376C140.621 119.095 140.011 120.304 139.03 120.868Z",
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask142_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.938 108.693L135.184 107.965C135.184 107.965 135.22 107.984 135.238 107.993L133.992 108.72C133.992 108.72 133.956 108.702 133.938 108.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.993 108.73L135.238 108.002C135.648 108.239 136.038 108.521 136.42 108.848L135.175 109.575C134.793 109.257 134.402 108.975 133.993 108.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.175 109.566L136.42 108.839C136.821 109.175 137.202 109.557 137.566 109.966L136.32 110.694C135.957 110.284 135.575 109.903 135.175 109.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.32 110.693L137.566 109.966C138.42 110.939 139.148 112.084 139.675 113.285L138.429 114.012C137.902 112.812 137.175 111.666 136.32 110.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.43 114.012L139.675 113.285C139.875 113.73 140.039 114.185 140.185 114.63L138.939 115.358C138.802 114.903 138.63 114.449 138.43 114.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.93 115.367L140.175 114.64C140.321 115.113 140.43 115.594 140.503 116.058L139.257 116.786C139.184 116.313 139.075 115.84 138.93 115.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.266 116.785L140.512 116.058C140.585 116.504 140.621 116.94 140.621 117.376C140.621 117.376 140.621 117.386 140.621 117.395L139.375 118.122C139.375 118.122 139.375 118.113 139.375 118.104C139.375 117.676 139.339 117.231 139.266 116.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.365 118.113L140.611 117.386C140.611 117.858 140.556 118.304 140.465 118.695L139.22 119.422C139.311 119.031 139.356 118.586 139.365 118.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.228 119.422L140.474 118.695C140.238 119.713 139.729 120.459 139.028 120.868L137.783 121.595C138.483 121.186 139.001 120.45 139.228 119.422Z",
    fill: "white"
  }))), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M133.937 108.693C136.947 110.43 139.375 114.639 139.366 118.095C139.356 121.55 136.911 122.95 133.901 121.213C130.891 119.477 128.464 115.267 128.473 111.803C128.482 108.347 130.928 106.947 133.937 108.684V108.693Z",
    fill: "#252529"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M114.625 106.483L114.643 114.339C114.643 116.331 115.953 118.313 118.571 119.831C123.827 122.886 132.364 122.886 137.656 119.831C140.32 118.295 141.648 116.276 141.639 114.267L141.621 106.411C141.621 108.42 140.302 110.439 137.638 111.975C132.355 115.03 123.808 115.03 118.553 111.975C115.943 110.457 114.634 108.475 114.625 106.483Z",
    fill: "#439B6B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask143_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 106,
    width: 28,
    height: 17
  }, _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M114.625 106.483L114.643 114.339C114.643 116.331 115.953 118.313 118.571 119.831C123.827 122.886 132.364 122.886 137.656 119.831C140.32 118.295 141.648 116.276 141.639 114.267L141.621 106.411C141.621 108.42 140.302 110.439 137.638 111.975C132.355 115.03 123.808 115.03 118.553 111.975C115.943 110.457 114.634 108.475 114.625 106.483Z",
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask143_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.625 106.484L114.643 114.34C114.643 114.64 114.67 114.94 114.734 115.231L114.716 107.375C114.652 107.075 114.625 106.784 114.625 106.484Z",
    fill: "#439B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.716 107.384L114.734 115.239C115.061 116.876 116.289 118.467 118.398 119.74L118.38 111.884C116.262 110.611 115.043 109.02 114.716 107.384Z",
    fill: "#439B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.39 111.884L118.408 119.74C118.463 119.777 118.517 119.804 118.572 119.84C119.472 120.368 120.472 120.795 121.527 121.14L121.509 113.284C120.445 112.939 119.454 112.512 118.554 111.984C118.499 111.948 118.445 111.921 118.39 111.884Z",
    fill: "#439B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.507 113.275L121.526 121.131C124.135 121.977 127.126 122.277 130.009 122.041L129.991 114.185C127.099 114.421 124.108 114.121 121.507 113.275Z",
    fill: "#439B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.991 114.185L130.009 122.041C132.801 121.813 135.501 121.077 137.656 119.831C140.32 118.295 141.648 116.276 141.639 114.267L141.621 106.411C141.621 108.42 140.302 110.439 137.638 111.975C135.483 113.221 132.792 113.957 129.991 114.185Z",
    fill: "#439B6B"
  }))), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M118.607 100.919C113.324 103.974 113.288 108.92 118.543 111.975C123.799 115.03 132.336 115.03 137.628 111.975C142.911 108.92 142.938 103.974 137.692 100.919C132.437 97.8638 123.89 97.8638 118.607 100.919Z",
    fill: "#4FDA8E"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M116.698 104.401V106.229C116.707 107.92 117.826 109.62 120.044 110.912C124.527 113.512 131.81 113.512 136.32 110.912C138.593 109.602 139.72 107.884 139.72 106.165V104.338C139.72 106.056 138.584 107.775 136.32 109.084C131.81 111.684 124.527 111.684 120.044 109.084C117.817 107.793 116.707 106.102 116.698 104.401Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask144_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 104,
    width: 24,
    height: 9
  }, _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M116.698 104.401V106.229C116.707 107.92 117.826 109.62 120.044 110.912C124.527 113.512 131.81 113.512 136.32 110.912C138.593 109.602 139.72 107.884 139.72 106.165V104.338C139.72 106.056 138.584 107.775 136.32 109.084C131.81 111.684 124.527 111.684 120.044 109.084C117.817 107.793 116.707 106.102 116.698 104.401Z",
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask144_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.698 104.402V106.229C116.698 106.484 116.726 106.739 116.78 106.993V105.166C116.726 104.911 116.698 104.656 116.698 104.402Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.771 105.156V106.984C117.053 108.384 118.099 109.739 119.899 110.821V108.993C118.09 107.911 117.044 106.556 116.771 105.156Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.899 108.993V110.821C119.953 110.848 119.999 110.875 120.044 110.902C120.808 111.348 121.663 111.721 122.563 112.012V110.184C121.654 109.893 120.808 109.52 120.035 109.075C119.99 109.047 119.944 109.02 119.899 108.993Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.564 110.184V112.012C124.792 112.73 127.347 112.994 129.802 112.785V110.957C127.338 111.157 124.783 110.902 122.564 110.184Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.801 110.966V112.794C132.192 112.594 134.483 111.966 136.32 110.912C138.593 109.602 139.721 107.884 139.721 106.165V104.338C139.721 106.056 138.584 107.775 136.32 109.084C134.483 110.148 132.183 110.775 129.801 110.966Z",
    fill: "#252529"
  }))), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M128.209 111.039C134.566 111.021 139.712 108.022 139.701 104.342C139.691 100.661 134.529 97.6912 128.172 97.7089C121.814 97.7267 116.669 100.725 116.679 104.406C116.69 108.087 121.852 111.056 128.209 111.039Z",
    fill: "#38373E"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M114.316 113.321L115.562 112.594C116.553 112.021 117.926 112.103 119.444 112.976L118.198 113.703C116.68 112.83 115.307 112.748 114.316 113.321Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask145_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 112,
    width: 6,
    height: 2
  }, _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M114.316 113.321L115.562 112.594C116.553 112.021 117.926 112.103 119.444 112.976L118.198 113.703C116.68 112.83 115.307 112.748 114.316 113.321Z",
    fill: "white"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask145_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.316 113.32L115.562 112.593C116.043 112.311 116.607 112.193 117.235 112.229L115.989 112.957C115.362 112.911 114.789 113.038 114.316 113.311V113.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.988 112.957L117.234 112.23C117.598 112.257 117.98 112.339 118.38 112.476L117.134 113.203C116.734 113.067 116.352 112.985 115.988 112.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.135 113.203L118.381 112.476C118.726 112.594 119.072 112.758 119.436 112.967L118.19 113.694C117.826 113.485 117.472 113.321 117.135 113.203Z",
    fill: "white"
  }))), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M123.281 125.878L122.036 126.605C123.018 126.032 123.618 124.832 123.627 123.114C123.636 119.658 121.208 115.449 118.199 113.712L119.444 112.985C122.454 114.721 124.882 118.931 124.873 122.386C124.873 124.105 124.263 125.314 123.281 125.878Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask146_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 112,
    width: 7,
    height: 15
  }, _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M123.281 125.878L122.036 126.605C123.018 126.032 123.618 124.832 123.627 123.114C123.636 119.658 121.208 115.449 118.199 113.712L119.444 112.985C122.454 114.721 124.882 118.931 124.873 122.386C124.873 124.105 124.263 125.314 123.281 125.878Z",
    fill: "white"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask146_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.199 113.703L119.445 112.976C119.445 112.976 119.481 112.994 119.5 113.003L118.253 113.731C118.253 113.731 118.217 113.713 118.199 113.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.243 113.731L119.489 113.003C119.898 113.24 120.289 113.521 120.671 113.849L119.425 114.576C119.043 114.258 118.652 113.976 118.243 113.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.426 114.576L120.671 113.848C121.072 114.185 121.453 114.567 121.817 114.976L120.571 115.703C120.208 115.294 119.826 114.912 119.426 114.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.571 115.703L121.816 114.976C122.671 115.949 123.399 117.095 123.926 118.295L122.68 119.022C122.153 117.822 121.425 116.676 120.571 115.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.682 119.022L123.927 118.295C124.127 118.741 124.291 119.195 124.436 119.641L123.191 120.368C123.054 119.913 122.882 119.459 122.682 119.022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.19 120.368L124.436 119.641C124.582 120.114 124.691 120.595 124.763 121.059L123.518 121.787C123.445 121.314 123.336 120.841 123.19 120.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.517 121.787L124.763 121.059C124.836 121.505 124.872 121.941 124.872 122.378C124.872 122.378 124.872 122.387 124.872 122.396L123.626 123.123C123.626 123.123 123.626 123.114 123.626 123.105C123.626 122.678 123.59 122.232 123.517 121.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.627 123.123L124.873 122.395C124.873 122.868 124.818 123.314 124.727 123.705L123.481 124.432C123.572 124.041 123.618 123.596 123.627 123.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.481 124.432L124.727 123.705C124.49 124.723 123.981 125.469 123.281 125.878L122.035 126.606C122.735 126.196 123.254 125.46 123.481 124.432Z",
    fill: "white"
  }))), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M118.197 113.703C121.207 115.44 123.634 119.649 123.625 123.105C123.616 126.56 121.17 127.96 118.161 126.223C115.151 124.487 112.723 120.277 112.732 116.813C112.742 113.357 115.187 111.957 118.197 113.694V113.703Z",
    fill: "#C2C3D0"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M115.679 116.813L116.307 116.449C116.825 116.149 117.552 116.185 118.352 116.649L117.725 117.013C116.925 116.549 116.207 116.513 115.679 116.813Z",
    fill: "#38373E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask147_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 116,
    width: 4,
    height: 2
  }, _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M115.679 116.813L116.307 116.449C116.825 116.149 117.552 116.185 118.352 116.649L117.725 117.013C116.925 116.549 116.207 116.513 115.679 116.813Z",
    fill: "white"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask147_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.679 116.813L116.307 116.449C116.562 116.303 116.862 116.24 117.189 116.258L116.562 116.622C116.234 116.594 115.934 116.667 115.679 116.813Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.561 116.622L117.189 116.258C117.38 116.267 117.58 116.313 117.798 116.385L117.171 116.749C116.961 116.676 116.761 116.631 116.561 116.622Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.17 116.749L117.798 116.385C117.98 116.449 118.161 116.531 118.353 116.649L117.725 117.013C117.534 116.904 117.352 116.813 117.17 116.749Z",
    fill: "#38373E"
  }))), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M120.372 123.45L119.744 123.814C120.263 123.514 120.581 122.877 120.581 121.968C120.581 120.15 119.308 117.931 117.717 117.013L118.344 116.649C119.926 117.567 121.208 119.786 121.208 121.604C121.208 122.514 120.89 123.15 120.372 123.45Z",
    fill: "#38373E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask148_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 116,
    width: 5,
    height: 8
  }, _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M120.372 123.45L119.744 123.814C120.263 123.514 120.581 122.877 120.581 121.968C120.581 120.15 119.308 117.931 117.717 117.013L118.344 116.649C119.926 117.567 121.208 119.786 121.208 121.604C121.208 122.514 120.89 123.15 120.372 123.45Z",
    fill: "white"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask148_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.726 117.013L118.353 116.649C118.353 116.649 118.371 116.658 118.381 116.667L117.753 117.031C117.753 117.031 117.735 117.022 117.726 117.013Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.752 117.032L118.38 116.668C118.598 116.795 118.799 116.941 118.999 117.114L118.371 117.477C118.171 117.305 117.962 117.159 117.752 117.032Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.371 117.477L118.998 117.113C119.208 117.295 119.408 117.495 119.599 117.704L118.971 118.068C118.78 117.85 118.58 117.65 118.371 117.477Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.979 118.068L119.607 117.704C120.052 118.213 120.434 118.822 120.716 119.45L120.089 119.813C119.807 119.177 119.425 118.577 118.979 118.068Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.09 119.814L120.718 119.45C120.818 119.686 120.909 119.923 120.981 120.159L120.354 120.523C120.281 120.287 120.19 120.05 120.09 119.814Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.353 120.523L120.981 120.159C121.053 120.413 121.117 120.659 121.154 120.905L120.526 121.269C120.489 121.023 120.426 120.768 120.353 120.523Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.526 121.277L121.154 120.914C121.19 121.15 121.208 121.378 121.208 121.605L120.58 121.969C120.58 121.741 120.562 121.514 120.526 121.277Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58 121.977L121.208 121.614C121.208 121.868 121.18 122.096 121.135 122.305L120.507 122.669C120.553 122.46 120.58 122.232 120.58 121.977Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.507 122.669L121.135 122.305C121.008 122.841 120.744 123.233 120.371 123.451L119.743 123.815C120.116 123.596 120.38 123.205 120.507 122.669Z",
    fill: "#38373E"
  }))), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M117.726 117.013C119.308 117.931 120.59 120.15 120.59 121.968C120.59 123.787 119.299 124.523 117.707 123.614C116.116 122.696 114.843 120.477 114.843 118.659C114.843 116.84 116.134 116.104 117.726 117.013Z",
    fill: "#252529"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 70.9409L176.1 67.6767C176.1 67.6767 176.018 67.6494 175.954 67.6767L180.355 70.9409C180.409 70.9136 180.464 70.9227 180.5 70.9409Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask149_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 67,
    width: 6,
    height: 4
  }, _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 70.9409L176.1 67.6767C176.1 67.6767 176.018 67.6494 175.954 67.6767L180.355 70.9409C180.409 70.9136 180.464 70.9227 180.5 70.9409Z",
    fill: "white"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask149_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.5 70.9408L176.099 67.6766C176.099 67.6766 176.063 67.6584 176.045 67.6584L180.446 70.9226C180.446 70.9226 180.491 70.9226 180.5 70.9408Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.436 70.9226L176.036 67.6584C176.036 67.6584 176.008 67.6584 175.99 67.6584L180.391 70.9226C180.391 70.9226 180.418 70.9226 180.436 70.9226Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.391 70.9222L175.99 67.658C175.99 67.658 175.963 67.658 175.954 67.6671L180.355 70.9313C180.355 70.9313 180.382 70.9222 180.391 70.9222Z",
    fill: "#252529"
  }))), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M175.763 68.1232L180.164 71.3874C180.164 71.3874 180.109 71.3146 180.118 71.251C180.127 71.1237 180.236 70.9873 180.354 70.9327L175.954 67.6685C175.835 67.7231 175.726 67.8595 175.717 67.9868C175.717 68.0504 175.726 68.0959 175.763 68.1232Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask150_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 67,
    width: 6,
    height: 5
  }, _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M175.763 68.1232L180.164 71.3874C180.164 71.3874 180.109 71.3146 180.118 71.251C180.127 71.1237 180.236 70.9873 180.354 70.9327L175.954 67.6685C175.835 67.7231 175.726 67.8595 175.717 67.9868C175.717 68.0504 175.726 68.0959 175.763 68.1232Z",
    fill: "white"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask150_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.355 70.9408L175.954 67.6765L180.355 70.9408Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.354 70.9408L175.953 67.6765C175.953 67.6765 175.926 67.6947 175.908 67.7038L180.308 70.968C180.308 70.968 180.336 70.9498 180.354 70.9408Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.309 70.9682L175.908 67.704C175.908 67.704 175.872 67.7313 175.863 67.7404L180.264 71.0046C180.264 71.0046 180.291 70.9773 180.309 70.9682Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.263 71.0045L175.862 67.7403C175.862 67.7403 175.798 67.813 175.771 67.8585L180.172 71.1227C180.172 71.1227 180.226 71.0409 180.263 71.0045Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.173 71.1138L175.772 67.8496C175.772 67.8496 175.754 67.8769 175.745 67.8951L180.145 71.1593C180.145 71.1593 180.164 71.132 180.173 71.1138Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.145 71.1683L175.744 67.9041C175.744 67.9041 175.735 67.9405 175.726 67.9496L180.127 71.2138C180.127 71.2138 180.136 71.1774 180.145 71.1683Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.127 71.2137L175.726 67.9494C175.726 67.9494 175.726 67.9767 175.726 67.9949L180.127 71.2591C180.127 71.2591 180.127 71.2318 180.127 71.2137Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.118 71.2595L175.717 67.9953C175.717 67.9953 175.717 68.0317 175.717 68.0408L180.118 71.305C180.118 71.305 180.118 71.2777 180.118 71.2595Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.118 71.3048L175.717 68.0406C175.717 68.0406 175.735 68.1043 175.763 68.1225L180.164 71.3867C180.164 71.3867 180.127 71.3412 180.118 71.3048Z",
    fill: "#252529"
  }))), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M180.354 70.9406C180.236 70.9952 180.127 71.1316 180.118 71.259C180.099 71.3863 180.19 71.45 180.309 71.3954C180.427 71.3409 180.527 71.2044 180.545 71.077C180.554 70.9497 180.472 70.8951 180.363 70.9406H180.354Z",
    fill: "#252529"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M152.468 85.0525L154.223 84.5433C154.696 84.407 155.078 83.9523 155.241 83.2067L153.487 83.7159C153.323 84.4524 152.941 84.9161 152.468 85.0525Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask151_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 83,
    width: 4,
    height: 3
  }, _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M152.468 85.0525L154.223 84.5433C154.696 84.407 155.078 83.9523 155.241 83.2067L153.487 83.7159C153.323 84.4524 152.941 84.9161 152.468 85.0525Z",
    fill: "white"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask151_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.468 85.0525L154.223 84.5433C154.696 84.407 155.078 83.9523 155.241 83.2067L153.487 83.7159C153.323 84.4524 152.941 84.9161 152.468 85.0525Z",
    fill: "#E0E2EA"
  }))), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M159.651 46.4733L157.896 46.9825C158.36 46.8461 158.906 47.0189 159.433 47.5281L161.188 47.0189C160.661 46.5097 160.115 46.3369 159.651 46.4733Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask152_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 46,
    width: 5,
    height: 2
  }, _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M159.651 46.4733L157.896 46.9825C158.36 46.8461 158.906 47.0189 159.433 47.5281L161.188 47.0189C160.661 46.5097 160.115 46.3369 159.651 46.4733Z",
    fill: "white"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask152_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.434 47.5282L161.189 47.019C160.852 46.6917 160.507 46.5098 160.188 46.4462L158.434 46.9553C158.761 47.019 159.106 47.2008 159.434 47.5282Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.433 46.955L160.188 46.4459C159.997 46.4095 159.824 46.4186 159.651 46.464L157.896 46.9732C158.069 46.9278 158.242 46.9187 158.433 46.955Z",
    fill: "#E0E2EA"
  }))), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M153.487 83.7159L155.242 83.2067L162.462 51.3102L160.707 51.8193L153.487 83.7159Z",
    fill: "#E0E2EA"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M160.705 51.8194L162.46 51.3102C162.778 49.91 162.215 48.0096 161.196 47.0185L159.441 47.5277C160.469 48.5188 161.024 50.4191 160.705 51.8194Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask153_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 47,
    width: 4,
    height: 5
  }, _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M160.705 51.8194L162.46 51.3102C162.778 49.91 162.215 48.0096 161.196 47.0185L159.441 47.5277C160.469 48.5188 161.024 50.4191 160.705 51.8194Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask153_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.706 51.8202L162.461 51.3108C162.561 50.8741 162.57 50.3829 162.516 49.8826L160.76 50.392C160.824 50.8832 160.806 51.3744 160.706 51.8202Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.759 50.4008L162.514 49.8916C162.469 49.5279 162.387 49.1733 162.269 48.8187L160.514 49.3279C160.632 49.6734 160.714 50.0371 160.759 50.4008Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.514 49.328L162.269 48.8189C162.033 48.1187 161.66 47.4732 161.196 47.0185L159.441 47.5277C159.914 47.9824 160.278 48.6279 160.514 49.328Z",
    fill: "#E0E2EA"
  }))), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M159.432 47.5279C158.405 46.5278 157.277 46.8187 156.904 48.1917L148.548 78.988C148.167 80.3882 148.721 82.3886 149.785 83.407L150.922 84.5072C151.994 85.5437 153.149 85.18 153.477 83.7161L160.696 51.8196C161.014 50.4193 160.451 48.519 159.432 47.5279Z",
    fill: "#C2C3D0"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M129.054 58.1479L127.417 58.9571C127.844 58.748 128.417 58.8207 129.026 59.2299L130.663 58.4206C130.054 58.0115 129.481 57.9387 129.054 58.1479Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask154_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 58,
    width: 4,
    height: 2
  }, _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M129.054 58.1479L127.417 58.9571C127.844 58.748 128.417 58.8207 129.026 59.2299L130.663 58.4206C130.054 58.0115 129.481 57.9387 129.054 58.1479Z",
    fill: "white"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask154_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.027 59.2208L130.664 58.4115C130.282 58.1478 129.909 58.0296 129.582 58.0296L127.945 58.8389C128.273 58.8389 128.645 58.9662 129.027 59.2208Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.935 58.8378L129.572 58.0285C129.381 58.0285 129.208 58.0649 129.054 58.1468L127.417 58.956C127.572 58.8742 127.753 58.8378 127.935 58.8378Z",
    fill: "#E0E2EA"
  }))), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M129.518 95.9001L131.154 95.0908L132.664 62.4214L131.027 63.2307L129.518 95.9001Z",
    fill: "#E0E2EA"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M131.028 63.2305L132.664 62.4213C132.728 60.9847 131.846 59.2116 130.664 58.4115L129.027 59.2207C130.209 60.0118 131.1 61.7939 131.028 63.2305Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask155_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 58,
    width: 4,
    height: 6
  }, _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M131.028 63.2305L132.664 62.4213C132.728 60.9847 131.846 59.2116 130.664 58.4115L129.027 59.2207C130.209 60.0118 131.1 61.7939 131.028 63.2305Z",
    fill: "white"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask155_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.028 63.2306L132.664 62.4214C132.683 61.9759 132.61 61.4849 132.464 61.0121L130.828 61.8213C130.973 62.2941 131.046 62.7851 131.028 63.2306Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.827 61.821L132.463 61.0118C132.354 60.6663 132.209 60.3208 132.036 59.9934L130.399 60.8027C130.572 61.13 130.718 61.4664 130.827 61.821Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4 60.8115L132.037 60.0022C131.682 59.3566 131.2 58.7838 130.664 58.4201L129.027 59.2294C129.573 59.5931 130.046 60.1659 130.4 60.8115Z",
    fill: "#E0E2EA"
  }))), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M129.027 59.2208C127.836 58.4207 126.781 58.9026 126.654 60.3119L123.826 92.0993C123.699 93.5451 124.599 95.4181 125.817 96.2364L127.127 97.1184C128.354 97.9458 129.436 97.3912 129.509 95.8909L131.018 63.2215C131.082 61.7849 130.2 60.0119 129.018 59.2117L129.027 59.2208Z",
    fill: "#C2C3D0"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M123.554 88.9805L117.234 92.6539C118.198 92.0901 119.544 92.2174 120.944 93.0267L127.263 89.3533C125.863 88.5441 124.517 88.4259 123.554 88.9805Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask156_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 88,
    width: 11,
    height: 6
  }, _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M123.554 88.9805L117.234 92.6539C118.198 92.0901 119.544 92.2174 120.944 93.0267L127.263 89.3533C125.863 88.5441 124.517 88.4259 123.554 88.9805Z",
    fill: "white"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask156_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.945 93.0176L127.264 89.3442C126.364 88.826 125.482 88.5896 124.709 88.635L118.39 92.3084C119.163 92.263 120.044 92.4994 120.945 93.0176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.389 92.3091L124.708 88.6357C124.29 88.663 123.899 88.7721 123.553 88.9721L117.234 92.6455C117.579 92.4454 117.961 92.3363 118.389 92.3091Z",
    fill: "white"
  }))), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M123.398 95.1544L129.718 91.481C128.927 90.5354 128.09 89.8262 127.263 89.3443L120.943 93.0177C121.762 93.4905 122.607 94.1997 123.398 95.1544Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask157_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 89,
    width: 10,
    height: 7
  }, _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M123.398 95.1544L129.718 91.481C128.927 90.5354 128.09 89.8262 127.263 89.3443L120.943 93.0177C121.762 93.4905 122.607 94.1997 123.398 95.1544Z",
    fill: "white"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask157_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.398 95.1544L129.718 91.481C128.927 90.5354 128.09 89.8262 127.263 89.3443L120.943 93.0177C121.762 93.4905 122.607 94.1997 123.398 95.1544Z",
    fill: "white"
  }))), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M131.564 104.956L137.883 101.283L129.718 91.4809L123.398 95.1543L131.564 104.956Z",
    fill: "white"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M132.228 110.666L138.547 106.993C139.075 106.684 139.393 106.038 139.402 105.12C139.402 103.883 138.82 102.41 137.874 101.283L131.555 104.956C132.492 106.093 133.083 107.557 133.083 108.793C133.083 109.712 132.755 110.366 132.228 110.666Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask158_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 101,
    width: 9,
    height: 10
  }, _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M132.228 110.666L138.547 106.993C139.075 106.684 139.393 106.038 139.402 105.12C139.402 103.883 138.82 102.41 137.874 101.283L131.555 104.956C132.492 106.093 133.083 107.557 133.083 108.793C133.083 109.712 132.755 110.366 132.228 110.666Z",
    fill: "white"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask158_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.227 110.666L138.546 106.993C139.074 106.684 139.392 106.038 139.401 105.12C139.401 104.529 139.265 103.874 139.019 103.229L132.7 106.902C132.945 107.548 133.082 108.193 133.082 108.793C133.082 109.712 132.754 110.366 132.227 110.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.701 106.902L139.02 103.229C138.857 102.801 138.638 102.374 138.384 101.974L132.064 105.647C132.319 106.047 132.537 106.475 132.701 106.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.064 105.647L138.384 101.974C138.229 101.738 138.056 101.501 137.874 101.283L131.555 104.956C131.737 105.175 131.91 105.411 132.064 105.647Z",
    fill: "white"
  }))), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M120.944 93.0177C118.38 91.5356 115.989 92.3539 115.816 95.4726C115.816 95.5908 115.807 95.7181 115.807 95.8363C115.798 99.337 118.253 103.592 121.299 105.356L130.146 110.466C131.765 111.403 133.074 110.648 133.074 108.793C133.074 107.557 132.492 106.084 131.546 104.956L123.381 95.1544C122.59 94.2088 121.754 93.4996 120.926 93.0177H120.944Z",
    fill: "#C2C3D0"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M125.464 58.9301L120.454 61.1577C121.108 60.8668 121.963 61.0123 122.845 61.6578L127.855 59.4302C126.973 58.7846 126.118 58.6391 125.464 58.9301Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask159_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 58,
    width: 8,
    height: 4
  }, _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M125.464 58.9301L120.454 61.1577C121.108 60.8668 121.963 61.0123 122.845 61.6578L127.855 59.4302C126.973 58.7846 126.118 58.6391 125.464 58.9301Z",
    fill: "white"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask159_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.854 61.6575L127.864 59.4298C127.3 59.0207 126.755 58.8116 126.264 58.7934L121.254 61.021C121.745 61.0392 122.29 61.2483 122.854 61.6575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.253 61.0121L126.263 58.7845C125.981 58.7754 125.717 58.8208 125.472 58.9299L120.462 61.1576C120.698 61.0485 120.971 61.003 121.253 61.0121Z",
    fill: "white"
  }))), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M146.866 79.2061L151.876 76.9785L127.863 59.4299L122.853 61.6576L146.866 79.2061Z",
    fill: "white"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M148.395 87.5166L153.405 85.2889C154.05 84.998 154.514 84.2888 154.632 83.2158C154.869 81.0609 153.641 78.2695 151.877 76.9784L146.867 79.206C148.631 80.4972 149.859 83.2886 149.622 85.4435C149.504 86.5164 149.04 87.2256 148.395 87.5166Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask160_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 76,
    width: 9,
    height: 12
  }, _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M148.395 87.5166L153.405 85.2889C154.05 84.998 154.514 84.2888 154.632 83.2158C154.869 81.0609 153.641 78.2695 151.877 76.9784L146.867 79.206C148.631 80.4972 149.859 83.2886 149.622 85.4435C149.504 86.5164 149.04 87.2256 148.395 87.5166Z",
    fill: "white"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask160_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.395 87.5167L153.405 85.2891C154.05 84.9981 154.514 84.2889 154.632 83.216C154.714 82.5159 154.632 81.743 154.432 80.9792L149.422 83.2069C149.622 83.9707 149.704 84.7435 149.622 85.4437C149.504 86.5166 149.04 87.2258 148.395 87.5167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.421 83.2067L154.431 80.9791C154.295 80.4517 154.095 79.9334 153.849 79.4333L148.839 81.661C149.085 82.152 149.285 82.6794 149.421 83.2067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.84 81.661L153.85 79.4334C153.359 78.4423 152.677 77.5603 151.877 76.9784L146.867 79.206C147.658 79.788 148.34 80.6699 148.84 81.661Z",
    fill: "white"
  }))), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M122.852 61.6576C121.097 60.3756 119.47 61.0757 119.233 63.2306C118.997 65.3855 120.224 68.1769 121.988 69.4681L146.002 87.0166C147.766 88.3078 149.384 87.5986 149.62 85.4436C149.857 83.2887 148.629 80.4973 146.865 79.2062L122.852 61.6576Z",
    fill: "#C2C3D0"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M156.677 49.0916L151.413 50.6192C151.913 50.4737 152.504 50.6464 153.086 51.1738L158.35 49.6463C157.777 49.1189 157.177 48.9461 156.677 49.0916Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask161_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 49,
    width: 8,
    height: 3
  }, _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M156.677 49.0916L151.413 50.6192C151.913 50.4737 152.504 50.6464 153.086 51.1738L158.35 49.6463C157.777 49.1189 157.177 48.9461 156.677 49.0916Z",
    fill: "white"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask161_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.077 51.1741L158.342 49.6466C157.987 49.3192 157.623 49.1283 157.278 49.0646L152.013 50.5922C152.359 50.6558 152.722 50.8468 153.077 51.1741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.013 50.5919L157.277 49.0644C157.068 49.028 156.859 49.0371 156.677 49.0917L151.413 50.6192C151.604 50.5646 151.804 50.5556 152.013 50.5919Z",
    fill: "white"
  }))), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M155.25 53.1467L160.515 51.6282L158.342 49.646L153.077 51.1736L155.25 53.1467Z",
    fill: "white"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M153.931 59.039L159.196 57.5205L160.514 51.6286L155.25 53.147L153.931 59.039Z",
    fill: "#E0E2EA"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M155.249 53.1468L153.085 51.1737C151.885 50.0826 150.621 50.5191 150.257 52.1375C149.903 53.7287 150.539 55.8836 151.694 56.9929C151.721 57.0111 151.739 57.0384 151.767 57.0566L153.931 59.0297L155.249 53.1377V53.1468Z",
    fill: "#C2C3D0"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M176.39 66.8857L158.632 54.0198C158.532 53.947 158.396 53.9198 158.241 53.947C158.169 53.9561 158.087 53.9834 158.014 54.0198L175.772 66.8857C175.854 66.8493 175.926 66.822 175.999 66.8129C176.163 66.7857 176.29 66.8129 176.39 66.8857Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask162_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 53,
    width: 19,
    height: 14
  }, _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M176.39 66.8857L158.632 54.0198C158.532 53.947 158.396 53.9198 158.241 53.947C158.169 53.9561 158.087 53.9834 158.014 54.0198L175.772 66.8857C175.854 66.8493 175.926 66.822 175.999 66.8129C176.163 66.7857 176.29 66.8129 176.39 66.8857Z",
    fill: "white"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask162_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.391 66.8858L158.633 54.0199C158.561 53.9653 158.479 53.9381 158.37 53.9381L176.127 66.804C176.227 66.804 176.318 66.8403 176.391 66.8858Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.126 66.804L158.369 53.9381C158.369 53.9381 158.287 53.9381 158.232 53.9472C158.214 53.9472 158.196 53.9472 158.178 53.9562L175.935 66.8221C175.935 66.8221 175.972 66.8221 175.99 66.8131C176.035 66.8131 176.081 66.804 176.126 66.804Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.935 66.8224L158.178 53.9565C158.123 53.9747 158.059 53.9929 158.005 54.0202L175.763 66.8861C175.817 66.8588 175.881 66.8406 175.935 66.8224Z",
    fill: "#252529"
  }))), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M157.177 56.0202L174.935 68.8861C174.735 68.7406 174.671 68.4315 174.79 68.0314C174.944 67.5313 175.344 67.0676 175.753 66.8857L157.996 54.0198C157.587 54.2017 157.187 54.6654 157.032 55.1655C156.914 55.5565 156.977 55.8747 157.177 56.0202Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask163_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 54,
    width: 20,
    height: 15
  }, _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M157.177 56.0202L174.935 68.8861C174.735 68.7406 174.671 68.4315 174.79 68.0314C174.944 67.5313 175.344 67.0676 175.753 66.8857L157.996 54.0198C157.587 54.2017 157.187 54.6654 157.032 55.1655C156.914 55.5565 156.977 55.8747 157.177 56.0202Z",
    fill: "white"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask163_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.762 66.8859L158.005 54.02L157.996 54.0291L175.753 66.8859H175.762Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.754 66.8859L157.996 54.02C157.933 54.0473 157.86 54.0927 157.796 54.1382L175.554 67.0041C175.618 66.9587 175.69 66.9223 175.754 66.8859Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.552 67.0041L157.795 54.1382C157.722 54.1837 157.658 54.2382 157.595 54.3019L175.352 67.1678C175.416 67.1041 175.489 67.0496 175.552 67.0041Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.354 67.168L157.597 54.3021C157.451 54.4385 157.315 54.6113 157.206 54.7931L174.963 67.659C175.072 67.4772 175.2 67.3044 175.354 67.159V67.168Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.963 67.6586L157.205 54.7927C157.169 54.8564 157.133 54.9291 157.105 55.0018L174.863 67.8677C174.89 67.795 174.927 67.7314 174.963 67.6586Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.853 67.8681L157.096 55.0022C157.077 55.0568 157.05 55.1113 157.032 55.1659C157.032 55.1841 157.023 55.2113 157.014 55.2295L174.771 68.0954C174.771 68.0954 174.78 68.0591 174.79 68.0318C174.808 67.9772 174.826 67.9227 174.853 67.8681Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.781 68.0953L157.024 55.2293C157.005 55.3021 156.987 55.3748 156.987 55.4385L174.745 68.3044C174.745 68.2407 174.763 68.168 174.781 68.0953Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.745 68.3044L156.987 55.4385C156.987 55.5112 156.987 55.584 156.987 55.6476L174.745 68.5135C174.745 68.4499 174.745 68.3771 174.745 68.3044Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.745 68.5137L156.987 55.6478C157.005 55.8114 157.078 55.9387 157.187 56.0205L174.945 68.8864C174.836 68.8046 174.772 68.6773 174.745 68.5137Z",
    fill: "#252529"
  }))), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M175.763 66.8859C175.354 67.0677 174.953 67.5314 174.799 68.0315C174.617 68.6225 174.863 69.0408 175.335 68.959C175.408 68.9499 175.49 68.9226 175.572 68.8862C175.981 68.7044 176.381 68.2407 176.536 67.7406C176.717 67.1496 176.472 66.7313 175.999 66.8131C175.926 66.8222 175.845 66.8495 175.772 66.8859H175.763Z",
    fill: "#252529"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M120.062 100.537L121.698 99.7279C122.144 99.5097 122.435 98.9914 122.471 98.2368L120.834 99.046C120.798 99.8007 120.507 100.319 120.062 100.537Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask164_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 98,
    width: 3,
    height: 3
  }, _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M120.062 100.537L121.698 99.7279C122.144 99.5097 122.435 98.9914 122.471 98.2368L120.834 99.046C120.798 99.8007 120.507 100.319 120.062 100.537Z",
    fill: "white"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask164_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.062 100.537L121.698 99.7279C122.144 99.5097 122.435 98.9914 122.471 98.2368L120.834 99.046C120.798 99.8007 120.507 100.319 120.062 100.537Z",
    fill: "#E0E2EA"
  }))), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M120.371 61.2937L118.734 62.103C119.162 61.8938 119.735 61.9666 120.344 62.3757L121.98 61.5665C121.371 61.1573 120.798 61.0846 120.371 61.2937Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask165_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 61,
    width: 4,
    height: 2
  }, _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M120.371 61.2937L118.734 62.103C119.162 61.8938 119.735 61.9666 120.344 62.3757L121.98 61.5665C121.371 61.1573 120.798 61.0846 120.371 61.2937Z",
    fill: "white"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask165_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.344 62.3761L121.98 61.5668C121.598 61.3032 121.226 61.185 120.898 61.185L119.262 61.9942C119.589 61.9942 119.962 62.1215 120.344 62.3761Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.261 61.985L120.898 61.1758C120.707 61.1758 120.534 61.2122 120.379 61.294L118.743 62.1032C118.897 62.0214 119.079 61.985 119.261 61.985Z",
    fill: "#E0E2EA"
  }))), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M120.834 99.046L122.471 98.2368L123.99 65.5765L122.344 66.3766L120.834 99.046Z",
    fill: "#E0E2EA"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M122.344 66.3768L123.981 65.5676C124.044 64.1309 123.162 62.3579 121.98 61.5578L120.344 62.367C121.526 63.1581 122.417 64.9402 122.344 66.3768Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask166_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 61,
    width: 4,
    height: 6
  }, _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M122.344 66.3768L123.981 65.5676C124.044 64.1309 123.162 62.3579 121.98 61.5578L120.344 62.367C121.526 63.1581 122.417 64.9402 122.344 66.3768Z",
    fill: "white"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask166_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.344 66.3766L123.981 65.5673C123.999 65.1218 123.926 64.6308 123.781 64.158L122.144 64.9672C122.29 65.44 122.362 65.931 122.344 66.3766Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.153 64.9671L123.79 64.1578C123.681 63.8123 123.535 63.4668 123.363 63.1395L121.726 63.9487C121.899 64.276 122.044 64.6125 122.153 64.9671Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.717 63.9578L123.353 63.1486C122.999 62.503 122.517 61.9302 121.98 61.5665L120.344 62.3757C120.889 62.7394 121.362 63.3122 121.717 63.9578Z",
    fill: "#E0E2EA"
  }))), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M120.344 62.3761C119.153 61.5759 118.098 62.0578 117.971 63.4672L115.143 95.2546C115.016 96.7003 115.916 98.5733 117.134 99.3917L118.443 100.274C119.671 101.101 120.753 100.546 120.826 99.0462L122.335 66.3768C122.399 64.9401 121.517 63.1671 120.335 62.367L120.344 62.3761Z",
    fill: "#C2C3D0"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M116.889 94.1997L116.098 94.6544C116.443 94.4543 116.925 94.4816 117.452 94.7907L118.243 94.3361C117.716 94.027 117.234 93.9997 116.889 94.1997Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask167_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 94,
    width: 3,
    height: 1
  }, _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M116.889 94.1997L116.098 94.6544C116.443 94.4543 116.925 94.4816 117.452 94.7907L118.243 94.3361C117.716 94.027 117.234 93.9997 116.889 94.1997Z",
    fill: "white"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask167_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.453 94.791L118.244 94.3362C117.826 94.0997 117.443 94.0269 117.134 94.1088L116.343 94.5636C116.652 94.4818 117.043 94.5545 117.453 94.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.342 94.5639L117.134 94.1091C117.052 94.1273 116.97 94.1637 116.897 94.2092L116.106 94.664C116.179 94.6185 116.261 94.5912 116.342 94.5639Z",
    fill: "white"
  }))), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M118.798 99.2916L119.589 98.837C119.935 98.6369 120.144 98.2187 120.144 97.6186C120.144 96.4093 119.298 94.9454 118.252 94.3362L117.461 94.7908C118.507 95.4 119.362 96.8639 119.353 98.0732C119.353 98.6733 119.144 99.0916 118.798 99.2916Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask168_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 94,
    width: 4,
    height: 6
  }, _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M118.798 99.2916L119.589 98.837C119.935 98.6369 120.144 98.2187 120.144 97.6186C120.144 96.4093 119.298 94.9454 118.252 94.3362L117.461 94.7908C118.507 95.4 119.362 96.8639 119.353 98.0732C119.353 98.6733 119.144 99.0916 118.798 99.2916Z",
    fill: "white"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask168_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.798 99.2912L119.589 98.8365C119.935 98.6365 120.144 98.2183 120.144 97.6181C120.144 97.0453 119.953 96.4088 119.644 95.8451L118.853 96.2997C119.162 96.8726 119.353 97.4999 119.353 98.0728C119.353 98.6729 119.144 99.0911 118.798 99.2912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.853 96.3002L119.644 95.8455C119.298 95.2182 118.798 94.6544 118.252 94.3362L117.461 94.7908C118.016 95.109 118.507 95.6637 118.853 96.3002Z",
    fill: "white"
  }))), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M117.453 94.791C116.407 94.1818 115.553 94.6728 115.543 95.8821C115.543 97.0914 116.389 98.5553 117.435 99.1645C118.48 99.7737 119.335 99.2827 119.344 98.0825C119.344 96.8732 118.499 95.4093 117.453 94.8001V94.791Z",
    fill: "#252529"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M118.944 62.9395L118.343 63.2943C118.607 63.1397 118.98 63.1579 119.38 63.3944L119.981 63.0396C119.571 62.8031 119.207 62.7849 118.944 62.9395Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask169_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 62,
    width: 2,
    height: 2
  }, _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M118.944 62.9395L118.343 63.2943C118.607 63.1397 118.98 63.1579 119.38 63.3944L119.981 63.0396C119.571 62.8031 119.207 62.7849 118.944 62.9395Z",
    fill: "white"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask169_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.381 63.3947L119.982 63.0399C119.663 62.858 119.372 62.8034 119.127 62.867L118.526 63.2218C118.763 63.1581 119.063 63.2218 119.381 63.3947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.525 63.2217L119.126 62.8669C119.062 62.8851 118.998 62.9124 118.944 62.9397L118.343 63.2945C118.398 63.2581 118.462 63.2399 118.525 63.2217Z",
    fill: "white"
  }))), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M120.407 66.8492L121.007 66.4946C121.271 66.34 121.434 66.0218 121.434 65.5581C121.434 64.6306 120.789 63.5031 119.98 63.0394L119.379 63.394C120.189 63.8578 120.834 64.9852 120.834 65.9127C120.834 66.3764 120.671 66.6946 120.407 66.8492Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask170_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 63,
    width: 3,
    height: 4
  }, _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M120.407 66.8492L121.007 66.4946C121.271 66.34 121.434 66.0218 121.434 65.5581C121.434 64.6306 120.789 63.5031 119.98 63.0394L119.379 63.394C120.189 63.8578 120.834 64.9852 120.834 65.9127C120.834 66.3764 120.671 66.6946 120.407 66.8492Z",
    fill: "white"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask170_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.408 66.8495L121.008 66.4949C121.271 66.3403 121.435 66.0221 121.435 65.5584C121.435 65.1219 121.29 64.6309 121.053 64.1945L120.453 64.5491C120.69 64.9856 120.844 65.4765 120.835 65.913C120.835 66.3767 120.671 66.6949 120.408 66.8495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.445 64.5495L121.045 64.1947C120.781 63.7126 120.399 63.2851 119.971 63.0395L119.371 63.3942C119.799 63.6398 120.172 64.0674 120.445 64.5495Z",
    fill: "white"
  }))), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M119.379 63.3944C118.57 62.9307 117.916 63.3034 117.916 64.2309C117.916 65.1583 118.561 66.2858 119.37 66.7495C120.18 67.2132 120.834 66.8404 120.834 65.913C120.834 64.9856 120.189 63.8581 119.379 63.3944Z",
    fill: "#252529"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M146.994 86.3984L148.749 85.8893C149.222 85.7529 149.604 85.2982 149.767 84.5527L148.012 85.0618C147.849 85.7983 147.467 86.262 146.994 86.3984Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask171_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 84,
    width: 4,
    height: 3
  }, _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M146.994 86.3984L148.749 85.8893C149.222 85.7529 149.604 85.2982 149.767 84.5527L148.012 85.0618C147.849 85.7983 147.467 86.262 146.994 86.3984Z",
    fill: "white"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask171_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.994 86.3984L148.749 85.8893C149.222 85.7529 149.604 85.2982 149.767 84.5527L148.012 85.0618C147.849 85.7983 147.467 86.262 146.994 86.3984Z",
    fill: "#E0E2EA"
  }))), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M154.178 47.8187L152.423 48.3278C152.887 48.1914 153.433 48.3642 153.96 48.8734L155.715 48.3642C155.187 47.855 154.642 47.6823 154.178 47.8187Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask172_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 47,
    width: 4,
    height: 2
  }, _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M154.178 47.8187L152.423 48.3278C152.887 48.1914 153.433 48.3642 153.96 48.8734L155.715 48.3642C155.187 47.855 154.642 47.6823 154.178 47.8187Z",
    fill: "white"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask172_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.959 48.8736L155.714 48.3644C155.378 48.0371 155.032 47.8552 154.714 47.7916L152.959 48.3008C153.286 48.3644 153.632 48.5462 153.959 48.8736Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.96 48.3003L154.715 47.7911C154.524 47.7547 154.351 47.7638 154.178 47.8093L152.423 48.3185C152.596 48.273 152.769 48.2639 152.96 48.3003Z",
    fill: "#E0E2EA"
  }))), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M148.013 85.0616L149.768 84.5524L156.987 52.6559L155.232 53.165L148.013 85.0616Z",
    fill: "#E0E2EA"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M155.231 53.1653L156.986 52.6561C157.304 51.2559 156.741 49.3555 155.722 48.3645L153.967 48.8736C154.995 49.8647 155.558 51.7651 155.231 53.1653Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask173_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 48,
    width: 5,
    height: 6
  }, _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M155.231 53.1653L156.986 52.6561C157.304 51.2559 156.741 49.3555 155.722 48.3645L153.967 48.8736C154.995 49.8647 155.558 51.7651 155.231 53.1653Z",
    fill: "white"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask173_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.231 53.166L156.987 52.6566C157.087 52.2199 157.096 51.7287 157.042 51.2284L155.286 51.7378C155.35 52.229 155.332 52.7202 155.231 53.166Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.278 51.7374L157.033 51.2282C156.987 50.8736 156.905 50.5099 156.787 50.1553L155.032 50.6645C155.15 51.01 155.232 51.3737 155.278 51.7374Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.032 50.674L156.787 50.1648C156.55 49.4646 156.178 48.8191 155.714 48.3645L153.959 48.8736C154.432 49.3283 154.805 49.9738 155.032 50.674Z",
    fill: "#E0E2EA"
  }))), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M153.959 48.8736C152.932 47.8734 151.804 48.1644 151.431 49.5373L143.075 80.3337C142.693 81.7339 143.248 83.7252 144.312 84.7526L145.448 85.8528C146.521 86.8894 147.676 86.5347 148.003 85.0709L155.223 53.1743C155.541 51.7741 154.977 49.8738 153.959 48.8827V48.8736Z",
    fill: "#C2C3D0"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M144.593 80.3972L143.884 80.8066C144.193 80.6246 144.63 80.6519 145.103 80.9248L145.812 80.5155C145.339 80.2426 144.903 80.2153 144.593 80.3972Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask174_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 80,
    width: 3,
    height: 1
  }, _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M144.593 80.3972L143.884 80.8066C144.193 80.6246 144.63 80.6519 145.103 80.9248L145.812 80.5155C145.339 80.2426 144.903 80.2153 144.593 80.3972Z",
    fill: "white"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask174_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.102 80.925L145.812 80.5157C145.439 80.2973 145.093 80.2337 144.811 80.3064L144.102 80.7158C144.384 80.643 144.729 80.7158 145.102 80.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.102 80.7161L144.812 80.3068C144.739 80.325 144.666 80.3522 144.593 80.3977L143.884 80.8071C143.947 80.7707 144.02 80.7343 144.102 80.7161Z",
    fill: "white"
  }))), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M146.313 84.9799L147.022 84.5707C147.331 84.3889 147.522 84.0161 147.522 83.4706C147.522 82.3795 146.758 81.061 145.813 80.5155L145.104 80.9246C146.049 81.4702 146.813 82.7977 146.813 83.8797C146.813 84.4162 146.622 84.7981 146.313 84.9799Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask175_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 80,
    width: 3,
    height: 5
  }, _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M146.313 84.9799L147.022 84.5707C147.331 84.3889 147.522 84.0161 147.522 83.4706C147.522 82.3795 146.758 81.061 145.813 80.5155L145.104 80.9246C146.049 81.4702 146.813 82.7977 146.813 83.8797C146.813 84.4162 146.622 84.7981 146.313 84.9799Z",
    fill: "white"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask175_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.312 84.9799L147.022 84.5707C147.331 84.3888 147.522 84.016 147.522 83.4705C147.522 82.9522 147.349 82.3885 147.067 81.8702L146.358 82.2794C146.64 82.7976 146.813 83.3614 146.813 83.8797C146.813 84.4161 146.622 84.798 146.312 84.9799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.358 82.2794L147.068 81.8703C146.758 81.2974 146.313 80.7974 145.813 80.5155L145.104 80.9246C145.604 81.2156 146.049 81.7157 146.358 82.2794Z",
    fill: "white"
  }))), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M145.103 80.9246C144.157 80.3791 143.384 80.8155 143.384 81.9066C143.384 82.9977 144.148 84.3161 145.094 84.8617C146.039 85.4072 146.812 84.9708 146.812 83.8797C146.812 82.7886 146.048 81.4702 145.103 80.9246Z",
    fill: "#252529"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M151.641 52.6559L151.022 53.0198C151.295 52.8652 151.668 52.8834 152.087 53.1199L152.705 52.756C152.287 52.5195 151.914 52.4922 151.641 52.6559Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask176_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 52,
    width: 2,
    height: 2
  }, _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M151.641 52.6559L151.022 53.0198C151.295 52.8652 151.668 52.8834 152.087 53.1199L152.705 52.756C152.287 52.5195 151.914 52.4922 151.641 52.6559Z",
    fill: "white"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask176_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.086 53.1201L152.704 52.7562C152.377 52.5652 152.077 52.5106 151.831 52.5743L151.212 52.9382C151.458 52.8745 151.758 52.9382 152.086 53.1201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.213 52.9384L151.832 52.5745C151.768 52.5927 151.705 52.62 151.641 52.6473L151.022 53.0111C151.077 52.9747 151.141 52.9475 151.213 52.9384Z",
    fill: "white"
  }))), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M153.149 56.6658L153.767 56.3021C154.04 56.1475 154.204 55.8111 154.204 55.3383C154.204 54.3927 153.54 53.2288 152.713 52.756L152.094 53.1197C152.922 53.5925 153.585 54.7564 153.585 55.702C153.585 56.1748 153.422 56.5021 153.149 56.6658Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask177_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 52,
    width: 3,
    height: 5
  }, _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M153.149 56.6658L153.767 56.3021C154.04 56.1475 154.204 55.8111 154.204 55.3383C154.204 54.3927 153.54 53.2288 152.713 52.756L152.094 53.1197C152.922 53.5925 153.585 54.7564 153.585 55.702C153.585 56.1748 153.422 56.5021 153.149 56.6658Z",
    fill: "white"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask177_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.15 56.6658L153.768 56.3021C154.041 56.1476 154.205 55.8111 154.205 55.3383C154.205 54.8837 154.059 54.3927 153.814 53.9381L153.195 54.3018C153.441 54.7473 153.595 55.2474 153.586 55.702C153.586 56.1748 153.423 56.5022 153.15 56.6658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.187 54.3024L153.805 53.9386C153.532 53.4382 153.141 53.0016 152.705 52.756L152.086 53.1198C152.523 53.3746 152.914 53.8112 153.187 54.3024Z",
    fill: "white"
  }))), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M152.085 53.12C151.258 52.6472 150.585 53.0291 150.585 53.9747C150.585 54.9204 151.249 56.0842 152.076 56.557C152.904 57.0298 153.576 56.6479 153.576 55.7023C153.576 54.7567 152.913 53.5929 152.085 53.12Z",
    fill: "#252529"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M148.758 211.984C156.441 216.421 156.477 223.613 148.849 228.041C141.211 232.479 128.8 232.479 121.117 228.041C113.433 223.604 113.397 216.412 121.026 211.975C128.654 207.538 141.075 207.538 148.758 211.975V211.984Z",
    fill: "#BDBDBD"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M129.564 185.234C130.019 184.97 130.437 184.943 130.728 185.116L130.401 185.689C130.183 185.57 129.892 185.579 129.564 185.77C129.237 185.961 128.946 186.28 128.737 186.652L128.4 186.461C128.7 185.943 129.11 185.498 129.564 185.234Z",
    fill: "white"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M129.546 179.815C132.065 178.36 134.111 179.533 134.12 182.424C134.129 185.316 132.138 188.753 129.674 190.244V190.135L129.483 190.244V190.353C127.009 191.717 125.009 190.544 125 187.689C125 184.798 127.028 181.27 129.546 179.815ZM129.574 190.071C131.983 188.68 133.938 185.298 133.929 182.524C133.92 179.751 131.956 178.633 129.546 180.024C127.137 181.415 125.182 184.798 125.191 187.571C125.2 190.344 127.164 191.462 129.574 190.071Z",
    fill: "white"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M129.564 186.58C129.809 186.434 130.028 186.471 130.146 186.625C130.201 186.707 130.237 186.816 130.237 186.962C130.237 187.389 129.937 187.908 129.564 188.126C129.191 188.344 128.891 188.172 128.891 187.744C128.891 187.608 128.918 187.453 128.982 187.307C129.1 187.007 129.309 186.725 129.564 186.589V186.58Z",
    fill: "white"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M129.554 183.606C130.4 183.115 131.173 183.07 131.727 183.388L131.4 183.961C130.927 183.688 130.272 183.734 129.563 184.143C128.854 184.552 128.199 185.27 127.727 186.08L127.39 185.889C127.945 184.925 128.709 184.088 129.554 183.597V183.606Z",
    fill: "white"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M129.555 181.979C130.792 181.261 131.91 181.197 132.728 181.661L132.401 182.233C131.674 181.815 130.664 181.879 129.564 182.515C128.464 183.152 127.455 184.252 126.736 185.507L126.4 185.316C127.209 183.916 128.328 182.688 129.564 181.97L129.555 181.979Z",
    fill: "white"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M129.601 198.636C129.601 198.636 129.664 198.6 129.701 198.591C129.965 198.491 130.165 198.636 130.165 198.955C130.165 199.309 129.919 199.737 129.61 199.919C129.301 200.101 129.046 199.955 129.046 199.6C129.046 199.282 129.246 198.9 129.51 198.7C129.537 198.673 129.574 198.654 129.601 198.636Z",
    fill: "white"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M129.673 190.126V190.235L129.7 198.591C129.673 198.6 129.636 198.618 129.6 198.636C129.564 198.654 129.536 198.673 129.509 198.7L129.482 190.344V190.235L129.673 190.126Z",
    fill: "white"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M141.884 203.955L143.075 203.264C144.021 202.719 145.321 202.792 146.766 203.628L145.575 204.319C144.13 203.483 142.829 203.41 141.884 203.955Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask178_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 202,
    width: 6,
    height: 3
  }, _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M141.884 203.955L143.075 203.264C144.021 202.719 145.321 202.792 146.766 203.628L145.575 204.319C144.13 203.483 142.829 203.41 141.884 203.955Z",
    fill: "white"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask178_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.884 203.955L143.075 203.264C143.53 203 144.066 202.882 144.666 202.919L143.475 203.61C142.875 203.564 142.338 203.691 141.884 203.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.476 203.619L144.667 202.928C145.012 202.955 145.376 203.028 145.758 203.164L144.567 203.855C144.185 203.719 143.821 203.646 143.476 203.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.567 203.855L145.758 203.164C146.085 203.282 146.422 203.437 146.767 203.637L145.576 204.328C145.231 204.128 144.894 203.973 144.567 203.855Z",
    fill: "white"
  }))), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M150.421 215.912L149.23 216.603C150.158 216.058 150.74 214.912 150.74 213.275C150.749 209.984 148.43 205.974 145.566 204.319L146.757 203.628C149.621 205.283 151.94 209.293 151.931 212.584C151.931 214.221 151.349 215.376 150.421 215.912Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask179_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 203,
    width: 7,
    height: 14
  }, _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M150.421 215.912L149.23 216.603C150.158 216.058 150.74 214.912 150.74 213.275C150.749 209.984 148.43 205.974 145.566 204.319L146.757 203.628C149.621 205.283 151.94 209.293 151.931 212.584C151.931 214.221 151.349 215.376 150.421 215.912Z",
    fill: "white"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask179_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.575 204.319L146.766 203.628C146.766 203.628 146.803 203.646 146.821 203.655L145.629 204.347C145.629 204.347 145.593 204.329 145.575 204.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.621 204.356L146.812 203.665C147.203 203.892 147.575 204.165 147.939 204.465L146.748 205.156C146.384 204.847 146.012 204.583 145.621 204.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.749 205.155L147.94 204.464C148.322 204.783 148.686 205.146 149.031 205.537L147.84 206.228C147.495 205.837 147.131 205.474 146.749 205.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.841 206.228L149.032 205.537C149.842 206.465 150.533 207.556 151.042 208.692L149.851 209.383C149.351 208.238 148.651 207.147 147.841 206.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.85 209.383L151.041 208.692C151.232 209.12 151.386 209.547 151.523 209.974L150.332 210.665C150.195 210.238 150.041 209.802 149.85 209.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.332 210.675L151.523 209.984C151.659 210.438 151.768 210.893 151.841 211.338L150.65 212.029C150.577 211.584 150.477 211.129 150.332 210.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.64 212.02L151.831 211.329C151.895 211.757 151.931 212.175 151.931 212.584C151.931 212.584 151.931 212.593 151.931 212.602L150.74 213.293C150.74 213.293 150.74 213.284 150.74 213.275C150.74 212.866 150.704 212.448 150.64 212.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.741 213.294L151.933 212.602C151.933 213.057 151.887 213.476 151.796 213.849L150.604 214.54C150.686 214.167 150.741 213.748 150.741 213.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.613 214.539L151.805 213.848C151.586 214.821 151.095 215.521 150.423 215.912L149.231 216.603C149.904 216.212 150.386 215.512 150.613 214.539Z",
    fill: "white"
  }))), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M145.575 204.319C148.44 205.974 150.758 209.984 150.749 213.275C150.74 216.567 148.412 217.894 145.548 216.239C142.684 214.585 140.365 210.575 140.375 207.283C140.384 203.992 142.711 202.664 145.575 204.319Z",
    fill: "#252529"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M150.731 211.857L150.713 218.349C150.713 220.576 149.24 222.804 146.312 224.513C140.411 227.941 130.827 227.941 124.89 224.513C121.908 222.786 120.407 220.522 120.417 218.267L120.435 211.775C120.435 214.039 121.917 216.303 124.908 218.021C130.846 221.449 140.438 221.449 146.33 218.021C149.258 216.321 150.722 214.093 150.731 211.857Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask180_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 211,
    width: 31,
    height: 17
  }, _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M150.731 211.857L150.713 218.349C150.713 220.576 149.24 222.804 146.312 224.513C140.411 227.941 130.827 227.941 124.89 224.513C121.908 222.786 120.407 220.522 120.417 218.267L120.435 211.775C120.435 214.039 121.917 216.303 124.908 218.021C130.846 221.449 140.438 221.449 146.33 218.021C149.258 216.321 150.722 214.093 150.731 211.857Z",
    fill: "white"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask180_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.732 211.856L150.714 218.348C150.714 218.685 150.677 219.021 150.614 219.349L150.632 212.857C150.696 212.52 150.732 212.193 150.732 211.856Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.622 212.857L150.604 219.349C150.231 221.186 148.867 222.968 146.485 224.395L146.503 217.903C148.876 216.476 150.249 214.694 150.622 212.857Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.512 217.912L146.494 224.404C146.431 224.44 146.376 224.477 146.312 224.513C145.303 225.104 144.185 225.586 142.994 225.977L143.012 219.485C144.203 219.103 145.321 218.612 146.331 218.021C146.394 217.985 146.458 217.948 146.512 217.912Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.003 219.476L142.985 225.968C140.057 226.914 136.702 227.259 133.465 226.986L133.483 220.494C136.72 220.758 140.084 220.422 143.003 219.476Z",
    fill: "#252529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.483 220.504L133.465 226.996C130.328 226.741 127.3 225.914 124.882 224.513C121.899 222.786 120.399 220.522 120.408 218.267L120.426 211.775C120.426 214.039 121.909 216.303 124.9 218.021C127.319 219.421 130.346 220.249 133.483 220.504Z",
    fill: "#252529"
  }))), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M146.258 205.61C152.195 209.038 152.222 214.594 146.33 218.021C140.429 221.449 130.846 221.449 124.908 218.021C118.971 214.594 118.944 209.038 124.836 205.61C130.728 202.182 140.32 202.182 146.258 205.61Z",
    fill: "#38373E"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M146.694 208.011V210.447C146.685 212.248 145.503 214.039 143.139 215.412C138.384 218.176 130.655 218.176 125.872 215.412C123.463 214.021 122.263 212.193 122.263 210.375V207.938C122.263 209.756 123.463 211.584 125.872 212.975C130.655 215.739 138.393 215.739 143.139 212.975C145.503 211.602 146.685 209.811 146.685 208.011H146.694Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask181_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 207,
    width: 25,
    height: 11
  }, _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M146.694 208.011V210.447C146.685 212.248 145.503 214.039 143.139 215.412C138.384 218.176 130.655 218.176 125.872 215.412C123.463 214.021 122.263 212.193 122.263 210.375V207.938C122.263 209.756 123.463 211.584 125.872 212.975C130.655 215.739 138.393 215.739 143.139 212.975C145.503 211.602 146.685 209.811 146.685 208.011H146.694Z",
    fill: "white"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask181_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.694 208.01V210.447C146.694 210.72 146.658 210.984 146.604 211.256V208.82C146.667 208.547 146.694 208.283 146.694 208.01Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.614 208.82V211.257C146.313 212.739 145.204 214.175 143.286 215.33V212.893C145.204 211.739 146.313 210.302 146.614 208.82Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.294 212.884V215.321C143.24 215.348 143.185 215.375 143.14 215.412C142.321 215.884 141.421 216.275 140.466 216.585V214.148C141.43 213.839 142.33 213.448 143.149 212.975C143.203 212.948 143.249 212.92 143.294 212.884Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.466 214.148V216.585C138.102 217.348 135.393 217.621 132.783 217.412V214.975C135.402 215.194 138.111 214.912 140.466 214.148Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.792 214.975V217.412C130.255 217.203 127.818 216.539 125.863 215.412C123.454 214.021 122.253 212.193 122.253 210.375V207.938C122.253 209.756 123.454 211.584 125.863 212.975C127.809 214.103 130.255 214.766 132.783 214.975H132.792Z",
    fill: "#E0E2EA"
  }))), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M143.085 202.973C147.867 205.737 147.895 210.211 143.139 212.975C138.384 215.739 130.655 215.739 125.873 212.975C121.09 210.211 121.063 205.737 125.818 202.973C130.573 200.209 138.302 200.209 143.094 202.973H143.085Z",
    fill: "white"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M143.577 210.402C144.068 210.684 144.077 211.148 143.577 211.439C143.086 211.72 142.286 211.72 141.795 211.439C141.304 211.157 141.304 210.693 141.795 210.402C142.286 210.12 143.086 210.12 143.577 210.402Z",
    fill: "#30ACC5"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M119.698 216.321L120.889 215.63C121.835 215.085 123.135 215.157 124.581 215.994L123.39 216.685C121.944 215.848 120.644 215.776 119.698 216.321Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask182_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 215,
    width: 6,
    height: 2
  }, _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M119.698 216.321L120.889 215.63C121.835 215.085 123.135 215.157 124.581 215.994L123.39 216.685C121.944 215.848 120.644 215.776 119.698 216.321Z",
    fill: "white"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask182_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.698 216.32L120.889 215.629C121.344 215.366 121.88 215.247 122.481 215.284L121.289 215.975C120.689 215.929 120.153 216.057 119.698 216.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.299 215.976L122.49 215.285C122.835 215.312 123.199 215.385 123.581 215.521L122.39 216.212C122.008 216.076 121.644 216.003 121.299 215.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.39 216.212L123.581 215.521C123.909 215.639 124.245 215.794 124.591 215.994L123.399 216.685C123.054 216.485 122.717 216.33 122.39 216.212Z",
    fill: "white"
  }))), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M128.236 228.269L127.045 228.96C127.973 228.414 128.554 227.269 128.554 225.632C128.564 222.34 126.245 218.331 123.381 216.676L124.572 215.985C127.436 217.64 129.755 221.649 129.746 224.941C129.746 226.578 129.164 227.732 128.236 228.269Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask183_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 215,
    width: 7,
    height: 14
  }, _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M128.236 228.269L127.045 228.96C127.973 228.414 128.554 227.269 128.554 225.632C128.564 222.34 126.245 218.331 123.381 216.676L124.572 215.985C127.436 217.64 129.755 221.649 129.746 224.941C129.746 226.578 129.164 227.732 128.236 228.269Z",
    fill: "white"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask183_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.39 216.676L124.582 215.985C124.582 215.985 124.618 216.003 124.636 216.012L123.445 216.703C123.445 216.703 123.408 216.685 123.39 216.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.444 216.712L124.635 216.021C125.026 216.249 125.399 216.521 125.763 216.821L124.572 217.512C124.208 217.203 123.835 216.94 123.444 216.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.572 217.513L125.763 216.821C126.145 217.14 126.509 217.503 126.854 217.894L125.663 218.585C125.318 218.194 124.954 217.831 124.572 217.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.662 218.585L126.853 217.894C127.662 218.822 128.353 219.913 128.863 221.049L127.672 221.74C127.171 220.595 126.471 219.504 125.662 218.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.664 221.74L128.855 221.049C129.046 221.477 129.2 221.904 129.337 222.331L128.145 223.022C128.009 222.595 127.855 222.159 127.664 221.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.144 223.031L129.335 222.34C129.472 222.795 129.581 223.25 129.653 223.695L128.462 224.386C128.39 223.941 128.29 223.486 128.144 223.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.464 224.386L129.655 223.695C129.719 224.122 129.755 224.541 129.755 224.95C129.755 224.95 129.755 224.959 129.755 224.968L128.564 225.659C128.564 225.659 128.564 225.65 128.564 225.641C128.564 225.232 128.528 224.813 128.464 224.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.564 225.65L129.756 224.959C129.756 225.414 129.71 225.832 129.619 226.205L128.428 226.897C128.51 226.524 128.564 226.105 128.564 225.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.427 226.896L129.618 226.205C129.4 227.178 128.909 227.878 128.236 228.269L127.045 228.96C127.718 228.569 128.2 227.869 128.427 226.896Z",
    fill: "white"
  }))), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M123.39 216.676C126.254 218.331 128.573 222.34 128.564 225.632C128.554 228.923 126.227 230.251 123.363 228.596C120.498 226.941 118.18 222.931 118.189 219.64C118.198 216.349 120.526 215.021 123.39 216.676Z",
    fill: "#C2C3D0"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M120.898 219.54L121.489 219.194C121.989 218.903 122.671 218.949 123.435 219.385L122.844 219.731C122.08 219.294 121.398 219.249 120.898 219.54Z",
    fill: "#38373E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask184_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 219,
    width: 4,
    height: 1
  }, _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M120.898 219.54L121.489 219.194C121.989 218.903 122.671 218.949 123.435 219.385L122.844 219.731C122.08 219.294 121.398 219.249 120.898 219.54Z",
    fill: "white"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask184_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.898 219.54L121.489 219.194C121.726 219.058 122.017 218.994 122.326 219.012L121.735 219.358C121.416 219.34 121.134 219.394 120.898 219.54Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.736 219.358L122.327 219.013C122.509 219.022 122.7 219.067 122.9 219.14L122.309 219.486C122.109 219.413 121.918 219.377 121.736 219.358Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.317 219.486L122.909 219.14C123.082 219.204 123.254 219.286 123.436 219.386L122.845 219.731C122.663 219.622 122.49 219.54 122.317 219.486Z",
    fill: "#38373E"
  }))), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M125.363 225.859L124.772 226.205C125.263 225.923 125.563 225.314 125.572 224.45C125.572 222.713 124.354 220.604 122.845 219.731L123.436 219.385C124.945 220.258 126.163 222.368 126.163 224.104C126.163 224.968 125.854 225.568 125.363 225.859Z",
    fill: "#38373E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask185_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 219,
    width: 5,
    height: 8
  }, _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M125.363 225.859L124.772 226.205C125.263 225.923 125.563 225.314 125.572 224.45C125.572 222.713 124.354 220.604 122.845 219.731L123.436 219.385C124.945 220.258 126.163 222.368 126.163 224.104C126.163 224.968 125.854 225.568 125.363 225.859Z",
    fill: "white"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask185_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.845 219.731L123.436 219.385C123.436 219.385 123.454 219.394 123.463 219.403L122.872 219.749C122.872 219.749 122.854 219.74 122.845 219.731Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.872 219.74L123.463 219.395C123.663 219.513 123.863 219.658 124.054 219.822L123.463 220.168C123.272 220.004 123.072 219.868 122.872 219.74Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.462 220.168L124.054 219.822C124.254 219.995 124.445 220.186 124.627 220.386L124.035 220.732C123.854 220.522 123.663 220.331 123.462 220.168Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.036 220.731L124.627 220.386C125.054 220.877 125.418 221.449 125.682 222.05L125.091 222.395C124.827 221.795 124.463 221.222 124.036 220.731Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.099 222.395L125.69 222.049C125.79 222.277 125.872 222.504 125.945 222.732L125.353 223.077C125.281 222.85 125.199 222.623 125.099 222.395Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.353 223.077L125.944 222.731C126.017 222.968 126.072 223.213 126.108 223.441L125.517 223.787C125.48 223.55 125.426 223.313 125.353 223.077Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.517 223.786L126.108 223.441C126.145 223.668 126.163 223.886 126.163 224.105L125.572 224.45C125.572 224.232 125.553 224.014 125.517 223.786Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.572 224.459L126.163 224.114C126.163 224.35 126.136 224.568 126.09 224.769L125.499 225.114C125.545 224.914 125.572 224.696 125.572 224.459Z",
    fill: "#38373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5 225.114L126.091 224.768C125.973 225.278 125.719 225.651 125.364 225.86L124.772 226.206C125.127 225.996 125.382 225.632 125.5 225.114Z",
    fill: "#38373E"
  }))), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M122.845 219.731C124.354 220.604 125.572 222.713 125.572 224.45C125.572 226.187 124.336 226.887 122.826 226.014C121.317 225.141 120.099 223.032 120.099 221.295C120.099 219.558 121.326 218.858 122.845 219.731Z",
    fill: "#252529"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M147.24 211.202V176.496L149.031 177.532V212.257L147.24 211.202Z",
    fill: "#252529"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M149.031 177.532L149.722 177.132V211.857L149.031 212.257V177.532Z",
    fill: "#424242"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M147.24 176.496L147.931 176.096L149.722 177.132L149.031 177.533L147.24 176.496Z",
    fill: "#494949"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M136.802 219.085V184.379L138.593 185.416V220.14L136.802 219.085Z",
    fill: "#252529"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M138.593 185.416L139.284 185.015V219.74L138.593 220.14V185.416Z",
    fill: "#424242"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M136.802 184.379L137.493 183.979L139.284 185.016L138.593 185.416L136.802 184.379Z",
    fill: "#494949"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M138.592 191.262V195.035L139.111 195.326L139.101 191.553L138.592 191.262Z",
    fill: "#0B90AA"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M139.101 191.553L150.239 185.134V188.916L139.11 195.326L139.101 191.553Z",
    fill: "#117488"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M138.592 191.262L139.101 191.553L150.24 185.134L149.722 184.834L138.592 191.262Z",
    fill: "#30ACC5"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M164.916 195.781L164.907 196.827L154.423 202.919V201.873L164.916 195.781Z",
    fill: "#383838"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M154.423 201.873V202.919L139.465 194.281V193.235L154.423 201.873Z",
    fill: "#272727"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M164.915 195.781L154.423 201.873L139.465 193.235L149.958 187.143L164.915 195.781Z",
    fill: "#3F3F3F"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M143.193 192.926V192.326C143.193 192.608 143.375 192.89 143.748 193.099V193.7C143.375 193.49 143.193 193.208 143.193 192.926Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask186_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 192,
    width: 1,
    height: 2
  }, _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M143.193 192.926V192.326C143.193 192.608 143.375 192.89 143.748 193.099V193.7C143.375 193.49 143.193 193.208 143.193 192.926Z",
    fill: "white"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask186_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.748 193.099V193.7C143.375 193.49 143.193 193.208 143.193 192.926V192.326C143.193 192.608 143.375 192.89 143.748 193.099Z",
    fill: "#C2C3D0"
  }))), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M161.915 195.026V195.627C161.915 195.9 161.733 196.182 161.369 196.391V195.79C161.733 195.581 161.915 195.308 161.915 195.026Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask187_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 195,
    width: 1,
    height: 2
  }, _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M161.915 195.026V195.627C161.915 195.9 161.733 196.182 161.369 196.391V195.79C161.733 195.581 161.915 195.308 161.915 195.026Z",
    fill: "white"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask187_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.916 195.026V195.627C161.916 195.627 161.916 195.709 161.897 195.754V195.154C161.897 195.154 161.916 195.072 161.916 195.026Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 195.154V195.754C161.86 195.981 161.688 196.2 161.396 196.382V195.781C161.697 195.608 161.86 195.381 161.906 195.154Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.396 195.781V196.381C161.396 196.381 161.378 196.381 161.369 196.39V195.79C161.369 195.79 161.387 195.79 161.396 195.781Z",
    fill: "#C2C3D0"
  }))), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M161.379 195.79L161.37 196.399L156.242 199.382V198.772L161.379 195.79Z",
    fill: "#C2C3D0"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M153.596 198.782L153.587 199.382L143.749 193.699V193.099L153.596 198.782Z",
    fill: "#C2C3D0"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M156.241 198.772V199.372C155.514 199.8 154.323 199.8 153.595 199.372V198.772C154.332 199.2 155.514 199.2 156.241 198.772Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask188_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 198,
    width: 4,
    height: 2
  }, _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M156.241 198.772V199.372C155.514 199.8 154.323 199.8 153.595 199.372V198.772C154.332 199.2 155.514 199.2 156.241 198.772Z",
    fill: "white"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask188_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.24 198.772V199.373C156.113 199.445 155.977 199.509 155.831 199.555V198.954C155.977 198.909 156.122 198.845 156.24 198.772Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.833 198.954V199.555C155.469 199.673 155.051 199.719 154.65 199.682V199.082C155.051 199.118 155.469 199.073 155.833 198.954Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.651 199.082V199.682C154.26 199.646 153.887 199.545 153.586 199.373V198.772C153.887 198.945 154.26 199.045 154.651 199.082Z",
    fill: "#C2C3D0"
  }))), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M161.37 194.263C162.106 194.69 162.106 195.372 161.37 195.799L156.232 198.782C155.505 199.209 154.323 199.209 153.586 198.782L143.748 193.099C143.012 192.672 143.012 191.99 143.739 191.562L148.877 188.58C149.604 188.153 150.795 188.153 151.522 188.58L161.361 194.263H161.37Z",
    fill: "white"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M145.931 190.698L146.203 190.853L147.995 189.816L147.731 189.652L145.931 190.698Z",
    fill: "#424242"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M148.195 193.262L146.622 194.181L144.049 192.689L145.622 191.78L148.195 193.262Z",
    fill: "#686868"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M155.341 192.917L153.768 193.835L151.195 192.344L152.768 191.435L155.341 192.917Z",
    fill: "#686868"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M155.378 191.371L154.614 191.826L153.351 191.09L154.123 190.644L155.378 191.371Z",
    fill: "#686868"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M157.031 192.335L156.258 192.781L154.995 192.053L155.767 191.608L157.031 192.335Z",
    fill: "#686868"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M151.931 193.253L150.722 193.953L148.749 192.817L149.958 192.117L151.931 193.253Z",
    fill: "#686868"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M154.387 194.554L153.178 195.254L151.205 194.108L152.414 193.408L154.387 194.554Z",
    fill: "#686868"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M153.05 196.809L152.077 197.372L150.477 196.454L151.449 195.89L153.05 196.809Z",
    fill: "#686868"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M161.46 194.799L160.487 195.372L158.887 194.444L159.869 193.881L161.46 194.799Z",
    fill: "#686868"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M159.204 193.535L158.231 194.099L156.631 193.181L157.613 192.617L159.204 193.535Z",
    fill: "#686868"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M160.333 195.49L159.642 195.9L158.505 195.236L159.196 194.835L160.333 195.49Z",
    fill: "#686868"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M159.397 196.081L158.697 196.491L157.56 195.836L158.26 195.426L159.397 196.081Z",
    fill: "#686868"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M158.471 196.572L157.77 196.973L156.642 196.318L157.333 195.917L158.471 196.572Z",
    fill: "#686868"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M152.304 195.117L150.285 196.29L146.985 194.39L149.003 193.217L152.304 195.117Z",
    fill: "#686868"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M153.686 190.426L151.913 191.462L149.013 189.789L150.786 188.753L153.686 190.426Z",
    fill: "#686868"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M158.868 194.726L157.095 195.763L154.195 194.081L155.968 193.053L158.868 194.726Z",
    fill: "#686868"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M153.26 195.745L152.677 196.081L151.895 195.626L152.477 195.29L153.26 195.745Z",
    fill: "#686868"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M154.241 196.336L153.659 196.672L152.868 196.217L153.45 195.881L154.241 196.336Z",
    fill: "#686868"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M155.124 195.59L154.369 196.027L153.351 195.436L154.106 194.999L155.124 195.59Z",
    fill: "#686868"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M155.359 194.999L154.895 195.272L154.268 194.908L154.732 194.644L155.359 194.999Z",
    fill: "#686868"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M156.222 195.536L155.759 195.809L155.131 195.445L155.595 195.172L156.222 195.536Z",
    fill: "#686868"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M155.325 196.509L154.861 196.773L154.233 196.409L154.697 196.145L155.325 196.509Z",
    fill: "#686868"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M155.996 196.145L155.532 196.418L154.904 196.054L155.368 195.781L155.996 196.145Z",
    fill: "#686868"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M156.788 195.917L156.488 196.09L156.105 195.872L156.415 195.699L156.788 195.917Z",
    fill: "#686868"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M155.923 198.018L154.614 198.782L152.468 197.536L153.778 196.772L155.923 198.018Z",
    fill: "#686868"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M157.324 197.236L156.451 197.745L155.014 196.918L155.896 196.409L157.324 197.236Z",
    fill: "#686868"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M149.35 191.971L148.068 192.717L145.977 191.507L147.259 190.762L149.35 191.971Z",
    fill: "#686868"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M149.941 190.753L149.15 191.207L147.868 190.462L148.65 190.007L149.941 190.753Z",
    fill: "#686868"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M151.577 191.744L150.785 192.208L149.503 191.462L150.285 191.007L151.577 191.744Z",
    fill: "#686868"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M143.211 192.144V191.544C143.211 191.826 143.393 192.108 143.766 192.317V192.918C143.393 192.708 143.211 192.426 143.211 192.144Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask189_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 191,
    width: 1,
    height: 2
  }, _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M143.211 192.144V191.544C143.211 191.826 143.393 192.108 143.766 192.317V192.918C143.393 192.708 143.211 192.426 143.211 192.144Z",
    fill: "white"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask189_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.766 192.308V192.908C143.393 192.699 143.211 192.417 143.211 192.135V191.535C143.211 191.817 143.393 192.099 143.766 192.308Z",
    fill: "#C2C3D0"
  }))), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M161.933 194.245V194.845C161.933 195.118 161.751 195.4 161.387 195.609V195.009C161.751 194.799 161.933 194.527 161.933 194.245Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask190_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 194,
    width: 1,
    height: 2
  }, _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M161.933 194.245V194.845C161.933 195.118 161.751 195.4 161.387 195.609V195.009C161.751 194.799 161.933 194.527 161.933 194.245Z",
    fill: "white"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask190_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.933 194.245V194.845C161.933 194.845 161.933 194.927 161.915 194.972V194.372C161.915 194.372 161.933 194.29 161.933 194.245Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.924 194.372V194.972C161.879 195.2 161.706 195.418 161.415 195.6V195C161.715 194.827 161.879 194.599 161.924 194.372Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.414 194.99V195.591C161.414 195.591 161.396 195.591 161.387 195.6V194.999C161.387 194.999 161.405 194.999 161.414 194.99Z",
    fill: "#C2C3D0"
  }))), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M161.387 195.008V195.608L156.25 198.591L156.259 197.991L161.387 195.008Z",
    fill: "#C2C3D0"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M153.614 197.991L153.605 198.591L143.767 192.917V192.308L153.614 197.991Z",
    fill: "#C2C3D0"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M156.26 197.991V198.591C155.533 199.018 154.342 199.018 153.614 198.591V197.991C154.351 198.418 155.533 198.418 156.26 197.991Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask191_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 197,
    width: 4,
    height: 2
  }, _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M156.26 197.991V198.591C155.533 199.018 154.342 199.018 153.614 198.591V197.991C154.351 198.418 155.533 198.418 156.26 197.991Z",
    fill: "white"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask191_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.26 197.991V198.591C156.133 198.664 155.996 198.727 155.851 198.773V198.172C155.996 198.127 156.142 198.063 156.26 197.991Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.851 198.172V198.773C155.487 198.891 155.069 198.936 154.668 198.9V198.3C155.069 198.336 155.487 198.291 155.851 198.172Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.668 198.3V198.9C154.277 198.864 153.904 198.764 153.604 198.591V197.991C153.904 198.163 154.277 198.263 154.668 198.3Z",
    fill: "#C2C3D0"
  }))), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M161.388 193.472C162.124 193.899 162.124 194.581 161.388 195.008L156.25 197.991C155.523 198.418 154.341 198.418 153.605 197.991L143.766 192.308C143.03 191.88 143.03 191.198 143.757 190.771L148.895 187.789C149.622 187.361 150.813 187.361 151.54 187.789L161.379 193.472H161.388Z",
    fill: "white"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M145.948 189.907L146.212 190.062L148.012 189.025L147.749 188.871L145.948 189.907Z",
    fill: "#424242"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M148.213 192.48L146.64 193.39L144.066 191.907L145.639 190.989L148.213 192.48Z",
    fill: "#686868"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M155.358 192.135L153.785 193.044L151.212 191.562L152.785 190.644L155.358 192.135Z",
    fill: "#686868"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M155.396 190.59L154.632 191.035L153.368 190.308L154.141 189.862L155.396 190.59Z",
    fill: "#686868"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M157.042 191.544L156.278 191.989L155.014 191.262L155.787 190.816L157.042 191.544Z",
    fill: "#686868"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M151.949 192.472L150.74 193.172L148.767 192.026L149.976 191.326L151.949 192.472Z",
    fill: "#686868"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M154.405 193.763L153.195 194.463L151.222 193.326L152.431 192.626L154.405 193.763Z",
    fill: "#686868"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M153.068 196.026L152.095 196.59L150.495 195.672L151.468 195.099L153.068 196.026Z",
    fill: "#686868"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M161.478 194.017L160.505 194.581L158.905 193.663L159.878 193.099L161.478 194.017Z",
    fill: "#686868"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M159.223 192.753L158.25 193.317L156.65 192.399L157.632 191.826L159.223 192.753Z",
    fill: "#686868"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M160.352 194.708L159.661 195.109L158.523 194.454L159.215 194.053L160.352 194.708Z",
    fill: "#686868"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M159.415 195.299L158.714 195.7L157.577 195.045L158.278 194.644L159.415 195.299Z",
    fill: "#686868"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M158.487 195.79L157.786 196.191L156.658 195.536L157.35 195.126L158.487 195.79Z",
    fill: "#686868"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M152.322 194.335L150.304 195.508L146.994 193.599L149.022 192.426L152.322 194.335Z",
    fill: "#686868"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M153.704 189.644L151.931 190.671L149.03 188.998L150.803 187.971L153.704 189.644Z",
    fill: "#686868"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M158.887 193.944L157.114 194.972L154.204 193.299L155.986 192.271L158.887 193.944Z",
    fill: "#686868"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M153.277 194.963L152.695 195.3L151.913 194.845L152.495 194.508L153.277 194.963Z",
    fill: "#686868"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M154.259 195.545L153.677 195.881L152.886 195.427L153.468 195.09L154.259 195.545Z",
    fill: "#686868"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M155.142 194.799L154.387 195.245L153.368 194.654L154.123 194.217L155.142 194.799Z",
    fill: "#686868"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M155.378 194.217L154.914 194.49L154.277 194.127L154.75 193.854L155.378 194.217Z",
    fill: "#686868"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M156.242 194.754L155.778 195.018L155.15 194.663L155.614 194.39L156.242 194.754Z",
    fill: "#686868"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M155.341 195.718L154.877 195.991L154.249 195.627L154.713 195.354L155.341 195.718Z",
    fill: "#686868"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M156.014 195.363L155.55 195.627L154.922 195.263L155.386 194.999L156.014 195.363Z",
    fill: "#686868"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M156.805 195.127L156.505 195.309L156.123 195.09L156.432 194.908L156.805 195.127Z",
    fill: "#686868"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M155.941 197.227L154.631 197.991L152.477 196.754L153.795 195.99L155.941 197.227Z",
    fill: "#686868"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M157.342 196.445L156.469 196.954L155.032 196.136L155.914 195.626L157.342 196.445Z",
    fill: "#686868"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M149.367 191.189L148.085 191.925L145.994 190.725L147.276 189.98L149.367 191.189Z",
    fill: "#686868"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M149.958 189.962L149.167 190.426L147.885 189.68L148.667 189.216L149.958 189.962Z",
    fill: "#686868"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M151.595 190.962L150.804 191.417L149.522 190.671L150.304 190.217L151.595 190.962Z",
    fill: "#686868"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M143.112 191.299V190.699C143.112 190.981 143.294 191.263 143.667 191.472V192.072C143.294 191.863 143.112 191.581 143.112 191.299Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask192_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 190,
    width: 1,
    height: 3
  }, _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M143.112 191.299V190.699C143.112 190.981 143.294 191.263 143.667 191.472V192.072C143.294 191.863 143.112 191.581 143.112 191.299Z",
    fill: "white"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask192_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.667 191.472V192.072C143.294 191.863 143.112 191.581 143.112 191.299V190.699C143.112 190.981 143.294 191.263 143.667 191.472Z",
    fill: "#C2C3D0"
  }))), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M161.833 193.408V194.009C161.833 194.281 161.651 194.563 161.288 194.773V194.172C161.651 193.963 161.833 193.69 161.833 193.408Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask193_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 193,
    width: 1,
    height: 2
  }, _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M161.833 193.408V194.009C161.833 194.281 161.651 194.563 161.288 194.773V194.172C161.651 193.963 161.833 193.69 161.833 193.408Z",
    fill: "white"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask193_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.833 193.408V194.008C161.833 194.008 161.833 194.09 161.814 194.136V193.535C161.814 193.535 161.833 193.453 161.833 193.408Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.824 193.526V194.127C161.779 194.354 161.606 194.572 161.315 194.754V194.154C161.615 193.981 161.779 193.754 161.824 193.526Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.307 194.153V194.754C161.307 194.754 161.288 194.754 161.279 194.763V194.163C161.279 194.163 161.297 194.163 161.307 194.153Z",
    fill: "#C2C3D0"
  }))), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M161.288 194.163V194.772L156.15 197.754V197.154L161.288 194.163Z",
    fill: "#C2C3D0"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M153.504 197.154V197.754L143.666 192.071V191.471L153.504 197.154Z",
    fill: "#C2C3D0"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M156.151 197.154V197.754C155.423 198.182 154.232 198.182 153.505 197.754V197.154C154.241 197.581 155.423 197.581 156.151 197.154Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask194_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 197,
    width: 4,
    height: 2
  }, _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M156.151 197.154V197.754C155.423 198.182 154.232 198.182 153.505 197.754V197.154C154.241 197.581 155.423 197.581 156.151 197.154Z",
    fill: "white"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask194_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.15 197.154V197.754C156.023 197.827 155.886 197.891 155.741 197.936V197.336C155.886 197.291 156.032 197.227 156.15 197.154Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.742 197.327V197.927C155.378 198.045 154.96 198.091 154.56 198.054V197.454C154.96 197.49 155.378 197.445 155.742 197.327Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.569 197.454V198.054C154.178 198.018 153.805 197.918 153.505 197.745V197.145C153.805 197.318 154.178 197.418 154.569 197.454Z",
    fill: "#C2C3D0"
  }))), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M161.278 192.635C162.015 193.063 162.015 193.745 161.278 194.172L156.141 197.154C155.414 197.582 154.232 197.582 153.495 197.154L143.657 191.472C142.921 191.044 142.921 190.362 143.648 189.935L148.785 186.953C149.513 186.525 150.704 186.525 151.431 186.953L161.269 192.635H161.278Z",
    fill: "white"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M145.84 189.071L146.113 189.226L147.913 188.189L147.64 188.035L145.84 189.071Z",
    fill: "#424242"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M148.104 191.635L146.531 192.553L143.958 191.062L145.531 190.153L148.104 191.635Z",
    fill: "#686868"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M155.251 191.29L153.678 192.208L151.104 190.726L152.677 189.808L155.251 191.29Z",
    fill: "#686868"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M155.297 189.744L154.524 190.198L153.269 189.471L154.033 189.016L155.297 189.744Z",
    fill: "#686868"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M156.941 190.707L156.168 191.153L154.914 190.425L155.677 189.98L156.941 190.707Z",
    fill: "#686868"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M151.851 191.626L150.642 192.326L148.668 191.189L149.878 190.489L151.851 191.626Z",
    fill: "#686868"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M154.304 192.926L153.095 193.626L151.122 192.49L152.322 191.78L154.304 192.926Z",
    fill: "#686868"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M152.958 195.181L151.985 195.745L150.394 194.826L151.367 194.263L152.958 195.181Z",
    fill: "#686868"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M161.379 193.181L160.397 193.745L158.806 192.817L159.779 192.253L161.379 193.181Z",
    fill: "#686868"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M159.124 191.908L158.142 192.481L156.551 191.553L157.524 190.989L159.124 191.908Z",
    fill: "#686868"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M160.252 193.863L159.552 194.272L158.415 193.617L159.115 193.208L160.252 193.863Z",
    fill: "#686868"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M159.308 194.463L158.617 194.863L157.479 194.208L158.171 193.808L159.308 194.463Z",
    fill: "#686868"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M158.379 194.945L157.688 195.345L156.551 194.69L157.242 194.29L158.379 194.945Z",
    fill: "#686868"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M152.223 193.49L150.195 194.672L146.895 192.763L148.913 191.59L152.223 193.49Z",
    fill: "#686868"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M153.606 188.798L151.833 189.835L148.933 188.162L150.706 187.125L153.606 188.798Z",
    fill: "#686868"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M158.778 193.099L157.005 194.135L154.104 192.462L155.878 191.426L158.778 193.099Z",
    fill: "#686868"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M153.178 194.118L152.596 194.463L151.804 193.999L152.386 193.663L153.178 194.118Z",
    fill: "#686868"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M154.161 194.708L153.579 195.045L152.787 194.59L153.369 194.253L154.161 194.708Z",
    fill: "#686868"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M155.033 193.963L154.278 194.4L153.259 193.809L154.014 193.372L155.033 193.963Z",
    fill: "#686868"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M155.269 193.381L154.805 193.645L154.178 193.281L154.642 193.017L155.269 193.381Z",
    fill: "#686868"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M156.133 193.908L155.669 194.181L155.042 193.817L155.505 193.553L156.133 193.908Z",
    fill: "#686868"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M155.242 194.881L154.778 195.145L154.15 194.79L154.614 194.517L155.242 194.881Z",
    fill: "#686868"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M155.914 194.518L155.441 194.79L154.813 194.427L155.277 194.154L155.914 194.518Z",
    fill: "#686868"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M156.706 194.29L156.396 194.463L156.014 194.245L156.323 194.072L156.706 194.29Z",
    fill: "#686868"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M155.832 196.39L154.522 197.154L152.376 195.908L153.686 195.154L155.832 196.39Z",
    fill: "#686868"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M157.232 195.609L156.359 196.118L154.931 195.29L155.804 194.781L157.232 195.609Z",
    fill: "#686868"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M149.258 190.344L147.985 191.09L145.894 189.88L147.167 189.135L149.258 190.344Z",
    fill: "#686868"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M149.849 189.125L149.067 189.58L147.776 188.834L148.567 188.38L149.849 189.125Z",
    fill: "#686868"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M151.487 190.126L150.705 190.58L149.414 189.835L150.205 189.38L151.487 190.126Z",
    fill: "#686868"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M143.103 190.453V189.853C143.103 190.135 143.284 190.417 143.657 190.626V191.226C143.284 191.017 143.103 190.735 143.103 190.453Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask195_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 189,
    width: 1,
    height: 3
  }, _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M143.103 190.453V189.853C143.103 190.135 143.284 190.417 143.657 190.626V191.226C143.284 191.017 143.103 190.735 143.103 190.453Z",
    fill: "white"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask195_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.657 190.626V191.226C143.284 191.017 143.103 190.735 143.103 190.453V189.853C143.103 190.135 143.284 190.417 143.657 190.626Z",
    fill: "#C2C3D0"
  }))), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M161.824 192.554V193.154C161.824 193.427 161.642 193.709 161.278 193.918V193.318C161.642 193.108 161.824 192.836 161.824 192.554Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask196_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 192,
    width: 1,
    height: 2
  }, _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M161.824 192.554V193.154C161.824 193.427 161.642 193.709 161.278 193.918V193.318C161.642 193.108 161.824 192.836 161.824 192.554Z",
    fill: "white"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask196_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.825 192.554V193.154C161.825 193.154 161.825 193.236 161.807 193.281V192.681C161.807 192.681 161.825 192.599 161.825 192.554Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.806 192.681V193.281C161.761 193.509 161.588 193.727 161.297 193.909V193.309C161.597 193.136 161.761 192.908 161.806 192.681Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.297 193.308V193.908C161.297 193.908 161.279 193.908 161.27 193.917V193.317C161.27 193.317 161.288 193.317 161.297 193.308Z",
    fill: "#C2C3D0"
  }))), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M161.279 193.317V193.926L156.142 196.909V196.309L161.279 193.317Z",
    fill: "#C2C3D0"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M153.494 196.309V196.909L143.647 191.226L143.656 190.626L153.494 196.309Z",
    fill: "#C2C3D0"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M156.142 196.309V196.909C155.415 197.336 154.223 197.336 153.496 196.909V196.309C154.233 196.736 155.415 196.736 156.142 196.309Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask197_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 196,
    width: 4,
    height: 2
  }, _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M156.142 196.309V196.909C155.415 197.336 154.223 197.336 153.496 196.909V196.309C154.233 196.736 155.415 196.736 156.142 196.309Z",
    fill: "white"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask197_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.141 196.309V196.909C156.013 196.982 155.877 197.045 155.731 197.091V196.491C155.877 196.445 156.023 196.381 156.141 196.309Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.733 196.481V197.082C155.369 197.2 154.951 197.245 154.55 197.209V196.609C154.951 196.645 155.369 196.6 155.733 196.481Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.56 196.609V197.209C154.169 197.173 153.796 197.073 153.496 196.9V196.3C153.796 196.472 154.169 196.573 154.56 196.609Z",
    fill: "#C2C3D0"
  }))), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M161.269 191.789C162.006 192.217 162.006 192.899 161.269 193.326L156.132 196.308C155.404 196.736 154.222 196.736 153.486 196.308L143.648 190.626C142.911 190.198 142.911 189.516 143.639 189.089L148.776 186.107C149.503 185.679 150.694 185.679 151.422 186.107L161.26 191.789H161.269Z",
    fill: "white"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M145.83 188.225L146.103 188.38L147.903 187.343L147.63 187.189L145.83 188.225Z",
    fill: "#424242"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M148.094 190.789L146.521 191.708L143.948 190.217L145.521 189.307L148.094 190.789Z",
    fill: "#686868"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M155.241 190.444L153.668 191.362L151.095 189.88L152.668 188.962L155.241 190.444Z",
    fill: "#686868"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M155.287 188.898L154.514 189.353L153.259 188.625L154.023 188.171L155.287 188.898Z",
    fill: "#686868"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M156.932 189.862L156.159 190.307L154.904 189.58L155.668 189.134L156.932 189.862Z",
    fill: "#686868"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M151.84 190.78L150.631 191.48L148.658 190.344L149.858 189.644L151.84 190.78Z",
    fill: "#686868"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M154.287 192.081L153.087 192.781L151.104 191.644L152.314 190.935L154.287 192.081Z",
    fill: "#686868"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M152.951 194.335L151.978 194.899L150.377 193.981L151.359 193.417L152.951 194.335Z",
    fill: "#686868"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M161.361 192.326L160.388 192.899L158.797 191.971L159.77 191.408L161.361 192.326Z",
    fill: "#686868"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M159.115 191.062L158.133 191.635L156.542 190.707L157.514 190.144L159.115 191.062Z",
    fill: "#686868"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M160.234 193.017L159.543 193.427L158.406 192.772L159.106 192.362L160.234 193.017Z",
    fill: "#686868"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M159.298 193.618L158.607 194.018L157.47 193.363L158.161 192.954L159.298 193.618Z",
    fill: "#686868"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M158.37 194.099L157.679 194.5L156.542 193.845L157.233 193.444L158.37 194.099Z",
    fill: "#686868"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M152.205 192.644L150.186 193.826L146.886 191.917L148.904 190.744L152.205 192.644Z",
    fill: "#686868"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M153.595 187.952L151.813 188.989L148.913 187.316L150.695 186.279L153.595 187.952Z",
    fill: "#686868"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M158.77 192.253L156.997 193.29L154.096 191.617L155.869 190.58L158.77 192.253Z",
    fill: "#686868"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M153.169 193.271L152.586 193.617L151.795 193.153L152.377 192.817L153.169 193.271Z",
    fill: "#686868"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M154.141 193.863L153.559 194.199L152.776 193.745L153.359 193.408L154.141 193.863Z",
    fill: "#686868"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M155.024 193.117L154.269 193.554L153.25 192.963L154.005 192.526L155.024 193.117Z",
    fill: "#686868"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M155.259 192.535L154.795 192.799L154.167 192.435L154.631 192.171L155.259 192.535Z",
    fill: "#686868"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M156.124 193.063L155.66 193.335L155.032 192.972L155.496 192.708L156.124 193.063Z",
    fill: "#686868"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M155.232 194.036L154.768 194.299L154.14 193.935L154.604 193.672L155.232 194.036Z",
    fill: "#686868"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M155.896 193.672L155.432 193.945L154.804 193.581L155.268 193.308L155.896 193.672Z",
    fill: "#686868"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M156.696 193.444L156.387 193.617L156.005 193.399L156.314 193.226L156.696 193.444Z",
    fill: "#686868"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M155.822 195.545L154.513 196.309L152.367 195.063L153.677 194.308L155.822 195.545Z",
    fill: "#686868"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M157.223 194.763L156.35 195.272L154.922 194.445L155.795 193.935L157.223 194.763Z",
    fill: "#686868"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M149.249 189.498L147.967 190.244L145.875 189.035L147.158 188.289L149.249 189.498Z",
    fill: "#686868"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M149.841 188.28L149.059 188.734L147.768 187.989L148.559 187.534L149.841 188.28Z",
    fill: "#686868"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M151.477 189.28L150.695 189.734L149.404 188.989L150.186 188.534L151.477 189.28Z",
    fill: "#686868"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M143.193 189.58V188.98C143.193 189.262 143.375 189.544 143.748 189.753V190.354C143.375 190.144 143.193 189.862 143.193 189.58Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask198_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 188,
    width: 1,
    height: 3
  }, _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M143.193 189.58V188.98C143.193 189.262 143.375 189.544 143.748 189.753V190.354C143.375 190.144 143.193 189.862 143.193 189.58Z",
    fill: "white"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask198_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.748 189.744V190.344C143.375 190.135 143.193 189.853 143.193 189.571V188.971C143.193 189.253 143.375 189.535 143.748 189.744Z",
    fill: "#C2C3D0"
  }))), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M161.915 191.68V192.281C161.915 192.554 161.733 192.836 161.369 193.045V192.444C161.733 192.235 161.915 191.962 161.915 191.68Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask199_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 191,
    width: 1,
    height: 3
  }, _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M161.915 191.68V192.281C161.915 192.554 161.733 192.836 161.369 193.045V192.444C161.733 192.235 161.915 191.962 161.915 191.68Z",
    fill: "white"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask199_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.916 191.68V192.281C161.916 192.281 161.916 192.363 161.897 192.408V191.808C161.897 191.808 161.916 191.726 161.916 191.68Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.906 191.808V192.408C161.86 192.636 161.688 192.854 161.396 193.036V192.436C161.697 192.263 161.86 192.035 161.906 191.808Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.396 192.426V193.027C161.396 193.027 161.378 193.027 161.369 193.036V192.435C161.369 192.435 161.387 192.435 161.396 192.426Z",
    fill: "#C2C3D0"
  }))), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M161.369 192.444V193.044L156.231 196.036V195.427L161.369 192.444Z",
    fill: "#C2C3D0"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M153.587 195.426V196.036L143.749 190.353V189.744L153.587 195.426Z",
    fill: "#C2C3D0"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M156.232 195.426V196.027C155.505 196.454 154.314 196.454 153.586 196.027V195.426C154.323 195.854 155.505 195.854 156.232 195.426Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask200_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 195,
    width: 4,
    height: 2
  }, _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M156.232 195.426V196.027C155.505 196.454 154.314 196.454 153.586 196.027V195.426C154.323 195.854 155.505 195.854 156.232 195.426Z",
    fill: "white"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask200_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.232 195.426V196.027C156.105 196.1 155.968 196.163 155.823 196.209V195.608C155.968 195.563 156.114 195.499 156.232 195.426Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.824 195.608V196.209C155.46 196.327 155.041 196.372 154.641 196.336V195.736C155.041 195.772 155.46 195.726 155.824 195.608Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.651 195.736V196.336C154.26 196.3 153.887 196.2 153.586 196.027V195.426C153.887 195.599 154.26 195.699 154.651 195.736Z",
    fill: "#C2C3D0"
  }))), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M161.361 190.908C162.097 191.335 162.097 192.017 161.361 192.444L156.224 195.427C155.496 195.854 154.314 195.854 153.578 195.427L143.74 189.744C143.003 189.317 143.003 188.635 143.73 188.207L148.868 185.225C149.595 184.798 150.786 184.798 151.514 185.225L161.352 190.908H161.361Z",
    fill: "white"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M145.931 187.343L146.194 187.507L147.995 186.461L147.731 186.307L145.931 187.343Z",
    fill: "#424242"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M148.185 189.916L146.612 190.826L144.039 189.344L145.612 188.425L148.185 189.916Z",
    fill: "#686868"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M155.341 189.571L153.759 190.489L151.186 188.998L152.759 188.08L155.341 189.571Z",
    fill: "#686868"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M155.378 188.025L154.605 188.471L153.351 187.743L154.123 187.298L155.378 188.025Z",
    fill: "#686868"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M157.022 188.98L156.258 189.425L154.995 188.698L155.767 188.253L157.022 188.98Z",
    fill: "#686868"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M151.931 189.907L150.722 190.607L148.749 189.471L149.958 188.762L151.931 189.907Z",
    fill: "#686868"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M154.387 191.199L153.178 191.899L151.205 190.762L152.414 190.062L154.387 191.199Z",
    fill: "#686868"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M153.041 193.462L152.068 194.026L150.477 193.108L151.449 192.535L153.041 193.462Z",
    fill: "#686868"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M161.461 191.453L160.488 192.017L158.888 191.098L159.861 190.535L161.461 191.453Z",
    fill: "#686868"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M159.205 190.189L158.232 190.753L156.631 189.834L157.604 189.262L159.205 190.189Z",
    fill: "#686868"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M160.334 192.144L159.642 192.545L158.505 191.89L159.197 191.489L160.334 192.144Z",
    fill: "#686868"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M159.389 192.735L158.697 193.136L157.56 192.481L158.251 192.08L159.389 192.735Z",
    fill: "#686868"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M158.46 193.226L157.768 193.627L156.631 192.972L157.332 192.562L158.46 193.226Z",
    fill: "#686868"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M152.305 191.772L150.286 192.944L146.977 191.035L148.995 189.862L152.305 191.772Z",
    fill: "#686868"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M153.687 187.079L151.914 188.107L149.013 186.434L150.786 185.406L153.687 187.079Z",
    fill: "#686868"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M158.87 191.381L157.088 192.408L154.187 190.735L155.96 189.707L158.87 191.381Z",
    fill: "#686868"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M153.259 192.399L152.677 192.735L151.885 192.281L152.467 191.944L153.259 192.399Z",
    fill: "#686868"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M154.241 192.981L153.659 193.317L152.868 192.862L153.45 192.526L154.241 192.981Z",
    fill: "#686868"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M155.123 192.235L154.368 192.681L153.34 192.09L154.095 191.653L155.123 192.235Z",
    fill: "#686868"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M155.351 191.653L154.887 191.926L154.259 191.562L154.723 191.289L155.351 191.653Z",
    fill: "#686868"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M156.215 192.19L155.751 192.463L155.123 192.099L155.587 191.826L156.215 192.19Z",
    fill: "#686868"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M155.325 193.154L154.861 193.427L154.233 193.063L154.697 192.79L155.325 193.154Z",
    fill: "#686868"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M155.996 192.799L155.532 193.063L154.895 192.708L155.368 192.435L155.996 192.799Z",
    fill: "#686868"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M156.788 192.562L156.478 192.744L156.105 192.526L156.406 192.344L156.788 192.562Z",
    fill: "#686868"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M155.922 194.663L154.604 195.427L152.458 194.19L153.776 193.426L155.922 194.663Z",
    fill: "#686868"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M157.324 193.89L156.442 194.399L155.014 193.572L155.887 193.062L157.324 193.89Z",
    fill: "#686868"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M149.341 188.625L148.068 189.362L145.977 188.161L147.25 187.416L149.341 188.625Z",
    fill: "#686868"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M149.941 187.398L149.15 187.861L147.858 187.116L148.649 186.661L149.941 187.398Z",
    fill: "#686868"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M151.577 188.398L150.786 188.853L149.495 188.116L150.286 187.653L151.577 188.398Z",
    fill: "#686868"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M150.44 139.38C149.576 139.88 148.794 140.735 148.23 141.708L148.858 142.072C149.258 141.372 149.813 140.762 150.44 140.408C151.067 140.053 151.613 140.017 152.022 140.253L152.649 139.162C152.077 138.835 151.304 138.88 150.44 139.38Z",
    fill: "white"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M150.45 141.926C149.977 142.199 149.568 142.735 149.35 143.299C149.24 143.581 149.177 143.863 149.177 144.127C149.177 144.936 149.75 145.263 150.459 144.854C151.168 144.445 151.732 143.463 151.723 142.654C151.723 142.39 151.659 142.172 151.55 142.026C151.332 141.717 150.923 141.653 150.45 141.926Z",
    fill: "white"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M150.431 136.298C148.831 137.225 147.376 138.808 146.33 140.626L146.957 140.99C147.849 139.453 149.067 138.107 150.431 137.325C151.786 136.543 153.013 136.471 153.913 136.98L154.541 135.889C153.486 135.289 152.031 135.38 150.431 136.298Z",
    fill: "white"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M150.422 133.216C148.076 134.57 145.957 136.889 144.43 139.544L145.057 139.908C146.43 137.535 148.33 135.452 150.422 134.243C152.513 133.034 154.422 132.916 155.795 133.707L156.423 132.616C154.886 131.734 152.758 131.861 150.413 133.216H150.422Z",
    fill: "white"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M159.078 134.052C159.096 139.526 155.232 146.209 150.476 148.964C145.712 151.71 141.829 149.501 141.811 144.027C141.793 138.562 145.657 131.87 150.422 129.124C155.177 126.378 159.069 128.588 159.087 134.061L159.078 134.052ZM150.476 148.546C155.041 145.909 158.741 139.508 158.723 134.261C158.705 129.024 154.986 126.897 150.422 129.533C145.857 132.17 142.157 138.58 142.175 143.818C142.193 149.064 145.912 151.183 150.476 148.546Z",
    fill: "white"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M168.279 234.797C158.059 240.698 158.005 250.263 168.161 256.155C178.308 262.056 194.82 262.056 205.04 256.155C215.26 250.254 215.315 240.689 205.159 234.797C195.011 228.896 178.499 228.896 168.279 234.797Z",
    fill: "#BDBDBD"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M163.752 243.426V245.053C163.77 248.599 166.098 252.136 170.753 254.846C180.128 260.292 195.367 260.292 204.796 254.846C209.542 252.109 211.915 248.509 211.906 244.917V243.289C211.906 246.881 209.542 250.482 204.796 253.218C195.367 258.665 180.128 258.665 170.753 253.218C166.098 250.518 163.77 246.972 163.761 243.426H163.752Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask201_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 243,
    width: 49,
    height: 16
  }, _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M163.752 243.426V245.053C163.77 248.599 166.098 252.136 170.753 254.846C180.128 260.292 195.367 260.292 204.796 254.846C209.542 252.109 211.915 248.509 211.906 244.917V243.289C211.906 246.881 209.542 250.482 204.796 253.218C195.367 258.665 180.128 258.665 170.753 253.218C166.098 250.518 163.77 246.972 163.761 243.426H163.752Z",
    fill: "white"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask201_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.752 243.426V245.053C163.77 248.599 166.098 252.136 170.753 254.846C180.128 260.292 195.367 260.292 204.796 254.846C209.542 252.109 211.915 248.509 211.906 244.917V243.289C211.906 246.881 209.542 250.482 204.796 253.218C195.367 258.665 180.128 258.665 170.753 253.218C166.098 250.518 163.77 246.972 163.761 243.426H163.752Z",
    fill: "#252529"
  }))), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M170.862 233.497C161.433 238.943 161.379 247.772 170.753 253.218C180.128 258.665 195.367 258.665 204.796 253.218C214.224 247.772 214.279 238.943 204.905 233.497C195.539 228.05 180.291 228.05 170.862 233.497Z",
    fill: "#38373E"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M168.008 237.261V238.052C168.008 238.279 168.162 238.516 168.472 238.689C169.081 239.043 170.081 239.043 170.69 238.689C170.999 238.507 171.154 238.279 171.154 238.043V237.252C171.154 237.488 170.999 237.725 170.69 237.898C170.072 238.252 169.081 238.252 168.472 237.898C168.171 237.725 168.017 237.488 168.017 237.261H168.008Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask202_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 237,
    width: 4,
    height: 2
  }, _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M168.008 237.261V238.052C168.008 238.279 168.162 238.516 168.472 238.689C169.081 239.043 170.081 239.043 170.69 238.689C170.999 238.507 171.154 238.279 171.154 238.043V237.252C171.154 237.488 170.999 237.725 170.69 237.898C170.072 238.252 169.081 238.252 168.472 237.898C168.171 237.725 168.017 237.488 168.017 237.261H168.008Z",
    fill: "white"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask202_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.008 237.261V238.052C168.008 238.189 168.062 238.334 168.181 238.462V237.67C168.071 237.543 168.008 237.406 168.008 237.261Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.18 237.661V238.452C168.252 238.534 168.353 238.616 168.471 238.689C168.689 238.816 168.962 238.898 169.253 238.935V238.143C168.962 238.107 168.689 238.025 168.471 237.898C168.353 237.825 168.252 237.752 168.18 237.661Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.244 238.143V238.935C169.753 238.999 170.299 238.917 170.69 238.689C170.999 238.507 171.154 238.28 171.154 238.043V237.252C171.154 237.489 170.999 237.725 170.69 237.898C170.299 238.125 169.753 238.207 169.253 238.143H169.244Z",
    fill: "#C2C3D0"
  }))), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M168.472 236.606C167.853 236.961 167.853 237.534 168.472 237.888C169.081 238.243 170.081 238.243 170.69 237.888C171.308 237.534 171.308 236.952 170.69 236.597C170.081 236.243 169.081 236.243 168.472 236.597V236.606Z",
    fill: "white"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M165.453 243.589V244.381C165.453 244.608 165.607 244.844 165.916 245.017C166.526 245.372 167.526 245.372 168.135 245.017C168.444 244.835 168.599 244.608 168.599 244.371V243.58C168.599 243.817 168.444 244.053 168.135 244.226C167.517 244.581 166.526 244.581 165.916 244.226C165.616 244.053 165.462 243.817 165.462 243.589H165.453Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask203_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 243,
    width: 4,
    height: 3
  }, _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M165.453 243.589V244.381C165.453 244.608 165.607 244.844 165.916 245.017C166.526 245.372 167.526 245.372 168.135 245.017C168.444 244.835 168.599 244.608 168.599 244.371V243.58C168.599 243.817 168.444 244.053 168.135 244.226C167.517 244.581 166.526 244.581 165.916 244.226C165.616 244.053 165.462 243.817 165.462 243.589H165.453Z",
    fill: "white"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask203_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.453 243.59V244.381C165.453 244.517 165.507 244.663 165.625 244.79V243.999C165.516 243.872 165.453 243.735 165.453 243.59Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.617 243.999V244.79C165.689 244.872 165.79 244.954 165.908 245.027C166.126 245.154 166.399 245.236 166.69 245.272V244.481C166.399 244.445 166.126 244.363 165.908 244.235C165.79 244.163 165.689 244.09 165.617 243.999Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.689 244.472V245.263C167.198 245.327 167.744 245.245 168.135 245.018C168.445 244.836 168.599 244.608 168.599 244.372V243.58C168.599 243.817 168.445 244.053 168.135 244.226C167.744 244.454 167.198 244.536 166.698 244.472H166.689Z",
    fill: "#C2C3D0"
  }))), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M165.916 242.944C165.298 243.299 165.298 243.871 165.916 244.226C166.526 244.581 167.526 244.581 168.135 244.226C168.753 243.871 168.753 243.289 168.135 242.935C167.526 242.58 166.526 242.58 165.916 242.935V242.944Z",
    fill: "white"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M168.78 249.554V250.345C168.78 250.573 168.935 250.809 169.244 250.982C169.853 251.336 170.853 251.336 171.463 250.982C171.772 250.8 171.926 250.573 171.926 250.336V249.545C171.926 249.782 171.772 250.018 171.463 250.191C170.844 250.545 169.853 250.545 169.244 250.191C168.944 250.018 168.789 249.782 168.789 249.554H168.78Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask204_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 249,
    width: 4,
    height: 3
  }, _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M168.78 249.554V250.345C168.78 250.573 168.935 250.809 169.244 250.982C169.853 251.336 170.853 251.336 171.463 250.982C171.772 250.8 171.926 250.573 171.926 250.336V249.545C171.926 249.782 171.772 250.018 171.463 250.191C170.844 250.545 169.853 250.545 169.244 250.191C168.944 250.018 168.789 249.782 168.789 249.554H168.78Z",
    fill: "white"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask204_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.78 249.554V250.346C168.78 250.482 168.835 250.628 168.953 250.755V249.964C168.844 249.836 168.78 249.7 168.78 249.554Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.943 249.963V250.755C169.016 250.836 169.116 250.918 169.234 250.991C169.453 251.118 169.726 251.2 170.017 251.237V250.445C169.726 250.409 169.453 250.327 169.234 250.2C169.116 250.127 169.016 250.054 168.943 249.963Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.016 250.446V251.237C170.526 251.301 171.071 251.219 171.463 250.992C171.772 250.81 171.926 250.582 171.926 250.346V249.554C171.926 249.791 171.772 250.027 171.463 250.2C171.071 250.428 170.526 250.509 170.025 250.446H170.016Z",
    fill: "#C2C3D0"
  }))), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M169.244 248.909C168.626 249.264 168.626 249.836 169.244 250.191C169.853 250.546 170.853 250.546 171.463 250.191C172.081 249.836 172.081 249.254 171.463 248.9C170.853 248.545 169.853 248.545 169.244 248.9V248.909Z",
    fill: "white"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M175.99 253.41V254.201C175.99 254.428 176.145 254.664 176.454 254.837C177.063 255.192 178.063 255.192 178.673 254.837C178.982 254.655 179.136 254.428 179.136 254.191V253.4C179.136 253.637 178.982 253.873 178.673 254.046C178.054 254.401 177.063 254.401 176.454 254.046C176.154 253.873 175.999 253.637 175.999 253.41H175.99Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask205_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 253,
    width: 5,
    height: 3
  }, _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M175.99 253.41V254.201C175.99 254.428 176.145 254.664 176.454 254.837C177.063 255.192 178.063 255.192 178.673 254.837C178.982 254.655 179.136 254.428 179.136 254.191V253.4C179.136 253.637 178.982 253.873 178.673 254.046C178.054 254.401 177.063 254.401 176.454 254.046C176.154 253.873 175.999 253.637 175.999 253.41H175.99Z",
    fill: "white"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask205_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.99 253.409V254.201C175.99 254.337 176.045 254.483 176.163 254.61V253.819C176.054 253.691 175.99 253.555 175.99 253.409Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.155 253.809V254.601C176.228 254.683 176.328 254.764 176.446 254.837C176.664 254.965 176.937 255.047 177.228 255.083V254.291C176.937 254.255 176.664 254.173 176.446 254.046C176.328 253.973 176.228 253.9 176.155 253.809Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.228 254.292V255.083C177.737 255.147 178.283 255.065 178.674 254.838C178.984 254.656 179.138 254.428 179.138 254.192V253.4C179.138 253.637 178.984 253.873 178.674 254.046C178.283 254.274 177.737 254.356 177.237 254.292H177.228Z",
    fill: "#C2C3D0"
  }))), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M176.454 252.755C175.836 253.109 175.836 253.682 176.454 254.037C177.063 254.391 178.063 254.391 178.673 254.037C179.291 253.682 179.291 253.1 178.673 252.746C178.063 252.391 177.063 252.391 176.454 252.746V252.755Z",
    fill: "white"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M186.457 254.864V255.655C186.457 255.883 186.611 256.119 186.92 256.292C187.529 256.646 188.53 256.646 189.139 256.292C189.448 256.11 189.603 255.883 189.603 255.646V254.855C189.603 255.092 189.448 255.328 189.139 255.501C188.521 255.855 187.529 255.855 186.92 255.501C186.62 255.328 186.466 255.092 186.466 254.864H186.457Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask206_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 254,
    width: 4,
    height: 3
  }, _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M186.457 254.864V255.655C186.457 255.883 186.611 256.119 186.92 256.292C187.529 256.646 188.53 256.646 189.139 256.292C189.448 256.11 189.603 255.883 189.603 255.646V254.855C189.603 255.092 189.448 255.328 189.139 255.501C188.521 255.855 187.529 255.855 186.92 255.501C186.62 255.328 186.466 255.092 186.466 254.864H186.457Z",
    fill: "white"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask206_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.457 254.864V255.655C186.457 255.792 186.511 255.937 186.629 256.065V255.273C186.52 255.146 186.457 255.01 186.457 254.864Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.62 255.274V256.065C186.693 256.147 186.793 256.229 186.911 256.302C187.13 256.429 187.402 256.511 187.694 256.547V255.756C187.402 255.719 187.13 255.638 186.911 255.51C186.793 255.437 186.693 255.365 186.62 255.274Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.693 255.747V256.538C188.203 256.602 188.749 256.52 189.14 256.292C189.449 256.11 189.604 255.883 189.604 255.647V254.855C189.604 255.092 189.449 255.328 189.14 255.501C188.749 255.728 188.203 255.81 187.702 255.747H187.693Z",
    fill: "#C2C3D0"
  }))), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M186.92 254.219C186.302 254.573 186.302 255.146 186.92 255.501C187.529 255.855 188.53 255.855 189.139 255.501C189.757 255.146 189.757 254.564 189.139 254.21C188.53 253.855 187.529 253.855 186.92 254.21V254.219Z",
    fill: "white"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M198.113 252.845V253.637C198.113 253.864 198.268 254.1 198.577 254.273C199.186 254.628 200.186 254.628 200.796 254.273C201.105 254.091 201.259 253.864 201.259 253.627V252.836C201.259 253.073 201.105 253.309 200.796 253.482C200.177 253.837 199.186 253.837 198.577 253.482C198.277 253.309 198.122 253.073 198.122 252.845H198.113Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask207_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 198,
    y: 252,
    width: 4,
    height: 3
  }, _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M198.113 252.845V253.637C198.113 253.864 198.268 254.1 198.577 254.273C199.186 254.628 200.186 254.628 200.796 254.273C201.105 254.091 201.259 253.864 201.259 253.627V252.836C201.259 253.073 201.105 253.309 200.796 253.482C200.177 253.837 199.186 253.837 198.577 253.482C198.277 253.309 198.122 253.073 198.122 252.845H198.113Z",
    fill: "white"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask207_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.113 252.845V253.637C198.113 253.773 198.168 253.919 198.286 254.046V253.255C198.177 253.127 198.113 252.991 198.113 252.845Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.276 253.255V254.046C198.349 254.128 198.449 254.21 198.567 254.283C198.786 254.41 199.059 254.492 199.35 254.528V253.737C199.059 253.701 198.786 253.619 198.567 253.491C198.449 253.419 198.349 253.346 198.276 253.255Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.349 253.728V254.519C199.858 254.583 200.404 254.501 200.795 254.274C201.104 254.092 201.259 253.864 201.259 253.628V252.836C201.259 253.073 201.104 253.309 200.795 253.482C200.404 253.71 199.858 253.792 199.358 253.728H199.349Z",
    fill: "#C2C3D0"
  }))), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M198.577 252.2C197.959 252.555 197.959 253.128 198.577 253.482C199.186 253.837 200.186 253.837 200.796 253.482C201.414 253.128 201.414 252.546 200.796 252.191C200.186 251.837 199.186 251.837 198.577 252.191V252.2Z",
    fill: "white"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M205.914 247.054V247.845C205.914 248.072 206.068 248.308 206.377 248.481C206.986 248.836 207.987 248.836 208.596 248.481C208.905 248.299 209.06 248.072 209.06 247.836V247.045C209.06 247.281 208.905 247.517 208.596 247.69C207.978 248.045 206.986 248.045 206.377 247.69C206.077 247.517 205.923 247.281 205.923 247.054H205.914Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask208_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 247,
    width: 5,
    height: 2
  }, _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M205.914 247.054V247.845C205.914 248.072 206.068 248.308 206.377 248.481C206.986 248.836 207.987 248.836 208.596 248.481C208.905 248.299 209.06 248.072 209.06 247.836V247.045C209.06 247.281 208.905 247.517 208.596 247.69C207.978 248.045 206.986 248.045 206.377 247.69C206.077 247.517 205.923 247.281 205.923 247.054H205.914Z",
    fill: "white"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask208_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.914 247.054V247.845C205.914 247.982 205.968 248.127 206.086 248.254V247.463C205.977 247.336 205.914 247.199 205.914 247.054Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.077 247.463V248.254C206.15 248.336 206.25 248.418 206.368 248.491C206.587 248.618 206.859 248.7 207.151 248.736V247.945C206.859 247.909 206.587 247.827 206.368 247.699C206.25 247.627 206.15 247.554 206.077 247.463Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.15 247.945V248.737C207.659 248.8 208.205 248.718 208.596 248.491C208.906 248.309 209.06 248.082 209.06 247.845V247.054C209.06 247.29 208.906 247.527 208.596 247.7C208.205 247.927 207.659 248.009 207.159 247.945H207.15Z",
    fill: "#C2C3D0"
  }))), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M206.377 246.408C205.759 246.763 205.759 247.336 206.377 247.69C206.986 248.045 207.987 248.045 208.596 247.69C209.214 247.336 209.214 246.754 208.596 246.399C207.987 246.045 206.986 246.045 206.377 246.399V246.408Z",
    fill: "white"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M205.324 238.216V239.007C205.324 239.234 205.478 239.471 205.787 239.643C206.397 239.998 207.397 239.998 208.006 239.643C208.315 239.462 208.47 239.234 208.47 238.998V238.207C208.47 238.443 208.315 238.68 208.006 238.852C207.388 239.207 206.397 239.207 205.787 238.852C205.487 238.68 205.333 238.443 205.333 238.216H205.324Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask209_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 238,
    width: 4,
    height: 2
  }, _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M205.324 238.216V239.007C205.324 239.234 205.478 239.471 205.787 239.643C206.397 239.998 207.397 239.998 208.006 239.643C208.315 239.462 208.47 239.234 208.47 238.998V238.207C208.47 238.443 208.315 238.68 208.006 238.852C207.388 239.207 206.397 239.207 205.787 238.852C205.487 238.68 205.333 238.443 205.333 238.216H205.324Z",
    fill: "white"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask209_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.324 238.216V239.007C205.324 239.144 205.378 239.289 205.497 239.417V238.625C205.387 238.498 205.324 238.361 205.324 238.216Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.487 238.625V239.416C205.56 239.498 205.66 239.58 205.778 239.653C205.997 239.78 206.27 239.862 206.561 239.899V239.107C206.27 239.071 205.997 238.989 205.778 238.861C205.66 238.789 205.56 238.716 205.487 238.625Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56 239.098V239.89C207.069 239.953 207.615 239.871 208.006 239.644C208.316 239.462 208.47 239.235 208.47 238.998V238.207C208.47 238.443 208.316 238.68 208.006 238.853C207.615 239.08 207.069 239.162 206.569 239.098H206.56Z",
    fill: "#C2C3D0"
  }))), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M205.787 237.57C205.169 237.925 205.169 238.498 205.787 238.852C206.397 239.207 207.397 239.207 208.006 238.852C208.624 238.498 208.624 237.916 208.006 237.561C207.397 237.206 206.397 237.206 205.787 237.561V237.57Z",
    fill: "white"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M168.871 222.313L168.925 242.499C168.925 245.317 170.789 248.136 174.49 250.291C181.946 254.628 194.075 254.628 201.585 250.291C205.359 248.109 207.25 245.254 207.241 242.389L207.186 222.204C207.186 225.059 205.313 227.923 201.531 230.105C194.03 234.443 181.891 234.443 174.435 230.105C170.735 227.951 168.88 225.141 168.871 222.313Z",
    fill: "#439B6B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask210_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 222,
    width: 40,
    height: 32
  }, _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M168.871 222.313L168.925 242.499C168.925 245.317 170.789 248.136 174.49 250.291C181.946 254.628 194.075 254.628 201.585 250.291C205.359 248.109 207.25 245.254 207.241 242.389L207.186 222.204C207.186 225.059 205.313 227.923 201.531 230.105C194.03 234.443 181.891 234.443 174.435 230.105C170.735 227.951 168.88 225.141 168.871 222.313Z",
    fill: "white"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask210_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.871 222.313L168.925 242.499C168.925 245.317 170.789 248.136 174.49 250.291C181.946 254.628 194.075 254.628 201.585 250.291C205.359 248.109 207.25 245.254 207.241 242.389L207.186 222.204C207.186 225.059 205.313 227.923 201.531 230.105C194.03 234.443 181.891 234.443 174.435 230.105C170.735 227.951 168.88 225.141 168.871 222.313Z",
    fill: "#439B6B"
  }))), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M174.526 214.412C167.025 218.749 166.979 225.768 174.435 230.105C181.891 234.442 194.02 234.442 201.531 230.105C209.032 225.768 209.069 218.749 201.613 214.412C194.157 210.084 182.037 210.074 174.526 214.412Z",
    fill: "#4FDA8E"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M154.588 179.287L156.506 178.169C156.816 177.987 157.016 177.605 157.016 177.06L155.097 178.178C155.097 178.724 154.906 179.115 154.588 179.287Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask211_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 154,
    y: 177,
    width: 4,
    height: 3
  }, _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M154.588 179.287L156.506 178.169C156.816 177.987 157.016 177.605 157.016 177.06L155.097 178.178C155.097 178.724 154.906 179.115 154.588 179.287Z",
    fill: "white"
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask211_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.588 179.287L156.506 178.169C156.816 177.987 157.016 177.605 157.016 177.06L155.097 178.178C155.097 178.724 154.906 179.115 154.588 179.287Z",
    fill: "#E0E2EA"
  }))), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M155.095 178.169L157.005 177.06L157.068 154.665L155.159 155.783L155.095 178.169Z",
    fill: "#E0E2EA"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M154.105 151.546L152.186 152.665C152.504 152.483 152.941 152.51 153.423 152.783L155.341 151.664C154.859 151.382 154.423 151.355 154.105 151.546Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask212_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 151,
    width: 4,
    height: 2
  }, _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M154.105 151.546L152.186 152.665C152.504 152.483 152.941 152.51 153.423 152.783L155.341 151.664C154.859 151.382 154.423 151.355 154.105 151.546Z",
    fill: "white"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask212_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.422 152.783L155.34 151.664C155.213 151.592 155.095 151.537 154.977 151.501L153.058 152.619C153.176 152.656 153.304 152.71 153.422 152.783Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.059 152.619L154.977 151.501C154.777 151.437 154.586 151.419 154.422 151.437L152.504 152.555C152.668 152.528 152.859 152.555 153.059 152.619Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.504 152.556L154.423 151.437C154.305 151.455 154.205 151.492 154.105 151.546L152.186 152.665C152.277 152.61 152.386 152.574 152.504 152.556Z",
    fill: "#E0E2EA"
  }))), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M155.16 155.783L157.078 154.665C157.078 153.565 156.305 152.219 155.351 151.664L153.432 152.783C154.387 153.337 155.169 154.674 155.16 155.783Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask213_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 151,
    width: 5,
    height: 5
  }, _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M155.16 155.783L157.078 154.665C157.078 153.565 156.305 152.219 155.351 151.664L153.432 152.783C154.387 153.337 155.169 154.674 155.16 155.783Z",
    fill: "white"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask213_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.159 155.784L157.077 154.665C157.077 154.502 157.059 154.338 157.032 154.174L155.113 155.293C155.141 155.456 155.159 155.62 155.159 155.784Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.114 155.293L157.032 154.174C156.987 153.929 156.914 153.674 156.805 153.429L154.886 154.547C154.986 154.793 155.068 155.047 155.114 155.293Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.887 154.547L156.805 153.429C156.705 153.192 156.578 152.965 156.441 152.747L154.523 153.865C154.668 154.083 154.787 154.311 154.887 154.547Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.522 153.865L156.441 152.747C156.259 152.474 156.041 152.219 155.814 152.01L153.895 153.129C154.131 153.338 154.341 153.592 154.522 153.865Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.886 153.119L155.804 152.001C155.659 151.864 155.504 151.755 155.34 151.664L153.422 152.783C153.586 152.874 153.74 152.992 153.886 153.119Z",
    fill: "#E0E2EA"
  }))), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M153.423 152.783C152.459 152.228 151.686 152.673 151.677 153.774L151.613 176.169C151.613 177.269 152.386 178.614 153.341 179.169C154.296 179.724 155.078 179.278 155.087 178.178L155.15 155.783C155.15 154.683 154.377 153.337 153.423 152.783Z",
    fill: "#C2C3D0"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M171.608 217.549V221.286C171.626 223.441 173.235 225.596 176.445 227.25C182.901 230.56 193.403 230.56 199.904 227.25C203.177 225.577 204.805 223.395 204.805 221.204V217.467C204.805 219.658 203.168 221.84 199.895 223.513C193.394 226.832 182.892 226.832 176.436 223.513C173.226 221.868 171.617 219.713 171.617 217.549H171.608Z",
    fill: "#252529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask214_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 217,
    width: 34,
    height: 13
  }, _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M171.608 217.549V221.286C171.626 223.441 173.235 225.596 176.445 227.25C182.901 230.56 193.403 230.56 199.904 227.25C203.177 225.577 204.805 223.395 204.805 221.204V217.467C204.805 219.658 203.168 221.84 199.895 223.513C193.394 226.832 182.892 226.832 176.436 223.513C173.226 221.868 171.617 219.713 171.617 217.549H171.608Z",
    fill: "white"
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask214_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.608 217.549V221.286C171.626 223.441 173.235 225.596 176.445 227.25C182.901 230.56 193.403 230.56 199.904 227.25C203.177 225.577 204.805 223.395 204.805 221.204V217.467C204.805 219.658 203.168 221.84 199.895 223.513C193.394 226.832 182.892 226.832 176.436 223.513C173.226 221.868 171.617 219.713 171.617 217.549H171.608Z",
    fill: "#252529"
  }))), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M176.509 210.711C170.008 214.466 169.972 220.549 176.436 224.304C182.892 228.059 193.394 228.059 199.895 224.304C206.396 220.549 206.432 214.466 199.977 210.711C193.521 206.956 183.01 206.956 176.509 210.711Z",
    fill: "#38373E"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M181.537 196.154L171.835 201.791C173.062 201.082 174.754 201.182 176.618 202.264L186.319 196.627C184.446 195.545 182.755 195.445 181.537 196.154Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask215_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 195,
    width: 16,
    height: 8
  }, _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M181.537 196.154L171.835 201.791C173.062 201.082 174.754 201.182 176.618 202.264L186.319 196.627C184.446 195.545 182.755 195.445 181.537 196.154Z",
    fill: "white"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask215_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.619 202.264L186.32 196.627C184.857 195.781 183.493 195.536 182.383 195.818L172.682 201.455C173.791 201.173 175.155 201.419 176.619 202.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.681 201.455L182.382 195.818C182.082 195.89 181.791 196.009 181.537 196.163L171.835 201.801C172.099 201.646 172.381 201.537 172.681 201.455Z",
    fill: "white"
  }))), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M182.62 210.002L192.322 204.365C191.222 201.2 188.949 198.145 186.321 196.627L176.619 202.264C179.247 203.783 181.52 206.829 182.62 210.002Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask216_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 196,
    width: 17,
    height: 15
  }, _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M182.62 210.002L192.322 204.365C191.222 201.2 188.949 198.145 186.321 196.627L176.619 202.264C179.247 203.783 181.52 206.829 182.62 210.002Z",
    fill: "white"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask216_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.619 210.002L192.321 204.365C192.039 203.546 191.675 202.737 191.248 201.955L181.546 207.593C181.974 208.375 182.337 209.184 182.619 210.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.547 207.592L191.249 201.955C190.021 199.718 188.267 197.754 186.321 196.627L176.619 202.264C178.574 203.392 180.32 205.356 181.547 207.592Z",
    fill: "white"
  }))), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M191.438 221.368L201.149 215.73L192.32 204.365L182.619 210.002L191.438 221.368Z",
    fill: "white"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M191.848 225.786L201.55 220.149C202.514 219.585 202.541 217.549 201.141 215.73L191.439 221.367C192.848 223.177 192.812 225.223 191.848 225.786Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask217_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 191,
    y: 215,
    width: 12,
    height: 11
  }, _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M191.848 225.786L201.55 220.149C202.514 219.585 202.541 217.549 201.141 215.73L191.439 221.367C192.848 223.177 192.812 225.223 191.848 225.786Z",
    fill: "white"
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask217_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.848 225.787L201.549 220.149C202.377 219.667 202.513 218.094 201.649 216.512L191.948 222.15C192.811 223.732 192.675 225.305 191.848 225.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.948 222.149L201.65 216.512C201.504 216.248 201.341 215.994 201.141 215.739L191.439 221.377C191.639 221.631 191.812 221.895 191.948 222.149Z",
    fill: "white"
  }))), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M176.619 202.264C172.9 200.118 169.881 201.837 169.872 206.11C169.863 210.383 172.864 215.584 176.582 217.73L190.221 225.604C192.558 226.95 193.44 223.931 191.449 221.376L182.629 210.011C181.529 206.847 179.256 203.791 176.628 202.273L176.619 202.264Z",
    fill: "#C2C3D0"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M150.703 151.773L147.212 153.801C147.648 153.546 148.248 153.574 148.912 153.947L152.404 151.919C151.74 151.546 151.149 151.519 150.703 151.773Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask218_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 151,
    width: 6,
    height: 3
  }, _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M150.703 151.773L147.212 153.801C147.648 153.546 148.248 153.574 148.912 153.947L152.404 151.919C151.74 151.546 151.149 151.519 150.703 151.773Z",
    fill: "white"
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask218_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.903 153.946L152.395 151.919C151.885 151.628 151.403 151.555 151.013 151.646L147.521 153.674C147.912 153.574 148.394 153.656 148.903 153.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.521 153.683L151.013 151.655C150.904 151.682 150.795 151.728 150.695 151.782L147.203 153.81C147.303 153.756 147.403 153.71 147.521 153.683Z",
    fill: "white"
  }))), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M183.446 179.496L186.937 177.469C187.401 177.205 187.683 176.623 187.683 175.814L184.191 177.842C184.191 178.66 183.91 179.233 183.446 179.496Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask219_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 175,
    width: 5,
    height: 5
  }, _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M183.446 179.496L186.937 177.469C187.401 177.205 187.683 176.623 187.683 175.814L184.191 177.842C184.191 178.66 183.91 179.233 183.446 179.496Z",
    fill: "white"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask219_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.446 179.496L186.937 177.469C187.401 177.205 187.683 176.623 187.683 175.814L184.191 177.842C184.191 178.66 183.91 179.233 183.446 179.496Z",
    fill: "white"
  }))), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M181.718 172.313L185.21 170.286L152.404 151.919L148.903 153.946L181.718 172.313Z",
    fill: "white"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M184.192 177.832L187.683 175.805V174.65L184.192 176.678V177.832Z",
    fill: "white"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M184.191 176.678L187.682 174.65C187.682 173.022 186.582 171.077 185.209 170.286L181.718 172.313C183.082 173.104 184.191 175.059 184.191 176.678Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask220_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 170,
    width: 7,
    height: 7
  }, _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M184.191 176.678L187.682 174.65C187.682 173.022 186.582 171.077 185.209 170.286L181.718 172.313C183.082 173.104 184.191 175.059 184.191 176.678Z",
    fill: "white"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask220_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.191 176.677L187.682 174.65C187.682 173.868 187.428 173.004 187 172.231L183.509 174.259C183.927 175.032 184.191 175.895 184.191 176.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.509 174.259L187.001 172.231C186.546 171.413 185.919 170.695 185.209 170.286L181.718 172.313C182.418 172.722 183.054 173.441 183.509 174.259Z",
    fill: "white"
  }))), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M181.764 172.277L148.949 153.91C147.595 153.155 146.503 153.828 146.503 155.438C146.503 157.038 147.585 158.975 148.931 159.784L181.701 179.287C183.101 180.097 184.219 179.424 184.228 177.805V176.641C184.228 175.014 183.128 173.068 181.764 172.277Z",
    fill: "#C2C3D0"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M156.322 187.307L155.159 186.634L154.268 188.189L155.431 188.862L156.322 187.307Z",
    fill: "#2A2A2A"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M155.432 188.862L154.268 188.189L155.004 188.626L156.178 189.29L155.432 188.862Z",
    fill: "#232323"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M156.324 184.388L155.151 183.725L155.16 186.634L156.324 187.307V184.388Z",
    fill: "#303030"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M154.688 183.434L153.515 182.77L155.151 183.725L156.324 184.388L154.688 183.434Z",
    fill: "#232323"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M155.115 181.97L153.951 181.297L151.478 182.724L152.651 183.388L155.115 181.97Z",
    fill: "#1E1E1E"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M152.652 183.388L151.478 182.724L151.487 183.934L152.652 184.607V183.388Z",
    fill: "#303030"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M152.65 184.606L154.687 183.433L156.324 184.388V187.307L155.433 188.862L156.178 189.289L157.378 187.207L157.369 183.279L155.114 181.97L152.65 183.388V184.606Z",
    fill: "#2B2B2B"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M143.203 187.726V187.125C143.203 187.407 143.385 187.689 143.758 187.898V188.499C143.385 188.29 143.203 188.008 143.203 187.726Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask221_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 187,
    width: 1,
    height: 2
  }, _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M143.203 187.726V187.125C143.203 187.407 143.385 187.689 143.758 187.898V188.499C143.385 188.29 143.203 188.008 143.203 187.726Z",
    fill: "white"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask221_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.758 187.889V188.49C143.385 188.28 143.203 187.998 143.203 187.716V187.116C143.203 187.398 143.385 187.68 143.758 187.889Z",
    fill: "#C2C3D0"
  }))), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M161.924 189.825V190.426C161.924 190.699 161.742 190.981 161.378 191.19V190.589C161.742 190.38 161.924 190.107 161.924 189.825Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask222_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 189,
    width: 1,
    height: 3
  }, _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M161.924 189.825V190.426C161.924 190.699 161.742 190.981 161.378 191.19V190.589C161.742 190.38 161.924 190.107 161.924 189.825Z",
    fill: "white"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask222_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.924 189.825V190.426C161.924 190.426 161.924 190.508 161.906 190.553V189.953C161.906 189.953 161.924 189.871 161.924 189.825Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.915 189.953V190.553C161.869 190.781 161.696 190.999 161.405 191.181V190.581C161.705 190.408 161.869 190.18 161.915 189.953Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.405 190.58V191.181C161.405 191.181 161.387 191.181 161.378 191.19V190.589C161.378 190.589 161.396 190.589 161.405 190.58Z",
    fill: "#C2C3D0"
  }))), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M161.388 190.589L161.379 191.189L156.25 194.181V193.572L161.388 190.589Z",
    fill: "#C2C3D0"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M153.605 193.572L153.595 194.181L143.757 188.498V187.889L153.605 193.572Z",
    fill: "#C2C3D0"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M156.25 193.572V194.172C155.523 194.599 154.331 194.599 153.604 194.172V193.572C154.34 193.999 155.523 193.999 156.25 193.572Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask223_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 193,
    width: 4,
    height: 2
  }, _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M156.25 193.572V194.172C155.523 194.599 154.331 194.599 153.604 194.172V193.572C154.34 193.999 155.523 193.999 156.25 193.572Z",
    fill: "white"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask223_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.251 193.572V194.172C156.124 194.245 155.987 194.308 155.842 194.354V193.754C155.987 193.708 156.133 193.644 156.251 193.572Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.842 193.754V194.354C155.478 194.472 155.06 194.518 154.66 194.481V193.881C155.06 193.917 155.478 193.872 155.842 193.754Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.66 193.881V194.481C154.269 194.445 153.896 194.345 153.596 194.172V193.572C153.896 193.744 154.269 193.845 154.66 193.881Z",
    fill: "#C2C3D0"
  }))), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M161.379 189.053C162.115 189.48 162.115 190.162 161.379 190.59L156.242 193.572C155.514 193.999 154.332 193.999 153.596 193.572L143.758 187.889C143.021 187.462 143.021 186.78 143.749 186.352L148.886 183.37C149.613 182.943 150.804 182.943 151.532 183.37L161.37 189.053H161.379Z",
    fill: "white"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M145.94 185.488L146.213 185.652L148.004 184.606L147.74 184.452L145.94 185.488Z",
    fill: "#424242"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 188.062L146.631 188.98L144.058 187.489L145.631 186.579L148.204 188.062Z",
    fill: "#686868"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M155.351 187.716L153.778 188.634L151.205 187.143L152.778 186.234L155.351 187.716Z",
    fill: "#686868"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M155.387 186.171L154.623 186.616L153.359 185.889L154.132 185.443L155.387 186.171Z",
    fill: "#686868"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M157.042 187.125L156.269 187.58L155.005 186.852L155.778 186.398L157.042 187.125Z",
    fill: "#686868"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M151.94 188.052L150.731 188.752L148.758 187.616L149.967 186.907L151.94 188.052Z",
    fill: "#686868"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M154.395 189.343L153.186 190.053L151.213 188.907L152.422 188.207L154.395 189.343Z",
    fill: "#686868"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M153.059 191.607L152.086 192.171L150.486 191.253L151.459 190.689L153.059 191.607Z",
    fill: "#686868"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M161.47 189.598L160.497 190.162L158.896 189.244L159.878 188.68L161.47 189.598Z",
    fill: "#686868"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M159.215 188.334L158.242 188.898L156.642 187.98L157.624 187.407L159.215 188.334Z",
    fill: "#686868"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M160.343 190.29L159.651 190.69L158.514 190.035L159.206 189.635L160.343 190.29Z",
    fill: "#686868"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M159.406 190.88L158.706 191.29L157.569 190.626L158.269 190.225L159.406 190.88Z",
    fill: "#686868"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M158.479 191.371L157.778 191.772L156.65 191.117L157.342 190.716L158.479 191.371Z",
    fill: "#686868"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M152.313 189.917L150.295 191.09L146.994 189.18L149.013 188.007L152.313 189.917Z",
    fill: "#686868"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M153.696 185.225L151.922 186.261L149.022 184.579L150.795 183.552L153.696 185.225Z",
    fill: "#686868"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M158.879 189.525L157.106 190.553L154.205 188.88L155.978 187.852L158.879 189.525Z",
    fill: "#686868"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M153.268 190.544L152.686 190.881L151.904 190.426L152.486 190.089L153.268 190.544Z",
    fill: "#686868"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M154.251 191.126L153.669 191.472L152.877 191.017L153.46 190.671L154.251 191.126Z",
    fill: "#686868"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M155.133 190.38L154.378 190.826L153.359 190.235L154.114 189.798L155.133 190.38Z",
    fill: "#686868"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M155.369 189.798L154.905 190.071L154.277 189.708L154.741 189.435L155.369 189.798Z",
    fill: "#686868"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M156.233 190.335L155.769 190.608L155.142 190.244L155.606 189.971L156.233 190.335Z",
    fill: "#686868"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M155.332 191.298L154.868 191.571L154.241 191.207L154.705 190.944L155.332 191.298Z",
    fill: "#686868"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M156.005 190.944L155.541 191.217L154.914 190.853L155.378 190.58L156.005 190.944Z",
    fill: "#686868"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M156.797 190.707L156.496 190.889L156.114 190.671L156.424 190.489L156.797 190.707Z",
    fill: "#686868"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M155.932 192.808L154.622 193.572L152.477 192.335L153.786 191.571L155.932 192.808Z",
    fill: "#686868"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M157.332 192.035L156.46 192.544L155.023 191.717L155.905 191.208L157.332 192.035Z",
    fill: "#686868"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M149.359 186.77L148.077 187.507L145.985 186.307L147.267 185.561L149.359 186.77Z",
    fill: "#686868"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M149.949 185.543L149.158 186.007L147.876 185.261L148.658 184.806L149.949 185.543Z",
    fill: "#686868"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M151.586 186.543L150.795 186.998L149.513 186.261L150.295 185.797L151.586 186.543Z",
    fill: "#686868"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M147.939 192.635L146.775 191.971L147.976 192.672L149.139 193.335L147.939 192.635Z",
    fill: "#232323"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M152.65 183.388L151.486 182.724L149.013 184.143L150.177 184.806L152.65 183.388Z",
    fill: "#1E1E1E"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M150.177 184.807L149.013 184.143L146.768 188.044L147.931 188.707L150.177 184.807Z",
    fill: "#2A2A2A"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M147.931 188.707L146.768 188.044L146.777 191.972L147.941 192.635L147.931 188.707Z",
    fill: "#303030"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M147.94 192.635L149.14 193.335L149.886 192.053L148.986 191.526V188.607L150.613 185.779L152.65 184.606V183.388L150.177 184.806L147.931 188.707L147.94 192.635Z",
    fill: "#2B2B2B"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M152.869 179.278L147.85 176.369L147.868 182.733L152.887 185.643L152.869 179.278Z",
    fill: "#C2C3D0"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M155.696 176.305L150.677 173.386C150.377 173.214 149.959 173.232 149.495 173.504L154.514 176.423C154.978 176.159 155.396 176.132 155.696 176.305Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask224_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 149,
    y: 173,
    width: 7,
    height: 4
  }, _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M155.696 176.305L150.677 173.386C150.377 173.214 149.959 173.232 149.495 173.504L154.514 176.423C154.978 176.159 155.396 176.132 155.696 176.305Z",
    fill: "white"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask224_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.695 176.305L150.676 173.386C150.53 173.305 150.357 173.268 150.167 173.277L155.186 176.196C155.377 176.187 155.549 176.223 155.695 176.305Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.186 176.196L150.167 173.277C150.058 173.277 149.94 173.314 149.822 173.35L154.841 176.269C154.959 176.223 155.077 176.205 155.186 176.196Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.841 176.269L149.822 173.35C149.722 173.386 149.613 173.432 149.503 173.495L154.522 176.414C154.632 176.35 154.741 176.305 154.841 176.269Z",
    fill: "#C2C3D0"
  }))), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M154.515 176.423L149.496 173.505C148.578 174.032 147.841 175.314 147.841 176.369L152.86 179.287C152.86 178.233 153.597 176.951 154.515 176.423Z",
    fill: "#C2C3D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask225_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 173,
    width: 8,
    height: 7
  }, _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M154.515 176.423L149.496 173.505C148.578 174.032 147.841 175.314 147.841 176.369L152.86 179.287C152.86 178.233 153.597 176.951 154.515 176.423Z",
    fill: "white"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask225_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.514 176.423L149.495 173.504C149.495 173.504 149.486 173.504 149.477 173.514L154.496 176.432C154.496 176.432 154.505 176.432 154.514 176.423Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.505 176.432L149.485 173.514C149.358 173.587 149.24 173.668 149.131 173.768L154.15 176.687C154.268 176.587 154.386 176.505 154.505 176.432Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.141 176.687L149.122 173.768C149.004 173.868 148.885 173.987 148.776 174.114L153.795 177.033C153.905 176.905 154.023 176.796 154.141 176.687Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.796 177.032L148.777 174.114C148.513 174.405 148.295 174.759 148.131 175.123L153.15 178.042C153.314 177.678 153.532 177.323 153.796 177.032Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.15 178.042L148.131 175.123C148.067 175.259 148.022 175.396 147.977 175.532L152.996 178.451C153.041 178.314 153.087 178.178 153.15 178.042Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.995 178.451L147.976 175.532C147.931 175.678 147.894 175.823 147.876 175.968L152.895 178.887C152.913 178.742 152.95 178.596 152.995 178.451Z",
    fill: "#C2C3D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.897 178.878L147.878 175.96C147.86 176.096 147.841 176.232 147.841 176.36L152.86 179.278C152.86 179.151 152.869 179.015 152.897 178.878Z",
    fill: "#C2C3D0"
  }))), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M154.514 176.423C153.595 176.951 152.859 178.233 152.859 179.287L152.877 185.652L156.196 183.734L156.178 177.369C156.178 176.314 155.432 175.896 154.514 176.423Z",
    fill: "#E0E2EA"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M177.71 213.521L181.447 211.348C182.065 210.984 182.438 210.193 182.393 209.075L178.656 211.248C178.701 212.366 178.328 213.166 177.71 213.521Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask226_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 209,
    width: 6,
    height: 5
  }, _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M177.71 213.521L181.447 211.348C182.065 210.984 182.438 210.193 182.393 209.075L178.656 211.248C178.701 212.366 178.328 213.166 177.71 213.521Z",
    fill: "white"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask226_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.71 213.521L181.447 211.348C182.065 210.984 182.438 210.193 182.393 209.075L178.656 211.248C178.701 212.366 178.328 213.166 177.71 213.521Z",
    fill: "#E0E2EA"
  }))), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M175.373 165.658L171.636 167.831C172.227 167.485 173.054 167.54 173.954 168.058L177.691 165.885C176.791 165.367 175.964 165.312 175.373 165.658Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask227_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 165,
    width: 7,
    height: 4
  }, _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M175.373 165.658L171.636 167.831C172.227 167.485 173.054 167.54 173.954 168.058L177.691 165.885C176.791 165.367 175.964 165.312 175.373 165.658Z",
    fill: "white"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask227_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.953 168.058L177.69 165.885C177.345 165.685 177.008 165.558 176.699 165.485L172.962 167.658C173.28 167.722 173.607 167.858 173.953 168.058Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.953 167.658L176.69 165.485C176.208 165.385 175.781 165.44 175.417 165.621L171.68 167.795C172.035 167.604 172.471 167.558 172.953 167.658Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.69 167.795L175.427 165.622C175.427 165.622 175.39 165.64 175.372 165.658L171.635 167.831C171.635 167.831 171.672 167.813 171.69 167.795Z",
    fill: "#E0E2EA"
  }))), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M178.655 211.248L182.401 209.075L180.937 171.332L177.2 173.505L178.655 211.248Z",
    fill: "#E0E2EA"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M177.199 173.504L180.936 171.331C180.854 169.286 179.427 166.894 177.69 165.885L173.953 168.058C175.69 169.058 177.117 171.459 177.199 173.504Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask228_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 165,
    width: 8,
    height: 9
  }, _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M177.199 173.504L180.936 171.331C180.854 169.286 179.427 166.894 177.69 165.885L173.953 168.058C175.69 169.058 177.117 171.459 177.199 173.504Z",
    fill: "white"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask228_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.199 173.504L180.936 171.331C180.909 170.586 180.699 169.804 180.363 169.049L176.626 171.222C176.962 171.977 177.172 172.759 177.199 173.504Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.627 171.213L180.364 169.04C180.082 168.403 179.71 167.794 179.273 167.267L175.536 169.44C175.973 169.967 176.345 170.577 176.627 171.213Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.535 169.44L179.272 167.267C178.799 166.694 178.263 166.212 177.69 165.876L173.953 168.049C174.526 168.376 175.072 168.867 175.535 169.44Z",
    fill: "#E0E2EA"
  }))), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M173.953 168.058C172.217 167.058 170.78 167.794 170.689 169.74L169.025 205.683C168.925 207.774 170.407 210.42 172.271 211.493L175.399 213.302C177.263 214.375 178.754 213.448 178.663 211.257L177.209 173.514C177.127 171.468 175.699 169.076 173.963 168.067L173.953 168.058Z",
    fill: "#C2C3D0"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M171.971 203.201L170.753 203.91C171.289 203.601 172.035 203.646 172.853 204.119L174.072 203.41C173.253 202.937 172.508 202.892 171.971 203.201Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask229_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 203,
    width: 5,
    height: 2
  }, _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M171.971 203.201L170.753 203.91C171.289 203.601 172.035 203.646 172.853 204.119L174.072 203.41C173.253 202.937 172.508 202.892 171.971 203.201Z",
    fill: "white"
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask229_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.843 204.119L174.061 203.41C173.416 203.037 172.825 202.928 172.334 203.055L171.115 203.764C171.597 203.646 172.197 203.746 172.843 204.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.116 203.756L172.335 203.046C172.199 203.083 172.08 203.128 171.962 203.201L170.743 203.91C170.861 203.847 170.98 203.792 171.116 203.756Z",
    fill: "white"
  }))), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M174.927 211.102L176.145 210.393C176.672 210.084 177 209.429 177.009 208.502C177.009 206.628 175.699 204.346 174.072 203.41L172.854 204.119C174.481 205.055 175.799 207.338 175.79 209.211C175.79 210.138 175.463 210.793 174.927 211.102Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask230_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 172,
    y: 203,
    width: 6,
    height: 9
  }, _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M174.927 211.102L176.145 210.393C176.672 210.084 177 209.429 177.009 208.502C177.009 206.628 175.699 204.346 174.072 203.41L172.854 204.119C174.481 205.055 175.799 207.338 175.79 209.211C175.79 210.138 175.463 210.793 174.927 211.102Z",
    fill: "white"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask230_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.927 211.102L176.145 210.393C176.673 210.083 177 209.429 177.009 208.501C177.009 207.61 176.718 206.628 176.227 205.746L175.009 206.455C175.49 207.337 175.791 208.319 175.791 209.211C175.791 210.138 175.463 210.793 174.927 211.102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.008 206.447L176.227 205.738C175.69 204.756 174.917 203.892 174.063 203.401L172.844 204.11C173.699 204.601 174.472 205.465 175.008 206.447Z",
    fill: "white"
  }))), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M172.844 204.119C171.217 203.182 169.889 203.937 169.889 205.801C169.889 207.674 171.198 209.947 172.826 210.893C174.454 211.829 175.781 211.084 175.781 209.211C175.781 207.338 174.472 205.055 172.844 204.119Z",
    fill: "#252529"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M148.558 182.452L150.477 181.333C150.786 181.151 150.986 180.77 150.986 180.224L149.067 181.342C149.067 181.888 148.876 182.279 148.558 182.452Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask231_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 180,
    width: 3,
    height: 3
  }, _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M148.558 182.452L150.477 181.333C150.786 181.151 150.986 180.77 150.986 180.224L149.067 181.342C149.067 181.888 148.876 182.279 148.558 182.452Z",
    fill: "white"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask231_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.558 182.452L150.477 181.333C150.786 181.151 150.986 180.77 150.986 180.224L149.067 181.342C149.067 181.888 148.876 182.279 148.558 182.452Z",
    fill: "#E0E2EA"
  }))), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M149.067 181.342L150.986 180.224L151.05 157.829L149.131 158.947L149.067 181.342Z",
    fill: "#E0E2EA"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M148.085 154.711L146.166 155.829C146.484 155.647 146.921 155.674 147.403 155.947L149.321 154.829C148.839 154.547 148.403 154.52 148.085 154.711Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask232_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 154,
    width: 4,
    height: 2
  }, _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M148.085 154.711L146.166 155.829C146.484 155.647 146.921 155.674 147.403 155.947L149.321 154.829C148.839 154.547 148.403 154.52 148.085 154.711Z",
    fill: "white"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask232_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.404 155.947L149.322 154.829C149.195 154.756 149.077 154.702 148.959 154.665L147.04 155.784C147.158 155.82 147.286 155.874 147.404 155.947Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.031 155.783L148.95 154.665C148.75 154.601 148.559 154.583 148.395 154.601L146.477 155.72C146.64 155.693 146.831 155.72 147.031 155.783Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.476 155.72L148.394 154.601C148.276 154.619 148.176 154.656 148.076 154.71L146.158 155.829C146.249 155.774 146.358 155.738 146.476 155.72Z",
    fill: "#E0E2EA"
  }))), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M149.13 158.947L151.049 157.829C151.049 156.729 150.276 155.383 149.321 154.829L147.403 155.947C148.358 156.502 149.14 157.838 149.13 158.947Z",
    fill: "#E0E2EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask233_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 154,
    width: 5,
    height: 5
  }, _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M149.13 158.947L151.049 157.829C151.049 156.729 150.276 155.383 149.321 154.829L147.403 155.947C148.358 156.502 149.14 157.838 149.13 158.947Z",
    fill: "white"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask233_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.129 158.947L151.048 157.829C151.048 157.665 151.03 157.502 151.003 157.338L149.084 158.456C149.111 158.62 149.129 158.784 149.129 158.947Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.085 158.457L151.004 157.338C150.958 157.093 150.886 156.838 150.776 156.593L148.858 157.711C148.958 157.956 149.04 158.211 149.085 158.457Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.858 157.711L150.776 156.592C150.676 156.356 150.549 156.129 150.413 155.911L148.494 157.029C148.64 157.247 148.758 157.474 148.858 157.711Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.494 157.029L150.413 155.911C150.231 155.638 150.013 155.383 149.785 155.174L147.867 156.292C148.103 156.502 148.312 156.756 148.494 157.029Z",
    fill: "#E0E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.867 156.283L149.785 155.165C149.64 155.029 149.485 154.919 149.321 154.829L147.403 155.947C147.566 156.038 147.721 156.156 147.867 156.283Z",
    fill: "#E0E2EA"
  }))), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M147.403 155.947C146.439 155.392 145.666 155.838 145.657 156.938L145.593 179.333C145.593 180.433 146.366 181.779 147.321 182.333C148.276 182.888 149.058 182.442 149.067 181.342L149.13 158.947C149.13 157.847 148.357 156.501 147.403 155.947Z",
    fill: "#C2C3D0"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M146.794 178.588L146.33 178.86C146.53 178.742 146.821 178.76 147.131 178.942L147.595 178.669C147.285 178.487 147.003 178.469 146.794 178.588Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask234_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 178,
    width: 2,
    height: 1
  }, _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M146.794 178.588L146.33 178.86C146.53 178.742 146.821 178.76 147.131 178.942L147.595 178.669C147.285 178.487 147.003 178.469 146.794 178.588Z",
    fill: "white"
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask234_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.122 178.942L147.586 178.669C147.341 178.524 147.113 178.487 146.931 178.533L146.467 178.806C146.649 178.76 146.877 178.806 147.122 178.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.466 178.806L146.93 178.533C146.875 178.542 146.83 178.57 146.784 178.588L146.32 178.861C146.32 178.861 146.411 178.815 146.466 178.806Z",
    fill: "white"
  }))), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M147.913 181.597L148.376 181.324C148.576 181.206 148.704 180.96 148.704 180.606C148.704 179.896 148.204 179.024 147.585 178.669L147.122 178.942C147.74 179.296 148.24 180.169 148.24 180.878C148.24 181.233 148.113 181.478 147.913 181.597Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask235_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 178,
    width: 2,
    height: 4
  }, _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M147.913 181.597L148.376 181.324C148.576 181.206 148.704 180.96 148.704 180.606C148.704 179.896 148.204 179.024 147.585 178.669L147.122 178.942C147.74 179.296 148.24 180.169 148.24 180.878C148.24 181.233 148.113 181.478 147.913 181.597Z",
    fill: "white"
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask235_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.913 181.597L148.376 181.324C148.576 181.206 148.704 180.96 148.704 180.606C148.704 180.269 148.595 179.896 148.404 179.56L147.94 179.833C148.122 180.169 148.24 180.542 148.24 180.878C148.24 181.233 148.113 181.478 147.913 181.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.949 179.825L148.413 179.552C148.212 179.179 147.912 178.851 147.594 178.66L147.13 178.933C147.457 179.124 147.748 179.452 147.949 179.825Z",
    fill: "white"
  }))), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M147.122 178.942C146.503 178.587 145.994 178.869 145.994 179.588C145.994 180.297 146.494 181.17 147.113 181.524C147.731 181.879 148.24 181.597 148.24 180.879C148.24 180.17 147.74 179.297 147.122 178.942Z",
    fill: "#252529"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M146.44 156.674L145.977 156.947C146.186 156.829 146.468 156.847 146.777 157.029L147.241 156.756C146.932 156.574 146.641 156.556 146.44 156.674Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask236_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 156,
    width: 3,
    height: 2
  }, _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M146.44 156.674L145.977 156.947C146.186 156.829 146.468 156.847 146.777 157.029L147.241 156.756C146.932 156.574 146.641 156.556 146.44 156.674Z",
    fill: "white"
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask236_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.777 157.02L147.24 156.747C146.995 156.602 146.767 156.565 146.586 156.611L146.122 156.884C146.304 156.838 146.531 156.884 146.777 157.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.112 156.884L146.576 156.611C146.521 156.62 146.476 156.647 146.43 156.665L145.966 156.938C145.966 156.938 146.057 156.893 146.112 156.884Z",
    fill: "white"
  }))), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M147.568 159.684L148.032 159.411C148.232 159.293 148.359 159.048 148.359 158.693C148.359 157.975 147.859 157.111 147.241 156.747L146.777 157.02C147.395 157.374 147.904 158.247 147.895 158.966C147.895 159.32 147.768 159.566 147.568 159.684Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask237_47_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 156,
    width: 3,
    height: 4
  }, _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M147.568 159.684L148.032 159.411C148.232 159.293 148.359 159.048 148.359 158.693C148.359 157.975 147.859 157.111 147.241 156.747L146.777 157.02C147.395 157.374 147.904 158.247 147.895 158.966C147.895 159.32 147.768 159.566 147.568 159.684Z",
    fill: "white"
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask237_47_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.568 159.684L148.032 159.411C148.232 159.293 148.359 159.047 148.359 158.693C148.359 158.356 148.25 157.975 148.059 157.638L147.595 157.911C147.777 158.247 147.895 158.62 147.895 158.966C147.895 159.32 147.768 159.566 147.568 159.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.595 157.911L148.059 157.639C147.85 157.266 147.559 156.938 147.232 156.747L146.768 157.02C147.095 157.211 147.386 157.538 147.595 157.911Z",
    fill: "white"
  }))), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M146.776 157.02C146.158 156.665 145.649 156.947 145.649 157.666C145.649 158.384 146.149 159.248 146.767 159.611C147.386 159.966 147.895 159.684 147.895 158.966C147.895 158.248 147.395 157.384 146.776 157.02Z",
    fill: "#252529"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M107.188 94.2449C106.106 94.2449 104.915 93.8903 103.687 93.1719C99.4408 90.717 95.9766 84.725 95.9766 79.8241C95.9766 77.3964 96.804 75.5779 98.3133 74.7141C99.8227 73.8504 101.805 74.0322 103.905 75.2506C108.161 77.7056 111.616 83.6976 111.616 88.5984C111.616 91.0261 110.788 92.8446 109.279 93.7084C108.652 94.0721 107.951 94.2449 107.188 94.2449ZM100.405 74.6232C99.7227 74.6232 99.0862 74.7778 98.5406 75.1051C97.1768 75.8962 96.4312 77.5692 96.4312 79.8332C96.4312 84.5977 99.7863 90.4169 103.914 92.7992C105.869 93.9266 107.697 94.1176 109.061 93.3356C110.425 92.5446 111.17 90.8715 111.17 88.6075C111.17 83.843 107.815 78.0238 103.687 75.6416C102.523 74.9687 101.405 74.6323 100.405 74.6323V74.6232Z",
    fill: "white"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M104.787 88.0529C104.587 87.5437 104.223 87.0618 103.796 86.8163C103.369 86.5708 103.005 86.6254 102.805 86.9073C102.705 87.0437 102.65 87.2346 102.65 87.4801C102.65 88.2075 103.16 89.0986 103.796 89.4623C104.423 89.826 104.942 89.5259 104.942 88.7985C104.942 88.5621 104.887 88.2984 104.787 88.0529Z",
    fill: "white"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4038 78.4242L98.9675 79.4062C100.204 78.6879 101.914 78.788 103.796 79.8791C105.678 80.9702 107.387 82.8341 108.624 84.98L109.188 84.6526C107.805 82.2613 105.896 80.17 103.796 78.9516C101.695 77.7332 99.7859 77.6241 98.4038 78.4242Z",
    fill: "white"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M100.104 81.3699L100.668 82.3519C101.468 81.8882 102.568 81.9519 103.787 82.6611C105.005 83.3703 106.105 84.5796 106.905 85.9617L107.469 85.6343C106.523 83.9977 105.223 82.5701 103.778 81.7336C102.341 80.9062 101.032 80.8244 100.086 81.3699H100.104Z",
    fill: "white"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M101.813 84.3251L102.377 85.307C102.74 85.0979 103.241 85.1252 103.795 85.4434C104.35 85.7617 104.85 86.3163 105.214 86.9437L105.777 86.6164C105.268 85.7344 104.568 84.9615 103.795 84.516C103.022 84.0705 102.322 84.025 101.813 84.3251Z",
    fill: "white"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M104.014 92.9811H103.569V118.286H104.014V92.9811Z",
    fill: "white"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M104.66 117.922C104.46 117.413 104.096 116.931 103.669 116.685C103.242 116.44 102.878 116.494 102.678 116.776C102.578 116.913 102.523 117.104 102.523 117.349C102.523 118.077 103.033 118.968 103.669 119.331C104.296 119.695 104.815 119.395 104.815 118.668C104.815 118.431 104.76 118.167 104.66 117.922Z",
    fill: "white"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M101.505 181.76C107.497 185.225 107.533 190.826 101.578 194.29C95.622 197.754 85.9384 197.754 79.9465 194.29C73.9545 190.826 73.9182 185.225 79.8737 181.76C85.8293 178.305 95.5129 178.305 101.505 181.76Z",
    fill: "#BDBDBD"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4753 180.833C88.4753 180.833 88.3934 182.024 87.9934 183.443C87.5751 184.934 88.0207 185.688 88.7753 185.943C89.6028 186.216 90.312 186.261 91.5122 186.907C92.5669 187.48 93.2125 189.625 96.5858 190.207C99.9591 190.789 99.3045 187.871 98.3043 186.934C97.2041 185.907 93.9308 181.842 93.9308 181.842L88.4844 180.833H88.4753Z",
    fill: "#1B2224"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4471 180.378C88.4471 180.378 88.3653 181.57 87.9652 182.988C87.547 184.479 88.1289 185.07 88.8745 185.325C89.7019 185.598 90.3384 185.716 91.5204 186.389C93.1389 187.316 93.1662 188.98 96.5395 189.562C99.9128 190.144 99.2763 187.416 98.2761 186.47C97.176 185.443 93.9027 181.379 93.9027 181.379L88.4562 180.369L88.4471 180.378Z",
    fill: "#3A3E3F"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5729 184.043C82.5729 184.043 82.4911 185.234 82.091 186.652C81.6728 188.143 82.1183 188.898 82.873 189.153C83.7004 189.426 84.4096 189.471 85.6098 190.117C86.6646 190.689 87.3101 192.835 90.6835 193.417C94.0568 193.999 93.4021 191.08 92.4019 190.144C91.3017 189.116 88.0284 185.052 88.0284 185.052L82.582 184.043H82.5729Z",
    fill: "#1B2224"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5468 183.588C82.5468 183.588 82.4649 184.779 82.0649 186.198C81.6466 187.689 82.2285 188.28 82.9741 188.534C83.8015 188.807 84.438 188.925 85.62 189.598C87.2385 190.526 87.2658 192.19 90.6391 192.772C94.0124 193.353 93.3759 190.626 92.3758 189.68C91.2756 188.653 88.0023 184.588 88.0023 184.588L82.5559 183.579L82.5468 183.588Z",
    fill: "#3A3E3F"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0845 157.92C95.0845 157.92 94.5117 171.404 94.739 175.814C94.8572 178.187 94.6481 180.006 94.2571 181.697C94.1571 182.124 93.3842 182.17 93.0115 182.17C91.4657 182.197 89.4926 182.861 88.3288 181.988C87.8924 181.661 88.056 180.442 88.0833 179.533C88.1833 175.469 88.1742 172.786 87.7378 169.768C87.3014 166.74 87.7378 161.466 88.6016 158.702C89.4654 155.938 95.0845 157.92 95.0845 157.92Z",
    fill: "#1A191D"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5131 133.288C95.5131 133.288 96.677 136.916 96.7224 146.172C96.7315 148.682 96.3769 152.746 95.8587 155.938C95.3404 159.129 94.7312 162.339 93.0945 162.421C91.4488 162.512 88.2573 164.93 88.2573 156.892C88.2573 148.855 88.7756 134.852 88.7756 134.852L95.5222 133.297L95.5131 133.288Z",
    fill: "#1A191D"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8545 157.838C81.8545 161.73 80.2088 164.066 80.4725 170.031C80.7361 175.996 82.3728 181.442 82.2 183.688C82.0273 185.934 88.2193 185.707 88.292 184.552C88.4193 182.542 88.9376 174.614 88.683 169.686C88.4193 164.757 89.0467 160.238 88.9285 157.074C88.8194 153.946 81.8545 157.838 81.8545 157.838Z",
    fill: "#38373E"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1819 134.152C79.1819 134.152 77.5361 137.78 77.9726 142.19C78.409 146.599 81.7732 156.801 81.7732 159.829C81.7732 162.857 88.9563 165.466 88.9563 157.51C88.9563 152.055 89.5564 152.937 89.4291 144.445C89.3928 142.299 91.4022 143.526 90.0747 135.37C89.5383 132.07 79.1819 134.161 79.1819 134.161V134.152Z",
    fill: "#38373E"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M104.832 125.569C104.832 125.569 105.05 125.996 105.942 126.433C106.723 126.823 107.915 127.151 107.787 127.496C107.651 127.878 106.323 127.351 106.342 127.733C106.433 129.488 106.423 130.779 104.941 130.606C103.496 130.442 105.06 129.206 104.778 128.469C104.432 127.56 103.978 127.314 103.978 127.314L104.832 125.56V125.569Z",
    fill: "#FFCEBB"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4118 105.474C90.1204 105.329 91.2843 107.738 91.5389 116.212C91.748 123.123 91.457 122.604 94.6394 124.196C98.0946 125.923 104.314 127.733 104.314 127.733L105.505 125.805L96.4306 120.277C96.4306 120.277 96.7762 114.403 96.567 111.221C96.3761 108.229 94.4394 105.61 92.4118 105.474Z",
    fill: "#449B6B"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3896 112.685C78.0172 109.03 89.5556 104.52 92.5379 105.62C95.5202 106.72 96.3658 114.112 95.6475 122.086C95.0383 128.942 95.9476 130.633 95.9021 134.261C95.8658 137.025 79.3265 137.044 78.7173 135.234C78.1081 133.416 79.5174 126.278 78.0444 121.177C76.5715 116.076 75.5804 114.476 76.3805 112.685H76.3896Z",
    fill: "#53C888"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1747 101.392C84.1747 101.392 83.9383 107.184 83.4019 108.675C87.4753 112.176 90.8123 110.566 90.8123 110.566C90.8123 110.566 90.6031 107.748 90.6668 105.929C85.2749 104.783 84.1747 101.401 84.1747 101.401V101.392Z",
    fill: "#EFBEAF"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6378 107.429C83.6378 107.429 88.2932 109.875 90.1117 110.721C90.5663 108.902 90.2026 106.656 90.2026 106.656L91.0482 105.747C91.0482 105.747 92.2303 107.575 92.0575 110.902C91.9393 113.239 91.3756 114.594 91.3756 114.594C91.3756 114.594 83.3014 109.202 82.4194 108.056C83.165 107.665 83.6469 107.429 83.6469 107.429H83.6378Z",
    fill: "#F7F7F7"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4015 103.283C84.4015 103.283 83.6104 101.937 83.1831 101.146C82.1829 99.2732 82.1647 95.4998 84.5469 94.045C86.9292 92.5811 88.484 93.8995 88.484 93.8995L87.4656 96.2818L84.4015 103.283Z",
    fill: "#72664E"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5471 93.8447C87.7562 93.8356 91.8933 94.1175 92.6207 96.4997C93.3481 98.882 92.5753 99.7003 93.0117 100.755C93.2936 101.419 94.1574 103.792 93.7027 104.019C93.339 104.21 92.9026 104.101 92.9026 104.528C92.9026 104.865 92.9026 106.456 92.5116 106.956C91.9479 107.684 90.3203 107.52 88.0745 106.574C85.8377 105.629 84.2283 105.056 84.2101 103.892C84.192 102.464 84.2101 102.392 84.0101 101.955C83.801 101.519 83.0099 99.7912 83.701 99.1547C84.392 98.5183 85.2103 99.7821 85.3558 99.6548C85.5013 99.5275 84.3465 94.0084 87.538 93.8538L87.5471 93.8447Z",
    fill: "#FFCEBB"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5572 95.4997C89.5572 95.4997 86.393 96.1453 86.3203 97.5455C86.2567 98.7366 85.8839 100.901 85.8839 100.901L85.1383 100.701L85.1837 99.5004C85.1837 99.5004 84.329 95.9271 85.1383 95.3633C85.9384 94.7996 87.8842 94.1722 88.9117 94.8542C89.93 95.5361 89.5663 95.5088 89.5663 95.5088L89.5572 95.4997Z",
    fill: "#72664E"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4212 96.5092C93.4212 96.5092 95.5034 97.3912 95.2579 98.8641C95.1033 99.8007 93.2121 100.492 88.9113 99.3279C84.6105 98.164 81.9737 97.4457 81.5918 96.1273C81.2099 94.8089 82.792 93.9087 83.9286 94.1815C85.0652 94.4543 93.4212 96.5183 93.4212 96.5183V96.5092Z",
    fill: "#53C888"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2915 95.4453C82.1005 96.5909 93.3661 99.4915 93.9117 98.2367C94.1845 95.7181 92.2569 92.863 89.4473 92.1447C85.883 91.2355 82.6097 93.4631 82.2915 95.4544V95.4453Z",
    fill: "#4EA073"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8114 95.3181C92.0934 96.2455 93.1118 97.3184 93.8756 98.2913C93.8937 98.2731 93.9028 98.2549 93.9119 98.2277C94.1847 95.709 92.448 92.363 88.7837 91.7902C86.2378 91.3992 84.6103 92.3903 83.3101 93.6723C85.174 93.5814 88.5473 93.6723 90.8114 95.309V95.3181Z",
    fill: "#53C888"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0391 126.996V127.487L100.186 132.224V131.733L92.0391 126.996Z",
    fill: "#4C4E50"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M100.187 131.733V132.224L106.324 128.678V128.187L100.187 131.733Z",
    fill: "#353638"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0391 126.996L100.186 131.733L106.323 128.187L98.1765 123.45L92.0391 126.996Z",
    fill: "#55575A"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7476 127.051L99.9852 131.251L105.513 128.06L98.2758 123.859L92.7476 127.051Z",
    fill: "#8A8A8A"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M102.795 129.906L102.877 129.951L103.577 129.551L103.495 129.506L102.795 129.906Z",
    fill: "#E0E2EA"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M103.677 129.37C103.677 129.37 103.64 129.424 103.677 129.443C103.713 129.461 103.777 129.461 103.814 129.443C103.85 129.424 103.85 129.388 103.814 129.37C103.777 129.351 103.722 129.351 103.686 129.37H103.677Z",
    fill: "#E0E2EA"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M91.421 125.805C91.8665 125.605 93.7486 124.914 94.3942 123.868C95.0398 122.823 95.4944 123.241 95.3671 123.65C95.2489 124.05 94.6033 124.678 94.7579 124.941C94.9216 125.205 98.0494 124.359 98.3313 124.878C98.6131 125.405 96.1218 125.578 95.9945 125.687C95.8581 125.814 96.2218 125.76 96.2673 126.087C96.3218 126.514 96.0581 126.469 96.0763 126.66C96.0763 126.751 96.2127 126.751 96.2309 127.005C96.2582 127.314 96.049 127.333 96.0399 127.451C96.0399 127.551 96.0763 127.56 96.0581 127.751C96.0581 127.833 95.949 128.387 94.3851 128.187C92.8303 127.987 92.1484 127.951 91.7574 128.051C91.3755 128.142 91.4028 125.796 91.4028 125.796L91.421 125.805Z",
    fill: "#FFCEBB"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1354 111.23C75.8441 111.084 74.6348 116.513 74.8894 124.987C75.0985 131.897 75.344 132.997 78.9538 132.743C82.7363 132.479 92.3289 128.178 92.3289 128.178L91.9379 125.16L80.3722 126.833C80.3722 126.833 80.9087 118.577 80.9087 115.331C80.9087 112.976 80.1449 111.339 78.1173 111.212L78.1354 111.23Z",
    fill: "#449B6B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_2",
    x1: 273.025,
    y1: 78.3696,
    x2: 250.711,
    y2: 42.6634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#BEEBD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9BD8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C99A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6AC493"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#61B788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53C888"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfid);
export default __webpack_public_path__ + "static/media/RFID.446f6780209f00a4f9c429ed4eef2327.svg";
export { ForwardRef as ReactComponent };